import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
}


export interface AnniversaryCard {
  __typename?: 'AnniversaryCard';
  anniversary: Scalars['String'];
  anniversaryCardId: Scalars['Int'];
  anniversaryDate: Scalars['DateTime'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creator: User;
  creatorUserId: Scalars['Int'];
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  hireDate: Scalars['DateTime'];
  isRead: Scalars['Boolean'];
  receiver: User;
  receiverUserId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
}

export interface AnniversaryCardCreateInput {
  anniversary: Scalars['String'];
  content: Scalars['String'];
  creatorUserId?: Maybe<Scalars['Int']>;
  receiverUserId: Scalars['Int'];
}

export interface AnniversaryCardSet {
  __typename?: 'AnniversaryCardSet';
  anniversary: Scalars['String'];
  blockedUsers: UsersPaginated;
  finishedUsers: UsersPaginated;
  totalUsers: UsersPaginated;
  unFinishedUsers: UsersPaginated;
}


export interface AnniversaryCardSetTotalUsersArgs {
  hrbpEmail?: Maybe<Scalars['String']>;
  leaderEmail: Scalars['String'];
  pagination: PaginationInput;
}

export interface AnniversaryCardUpdateInput {
  anniversaryCardId: Scalars['Int'];
  content?: Maybe<Scalars['String']>;
  isRead?: Maybe<Scalars['Boolean']>;
}

export interface Announcement {
  __typename?: 'Announcement';
  announcementId: Scalars['Int'];
  content: Scalars['String'];
  postId: Scalars['Int'];
  repliedType?: Maybe<AnnouncementReplyType>;
  title: Scalars['String'];
  type: AnnouncementType;
  videos: Array<File>;
}

export enum AnnouncementReplyType {
  Negative = 'Negative',
  Neutrality = 'Neutrality',
  Positive = 'Positive'
}

export enum AnnouncementType {
  Announcement = 'Announcement',
  Feature = 'Feature',
  Fix = 'Fix',
  Improvement = 'Improvement'
}

export interface AnnualReport {
  __typename?: 'AnnualReport';
  firstLandingDate: Scalars['String'];
  firstPostingDate?: Maybe<Scalars['String']>;
  highestRateLandingDate?: Maybe<Scalars['String']>;
  identity: AnnualReportIdentity;
  okr: AnnualReportOkr;
  project: AnnualReportProject;
  totalCommonGroupWithWorkCircleCount: Array<Group>;
  totalEventParticipatedCount: Scalars['Int'];
  totalFollowedEachOtherCount: Scalars['Int'];
  totalFollowedGroupCount: Scalars['Int'];
  totalGroupCount: Scalars['Int'];
  totalLandingCount: Scalars['Int'];
  totalLandingDateCount: Scalars['Int'];
  totalPostCommentCount: Scalars['Int'];
  totalPostCount: Scalars['Int'];
  totalPostLikedCount: Scalars['Int'];
  workCircleCommonGroup?: Maybe<Scalars['String']>;
}

export enum AnnualReportIdentity {
  Atmosphere = 'Atmosphere',
  CommonLanding = 'CommonLanding',
  Content = 'Content',
  InActivity = 'InActivity',
  Passerby = 'Passerby',
  Social = 'Social'
}

export interface AnnualReportOkr {
  __typename?: 'AnnualReportOKR';
  firstContent: Scalars['String'];
  total: Scalars['Int'];
}

export interface AnnualReportProject {
  __typename?: 'AnnualReportProject';
  ownedCount: Scalars['Int'];
  participatedCount: Scalars['Int'];
}

export interface AppState {
  __typename?: 'AppState';
  showSidebar: Scalars['Boolean'];
  showSearchHeader: Scalars['Boolean'];
}

export interface Banner {
  __typename?: 'Banner';
  bannerId: Scalars['Int'];
  file: File;
  fileId: Scalars['Int'];
  index?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
}

export interface BannerEdge {
  __typename?: 'BannerEdge';
  cursor: Scalars['String'];
  node: Banner;
}

export interface BannerPaginated {
  __typename?: 'BannerPaginated';
  edges: Array<BannerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface BasicProfile {
  __typename?: 'BasicProfile';
  aboutMe: ValueVisibility;
  beganWorkDate: ValueVisibility;
  business: ValueVisibility;
  createdAt: Scalars['DateTime'];
  educationBackground: ValueVisibility;
  englishName: ValueVisibility;
  gender: ValueVisibility;
  github: ValueVisibility;
  hobbies: ValueVisibility;
  linkedin: ValueVisibility;
  major: ValueVisibility;
  photo: PhotoIdValueVisibility;
  photoFile?: Maybe<File>;
  seatNumber: ValueVisibility;
  skillSet: ValueVisibility;
  speciality: ValueVisibility;
  university: ValueVisibility;
  workCircleFeedback?: Maybe<Scalars['Boolean']>;
}

export interface BasicProfileInput {
  aboutMe: ValueVisibilityInput;
  beganWorkDate: ValueVisibilityInput;
  business: ValueVisibilityInput;
  educationBackground: ValueVisibilityInput;
  englishName: ValueVisibilityInput;
  gender: ValueVisibilityInput;
  github: ValueVisibilityInput;
  hobbies: ValueVisibilityInput;
  linkedin: ValueVisibilityInput;
  major: ValueVisibilityInput;
  seatNumber: ValueVisibilityInput;
  skillSet: ValueVisibilityInput;
  speciality: ValueVisibilityInput;
  university: ValueVisibilityInput;
  workCircleFeedback?: Maybe<Scalars['Boolean']>;
}

export interface CareerProfile {
  __typename?: 'CareerProfile';
  duration: Scalars['String'];
  experienceType: ExperienceType;
  jobDescription: Scalars['String'];
  organization: Scalars['String'];
  pastExperienceId?: Maybe<Scalars['Int']>;
  position: Scalars['String'];
}

export interface CareerProfileInput {
  duration: Scalars['String'];
  experienceType: ExperienceType;
  jobDescription: Scalars['String'];
  organization: Scalars['String'];
  pastExperienceId?: Maybe<Scalars['Int']>;
  position: Scalars['String'];
}

export interface ChatGpt {
  __typename?: 'ChatGpt';
  answer: Scalars['String'];
  created: Scalars['Int'];
  id: Scalars['String'];
  model: Scalars['String'];
}

export interface ChatGptGroup {
  __typename?: 'ChatGptGroup';
  chatgptGroupId: Scalars['Int'];
  messages?: Maybe<Array<ChatGptGroupMessage>>;
  name: Scalars['String'];
  userId: Scalars['Int'];
}

export interface ChatGptGroupMessage {
  __typename?: 'ChatGptGroupMessage';
  chatgptGroupId: Scalars['Int'];
  content: Scalars['String'];
  createdTime: Scalars['DateTime'];
  msgId: Scalars['Int'];
  role: ChatGptMessageRoleEnum;
}

export interface ChatGptGroupMessageInput {
  content: Scalars['String'];
  createdTime: Scalars['String'];
  role: ChatGptMessageRoleEnum;
}

export interface ChatGptInput {
  chatgptGroupId?: Maybe<Scalars['Int']>;
  messages: Array<ChatGptResponseInput>;
  model: Scalars['String'];
  msgId?: Maybe<Scalars['Int']>;
}

export enum ChatGptMessageRoleEnum {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  User = 'USER'
}

export interface ChatGptResponseInput {
  content: Scalars['String'];
  role: ChatGptMessageRoleEnum;
}

export interface Claude {
  __typename?: 'Claude';
  answer: Scalars['String'];
  created: Scalars['Int'];
  id: Scalars['String'];
  model: Scalars['String'];
}

export interface Comment {
  __typename?: 'Comment';
  commentId: Scalars['Int'];
  comments: CommentsPaginated;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 匿名返回 null */
  creator?: Maybe<User>;
  isAnonymous: Scalars['Boolean'];
  /** 是否为 viewer 创建，为了匿名 post 上不返回 creatorUserId */
  isViewerCreated: Scalars['Boolean'];
  liked: Scalars['Boolean'];
  likedCount: Scalars['Int'];
  likedUsers: UsersPaginated;
  mentions: Array<Mention>;
  parentComment?: Maybe<Comment>;
  parentCommentId?: Maybe<Scalars['Int']>;
  post: Post;
  postId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
}


export interface CommentCommentsArgs {
  pagination: PaginationInput;
}


export interface CommentLikedUsersArgs {
  pagination: PaginationInput;
}

export interface CommentEdge {
  __typename?: 'CommentEdge';
  cursor: Scalars['String'];
  node: Comment;
}

export interface CommentsPaginated {
  __typename?: 'CommentsPaginated';
  edges: Array<CommentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface CompanyProfile {
  __typename?: 'CompanyProfile';
  address: Scalars['String'];
  departmentName: ValueVisibility;
  email: ValueVisibility;
  employedDate: ValueVisibility;
  financialContact: ValueVisibility;
  floor: Scalars['String'];
  hrbpContact: ValueVisibility;
  jobType: ValueVisibility;
  location: ValueVisibility;
  mentor: ValueVisibility;
  orgLeader: ValueVisibility;
  workPhone: ValueVisibility;
}

export interface CompanyProfileInput {
  address: Scalars['String'];
  departmentName: ValueVisibilityInput;
  email: ValueVisibilityInput;
  employedDate: ValueVisibilityInput;
  financialContact: ValueVisibilityInput;
  floor: Scalars['String'];
  hrbpContact: ValueVisibilityInput;
  jobType: ValueVisibilityInput;
  location: ValueVisibilityInput;
  mentor: ValueVisibilityInput;
  orgLeader: ValueVisibilityInput;
  workPhone: ValueVisibilityInput;
}

export interface CreateAnnouncementInput {
  content: Scalars['String'];
  fileIds?: Maybe<Array<Scalars['Int']>>;
  title: Scalars['String'];
  type: AnnouncementType;
}

export interface CreateAnnouncementReplyInput {
  announcementId: Scalars['Int'];
  content: Scalars['String'];
  replyType: AnnouncementReplyType;
}

export interface CreateChatGptGroupInput {
  messages?: Maybe<Array<ChatGptGroupMessageInput>>;
  name: Scalars['String'];
}

export interface CreateCommentInput {
  content: Scalars['String'];
  isAnonymous?: Maybe<Scalars['Boolean']>;
  parentCommentId?: Maybe<Scalars['Int']>;
  postId: Scalars['Int'];
}

export interface CreateEventInput {
  avcLink?: Maybe<Scalars['String']>;
  avcPassword?: Maybe<Scalars['String']>;
  avcRoom?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  deadline?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  foreignGuests?: Maybe<Scalars['String']>;
  guests: Array<Scalars['String']>;
  location: Scalars['String'];
  openPosition?: Maybe<Scalars['Int']>;
  restriction?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  topic: Scalars['String'];
}

export interface CreateEventParticipantInput {
  eventId: Scalars['Int'];
  isInterested?: Maybe<Scalars['Boolean']>;
  isParticipated?: Maybe<Scalars['Boolean']>;
  postId: Scalars['Int'];
}

export interface CreateFileInput {
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
}

export interface CreateGroupInput {
  canPostAnonymously?: Maybe<Scalars['Boolean']>;
  canUnfollow?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  groupCategoryId?: Maybe<Scalars['Int']>;
  isOfficial?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pmoProjectId?: Maybe<Scalars['String']>;
  privateSetting?: Maybe<GroupPrivateSetting>;
  whoCanPost?: Maybe<WhoCanPost>;
}

export interface CreateHonorInput {
  commendation: Scalars['String'];
  honoredIndividuals: Array<Scalars['String']>;
  honoredProjects?: Maybe<Scalars['String']>;
  honoredSignificants?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
}

export interface CreateKnowledgeGroupInput {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentIds?: Maybe<Array<Scalars['Int']>>;
}

export interface CreateKnowledgePostInput {
  authorId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  fileIds?: Maybe<Array<Scalars['Int']>>;
  knowledgeGroupId: Scalars['Int'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
}

export interface CreatePostInput {
  content: Scalars['String'];
  event?: Maybe<CreateEventInput>;
  fileIds?: Maybe<Array<Scalars['Int']>>;
  groupId?: Maybe<Scalars['Int']>;
  honor?: Maybe<CreateHonorInput>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isMarkdown?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<CreatePostLinkInput>>;
  postType?: Maybe<PostType>;
  receiverUserId?: Maybe<Scalars['Int']>;
  sectionId?: Maybe<SectionType>;
}

export interface CreatePostLinkInput {
  description: Scalars['String'];
  logo: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
}


export interface DeleteCommentInput {
  commentId: Scalars['Int'];
}

export interface Department {
  __typename?: 'Department';
  departmentId: Scalars['Int'];
  journals: PostsPaginated;
  leader?: Maybe<User>;
  members: Array<User>;
  name: Scalars['String'];
  parentDepartmentId: Scalars['Int'];
}


export interface DepartmentJournalsArgs {
  filter: GetPostsFilter;
  pagination: PaginationInput;
}

export enum DepartmentRole {
  Finance = 'FINANCE',
  Hrbp = 'HRBP'
}

export interface Event {
  __typename?: 'Event';
  avcLink?: Maybe<Scalars['String']>;
  avcPassword?: Maybe<Scalars['String']>;
  avcRoom?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  deadline?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  foreignGuests?: Maybe<Scalars['String']>;
  guests: Array<Mention>;
  interestedCount: Scalars['Int'];
  interestedUsers: UsersPaginated;
  isInterested: Scalars['Boolean'];
  isParticipated: Scalars['Boolean'];
  location: Scalars['String'];
  openPosition?: Maybe<Scalars['Int']>;
  participants: UsersPaginated;
  participatedCount: Scalars['Int'];
  postId: Scalars['Int'];
  restriction?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  topic: Scalars['String'];
}


export interface EventInterestedUsersArgs {
  filter?: Maybe<GetUsersFilter>;
  pagination: PaginationInput;
}


export interface EventParticipantsArgs {
  filter?: Maybe<GetUsersFilter>;
  pagination: PaginationInput;
}

export interface EventEdge {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
}

export interface EventPaginated {
  __typename?: 'EventPaginated';
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface EventParticipant {
  __typename?: 'EventParticipant';
  eventParticipantId: Scalars['Int'];
  isInterested: Scalars['Boolean'];
  isParticipated: Scalars['Boolean'];
  participant: User;
}

export interface EventParticipantEdge {
  __typename?: 'EventParticipantEdge';
  cursor: Scalars['String'];
  node: EventParticipant;
}

export enum ExperienceType {
  Career = 'Career',
  Education = 'Education'
}

export interface FeatureToggle {
  __typename?: 'FeatureToggle';
  feature: Scalars['String'];
  value: Scalars['String'];
}

export interface Featured {
  __typename?: 'Featured';
  createdAt: Scalars['DateTime'];
  entity: FeaturedEntity;
  entityId: Scalars['Int'];
  entityType: FeaturedEntityType;
  featuredId: Scalars['Int'];
}

export type FeaturedEntity = Group | Post;

export enum FeaturedEntityType {
  Group = 'Group',
  Post = 'Post'
}

export interface File {
  __typename?: 'File';
  createdAt: Scalars['DateTime'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['Int'];
  fileId: Scalars['Int'];
  name: Scalars['String'];
  oss: FileOss;
  postId?: Maybe<Scalars['Int']>;
  progress?: Maybe<Scalars['Int']>;
  size: Scalars['Int'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
}

export interface FileEdge {
  __typename?: 'FileEdge';
  cursor: Scalars['String'];
  node: File;
}

export interface FileOss {
  __typename?: 'FileOSS';
  expireAt: Scalars['DateTime'];
  key: Scalars['String'];
  OSSAccessKeyId: Scalars['String'];
  policy: Scalars['String'];
  Signature: Scalars['String'];
  success_action_status: Scalars['Int'];
  uploadUrl: Scalars['String'];
}

export interface FilesPaginated {
  __typename?: 'FilesPaginated';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface Follow {
  __typename?: 'Follow';
  creator?: Maybe<User>;
  creatorUser?: Maybe<User>;
  creatorUserId?: Maybe<Scalars['Int']>;
  followeeGroup?: Maybe<Group>;
  followeeGroupId?: Maybe<Scalars['Int']>;
  followeeUser?: Maybe<User>;
  followeeUserId?: Maybe<Scalars['Int']>;
  follower: User;
  followerUserId: Scalars['Int'];
  followId: Scalars['Int'];
}

export interface GetDepartmentsFilter {
  search?: Maybe<Scalars['String']>;
}

export interface GetGroupsFilter {
  categoryId?: Maybe<Scalars['Int']>;
  creatorUserId?: Maybe<Scalars['Int']>;
  followerUserId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isOfficial?: Maybe<Scalars['Boolean']>;
  isPinned?: Maybe<Scalars['Boolean']>;
  privateSetting?: Maybe<GroupPrivateSetting>;
  search?: Maybe<Scalars['String']>;
  whoCanPost?: Maybe<Array<WhoCanPost>>;
}

export interface GetPostsFilter {
  endTs?: Maybe<Scalars['DateTime']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  postTypes?: Maybe<Array<PostType>>;
  startTs?: Maybe<Scalars['DateTime']>;
}

export interface GetUsersFilter {
  hasOnboarding?: Maybe<Scalars['Boolean']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
}

export interface Group {
  __typename?: 'Group';
  admins: UsersPaginated;
  archivedAt?: Maybe<Scalars['DateTime']>;
  avatarUrl?: Maybe<Scalars['String']>;
  canPostAnonymously: Scalars['Boolean'];
  canUnfollow: Scalars['Boolean'];
  category?: Maybe<GroupCategory>;
  createdAt: Scalars['DateTime'];
  creator: User;
  creatorUserId: Scalars['Int'];
  description: Scalars['String'];
  featuredAt?: Maybe<Scalars['DateTime']>;
  files: FilesPaginated;
  followers: UsersPaginated;
  groupCategoryId?: Maybe<Scalars['Int']>;
  groupId: Scalars['Int'];
  impact: Scalars['Float'];
  isFollowing: Scalars['Boolean'];
  isOfficial: Scalars['Boolean'];
  isPinned: Scalars['Boolean'];
  memberRequest: GroupMemberRequest;
  name: Scalars['String'];
  pmoLink?: Maybe<Scalars['String']>;
  pmoProjectId?: Maybe<Scalars['String']>;
  posts: PostsPaginated;
  privateSetting: GroupPrivateSetting;
  recentUnreadCount?: Maybe<Scalars['Int']>;
  topPost?: Maybe<Post>;
  unreadMemberRequests: GroupMemberRequestPaginated;
  updatedAt: Scalars['DateTime'];
  whoCanPost: WhoCanPost;
}


export interface GroupAdminsArgs {
  filter: GetUsersFilter;
  pagination: PaginationInput;
}


export interface GroupFilesArgs {
  pagination: PaginationInput;
}


export interface GroupFollowersArgs {
  filter: GetUsersFilter;
  pagination: PaginationInput;
}


export interface GroupPostsArgs {
  filter: GetPostsFilter;
  pagination: PaginationInput;
}


export interface GroupUnreadMemberRequestsArgs {
  pagination: PaginationInput;
}

export enum GroupApplyStatus {
  Created = 'Created',
  Joined = 'Joined',
  Pending = 'Pending'
}

export interface GroupCategory {
  __typename?: 'GroupCategory';
  createdAt: Scalars['DateTime'];
  groupCategoryId: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
}

export interface GroupEdge {
  __typename?: 'GroupEdge';
  cursor: Scalars['String'];
  node: Group;
}

export interface GroupMemberRequest {
  __typename?: 'GroupMemberRequest';
  approver?: Maybe<User>;
  approverUserId?: Maybe<Scalars['Int']>;
  creator: User;
  creatorUserId: Scalars['Int'];
  group: Group;
  groupId: Scalars['Int'];
  isApproved?: Maybe<Scalars['Boolean']>;
  requestId: Scalars['Int'];
}

export interface GroupMemberRequestEdge {
  __typename?: 'GroupMemberRequestEdge';
  cursor: Scalars['String'];
  node: GroupMemberRequest;
}

export interface GroupMemberRequestFeedBack {
  __typename?: 'GroupMemberRequestFeedBack';
  alreadyApproved: Scalars['Boolean'];
  requesetHandled: Scalars['Boolean'];
}

export interface GroupMemberRequestPaginated {
  __typename?: 'GroupMemberRequestPaginated';
  edges: Array<GroupMemberRequestEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export enum GroupPrivateSetting {
  Closed = 'Closed',
  Normal = 'Normal'
}

export interface GroupsPaginated {
  __typename?: 'GroupsPaginated';
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface Hobby {
  __typename?: 'Hobby';
  evaluatedUsers?: Maybe<UsersPaginated>;
  hobbyId: Scalars['Int'];
  name: Scalars['String'];
}

export interface HobbyEdge {
  __typename?: 'HobbyEdge';
  cursor: Scalars['String'];
  node: Hobby;
}

export interface HobbyInput {
  search?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Int']>;
}

export interface HobbyPaginated {
  __typename?: 'HobbyPaginated';
  edges: Array<HobbyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface Honor {
  __typename?: 'Honor';
  commendation: Scalars['String'];
  honoredIndividuals: Array<Mention>;
  honoredProjects?: Maybe<Scalars['String']>;
  honoredSignificants?: Maybe<Array<Mention>>;
  honorId: Scalars['Int'];
  postId: Scalars['Int'];
  title: Scalars['String'];
}

export interface HonorEdge {
  __typename?: 'HonorEdge';
  cursor: Scalars['String'];
  node: Honor;
}

export interface HonorPaginated {
  __typename?: 'HonorPaginated';
  edges: Array<HonorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface KeyResult {
  __typename?: 'KeyResult';
  importance: Scalars['Float'];
  krId: Scalars['Int'];
  name: Scalars['String'];
  progress: Scalars['Float'];
  score: Scalars['Float'];
}

export interface KnowledgeGroup {
  __typename?: 'KnowledgeGroup';
  childGroupIds?: Maybe<Array<Scalars['Int']>>;
  childGroups?: Maybe<Array<KnowledgeGroup>>;
  childPositions?: Maybe<Array<Scalars['Int']>>;
  creator: User;
  creatorUserId: Scalars['Int'];
  description: Scalars['String'];
  knowledgeGroupId: Scalars['Int'];
  name: Scalars['String'];
  parentGroups?: Maybe<Array<KnowledgeGroup>>;
  parentKnowledgeGroupId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  posts: KnowledgePostPaginated;
}


export interface KnowledgeGroupPostsArgs {
  pagination: PaginationInput;
  search?: Maybe<Scalars['String']>;
}

export interface KnowledgeGroupEdge {
  __typename?: 'KnowledgeGroupEdge';
  cursor: Scalars['String'];
  node: KnowledgeGroup;
}

export interface KnowledgeGroupPaginated {
  __typename?: 'KnowledgeGroupPaginated';
  edges: Array<KnowledgeGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface KnowledgeLink {
  __typename?: 'KnowledgeLink';
  knowledgePostLinkId: Scalars['Int'];
  url: Scalars['String'];
}

export interface KnowledgeNs {
  __typename?: 'KnowledgeNS';
  group: KnowledgeGroup;
  groups: KnowledgeGroupPaginated;
  post: KnowledgePost;
  posts: KnowledgePostPaginated;
}


export interface KnowledgeNsGroupArgs {
  knowledgeGroupId: Scalars['Int'];
}


export interface KnowledgeNsGroupsArgs {
  pagination: PaginationInput;
  search?: Maybe<Scalars['String']>;
}


export interface KnowledgeNsPostArgs {
  knowledgePostId: Scalars['Int'];
}


export interface KnowledgeNsPostsArgs {
  pagination: PaginationInput;
  search?: Maybe<Scalars['String']>;
}

export interface KnowledgePost {
  __typename?: 'KnowledgePost';
  author: User;
  authorId: Scalars['Int'];
  creator: User;
  creatorUserId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  files: Array<File>;
  knowledgeGroupId: Scalars['Int'];
  knowledgePostId: Scalars['Int'];
  link?: Maybe<KnowledgeLink>;
  title: Scalars['String'];
}

export interface KnowledgePostEdge {
  __typename?: 'KnowledgePostEdge';
  cursor: Scalars['String'];
  node: KnowledgePost;
}

export interface KnowledgePostPaginated {
  __typename?: 'KnowledgePostPaginated';
  edges: Array<KnowledgePostEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface Mention {
  __typename?: 'Mention';
  entity?: Maybe<MentionEntity>;
  entityId: Scalars['Int'];
  entityType: MentionEntityType;
  mentionId: Scalars['Int'];
  user: User;
  userId: Scalars['Int'];
}

export type MentionEntity = Comment | Post;

export enum MentionEntityType {
  Comment = 'Comment',
  HonoredSig = 'HonoredSig',
  Post = 'Post'
}

export interface Mutation {
  __typename?: 'Mutation';
  addBanner: Scalars['Boolean'];
  anniversaryCardCreate: AnniversaryCard;
  anniversaryCardUpdate: AnniversaryCard;
  announcementCreate: Post;
  announcementReplyCreate: Post;
  announcementUpdate: Post;
  basicProfileAboutMeUpdate: BasicProfile;
  basicProfileUpdate: BasicProfile;
  careerProfileDelete: Scalars['Int'];
  careerProfileUpdate: Array<CareerProfile>;
  chatGptGroupAdded: ChatGptGroup;
  chatGptGroupDeleted: Scalars['Int'];
  chatGptGroupMessageUpsert: ChatGptGroupMessage;
  chatGptGroupUpdated: ChatGptGroup;
  commentCreate: Comment;
  commentDelete: Scalars['Boolean'];
  commentLikeToggle: Comment;
  commentUpdate: Comment;
  companyProfileUpdate: CompanyProfile;
  createJournalProject: Scalars['Boolean'];
  deleteBanner: Scalars['Boolean'];
  deleteJournalProject: Scalars['Boolean'];
  departmentBatchFollow: Scalars['Boolean'];
  eventParticipantCreateUpdate: Event;
  featuredCommentDisplay: Scalars['Boolean'];
  featuredCommentHide: Scalars['Boolean'];
  featuredPostTop: Post;
  featuredPostUnTop: Post;
  featureToggleUpdate: FeatureToggle;
  fileCreate: File;
  groupAdminAdd: Scalars['Boolean'];
  groupAdminRemove: Scalars['Boolean'];
  groupApply: GroupApplyStatus;
  groupArchive: Scalars['Boolean'];
  groupBatchFollow: Array<Group>;
  groupCategoryAdd: GroupCategory;
  groupCategoryDelete: GroupCategory;
  groupCategoryUpdate: GroupCategory;
  groupCreate: Group;
  groupFeature: Scalars['Boolean'];
  groupFollow: Group;
  groupFollowerRemove: Scalars['Boolean'];
  groupInvite: Scalars['Boolean'];
  groupMemberRequestApprove: GroupMemberRequestFeedBack;
  groupPinUpdate: Group;
  groupUnArchive: Scalars['Boolean'];
  groupUnFeature: Scalars['Boolean'];
  groupUnfollow: Group;
  groupUpdate: Group;
  hobbyCreate?: Maybe<Hobby>;
  knowledgeGroupCreate: KnowledgeGroup;
  knowledgeGroupDelete: Scalars['Boolean'];
  knowledgeGroupFavorToggle: Scalars['Boolean'];
  knowledgeGroupUpdate: KnowledgeGroup;
  knowledgePostCreate: KnowledgePost;
  knowledgePostDelete: Scalars['Boolean'];
  knowledgePostUpdate: KnowledgePost;
  knowledgeSync: Scalars['Boolean'];
  notificationRead: Scalars['Boolean'];
  notificationSettingUpdate: NotificationSetting;
  photoUpdate: BasicProfile;
  postArchive: Scalars['Boolean'];
  postBatchCreate: Array<Post>;
  postCreate: Post;
  postFavorToggle: Post;
  postFeature: Post;
  postLikeToggle: Post;
  postRead: Post;
  postShare: Post;
  postTagUpdate: Post;
  postTop: Post;
  postUnArchive: Scalars['Boolean'];
  postUnFeature: Post;
  postUnTop: Scalars['Boolean'];
  postUpdate: Post;
  postUsefulToggle: Post;
  sectionAdd: Section;
  sectionDelete: Section;
  sectionPostTop: Post;
  sectionPostUnTop: Post;
  sectionUpdate: Section;
  setBanner: Scalars['Boolean'];
  skillCreate?: Maybe<Skill>;
  switchKnowledgeGroup: Scalars['Boolean'];
  systemAdminAdd: Scalars['Boolean'];
  systemAdminRemove: Scalars['Boolean'];
  toggleWebsiteCommon: Website;
  updateEventReadTimestamp: User;
  userAboutMePartUpdate: Scalars['String'];
  userBatchFollow: Array<User>;
  userFollow: User;
  userHobbyBatchUpdate: User;
  userHobbyUpdate: Scalars['Boolean'];
  userInfoEditModalUpdate: Scalars['Boolean'];
  userInfoHeaderUpdate: Scalars['Boolean'];
  userInfoWorkCircleFeedBackUpdate: Scalars['Boolean'];
  userPinUpdate: User;
  userSkillBatchUpdate: User;
  userSkillUpdate: Scalars['String'];
  userUnfollow: User;
  viewerUpdate: User;
  visitPage: Scalars['Boolean'];
  websiteAdd: Website;
  websiteCategoryAdd: WebsiteCategory;
  websiteCategoryUpdate: WebsiteCategory;
  websiteDelete: Scalars['Boolean'];
  websiteUpdate: Website;
}


export interface MutationAddBannerArgs {
  fileId: Scalars['Int'];
}


export interface MutationAnniversaryCardCreateArgs {
  input: AnniversaryCardCreateInput;
}


export interface MutationAnniversaryCardUpdateArgs {
  input: AnniversaryCardUpdateInput;
}


export interface MutationAnnouncementCreateArgs {
  input: CreateAnnouncementInput;
}


export interface MutationAnnouncementReplyCreateArgs {
  input: CreateAnnouncementReplyInput;
}


export interface MutationAnnouncementUpdateArgs {
  input: UpdateAnnouncementInput;
}


export interface MutationBasicProfileAboutMeUpdateArgs {
  aboutMe: ValueVisibilityInput;
}


export interface MutationBasicProfileUpdateArgs {
  basicProfile: BasicProfileInput;
}


export interface MutationCareerProfileDeleteArgs {
  careerProfileId: Scalars['Int'];
}


export interface MutationCareerProfileUpdateArgs {
  careerProfile: CareerProfileInput;
}


export interface MutationChatGptGroupAddedArgs {
  input: CreateChatGptGroupInput;
}


export interface MutationChatGptGroupDeletedArgs {
  chatgptGroupId: Scalars['Int'];
}


export interface MutationChatGptGroupMessageUpsertArgs {
  input: UpsertChatGptGroupMessageInput;
}


export interface MutationChatGptGroupUpdatedArgs {
  input: UpdateChatGptGroupInput;
}


export interface MutationCommentCreateArgs {
  comment: CreateCommentInput;
}


export interface MutationCommentDeleteArgs {
  comment: DeleteCommentInput;
}


export interface MutationCommentLikeToggleArgs {
  commentId: Scalars['Int'];
  like: Scalars['Boolean'];
}


export interface MutationCommentUpdateArgs {
  comment: UpdateCommentInput;
}


export interface MutationCompanyProfileUpdateArgs {
  companyProfile: CompanyProfileInput;
}


export interface MutationCreateJournalProjectArgs {
  project: Scalars['String'];
  userId: Scalars['Int'];
}


export interface MutationDeleteBannerArgs {
  bannerId: Scalars['Int'];
}


export interface MutationDeleteJournalProjectArgs {
  project: Scalars['String'];
  userId: Scalars['Int'];
}


export interface MutationDepartmentBatchFollowArgs {
  followeeDepartmentIds?: Maybe<Array<Scalars['Int']>>;
}


export interface MutationEventParticipantCreateUpdateArgs {
  input: CreateEventParticipantInput;
}


export interface MutationFeaturedCommentDisplayArgs {
  postId: Scalars['Int'];
}


export interface MutationFeaturedCommentHideArgs {
  postId: Scalars['Int'];
}


export interface MutationFeaturedPostTopArgs {
  postId: Scalars['Int'];
}


export interface MutationFeaturedPostUnTopArgs {
  postId: Scalars['Int'];
}


export interface MutationFeatureToggleUpdateArgs {
  feature: Scalars['String'];
}


export interface MutationFileCreateArgs {
  file: CreateFileInput;
}


export interface MutationGroupAdminAddArgs {
  groupId: Scalars['Int'];
  userId: Scalars['Int'];
}


export interface MutationGroupAdminRemoveArgs {
  groupId: Scalars['Int'];
  userId: Scalars['Int'];
}


export interface MutationGroupApplyArgs {
  groupId: Scalars['Int'];
}


export interface MutationGroupArchiveArgs {
  groupId: Scalars['Int'];
}


export interface MutationGroupBatchFollowArgs {
  followeeGroupIds?: Maybe<Array<Scalars['Int']>>;
}


export interface MutationGroupCategoryAddArgs {
  name: Scalars['String'];
}


export interface MutationGroupCategoryDeleteArgs {
  groupCategoryId: Scalars['Int'];
}


export interface MutationGroupCategoryUpdateArgs {
  groupCategoryId: Scalars['Int'];
  name: Scalars['String'];
}


export interface MutationGroupCreateArgs {
  group: CreateGroupInput;
}


export interface MutationGroupFeatureArgs {
  groupId: Scalars['Int'];
}


export interface MutationGroupFollowArgs {
  followeeGroupId: Scalars['Int'];
  followerUserId?: Maybe<Scalars['Int']>;
}


export interface MutationGroupFollowerRemoveArgs {
  followeeGroupId: Scalars['Int'];
  followerUserId: Scalars['Int'];
}


export interface MutationGroupInviteArgs {
  departmentIds?: Maybe<Array<Scalars['Int']>>;
  followeeGroupId: Scalars['Int'];
  followerUserIds?: Maybe<Array<Scalars['Int']>>;
}


export interface MutationGroupMemberRequestApproveArgs {
  isApproved: Scalars['Boolean'];
  requestId: Scalars['Int'];
}


export interface MutationGroupPinUpdateArgs {
  groupId: Scalars['Int'];
}


export interface MutationGroupUnArchiveArgs {
  groupId: Scalars['Int'];
}


export interface MutationGroupUnFeatureArgs {
  groupId: Scalars['Int'];
}


export interface MutationGroupUnfollowArgs {
  followeeGroupId: Scalars['Int'];
}


export interface MutationGroupUpdateArgs {
  group: UpdateGroupInput;
  groupId: Scalars['Int'];
}


export interface MutationHobbyCreateArgs {
  name: Scalars['String'];
}


export interface MutationKnowledgeGroupCreateArgs {
  knowledgeGroupInput: CreateKnowledgeGroupInput;
}


export interface MutationKnowledgeGroupDeleteArgs {
  knowledgeGroupId: Scalars['Int'];
}


export interface MutationKnowledgeGroupFavorToggleArgs {
  knowledgeGroupId: Scalars['Int'];
}


export interface MutationKnowledgeGroupUpdateArgs {
  knowledgeGroupId: Scalars['Int'];
  knowledgeGroupInput: UpdateKnowledgeGroupInput;
}


export interface MutationKnowledgePostCreateArgs {
  knowledgePostInput: CreateKnowledgePostInput;
}


export interface MutationKnowledgePostDeleteArgs {
  knowledgePostId: Scalars['Int'];
}


export interface MutationKnowledgePostUpdateArgs {
  knowledgePostId: Scalars['Int'];
  knowledgePostInput: UpdateKnowledgePostInput;
}


export interface MutationNotificationSettingUpdateArgs {
  notificationSetting: UpdateNotificationSettingInput;
  notificationSettingId: Scalars['Int'];
}


export interface MutationPhotoUpdateArgs {
  fileId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  visible: Scalars['Boolean'];
}


export interface MutationPostArchiveArgs {
  postId: Scalars['Int'];
}


export interface MutationPostBatchCreateArgs {
  post: CreatePostInput;
  receiverUserIds: Array<Scalars['Int']>;
}


export interface MutationPostCreateArgs {
  post: CreatePostInput;
}


export interface MutationPostFavorToggleArgs {
  postId: Scalars['Int'];
}


export interface MutationPostFeatureArgs {
  postId: Scalars['Int'];
}


export interface MutationPostLikeToggleArgs {
  like: Scalars['Boolean'];
  postId: Scalars['Int'];
}


export interface MutationPostReadArgs {
  postId: Scalars['Int'];
}


export interface MutationPostShareArgs {
  post: SharePostInput;
}


export interface MutationPostTagUpdateArgs {
  postId: Scalars['Int'];
  tags: Array<PostTagType>;
}


export interface MutationPostTopArgs {
  groupId: Scalars['Int'];
  postId: Scalars['Int'];
}


export interface MutationPostUnArchiveArgs {
  postId: Scalars['Int'];
}


export interface MutationPostUnFeatureArgs {
  postId: Scalars['Int'];
}


export interface MutationPostUnTopArgs {
  groupId: Scalars['Int'];
}


export interface MutationPostUpdateArgs {
  post: UpdatePostInput;
  postId: Scalars['Int'];
}


export interface MutationPostUsefulToggleArgs {
  postId: Scalars['Int'];
}


export interface MutationSectionAddArgs {
  name: Scalars['String'];
}


export interface MutationSectionDeleteArgs {
  sectionId: Scalars['Int'];
}


export interface MutationSectionPostTopArgs {
  postId: Scalars['Int'];
  sectionId: SectionType;
}


export interface MutationSectionPostUnTopArgs {
  postId: Scalars['Int'];
  sectionId: SectionType;
}


export interface MutationSectionUpdateArgs {
  name: Scalars['String'];
  SectionId: Scalars['Int'];
}


export interface MutationSetBannerArgs {
  input: Array<SetBannerInput>;
}


export interface MutationSkillCreateArgs {
  name: Scalars['String'];
}


export interface MutationSwitchKnowledgeGroupArgs {
  includeTarget: Scalars['Boolean'];
  parentId?: Maybe<Scalars['Int']>;
  sourceId: Scalars['Int'];
  targetId: Scalars['Int'];
}


export interface MutationSystemAdminAddArgs {
  userId: Scalars['Int'];
}


export interface MutationSystemAdminRemoveArgs {
  userId: Scalars['Int'];
}


export interface MutationToggleWebsiteCommonArgs {
  websiteId: Scalars['Int'];
}


export interface MutationUserAboutMePartUpdateArgs {
  input: UserInfoAboutMePartInput;
}


export interface MutationUserBatchFollowArgs {
  followeeUserIds?: Maybe<Array<Scalars['Int']>>;
}


export interface MutationUserFollowArgs {
  followeeUserId: Scalars['Int'];
}


export interface MutationUserHobbyBatchUpdateArgs {
  hobbyIds: Array<Scalars['Int']>;
  userId: Scalars['Int'];
}


export interface MutationUserHobbyUpdateArgs {
  hobbyId: Scalars['Int'];
  userId: Scalars['Int'];
}


export interface MutationUserInfoEditModalUpdateArgs {
  input: UserInfoEditModalInput;
}


export interface MutationUserInfoHeaderUpdateArgs {
  input: UserInfoHeaderInput;
}


export interface MutationUserInfoWorkCircleFeedBackUpdateArgs {
  feedback: Scalars['Boolean'];
}


export interface MutationUserPinUpdateArgs {
  userId: Scalars['Int'];
}


export interface MutationUserSkillBatchUpdateArgs {
  skillIds: Array<Scalars['Int']>;
  userId: Scalars['Int'];
}


export interface MutationUserSkillUpdateArgs {
  skillId: Scalars['Int'];
  userId: Scalars['Int'];
}


export interface MutationUserUnfollowArgs {
  followeeUserId: Scalars['Int'];
}


export interface MutationViewerUpdateArgs {
  hasOnboarding?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  shouldBeAnnounced?: Maybe<Scalars['Boolean']>;
}


export interface MutationVisitPageArgs {
  userId: Scalars['Int'];
}


export interface MutationWebsiteAddArgs {
  websiteCreateInput: WebsiteCreateInput;
}


export interface MutationWebsiteCategoryAddArgs {
  websiteCategoryCreateInput: WebsiteCategoryCreateInput;
}


export interface MutationWebsiteCategoryUpdateArgs {
  websiteCategoryId: Scalars['Int'];
  websiteCategoryUpdateInput: WebsiteCategoryUpdateInput;
}


export interface MutationWebsiteDeleteArgs {
  websiteId: Scalars['Int'];
}


export interface MutationWebsiteUpdateArgs {
  websiteId: Scalars['Int'];
  websiteUpdateInput: WebsiteUpdateInput;
}

export interface Notification {
  __typename?: 'Notification';
  actionType: NotificationActionType;
  createdAt: Scalars['DateTime'];
  creators: Array<Maybe<User>>;
  message?: Maybe<NotificationMessage>;
  notificationId: Scalars['Int'];
  targetEntityId: Scalars['Int'];
  targetEntityType: NotificationTargetEntityType;
  updatedAt: Scalars['DateTime'];
}

export enum NotificationActionType {
  Comment = 'Comment',
  Create = 'Create',
  Feature = 'Feature',
  FeedBack = 'FeedBack',
  Follow = 'Follow',
  Interested = 'Interested',
  Invite = 'Invite',
  Like = 'Like',
  Mention = 'Mention',
  Notice = 'Notice',
  Participated = 'Participated',
  Share = 'Share',
  SkillAgree = 'SkillAgree',
  Useful = 'Useful'
}

export enum NotificationContentType {
  Comment = 'Comment',
  Event = 'Event',
  Mention = 'Mention',
  Post = 'Post',
  SkillAgree = 'SkillAgree'
}

export interface NotificationEdge {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String'];
  node: Notification;
}

export interface NotificationMessage {
  __typename?: 'NotificationMessage';
  content: Scalars['String'];
  phrase: Scalars['String'];
  targetId?: Maybe<Scalars['String']>;
  targetKind?: Maybe<Scalars['String']>;
}

export enum NotificationOutletType {
  Browser = 'Browser',
  Email = 'Email',
  Wechat = 'Wechat'
}

export interface NotificationPaginated {
  __typename?: 'NotificationPaginated';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface NotificationSetting {
  __typename?: 'NotificationSetting';
  contentType: NotificationContentType;
  createdAt: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  notificationSettingId: Scalars['Int'];
  outletType: NotificationOutletType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
}

export enum NotificationTargetEntityType {
  Comment = 'Comment',
  Event = 'Event',
  Feature = 'Feature',
  Follow = 'Follow',
  Group = 'Group',
  GroupMemberRequest = 'GroupMemberRequest',
  Mention = 'Mention',
  Post = 'Post',
  User = 'User'
}

export interface OkrCycle {
  __typename?: 'OKRCycle';
  cycleId: Scalars['Int'];
  endAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startAt?: Maybe<Scalars['String']>;
}

export interface OkrDepartment {
  __typename?: 'OKRDepartment';
  id: Scalars['Int'];
  name: Scalars['String'];
  relatedDepartments: Array<OkrDepartment>;
}

export interface OkrNote {
  __typename?: 'OKRNote';
  content: Scalars['String'];
  objectiveNoteId: Scalars['Int'];
  type: Scalars['Int'];
}

export enum OkrTypeEnums {
  Company = 'COMPANY',
  Cooperating = 'COOPERATING',
  Departmental = 'DEPARTMENTAL',
  Personal = 'PERSONAL'
}

export interface OkrUser {
  __typename?: 'OKRUser';
  alias: Scalars['String'];
  avatar: Scalars['String'];
  departments: Array<OkrDepartment>;
  email: Scalars['String'];
  gender: Scalars['String'];
  iamId: Scalars['Int'];
  name: Scalars['String'];
}

export interface Objective {
  __typename?: 'Objective';
  creatorUserId: Scalars['Int'];
  cycleId: Scalars['Int'];
  department?: Maybe<OkrDepartment>;
  departmentId: Scalars['Int'];
  krs: Array<KeyResult>;
  name: Scalars['String'];
  note?: Maybe<OkrNote>;
  objectiveId: Scalars['Int'];
  parent?: Maybe<Objective>;
  parentId?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  user?: Maybe<OkrUser>;
}

export interface ObjectivesPaginatedFeature {
  __typename?: 'ObjectivesPaginatedFeature';
  objectives: Array<Objective>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
}

export interface PageInfo {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
}

export interface PaginationInput {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
}

export interface PhotoIdValueVisibility {
  __typename?: 'PhotoIdValueVisibility';
  isVisible: Scalars['Boolean'];
  value?: Maybe<Scalars['Int']>;
}

export interface PhotoIdValueVisibilityInput {
  isVisible: Scalars['Boolean'];
  value?: Maybe<Scalars['Int']>;
}

export interface Post {
  __typename?: 'Post';
  announcement?: Maybe<Announcement>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  comment: Comment;
  commentCount: Scalars['Int'];
  comments: CommentsPaginated;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 匿名返回 null */
  creator?: Maybe<User>;
  descendantPosts?: Maybe<PostsPaginated>;
  event?: Maybe<Event>;
  featuredAt?: Maybe<Scalars['DateTime']>;
  feltUsefulUsers: UsersPaginated;
  files: Array<File>;
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['Int']>;
  honor?: Maybe<Honor>;
  impact: Scalars['Float'];
  isAnonymous: Scalars['Boolean'];
  isCommentDisplayable?: Maybe<Scalars['Boolean']>;
  isFavored: Scalars['Boolean'];
  isFeaturedTop?: Maybe<Scalars['Boolean']>;
  isMarkdown: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  isUseful: Scalars['Boolean'];
  /** 是否为 viewer 创建，为了匿名 post 上不返回 creatorUserId */
  isViewerCreated: Scalars['Boolean'];
  liked: Scalars['Boolean'];
  likedCount: Scalars['Int'];
  likedUsers: UsersPaginated;
  links: Array<PostLink>;
  mentions: Array<Mention>;
  originalPost?: Maybe<Post>;
  originalPostId?: Maybe<Scalars['Int']>;
  postId: Scalars['Int'];
  postType: PostType;
  readCount: Scalars['Int'];
  readUsers: UsersPaginated;
  receiver?: Maybe<User>;
  recommendPostInfo: RecommendPostInfo;
  sectionId?: Maybe<SectionType>;
  sharedCount: Scalars['Int'];
  sharedUsers: UsersPaginated;
  tags: Array<PostTagType>;
  updatedAt: Scalars['DateTime'];
  usefulCount: Scalars['Int'];
}


export interface PostCommentArgs {
  commentId: Scalars['Int'];
}


export interface PostCommentsArgs {
  pagination: PaginationInput;
}


export interface PostDescendantPostsArgs {
  pagination: PaginationInput;
}


export interface PostFeltUsefulUsersArgs {
  pagination: PaginationInput;
}


export interface PostLikedUsersArgs {
  pagination: PaginationInput;
}


export interface PostReadUsersArgs {
  pagination: PaginationInput;
}


export interface PostSharedUsersArgs {
  pagination: PaginationInput;
}

export interface PostEdge {
  __typename?: 'PostEdge';
  cursor: Scalars['String'];
  node: Post;
}

export interface PostLink {
  __typename?: 'PostLink';
  description: Scalars['String'];
  logo: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
}

export enum PostTagType {
  Entertainment = 'Entertainment',
  TechShare = 'TechShare',
  WorkProcess = 'WorkProcess'
}

export enum PostType {
  Announcement = 'Announcement',
  Event = 'Event',
  Forum = 'Forum',
  General = 'General',
  Honor = 'Honor',
  Introduction = 'Introduction',
  Journal = 'Journal',
  Thanks = 'Thanks'
}

export interface PostsPaginated {
  __typename?: 'PostsPaginated';
  edges: Array<PostEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface Project {
  __typename?: 'Project';
  completePercentage: Scalars['Float'];
  delayDate?: Maybe<Scalars['Int']>;
  endTime: Scalars['String'];
  health?: Maybe<Scalars['String']>;
  industry: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  ownerUser?: Maybe<User>;
  priority?: Maybe<Scalars['String']>;
  progress: Scalars['Float'];
  projectId: Scalars['String'];
  projectRole: Scalars['String'];
  scene: Scalars['String'];
  stage: Scalars['String'];
  startTime: Scalars['String'];
  status: Scalars['String'];
  url: Scalars['String'];
}

export interface Query {
  __typename?: 'Query';
  anniversaryCard: AnniversaryCard;
  anniversaryCardSet: AnniversaryCardSet;
  announcement: Announcement;
  announcementPosts: PostsPaginated;
  appState: AppState;
  banner: Banner;
  banners: BannerPaginated;
  basicProfile: BasicProfile;
  chatGpt: ChatGpt;
  chatgptGroup: ChatGptGroup;
  chatgptGroups: Array<ChatGptGroup>;
  claude: Claude;
  cycles: Array<OkrCycle>;
  department: Department;
  departments: Array<Department>;
  event: Event;
  events: EventPaginated;
  featureToggles: Array<FeatureToggle>;
  featured: Featured;
  follow: Follow;
  group: Group;
  groupCategories: Array<GroupCategory>;
  groupMemberRequest: GroupMemberRequest;
  groups: GroupsPaginated;
  hobbies: Array<Hobby>;
  hobby: Hobby;
  honor: Honor;
  honors: HonorPaginated;
  knowledge: KnowledgeNs;
  objectivesFeature: ObjectivesPaginatedFeature;
  post: Post;
  recommend: Recommend;
  search: Search;
  searchState: SearchState;
  section: Section;
  sections: Array<Section>;
  skill: Skill;
  skills: Array<Skill>;
  statistics: Statistics;
  user: User;
  users: UsersPaginated;
  viewer: User;
  website: WebsiteNs;
}


export interface QueryAnniversaryCardArgs {
  anniversaryCardId: Scalars['Int'];
}


export interface QueryAnniversaryCardSetArgs {
  anniversary: Scalars['String'];
  creatorUserId: Scalars['Int'];
  hrbpEmail?: Maybe<Scalars['String']>;
  leaderEmail: Scalars['String'];
  pagination: PaginationInput;
}


export interface QueryAnnouncementArgs {
  announcementId: Scalars['Int'];
}


export interface QueryAnnouncementPostsArgs {
  pagination: PaginationInput;
}


export interface QueryBannerArgs {
  bannerId: Scalars['Int'];
}


export interface QueryBannersArgs {
  pagination: PaginationInput;
}


export interface QueryBasicProfileArgs {
  userId: Scalars['Int'];
}


export interface QueryChatGptArgs {
  input: ChatGptInput;
}


export interface QueryChatgptGroupArgs {
  chatgptGroupId: Scalars['Int'];
}


export interface QueryClaudeArgs {
  input: Scalars['String'];
}


export interface QueryDepartmentArgs {
  departmentId: Scalars['Int'];
}


export interface QueryDepartmentsArgs {
  filter: GetDepartmentsFilter;
}


export interface QueryEventArgs {
  eventId: Scalars['Int'];
}


export interface QueryEventsArgs {
  endDate: Scalars['String'];
  pagination: PaginationInput;
  startDate: Scalars['String'];
}


export interface QueryGroupArgs {
  groupId: Scalars['Int'];
}


export interface QueryGroupMemberRequestArgs {
  requestId: Scalars['Int'];
}


export interface QueryGroupsArgs {
  filter: GetGroupsFilter;
  pagination: PaginationInput;
}


export interface QueryHobbiesArgs {
  input: HobbyInput;
  userId: Scalars['Int'];
}


export interface QueryHobbyArgs {
  hobbyId: Scalars['Int'];
}


export interface QueryHonorArgs {
  honorId: Scalars['Int'];
}


export interface QueryHonorsArgs {
  pagination: PaginationInput;
}


export interface QueryObjectivesFeatureArgs {
  cycleId: Scalars['Int'];
  type: OkrTypeEnums;
  userId: Scalars['Int'];
}


export interface QueryPostArgs {
  postId: Scalars['Int'];
}


export interface QuerySectionArgs {
  sectionId: SectionType;
}


export interface QuerySectionsArgs {
  sectionIds: Array<SectionType>;
}


export interface QuerySkillArgs {
  skillId: Scalars['Int'];
}


export interface QuerySkillsArgs {
  input: SkillInput;
  userId: Scalars['Int'];
}


export interface QueryUserArgs {
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
}


export interface QueryUsersArgs {
  filter: GetUsersFilter;
  pagination: PaginationInput;
}


export interface QueryViewerArgs {
  isInitialLoad?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
}

export interface Recommend {
  __typename?: 'Recommend';
  banners: BannerPaginated;
  featuredGroups: Array<Group>;
  featuredPosts: PostsPaginated;
  groups: Array<Group>;
  onboardingRecommendedGroups: Array<Group>;
  onboardingRecommendedUsers: Array<User>;
  recommendedPosts: PostsPaginated;
  selectorsRecommendedGroups: Array<Group>;
  topFeaturedPosts?: Maybe<Post>;
  trendingGroups: GroupsPaginated;
  trendingPosts: PostsPaginated;
  trendingUsers: Array<User>;
  users: Array<User>;
  usersRankedByLikes: UsersPaginated;
}


export interface RecommendBannersArgs {
  pagination: PaginationInput;
}


export interface RecommendFeaturedGroupsArgs {
  categoryId?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
}


export interface RecommendFeaturedPostsArgs {
  pagination: PaginationInput;
}


export interface RecommendGroupsArgs {
  isOnboarding?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
}


export interface RecommendOnboardingRecommendedGroupsArgs {
  isOnboarding?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
}


export interface RecommendOnboardingRecommendedUsersArgs {
  isOnboarding?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
}


export interface RecommendRecommendedPostsArgs {
  pagination: PaginationInput;
  postId: Scalars['Int'];
}


export interface RecommendTrendingGroupsArgs {
  pagination: PaginationInput;
  timeSpan?: Maybe<Scalars['Int']>;
}


export interface RecommendTrendingPostsArgs {
  pagination: PaginationInput;
  timeSpan?: Maybe<Scalars['Int']>;
}


export interface RecommendTrendingUsersArgs {
  isOnboarding?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
}


export interface RecommendUsersArgs {
  isOnboarding?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
}


export interface RecommendUsersRankedByLikesArgs {
  pagination: PaginationInput;
  timeSpan?: Maybe<Scalars['Int']>;
}

export interface RecommendPostInfo {
  __typename?: 'RecommendPostInfo';
  commentFolloweeIds: Array<Scalars['Int']>;
  commentFollowees: Array<User>;
  likedFolloweeIds: Array<Scalars['Int']>;
  likedFollowees: Array<User>;
}

export enum Resource {
  Group = 'Group',
  GroupAdmin = 'GroupAdmin',
  SystemAdmin = 'SystemAdmin',
  User = 'User'
}

export enum Role {
  GroupAdmin = 'GroupAdmin',
  RootAdmin = 'RootAdmin',
  SystemAdmin = 'SystemAdmin',
  User = 'User'
}

export interface Search {
  __typename?: 'Search';
  contents: SearchResult;
  suggestions: SearchSuggestions;
  urlMetaData: SearchUrlMetaData;
}


export interface SearchContentsArgs {
  count?: Maybe<Scalars['Int']>;
  docSource: Array<Scalars['String']>;
  docType: Array<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  page: Scalars['Int'];
  search: Scalars['String'];
}


export interface SearchSuggestionsArgs {
  count?: Maybe<Scalars['Int']>;
  search: Scalars['String'];
}


export interface SearchUrlMetaDataArgs {
  url: Scalars['String'];
}

export interface SearchFacet {
  __typename?: 'SearchFacet';
  name: Scalars['String'];
  showName: Scalars['String'];
  values: Array<SearchFacetValue>;
}

export interface SearchFacetValue {
  __typename?: 'SearchFacetValue';
  count: Scalars['Float'];
  selected: Scalars['Boolean'];
  value: Scalars['String'];
}

export interface SearchItem {
  __typename?: 'SearchItem';
  author?: Maybe<Scalars['String']>;
  authorUser?: Maybe<User>;
  body?: Maybe<Scalars['String']>;
  contentId: Scalars['Int'];
  docQuality: Scalars['Float'];
  docSource: Scalars['String'];
  docType: Array<Scalars['String']>;
  favouriteCount: Scalars['Float'];
  id: Scalars['String'];
  keywordSuggest: Scalars['String'];
  lastModDate?: Maybe<Scalars['Timestamp']>;
  likeCount: Scalars['String'];
  name: Scalars['String'];
  redirectLink: Scalars['String'];
  spaceId: Scalars['Float'];
  spaceName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}

export interface SearchResult {
  __typename?: 'SearchResult';
  facets: Array<SearchFacet>;
  items: Array<SearchItem>;
  total: Scalars['Int'];
}

export interface SearchState {
  __typename?: 'SearchState';
  search: Scalars['String'];
  input: Scalars['String'];
}

export interface SearchSuggestion {
  __typename?: 'SearchSuggestion';
  id: Scalars['Int'];
  keyword: Scalars['String'];
  type: Scalars['String'];
}

export interface SearchSuggestionField {
  __typename?: 'SearchSuggestionField';
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface SearchSuggestionUser {
  __typename?: 'SearchSuggestionUser';
  fields: Array<SearchSuggestionField>;
  id: Scalars['Int'];
  keyword: Scalars['String'];
  type: Scalars['String'];
  user?: Maybe<User>;
}

export interface SearchSuggestions {
  __typename?: 'SearchSuggestions';
  confluence: Array<SearchSuggestion>;
  groups: Array<SearchSuggestion>;
  users: Array<SearchSuggestionUser>;
}

export interface SearchUrlMetaData {
  __typename?: 'SearchUrlMetaData';
  description?: Maybe<Scalars['String']>;
  failedReason?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
}

export interface Section {
  __typename?: 'Section';
  createdAt: Scalars['DateTime'];
  hasUnread: Scalars['Boolean'];
  name: Scalars['String'];
  posts: PostsPaginated;
  sectionId: SectionType;
  topPost?: Maybe<Post>;
  updatedAt: Scalars['DateTime'];
}


export interface SectionPostsArgs {
  filter: GetPostsFilter;
  pagination: PaginationInput;
}

export enum SectionType {
  Entertainment = 'Entertainment',
  NewAgoran = 'NewAgoran',
  Null = 'Null',
  Synthesis = 'Synthesis'
}

export interface SetBannerInput {
  bannerId: Scalars['Int'];
  index: Scalars['Int'];
  link?: Maybe<Scalars['String']>;
}

export interface SharePostInput {
  content: Scalars['String'];
  event?: Maybe<CreateEventInput>;
  fileIds?: Maybe<Array<Scalars['Int']>>;
  groupId?: Maybe<Scalars['Int']>;
  honor?: Maybe<CreateHonorInput>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isMarkdown?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<CreatePostLinkInput>>;
  originalPostId: Scalars['Int'];
  postType?: Maybe<PostType>;
  receiverUserId?: Maybe<Scalars['Int']>;
  sectionId?: Maybe<SectionType>;
}

export interface Skill {
  __typename?: 'Skill';
  evaluatedUsers?: Maybe<UsersPaginated>;
  name: Scalars['String'];
  skillId: Scalars['Int'];
}


export interface SkillEvaluatedUsersArgs {
  pagination: PaginationInput;
  userId: Scalars['Int'];
}

export interface SkillEdge {
  __typename?: 'SkillEdge';
  cursor: Scalars['String'];
  node: Skill;
}

export interface SkillInput {
  search?: Maybe<Scalars['String']>;
  top?: Maybe<Scalars['Int']>;
}

export interface SkillsPaginated {
  __typename?: 'SkillsPaginated';
  edges: Array<SkillEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface StatisticCentralTendencyImpactValue {
  __typename?: 'StatisticCentralTendencyImpactValue';
  date?: Maybe<Scalars['String']>;
  mean: Scalars['Float'];
  median: Scalars['Float'];
  mode: Scalars['Float'];
}

export interface StatisticFeaturedJournalTrendValue {
  __typename?: 'StatisticFeaturedJournalTrendValue';
  count: Scalars['Int'];
  date: Scalars['String'];
}

export interface StatisticFeaturedJournalValue {
  __typename?: 'StatisticFeaturedJournalValue';
  count: Scalars['Int'];
  url: Scalars['String'];
}

export interface StatisticImpactValue {
  __typename?: 'StatisticImpactValue';
  date: Scalars['DateTime'];
  email: Scalars['String'];
  impact: Scalars['Float'];
  name: Scalars['String'];
  userId: Scalars['Int'];
}

export interface StatisticInput {
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  week?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
}

export interface StatisticPostContentTagValue {
  __typename?: 'StatisticPostContentTagValue';
  data: Array<StatisticPostContentTypeBasicValue>;
  date?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
  yearMonth?: Maybe<Scalars['String']>;
  yearWeek?: Maybe<Scalars['String']>;
}

export interface StatisticPostContentTypeBasicValue {
  __typename?: 'StatisticPostContentTypeBasicValue';
  count: Scalars['Int'];
  tag: PostTagType;
  tagName: Scalars['String'];
}

export interface StatisticUserValue {
  __typename?: 'StatisticUserValue';
  beenVisitedCount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  interactionCount?: Maybe<Scalars['Int']>;
  landingCount?: Maybe<Scalars['Int']>;
  landingDayCount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  postingCount?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  visitCount?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['String']>;
  yearMonth?: Maybe<Scalars['String']>;
}

export interface StatisticValue {
  __typename?: 'StatisticValue';
  date?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
  year?: Maybe<Scalars['String']>;
  yearMonth?: Maybe<Scalars['String']>;
  yearWeek?: Maybe<Scalars['String']>;
}

export interface Statistics {
  __typename?: 'Statistics';
  contributedImpact: Array<StatisticCentralTendencyImpactValue>;
  featuredJournalData?: Maybe<Array<StatisticFeaturedJournalValue>>;
  featuredJournalTrendData?: Maybe<Array<StatisticFeaturedJournalTrendValue>>;
  featuredJournalVisitorCount: Scalars['Int'];
  impact: Array<StatisticCentralTendencyImpactValue>;
  landingCount: Array<StatisticValue>;
  landingPeopleCount: Array<StatisticValue>;
  landingRate: Array<StatisticValue>;
  peopleCount: Array<StatisticValue>;
  postContentTagPercentage: StatisticPostContentTagValue;
  postContentTagTrend: Array<StatisticPostContentTagValue>;
  postingRate: Array<StatisticValue>;
  postsCount: Array<StatisticValue>;
  userInfo: Array<StatisticUserValue>;
  userPageVisitsTotalCount: Scalars['Int'];
  userPageVisitsYesterdayCount: Scalars['Int'];
  weeklyLandingPeopleCount: Array<StatisticValue>;
  weeklyPostsCount: Array<StatisticValue>;
  yesterdayImpact: Array<StatisticImpactValue>;
}


export interface StatisticsContributedImpactArgs {
  input: StatisticInput;
}


export interface StatisticsFeaturedJournalDataArgs {
  endTime: Scalars['String'];
  session: Scalars['Int'];
  startTime: Scalars['String'];
}


export interface StatisticsFeaturedJournalTrendDataArgs {
  endTime: Scalars['String'];
  session: Scalars['Int'];
  startTime: Scalars['String'];
}


export interface StatisticsFeaturedJournalVisitorCountArgs {
  session: Scalars['Int'];
}


export interface StatisticsImpactArgs {
  input: StatisticInput;
}


export interface StatisticsLandingCountArgs {
  input: StatisticInput;
}


export interface StatisticsLandingPeopleCountArgs {
  input: StatisticInput;
}


export interface StatisticsLandingRateArgs {
  input: StatisticInput;
}


export interface StatisticsPeopleCountArgs {
  input: StatisticInput;
}


export interface StatisticsPostContentTagPercentageArgs {
  input: StatisticInput;
}


export interface StatisticsPostContentTagTrendArgs {
  input: StatisticInput;
}


export interface StatisticsPostingRateArgs {
  input: StatisticInput;
}


export interface StatisticsPostsCountArgs {
  input: StatisticInput;
}


export interface StatisticsUserInfoArgs {
  input: StatisticInput;
}


export interface StatisticsWeeklyLandingPeopleCountArgs {
  input: StatisticInput;
}


export interface StatisticsWeeklyPostsCountArgs {
  input: StatisticInput;
}

export interface Subscription {
  __typename?: 'Subscription';
  commentAdded: Comment;
  commentDeleted: Comment;
  commentUpdated: Comment;
  groupAdded: Group;
  groupMemeberRequestChanged: Group;
  groupUpdated: Group;
  notificationCountChanged: Scalars['Int'];
  postAdded: Post;
  postDeleted: Scalars['Int'];
  postUpdated: Post;
  sectionUnreadUpdate: Section;
  userUpdated: User;
}


export interface SubscriptionCommentAddedArgs {
  postId: Scalars['Int'];
}


export interface SubscriptionCommentDeletedArgs {
  postId: Scalars['Int'];
}


export interface SubscriptionCommentUpdatedArgs {
  postId: Scalars['Int'];
}


export interface SubscriptionGroupMemeberRequestChangedArgs {
  groupId: Scalars['Int'];
}


export interface SubscriptionGroupUpdatedArgs {
  groupId: Scalars['Int'];
}


export interface SubscriptionPostAddedArgs {
  groupId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
}


export interface SubscriptionPostUpdatedArgs {
  postId: Scalars['Int'];
}


export interface SubscriptionSectionUnreadUpdateArgs {
  sectionId: SectionType;
}


export interface SubscriptionUserUpdatedArgs {
  userId: Scalars['Int'];
}


export interface UpdateAnnouncementInput {
  announcementId: Scalars['Int'];
  content?: Maybe<Scalars['String']>;
  fileIds?: Maybe<Array<Scalars['Int']>>;
  postId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<AnnouncementType>;
}

export interface UpdateChatGptGroupInput {
  chatgptGroupId: Scalars['Int'];
  name: Scalars['String'];
}

export interface UpdateCommentInput {
  commentId: Scalars['Int'];
  content: Scalars['String'];
}

export interface UpdateGroupInput {
  canPostAnonymously?: Maybe<Scalars['Boolean']>;
  canUnfollow?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  groupCategoryId?: Maybe<Scalars['Int']>;
  isOfficial?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pmoProjectId?: Maybe<Scalars['String']>;
  privateSetting?: Maybe<GroupPrivateSetting>;
  whoCanPost?: Maybe<WhoCanPost>;
}

export interface UpdateKnowledgeGroupInput {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentIds?: Maybe<Array<Scalars['Int']>>;
}

export interface UpdateKnowledgePostInput {
  authorId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fileIds?: Maybe<Array<Scalars['Int']>>;
  knowledgeGroupId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

export interface UpdateNotificationSettingInput {
  isActive: Scalars['Boolean'];
}

export interface UpdatePostInput {
  content?: Maybe<Scalars['String']>;
  event?: Maybe<CreateEventInput>;
  fileIds?: Maybe<Array<Scalars['Int']>>;
  groupId?: Maybe<Scalars['Int']>;
  honor?: Maybe<CreateHonorInput>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isMarkdown?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<CreatePostLinkInput>>;
  postType?: Maybe<PostType>;
  receiverUserId?: Maybe<Scalars['Int']>;
  sectionId?: Maybe<SectionType>;
}

export interface UpsertChatGptGroupMessageInput {
  chatgptGroupId: Scalars['Int'];
  content: Scalars['String'];
  createdTime: Scalars['String'];
  msgId?: Maybe<Scalars['Int']>;
  role: ChatGptMessageRoleEnum;
}

export interface User {
  __typename?: 'User';
  activeGroups: Array<Group>;
  alias: Scalars['String'];
  allPosts: PostsPaginated;
  anniversaryCards?: Maybe<Array<AnniversaryCard>>;
  anniversaryCardSet?: Maybe<AnniversaryCardSet>;
  annualReport: AnnualReport;
  anonymousCount: Scalars['Int'];
  avatarUrl: Scalars['String'];
  basicProfile: BasicProfile;
  businessPartner?: Maybe<User>;
  careerProfile: Array<CareerProfile>;
  chatgptTokens: Scalars['Int'];
  colleagues: Array<User>;
  commentedPosts: PostsPaginated;
  companyProfile: CompanyProfile;
  contributedImpact: Scalars['Float'];
  contributedKnowledge?: Maybe<KnowledgePostPaginated>;
  createdAt: Scalars['DateTime'];
  createdGroups: GroupsPaginated;
  createdPosts: PostsPaginated;
  currentCycle?: Maybe<OkrCycle>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  departments: Array<Department>;
  email: Scalars['String'];
  favoredKnowledgeGroups?: Maybe<Array<KnowledgeGroup>>;
  favoredPosts: PostsPaginated;
  featuredPosts: PostsPaginated;
  files: FilesPaginated;
  finishedEvents?: Maybe<EventPaginated>;
  followedUsers: UsersPaginated;
  followingGroups: GroupsPaginated;
  followingPosts: PostsPaginated;
  followingUsers: UsersPaginated;
  gender: Scalars['String'];
  hasOnboarding: Scalars['Boolean'];
  hasUnReadEvent: Scalars['Boolean'];
  hireDate?: Maybe<Scalars['DateTime']>;
  hobbies?: Maybe<HobbyPaginated>;
  hrbpRelatedLeaders?: Maybe<Array<User>>;
  impact: Scalars['Float'];
  isAnniversaryCardCreator: Scalars['Boolean'];
  isAnniversaryCardValidator: Scalars['Boolean'];
  isFollowing: Scalars['Boolean'];
  isFollowingEachOther: Scalars['Boolean'];
  isPinned: Scalars['Boolean'];
  journalProjects: Array<Scalars['String']>;
  language: Scalars['String'];
  latestAnniversary?: Maybe<Scalars['String']>;
  leaders: Array<User>;
  likedCount: Scalars['Int'];
  likedPosts: PostsPaginated;
  mobile: Scalars['String'];
  name: Scalars['String'];
  notification: Notification;
  notifications: NotificationPaginated;
  notificationSettings: Array<NotificationSetting>;
  objectivesFeature?: Maybe<ObjectivesPaginatedFeature>;
  permissions: Array<UserPermission>;
  projects: Array<Project>;
  requestedAnniversary?: Maybe<Scalars['String']>;
  roles: Array<UserRole>;
  shouldBeAnnounced: Scalars['Boolean'];
  skills?: Maybe<SkillsPaginated>;
  thanksPosts: PostsPaginated;
  timelineEvents: UserTimelineEventPaginated;
  unStartEvents?: Maybe<EventPaginated>;
  updatedAt: Scalars['DateTime'];
  userfulPosts: PostsPaginated;
  userId: Scalars['Int'];
  viewedUsers: UsersPaginated;
  workCircle: WorkCircle;
  yesterdayImpact: Scalars['Float'];
  yesterdayVisitors: UsersPaginated;
}


export interface UserActiveGroupsArgs {
  limit: Scalars['Float'];
}


export interface UserAllPostsArgs {
  filter: GetPostsFilter;
  pagination: PaginationInput;
}


export interface UserAnniversaryCardsArgs {
  anniversary?: Maybe<Scalars['String']>;
}


export interface UserAnniversaryCardSetArgs {
  anniversary: Scalars['String'];
  creatorUserId: Scalars['Int'];
  hrbpEmail?: Maybe<Scalars['String']>;
  leaderEmail: Scalars['String'];
  pagination: PaginationInput;
}


export interface UserBusinessPartnerArgs {
  role: DepartmentRole;
}


export interface UserCommentedPostsArgs {
  pagination: PaginationInput;
}


export interface UserContributedKnowledgeArgs {
  pagination: PaginationInput;
}


export interface UserCreatedGroupsArgs {
  filter: GetGroupsFilter;
  pagination: PaginationInput;
}


export interface UserCreatedPostsArgs {
  filter: GetPostsFilter;
  pagination: PaginationInput;
}


export interface UserFavoredPostsArgs {
  pagination: PaginationInput;
}


export interface UserFeaturedPostsArgs {
  pagination: PaginationInput;
}


export interface UserFilesArgs {
  fileIds?: Maybe<Array<Scalars['Int']>>;
  pagination: PaginationInput;
}


export interface UserFinishedEventsArgs {
  pagination: PaginationInput;
}


export interface UserFollowedUsersArgs {
  filter: GetUsersFilter;
  pagination: PaginationInput;
}


export interface UserFollowingGroupsArgs {
  filter: GetGroupsFilter;
  pagination: PaginationInput;
}


export interface UserFollowingPostsArgs {
  filter: GetPostsFilter;
  pagination: PaginationInput;
  useRecommendation?: Maybe<Scalars['Boolean']>;
}


export interface UserFollowingUsersArgs {
  filter: GetUsersFilter;
  isPinned?: Maybe<Scalars['Boolean']>;
  pagination: PaginationInput;
}


export interface UserHobbiesArgs {
  pagination: PaginationInput;
  userId: Scalars['Int'];
}


export interface UserLikedPostsArgs {
  pagination: PaginationInput;
}


export interface UserNotificationArgs {
  notificationId: Scalars['Int'];
}


export interface UserNotificationsArgs {
  isRead?: Maybe<Scalars['Boolean']>;
  pagination: PaginationInput;
}


export interface UserSkillsArgs {
  pagination: PaginationInput;
  selfCreated?: Maybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
}


export interface UserThanksPostsArgs {
  pagination: PaginationInput;
}


export interface UserTimelineEventsArgs {
  pagination: PaginationInput;
  type: Scalars['String'];
}


export interface UserUnStartEventsArgs {
  pagination: PaginationInput;
}


export interface UserUserfulPostsArgs {
  pagination: PaginationInput;
}


export interface UserViewedUsersArgs {
  pagination: PaginationInput;
}


export interface UserYesterdayVisitorsArgs {
  pagination: PaginationInput;
}

export interface UserEdge {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: User;
}

export interface UserInfoAboutMePartInput {
  aboutMe?: Maybe<Scalars['String']>;
  github?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
}

export interface UserInfoEditModalInput {
  aboutMe?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  github?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  seatNumber?: Maybe<Scalars['String']>;
}

export interface UserInfoHeaderInput {
  address?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  seatNumber?: Maybe<Scalars['String']>;
}

export interface UserPermission {
  __typename?: 'UserPermission';
  action: Scalars['String'];
  resource: Resource;
}

export interface UserRole {
  __typename?: 'UserRole';
  groupId?: Maybe<Scalars['Int']>;
  role: Role;
}

export enum UserTimelineActionType {
  AnniversaryReceive = 'ANNIVERSARY_RECEIVE',
  PostCreate = 'POST_CREATE',
  PostEventInterest = 'POST_EVENT_INTEREST',
  PostEventInvited = 'POST_EVENT_INVITED',
  PostEventParticipate = 'POST_EVENT_PARTICIPATE',
  PostHonorParticipate = 'POST_HONOR_PARTICIPATE',
  PostHonorSignificant = 'POST_HONOR_SIGNIFICANT',
  PostThankReceive = 'POST_THANK_RECEIVE'
}

export type UserTimelineEntity = AnniversaryCard | Post;

export interface UserTimelineEvent {
  __typename?: 'UserTimelineEvent';
  actionType: UserTimelineActionType;
  createdAt: Scalars['DateTime'];
  entity?: Maybe<UserTimelineEntity>;
  entityId: Scalars['Float'];
  userTimelineEventId: Scalars['Float'];
}

export interface UserTimelineEventEdge {
  __typename?: 'UserTimelineEventEdge';
  cursor: Scalars['String'];
  node: UserTimelineEvent;
}

export interface UserTimelineEventPaginated {
  __typename?: 'UserTimelineEventPaginated';
  edges: Array<UserTimelineEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface UsersPaginated {
  __typename?: 'UsersPaginated';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface ValueVisibility {
  __typename?: 'ValueVisibility';
  isVisible: Scalars['Boolean'];
  value: Scalars['String'];
}

export interface ValueVisibilityInput {
  isVisible: Scalars['Boolean'];
  value: Scalars['String'];
}

export interface Website {
  __typename?: 'Website';
  description: Scalars['String'];
  faviconUrl?: Maybe<Scalars['String']>;
  isCommon: Scalars['Boolean'];
  maintainers: Array<User>;
  title: Scalars['String'];
  url: Scalars['String'];
  websiteCategoryId: Scalars['Int'];
  websiteId: Scalars['Int'];
}

export interface WebsiteCategory {
  __typename?: 'WebsiteCategory';
  title: Scalars['String'];
  websiteCategoryId: Scalars['Int'];
  websites: WebsitePaginated;
}


export interface WebsiteCategoryWebsitesArgs {
  pagination: PaginationInput;
}

export interface WebsiteCategoryCreateInput {
  title: Scalars['String'];
}

export interface WebsiteCategoryEdge {
  __typename?: 'WebsiteCategoryEdge';
  cursor: Scalars['String'];
  node: WebsiteCategory;
}

export interface WebsiteCategoryPaginated {
  __typename?: 'WebsiteCategoryPaginated';
  edges: Array<WebsiteCategoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface WebsiteCategoryUpdateInput {
  title?: Maybe<Scalars['String']>;
}

export interface WebsiteCreateInput {
  description?: Maybe<Scalars['String']>;
  maintainerUserIds: Array<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
  websiteCategoryId: Scalars['Int'];
}

export interface WebsiteEdge {
  __typename?: 'WebsiteEdge';
  cursor: Scalars['String'];
  node: Website;
}

export interface WebsiteNs {
  __typename?: 'WebsiteNS';
  categories: WebsiteCategoryPaginated;
  category: WebsiteCategory;
  entities: WebsitePaginated;
  entity: Website;
}


export interface WebsiteNsCategoriesArgs {
  pagination: PaginationInput;
}


export interface WebsiteNsCategoryArgs {
  websiteCategoryId: Scalars['Int'];
}


export interface WebsiteNsEntitiesArgs {
  isCommon?: Maybe<Scalars['Boolean']>;
  pagination: PaginationInput;
  websiteCategoryId?: Maybe<Scalars['Int']>;
}


export interface WebsiteNsEntityArgs {
  websiteId: Scalars['Int'];
}

export interface WebsitePaginated {
  __typename?: 'WebsitePaginated';
  edges: Array<WebsiteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface WebsiteUpdateInput {
  description?: Maybe<Scalars['String']>;
  maintainerUserIds?: Maybe<Array<Scalars['Int']>>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  websiteCategoryId?: Maybe<Scalars['Int']>;
}

export enum WhoCanPost {
  Admin = 'Admin',
  Anyone = 'Anyone',
  Member = 'Member'
}

export interface WorkCircle {
  __typename?: 'WorkCircle';
  status: WorkCircleStatus;
  users: Array<Array<User>>;
}

export enum WorkCircleStatus {
  Fail = 'Fail',
  Success = 'Success',
  Update = 'Update'
}

export type GetGroupCardInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetGroupCardInfoQuery = { __typename?: 'Query', group: (
    { __typename?: 'Group', isFollowing: boolean, isPinned: boolean, creator: { __typename?: 'User', userId: number, name: string, avatarUrl: string, departments: Array<{ __typename?: 'Department', departmentId: number, name: string }> }, followers: { __typename?: 'UsersPaginated', totalCount: number }, posts: { __typename?: 'PostsPaginated', totalCount: number } }
    & RequestedGroupFragment
  ) };

export type RequestedGroupsPaginatedFragment = { __typename?: 'GroupsPaginated', totalCount: number, pageInfo: (
    { __typename?: 'PageInfo' }
    & RequestedPageInfoFragment
  ), edges: Array<{ __typename?: 'GroupEdge', node: (
      { __typename?: 'Group', creator: { __typename?: 'User', userId: number } }
      & RequestedGroupFragment
    ) }> };

export type GetGroupListQueryVariables = Exact<{
  userId: Scalars['Int'];
  pagination: PaginationInput;
  filter: GetGroupsFilter;
  withViewer?: Maybe<Scalars['Boolean']>;
  withUser?: Maybe<Scalars['Boolean']>;
  withFollowing?: Maybe<Scalars['Boolean']>;
  withCreated?: Maybe<Scalars['Boolean']>;
  withActive?: Maybe<Scalars['Boolean']>;
}>;


export type GetGroupListQuery = { __typename?: 'Query', viewer: Maybe<{ __typename?: 'User', userId: number, activeGroups: Maybe<Array<(
      { __typename?: 'Group' }
      & RequestedGroupFragment
    )>>, followingGroups: Maybe<(
      { __typename?: 'GroupsPaginated' }
      & RequestedGroupsPaginatedFragment
    )>, createdGroups: Maybe<(
      { __typename?: 'GroupsPaginated' }
      & RequestedGroupsPaginatedFragment
    )> }>, user: Maybe<{ __typename?: 'User', userId: number, followingGroups: Maybe<(
      { __typename?: 'GroupsPaginated' }
      & RequestedGroupsPaginatedFragment
    )>, createdGroups: Maybe<(
      { __typename?: 'GroupsPaginated' }
      & RequestedGroupsPaginatedFragment
    )> }> };

export type GetGroupSelectorListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupSelectorListQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, activeGroups: Array<(
      { __typename?: 'Group' }
      & RequestedGroupFragment
    )> }, recommend: { __typename?: 'Recommend', selectorsRecommendedGroups: Array<(
      { __typename?: 'Group' }
      & RequestedGroupFragment
    )> } };

export type SearchUserQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: GetUsersFilter;
}>;


export type SearchUserQuery = { __typename?: 'Query', users: { __typename?: 'UsersPaginated', edges: Array<{ __typename?: 'UserEdge', node: (
        { __typename?: 'User' }
        & UserInfoFragment
      ) }> } };

export type GetPostListQueryVariables = Exact<{
  pagination: PaginationInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
  withCommentedPosts?: Maybe<Scalars['Boolean']>;
  withFavoredPosts?: Maybe<Scalars['Boolean']>;
  withLikedPosts?: Maybe<Scalars['Boolean']>;
  withUsefulPosts?: Maybe<Scalars['Boolean']>;
}>;


export type GetPostListQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, commentedPosts: Maybe<(
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    )>, favoredPosts: Maybe<(
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    )>, likedPosts: Maybe<(
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    )>, userfulPosts: Maybe<(
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    )> } };

export type GetDescendantPostQueryVariables = Exact<{
  postId: Scalars['Int'];
  pagination: PaginationInput;
}>;


export type GetDescendantPostQuery = { __typename?: 'Query', post: { __typename?: 'Post', postId: number, descendantPosts?: Maybe<{ __typename?: 'PostsPaginated', edges: Array<{ __typename?: 'PostEdge', node: { __typename?: 'Post', postId: number, content: string, createdAt: any, creator?: Maybe<(
            { __typename?: 'User' }
            & UserInfoFragment
          )>, group?: Maybe<{ __typename?: 'Group', groupId: number, name: string }> } }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) }> } };

export type GetUserCardInfoQueryVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
}>;


export type GetUserCardInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, email: string } };

export type UserCardUsageFragment = { __typename?: 'User', createdPosts: { __typename?: 'PostsPaginated', totalCount: number }, followedUsers: { __typename?: 'UsersPaginated', totalCount: number }, featuredPosts: { __typename?: 'PostsPaginated', totalCount: number }, contributedKnowledge?: Maybe<{ __typename?: 'KnowledgePostPaginated', totalCount: number }> };

export type RequestedUsersPaginatedFragment = { __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
    { __typename?: 'PageInfo' }
    & RequestedPageInfoFragment
  ), edges: Array<{ __typename?: 'UserEdge', node: (
      { __typename?: 'User' }
      & UserWithExtrasFragment
    ) }> };

export type GetUserListQueryVariables = Exact<{
  userId: Scalars['Int'];
  groupId: Scalars['Int'];
  postId: Scalars['Int'];
  eventId: Scalars['Int'];
  pagination: PaginationInput;
  filter: GetUsersFilter;
  withAllUsers?: Maybe<Scalars['Boolean']>;
  withUser?: Maybe<Scalars['Boolean']>;
  withGroup?: Maybe<Scalars['Boolean']>;
  withPost?: Maybe<Scalars['Boolean']>;
  withEvent?: Maybe<Scalars['Boolean']>;
  withFollowingUsers?: Maybe<Scalars['Boolean']>;
  withFollowedUsers?: Maybe<Scalars['Boolean']>;
  withGroupMembers?: Maybe<Scalars['Boolean']>;
  withGroupAdmins?: Maybe<Scalars['Boolean']>;
  withPostLikedUsers?: Maybe<Scalars['Boolean']>;
  withPostReadUsers?: Maybe<Scalars['Boolean']>;
  withPostSharedUsers?: Maybe<Scalars['Boolean']>;
  withPostFeltUsefulUsers?: Maybe<Scalars['Boolean']>;
  withEventParticipants?: Maybe<Scalars['Boolean']>;
  withEventInterestedUsers?: Maybe<Scalars['Boolean']>;
  withYesterdayVisitors?: Maybe<Scalars['Boolean']>;
  withUserPageVisitors?: Maybe<Scalars['Boolean']>;
}>;


export type GetUserListQuery = { __typename?: 'Query', users: Maybe<(
    { __typename?: 'UsersPaginated' }
    & RequestedUsersPaginatedFragment
  )>, user: Maybe<{ __typename?: 'User', userId: number, followingUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, followedUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, yesterdayVisitors: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, viewedUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )> }>, group: Maybe<{ __typename?: 'Group', groupId: number, followers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, admins: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )> }>, post: Maybe<{ __typename?: 'Post', postId: number, likedUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, readUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, sharedUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, feltUsefulUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )> }>, event: Maybe<{ __typename?: 'Event', eventId: number, topic: string, participants: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )>, interestedUsers: Maybe<(
      { __typename?: 'UsersPaginated' }
      & RequestedUsersPaginatedFragment
    )> }> };

export type GetFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureTogglesQuery = { __typename?: 'Query', featureToggles: Array<{ __typename?: 'FeatureToggle', feature: string, value: string }> };

export type FeatureToggleUpateMutationVariables = Exact<{
  feature: Scalars['String'];
}>;


export type FeatureToggleUpateMutation = { __typename?: 'Mutation', featureToggleUpdate: { __typename?: 'FeatureToggle', feature: string, value: string } };

export type SystemAdminAddMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type SystemAdminAddMutation = { __typename?: 'Mutation', systemAdminAdd: boolean };

export type SystemAdminRemoveMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type SystemAdminRemoveMutation = { __typename?: 'Mutation', systemAdminRemove: boolean };

export type GroupAdminAddMutationVariables = Exact<{
  userId: Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type GroupAdminAddMutation = { __typename?: 'Mutation', groupAdminAdd: boolean };

export type GroupAdminRemoveMutationVariables = Exact<{
  userId: Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type GroupAdminRemoveMutation = { __typename?: 'Mutation', groupAdminRemove: boolean };

export type AnniversaryCardInfoFragment = { __typename?: 'AnniversaryCard', anniversaryCardId: number, anniversary: string, creatorUserId: number, createdAt: any, updatedAt: any, hireDate: any, receiverUserId: number, header?: Maybe<string>, content: string, footer?: Maybe<string>, isRead: boolean, cardCreator: (
    { __typename?: 'User', departments: Array<(
      { __typename?: 'Department' }
      & RequestedDepartmentFragment
    )> }
    & UserInfoFragment
  ), cardReceiver: (
    { __typename?: 'User', departments: Array<(
      { __typename?: 'Department' }
      & RequestedDepartmentFragment
    )> }
    & UserInfoFragment
  ) };

export type UserInfoWithAnniversaryCardFragment = (
  { __typename?: 'User', requestedAnniversary?: Maybe<string>, hireDate?: Maybe<any>, anniversaryCards?: Maybe<Array<(
    { __typename?: 'AnniversaryCard' }
    & AnniversaryCardInfoFragment
  )>> }
  & UserInfoFragment
);

export type GetAnniversaryCardsQueryVariables = Exact<{
  anniversary: Scalars['String'];
  creatorUserId: Scalars['Int'];
  pagination: PaginationInput;
  leaderEmail: Scalars['String'];
  hrbpEmail?: Maybe<Scalars['String']>;
  withFinished?: Maybe<Scalars['Boolean']>;
  withUnfinished?: Maybe<Scalars['Boolean']>;
  withBlocked?: Maybe<Scalars['Boolean']>;
}>;


export type GetAnniversaryCardsQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, anniversaryCardSet?: Maybe<{ __typename?: 'AnniversaryCardSet', anniversary: string, unFinishedUsers: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
            { __typename?: 'User' }
            & UserInfoWithAnniversaryCardFragment
          ) }> }>, finishedUsers: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
            { __typename?: 'User' }
            & UserInfoWithAnniversaryCardFragment
          ) }> }>, blockedUsers: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
            { __typename?: 'User' }
            & UserInfoWithAnniversaryCardFragment
          ) }> }> }> } };

export type GetUserAnniversaryCardsQueryVariables = Exact<{
  userId: Scalars['Int'];
  anniversary?: Maybe<Scalars['String']>;
}>;


export type GetUserAnniversaryCardsQuery = { __typename?: 'Query', user: (
    { __typename?: 'User', hireDate?: Maybe<any>, anniversaryCards?: Maybe<Array<(
      { __typename?: 'AnniversaryCard' }
      & AnniversaryCardInfoFragment
    )>> }
    & UserInfoFragment
  ) };

export type GetHrbpRelatedLeadersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHrbpRelatedLeadersQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, hrbpRelatedLeaders?: Maybe<Array<(
      { __typename?: 'User' }
      & UserInfoFragment
    )>> } };

export type AnniversaryCardCreateMutationVariables = Exact<{
  input: AnniversaryCardCreateInput;
}>;


export type AnniversaryCardCreateMutation = { __typename?: 'Mutation', anniversaryCardCreate: (
    { __typename?: 'AnniversaryCard' }
    & AnniversaryCardInfoFragment
  ) };

export type AnniversaryCardUpdateMutationVariables = Exact<{
  input: AnniversaryCardUpdateInput;
}>;


export type AnniversaryCardUpdateMutation = { __typename?: 'Mutation', anniversaryCardUpdate: (
    { __typename?: 'AnniversaryCard' }
    & AnniversaryCardInfoFragment
  ) };

export type GetAnnouncementPostsQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetAnnouncementPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostsPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'PostEdge', node: (
        { __typename?: 'Post' }
        & RequestedPostFragment
      ) }> } };

export type AnnouncementReplyCreateMutationVariables = Exact<{
  input: CreateAnnouncementReplyInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type AnnouncementReplyCreateMutation = { __typename?: 'Mutation', announcementReplyCreate: (
    { __typename?: 'Post' }
    & RequestedPostFragment
    & ParentCommentsFragment
  ) };

export type RequestedAnnualReportFragment = { __typename?: 'AnnualReport', firstLandingDate: string, firstPostingDate?: Maybe<string>, totalLandingCount: number, totalLandingDateCount: number, totalPostCount: number, totalPostCommentCount: number, totalPostLikedCount: number, totalFollowedGroupCount: number, totalFollowedEachOtherCount: number, totalEventParticipatedCount: number, highestRateLandingDate?: Maybe<string>, totalGroupCount: number, identity: AnnualReportIdentity, totalCommonGroupWithWorkCircleCount: Array<{ __typename?: 'Group', groupId: number, name: string, followers: { __typename?: 'UsersPaginated', totalCount: number } }>, okr: { __typename?: 'AnnualReportOKR', total: number, firstContent: string }, project: { __typename?: 'AnnualReportProject', participatedCount: number, ownedCount: number } };

export type GetViewerAnnualReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerAnnualReportQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, name: string, email: string, annualReport: (
      { __typename?: 'AnnualReport' }
      & RequestedAnnualReportFragment
    ) } };

export type GetUserAnnualReportQueryVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
}>;


export type GetUserAnnualReportQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, name: string, email: string, annualReport: (
      { __typename?: 'AnnualReport' }
      & RequestedAnnualReportFragment
    ) } };

export type AppStateQueryVariables = Exact<{ [key: string]: never; }>;


export type AppStateQuery = { __typename?: 'Query', appState: { __typename?: 'AppState', showSidebar: boolean, showSearchHeader: boolean } };

export type EventInfoFragment = { __typename?: 'Event', eventId: number, topic: string, isParticipated: boolean, isInterested: boolean, startTime: any, endTime: any, deadline?: Maybe<any>, postId: number };

export type EventInfoWithExtraFragment = (
  { __typename?: 'Event', content: string, location: string, openPosition?: Maybe<number>, restriction?: Maybe<string>, foreignGuests?: Maybe<string>, avcRoom?: Maybe<string>, avcPassword?: Maybe<string>, avcLink?: Maybe<string>, participatedCount: number, interestedCount: number, guests: Array<{ __typename?: 'Mention', user: (
      { __typename?: 'User' }
      & UserInfoFragment
    ) }> }
  & EventInfoFragment
);

export type GetMonthlyEventsQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  pagination?: PaginationInput;
}>;


export type GetMonthlyEventsQuery = { __typename?: 'Query', events: { __typename?: 'EventPaginated', edges: Array<{ __typename?: 'EventEdge', node: (
        { __typename?: 'Event' }
        & EventInfoFragment
      ) }> } };

export type GetEventQueryVariables = Exact<{
  eventId: Scalars['Int'];
  participantPagination?: PaginationInput;
}>;


export type GetEventQuery = { __typename?: 'Query', event: (
    { __typename?: 'Event', participants: { __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }> } }
    & EventInfoWithExtraFragment
  ) };

export type GetViewerUnStartEventsQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetViewerUnStartEventsQuery = { __typename?: 'Query', viewer: (
    { __typename?: 'User', unStartEvents?: Maybe<{ __typename?: 'EventPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'EventEdge', node: (
          { __typename?: 'Event' }
          & EventInfoFragment
        ) }> }> }
    & UserInfoFragment
  ) };

export type GetViewerFinishedEventsQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetViewerFinishedEventsQuery = { __typename?: 'Query', viewer: (
    { __typename?: 'User', finishedEvents?: Maybe<{ __typename?: 'EventPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'EventEdge', node: (
          { __typename?: 'Event' }
          & EventInfoFragment
        ) }> }> }
    & UserInfoFragment
  ) };

export type EventParticipantCreateUpdateMutationVariables = Exact<{
  input: CreateEventParticipantInput;
}>;


export type EventParticipantCreateUpdateMutation = { __typename?: 'Mutation', eventParticipantCreateUpdate: { __typename?: 'Event', eventId: number, isParticipated: boolean, isInterested: boolean, participatedCount: number, interestedCount: number } };

export type RequestedDepartmentFragment = { __typename?: 'Department', departmentId: number, parentDepartmentId: number, name: string };

export type RequestedDepartmentWithMembersFragment = { __typename?: 'Department', departmentId: number, parentDepartmentId: number, name: string, members: Array<(
    { __typename?: 'User' }
    & UserInfoFragment
  )> };

export type GetDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentsQuery = { __typename?: 'Query', departments: Array<(
    { __typename?: 'Department' }
    & RequestedDepartmentFragment
  )> };

export type GetMembersByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['Int'];
}>;


export type GetMembersByDepartmentQuery = { __typename?: 'Query', department: (
    { __typename?: 'Department' }
    & RequestedDepartmentWithMembersFragment
  ) };

export type GetTrendingGroupsQueryVariables = Exact<{
  pagination: PaginationInput;
  withPosts?: Maybe<Scalars['Boolean']>;
  withFollowers?: Maybe<Scalars['Boolean']>;
}>;


export type GetTrendingGroupsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', trendingGroups: { __typename?: 'GroupsPaginated', edges: Array<{ __typename?: 'GroupEdge', node: (
          { __typename?: 'Group', isFollowing: boolean }
          & GroupWithExtrasFragment
        ) }> } } };

export type GetTrendingPostsQueryVariables = Exact<{
  pagination: PaginationInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
  timeSpan: Scalars['Int'];
}>;


export type GetTrendingPostsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', trendingPosts: { __typename?: 'PostsPaginated', edges: Array<{ __typename?: 'PostEdge', node: (
          { __typename?: 'Post' }
          & RequestedPostFragment
          & ParentCommentsFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) } } };

export type GetFeaturedPostsQueryVariables = Exact<{
  pagination: PaginationInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetFeaturedPostsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', featuredPosts: { __typename?: 'PostsPaginated', edges: Array<{ __typename?: 'PostEdge', node: (
          { __typename?: 'Post' }
          & RequestedPostFragment
          & ParentCommentsFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) } } };

export type GetFeaturedGroupsQueryVariables = Exact<{
  count: Scalars['Int'];
  categoryId?: Maybe<Scalars['Int']>;
  withPosts?: Maybe<Scalars['Boolean']>;
  withFollowers?: Maybe<Scalars['Boolean']>;
}>;


export type GetFeaturedGroupsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', featuredGroups: Array<(
      { __typename?: 'Group' }
      & GroupWithExtrasFragment
    )> } };

export type GetTopFeaturedPostsQueryVariables = Exact<{
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetTopFeaturedPostsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', topFeaturedPosts?: Maybe<(
      { __typename?: 'Post' }
      & RequestedPostFragment
      & ParentCommentsFragment
    )> } };

export type PostFeatureMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostFeatureMutation = { __typename?: 'Mutation', postFeature: { __typename?: 'Post', postId: number, featuredAt?: Maybe<any> } };

export type PostUnFeatureMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostUnFeatureMutation = { __typename?: 'Mutation', postUnFeature: { __typename?: 'Post', postId: number, featuredAt?: Maybe<any> } };

export type FeaturedPostTopMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type FeaturedPostTopMutation = { __typename?: 'Mutation', featuredPostTop: { __typename?: 'Post', postId: number, isFeaturedTop?: Maybe<boolean> } };

export type FeaturedPostUnTopMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type FeaturedPostUnTopMutation = { __typename?: 'Mutation', featuredPostUnTop: { __typename?: 'Post', postId: number, isFeaturedTop?: Maybe<boolean> } };

export type FeaturedCommentDisplayMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type FeaturedCommentDisplayMutation = { __typename?: 'Mutation', featuredCommentDisplay: boolean };

export type FeaturedCommentHideMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type FeaturedCommentHideMutation = { __typename?: 'Mutation', featuredCommentHide: boolean };

export type GroupFeatureMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupFeatureMutation = { __typename?: 'Mutation', groupFeature: boolean };

export type GroupUnFeatureMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupUnFeatureMutation = { __typename?: 'Mutation', groupUnFeature: boolean };

export type LocalFileFragment = { __typename?: 'File', fileId: number, name: string, size: number, type: string, url: string, oss: { __typename?: 'FileOSS', uploadUrl: string, expireAt: any, key: string, OSSAccessKeyId: string, Signature: string, policy: string, success_action_status: number } };

export type GetViewerFilesQueryVariables = Exact<{
  pagination: PaginationInput;
  fileIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetViewerFilesQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, files: { __typename?: 'FilesPaginated', edges: Array<{ __typename?: 'FileEdge', node: (
          { __typename?: 'File', postId?: Maybe<number> }
          & LocalFileFragment
        ) }> } } };

export type FileCreateMutationVariables = Exact<{
  file: CreateFileInput;
}>;


export type FileCreateMutation = { __typename?: 'Mutation', fileCreate: (
    { __typename?: 'File' }
    & LocalFileFragment
  ) };

export type UserFollowMutationVariables = Exact<{
  followeeUserId: Scalars['Int'];
}>;


export type UserFollowMutation = { __typename?: 'Mutation', userFollow: { __typename?: 'User', userId: number, isFollowing: boolean, isFollowingEachOther: boolean } };

export type UserUnfollowMutationVariables = Exact<{
  followeeUserId: Scalars['Int'];
}>;


export type UserUnfollowMutation = { __typename?: 'Mutation', userUnfollow: { __typename?: 'User', userId: number, isFollowing: boolean, isFollowingEachOther: boolean } };

export type GroupFollowMutationVariables = Exact<{
  followeeGroupId: Scalars['Int'];
  followerUserId?: Maybe<Scalars['Int']>;
}>;


export type GroupFollowMutation = { __typename?: 'Mutation', groupFollow: { __typename?: 'Group', groupId: number, isFollowing: boolean } };

export type GroupUnfollowMutationVariables = Exact<{
  followeeGroupId: Scalars['Int'];
}>;


export type GroupUnfollowMutation = { __typename?: 'Mutation', groupUnfollow: { __typename?: 'Group', groupId: number, isFollowing: boolean } };

export type UserBatchFollowMutationVariables = Exact<{
  followeeUserIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type UserBatchFollowMutation = { __typename?: 'Mutation', userBatchFollow: Array<{ __typename?: 'User', userId: number, isFollowing: boolean }> };

export type GroupBatchFollowMutationVariables = Exact<{
  followeeGroupIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GroupBatchFollowMutation = { __typename?: 'Mutation', groupBatchFollow: Array<{ __typename?: 'Group', groupId: number, isFollowing: boolean }> };

export type DepartmentBatchFollowMutationVariables = Exact<{
  followeeDepartmentIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type DepartmentBatchFollowMutation = { __typename?: 'Mutation', departmentBatchFollow: boolean };

export type RequestedGroupFragment = { __typename?: 'Group', groupId: number, name: string, isPinned: boolean, description: string, creatorUserId: number, privateSetting: GroupPrivateSetting, isOfficial: boolean, isFollowing: boolean, canUnfollow: boolean, canPostAnonymously: boolean, whoCanPost: WhoCanPost, groupCategoryId?: Maybe<number>, featuredAt?: Maybe<any>, pmoProjectId?: Maybe<string>, pmoLink?: Maybe<string>, category?: Maybe<{ __typename?: 'GroupCategory', groupCategoryId: number, name: string }> };

export type GroupWithExtrasFragment = (
  { __typename?: 'Group', createdAt: any, creator: (
    { __typename?: 'User' }
    & UserInfoFragment
  ), posts: Maybe<{ __typename?: 'PostsPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'PostEdge', node: { __typename?: 'Post', postId: number } }> }>, followers: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', userId: number } }> }> }
  & RequestedGroupFragment
);

export type GetGroupsQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: GetGroupsFilter;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupsPaginated', pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'GroupEdge', cursor: string, node: (
        { __typename?: 'Group' }
        & RequestedGroupFragment
      ) }> } };

export type GetGroupQueryVariables = Exact<{
  groupId: Scalars['Int'];
  withAdmins: Scalars['Boolean'];
  pagination: PaginationInput;
}>;


export type GetGroupQuery = { __typename?: 'Query', group: (
    { __typename?: 'Group', isPinned: boolean, isFollowing: boolean, creator: (
      { __typename?: 'User' }
      & UserInfoFragment
    ), admins: Maybe<{ __typename?: 'UsersPaginated', edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }> }> }
    & RequestedGroupFragment
  ) };

export type GetGroupCreatorQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetGroupCreatorQuery = { __typename?: 'Query', group: { __typename?: 'Group', groupId: number, creator: (
      { __typename?: 'User' }
      & UserInfoFragment
    ) } };

export type GetGroupFollowersQueryVariables = Exact<{
  groupId: Scalars['Int'];
  pagination: PaginationInput;
  usersFilter: GetUsersFilter;
}>;


export type GetGroupFollowersQuery = { __typename?: 'Query', group: { __typename?: 'Group', groupId: number, users: { __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User', departments: Array<(
            { __typename?: 'Department' }
            & RequestedDepartmentFragment
          )> }
          & UserInfoFragment
        ) }> } } };

export type GetGroupAdminsQueryVariables = Exact<{
  groupId: Scalars['Int'];
  pagination: PaginationInput;
  usersFilter: GetUsersFilter;
}>;


export type GetGroupAdminsQuery = { __typename?: 'Query', group: { __typename?: 'Group', groupId: number, users: { __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User', departments: Array<(
            { __typename?: 'Department' }
            & RequestedDepartmentFragment
          )> }
          & UserInfoFragment
        ) }> } } };

export type GetGroupFilesQueryVariables = Exact<{
  groupId: Scalars['Int'];
  pagination: PaginationInput;
}>;


export type GetGroupFilesQuery = { __typename?: 'Query', group: { __typename?: 'Group', groupId: number, files: { __typename?: 'FilesPaginated', totalCount: number, edges: Array<{ __typename?: 'FileEdge', node: (
          { __typename?: 'File', postId?: Maybe<number>, createdAt: any, creator?: Maybe<{ __typename?: 'User', userId: number, name: string, email: string, avatarUrl: string }> }
          & LocalFileFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) } } };

export type GetNewestsGroupsQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: GetGroupsFilter;
  withPosts?: Maybe<Scalars['Boolean']>;
  withFollowers?: Maybe<Scalars['Boolean']>;
}>;


export type GetNewestsGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupsPaginated', pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'GroupEdge', node: (
        { __typename?: 'Group' }
        & GroupWithExtrasFragment
      ) }> } };

export type GetViewerFollowingGroupsQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: GetGroupsFilter;
  withPosts?: Maybe<Scalars['Boolean']>;
  withFollowers?: Maybe<Scalars['Boolean']>;
}>;


export type GetViewerFollowingGroupsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, groups: { __typename?: 'GroupsPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'GroupEdge', node: (
          { __typename?: 'Group', recentUnreadCount?: Maybe<number>, isPinned: boolean }
          & GroupWithExtrasFragment
        ) }> } } };

export type GetViewerCreatedGroupsQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: GetGroupsFilter;
  withPosts?: Maybe<Scalars['Boolean']>;
  withFollowers?: Maybe<Scalars['Boolean']>;
}>;


export type GetViewerCreatedGroupsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, groups: { __typename?: 'GroupsPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'GroupEdge', node: (
          { __typename?: 'Group' }
          & GroupWithExtrasFragment
        ) }> } } };

export type GetGroupCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupCategoriesQuery = { __typename?: 'Query', groupCategories: Array<{ __typename?: 'GroupCategory', groupCategoryId: number, name: string }> };

export type GetUnreadMemberRequestsQueryVariables = Exact<{
  groupId: Scalars['Int'];
  pagination: PaginationInput;
}>;


export type GetUnreadMemberRequestsQuery = { __typename?: 'Query', group: { __typename?: 'Group', groupId: number, unreadMemberRequests: { __typename?: 'GroupMemberRequestPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'GroupMemberRequestEdge', node: { __typename?: 'GroupMemberRequest', requestId: number, creator: (
            { __typename?: 'User' }
            & UserWithExtrasFragment
          ) } }> } } };

export type GetGroupMemberRequestQueryVariables = Exact<{
  requestId: Scalars['Int'];
}>;


export type GetGroupMemberRequestQuery = { __typename?: 'Query', groupMemberRequest: { __typename?: 'GroupMemberRequest', requestId: number, isApproved?: Maybe<boolean>, creator: (
      { __typename?: 'User' }
      & UserInfoFragment
    ), group: (
      { __typename?: 'Group' }
      & RequestedGroupFragment
    ), approver?: Maybe<(
      { __typename?: 'User' }
      & UserInfoFragment
    )> } };

export type GroupCreateMutationVariables = Exact<{
  group: CreateGroupInput;
}>;


export type GroupCreateMutation = { __typename?: 'Mutation', groupCreate: (
    { __typename?: 'Group' }
    & RequestedGroupFragment
  ) };

export type GroupUpdateMutationVariables = Exact<{
  groupId: Scalars['Int'];
  group: UpdateGroupInput;
}>;


export type GroupUpdateMutation = { __typename?: 'Mutation', groupUpdate: (
    { __typename?: 'Group' }
    & RequestedGroupFragment
  ) };

export type GroupArchiveMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupArchiveMutation = { __typename?: 'Mutation', groupArchive: boolean };

export type GroupUnArchiveMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupUnArchiveMutation = { __typename?: 'Mutation', groupUnArchive: boolean };

export type GroupInviteMutationVariables = Exact<{
  followeeGroupId: Scalars['Int'];
  followerUserIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  departmentIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GroupInviteMutation = { __typename?: 'Mutation', groupInvite: boolean };

export type GroupApplyMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupApplyMutation = { __typename?: 'Mutation', groupApply: GroupApplyStatus };

export type GroupPinUpdateMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupPinUpdateMutation = { __typename?: 'Mutation', groupPinUpdate: { __typename?: 'Group', groupId: number, isPinned: boolean } };

export type GroupMemberRequestApproveMutationVariables = Exact<{
  requestId: Scalars['Int'];
  isApproved: Scalars['Boolean'];
}>;


export type GroupMemberRequestApproveMutation = { __typename?: 'Mutation', groupMemberRequestApprove: { __typename?: 'GroupMemberRequestFeedBack', alreadyApproved: boolean, requesetHandled: boolean } };

export type GroupFollowerRemoveMutationVariables = Exact<{
  followeeGroupId: Scalars['Int'];
  followerUserId: Scalars['Int'];
}>;


export type GroupFollowerRemoveMutation = { __typename?: 'Mutation', groupFollowerRemove: boolean };

export type GroupUpdatedSubscriptionVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupUpdatedSubscription = { __typename?: 'Subscription', groupUpdated: (
    { __typename?: 'Group' }
    & RequestedGroupFragment
  ) };

export type GroupAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GroupAddedSubscription = { __typename?: 'Subscription', groupAdded: (
    { __typename?: 'Group' }
    & RequestedGroupFragment
  ) };

export type GroupMemberRequestChangedSubscriptionVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupMemberRequestChangedSubscription = { __typename?: 'Subscription', groupMemeberRequestChanged: { __typename?: 'Group', groupId: number, unreadMemberRequests: { __typename?: 'GroupMemberRequestPaginated', totalCount: number } } };

export type RequestedKnowledgeGroupFragment = { __typename?: 'KnowledgeGroup', knowledgeGroupId: number, parentKnowledgeGroupId?: Maybe<number>, creatorUserId: number, name: string, description: string, path?: Maybe<string>, creator: (
    { __typename?: 'User' }
    & UserInfoFragment
  ), parentGroups?: Maybe<Array<{ __typename?: 'KnowledgeGroup', knowledgeGroupId: number, name: string }>> };

export type RequestedKnowledgePostFragment = { __typename?: 'KnowledgePost', knowledgePostId: number, knowledgeGroupId: number, creatorUserId: number, authorId: number, title: string, description?: Maybe<string>, author: (
    { __typename?: 'User' }
    & UserInfoFragment
  ), link?: Maybe<{ __typename?: 'KnowledgeLink', knowledgePostLinkId: number, url: string }>, files: Array<(
    { __typename?: 'File' }
    & LocalFileFragment
  )> };

export type GetKnowledgeGroupsQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetKnowledgeGroupsQuery = { __typename?: 'Query', knowledge: { __typename?: 'KnowledgeNS', groups: { __typename?: 'KnowledgeGroupPaginated', edges: Array<{ __typename?: 'KnowledgeGroupEdge', node: { __typename?: 'KnowledgeGroup', knowledgeGroupId: number, parentKnowledgeGroupId?: Maybe<number>, path?: Maybe<string>, name: string, position: number, childGroupIds?: Maybe<Array<number>>, childPositions?: Maybe<Array<number>>, posts: { __typename?: 'KnowledgePostPaginated', totalCount: number } } }> } } };

export type GetKnowledgeGroupQueryVariables = Exact<{
  knowledgeGroupId: Scalars['Int'];
}>;


export type GetKnowledgeGroupQuery = { __typename?: 'Query', knowledge: { __typename?: 'KnowledgeNS', group: { __typename?: 'KnowledgeGroup', knowledgeGroupId: number, name: string, parentGroups?: Maybe<Array<{ __typename?: 'KnowledgeGroup', knowledgeGroupId: number, name: string }>> } } };

export type GetKnowledgeGroupPostsQueryVariables = Exact<{
  pagination: PaginationInput;
  search?: Maybe<Scalars['String']>;
  knowledgeGroupId: Scalars['Int'];
}>;


export type GetKnowledgeGroupPostsQuery = { __typename?: 'Query', knowledge: { __typename?: 'KnowledgeNS', group: (
      { __typename?: 'KnowledgeGroup', posts: { __typename?: 'KnowledgePostPaginated', pageInfo: (
          { __typename?: 'PageInfo' }
          & RequestedPageInfoFragment
        ), edges: Array<{ __typename?: 'KnowledgePostEdge', node: (
            { __typename?: 'KnowledgePost' }
            & RequestedKnowledgePostFragment
          ) }> } }
      & RequestedKnowledgeGroupFragment
    ) } };

export type GetKnowledgePostsQueryVariables = Exact<{
  pagination: PaginationInput;
  search: Scalars['String'];
}>;


export type GetKnowledgePostsQuery = { __typename?: 'Query', knowledge: { __typename?: 'KnowledgeNS', posts: { __typename?: 'KnowledgePostPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'KnowledgePostEdge', node: (
          { __typename?: 'KnowledgePost' }
          & RequestedKnowledgePostFragment
        ) }> } } };

export type GetKnowledgePostQueryVariables = Exact<{
  knowledgePostId: Scalars['Int'];
}>;


export type GetKnowledgePostQuery = { __typename?: 'Query', knowledge: { __typename?: 'KnowledgeNS', post: (
      { __typename?: 'KnowledgePost' }
      & RequestedKnowledgePostFragment
    ) } };

export type GetFavoredKnowledgeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavoredKnowledgeGroupsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, favoredKnowledgeGroups?: Maybe<Array<(
      { __typename?: 'KnowledgeGroup', posts: { __typename?: 'KnowledgePostPaginated', totalCount: number } }
      & RequestedKnowledgeGroupFragment
    )>> } };

export type KnowledgeGroupCreateMutationVariables = Exact<{
  knowledgeGroupInput: CreateKnowledgeGroupInput;
}>;


export type KnowledgeGroupCreateMutation = { __typename?: 'Mutation', knowledgeGroupCreate: (
    { __typename?: 'KnowledgeGroup' }
    & RequestedKnowledgeGroupFragment
  ) };

export type KnowledgeGroupUpdateMutationVariables = Exact<{
  knowledgeGroupInput: UpdateKnowledgeGroupInput;
  knowledgeGroupId: Scalars['Int'];
}>;


export type KnowledgeGroupUpdateMutation = { __typename?: 'Mutation', knowledgeGroupUpdate: (
    { __typename?: 'KnowledgeGroup' }
    & RequestedKnowledgeGroupFragment
  ) };

export type KnowledgeGroupFavorToggleMutationVariables = Exact<{
  knowledgeGroupId: Scalars['Int'];
}>;


export type KnowledgeGroupFavorToggleMutation = { __typename?: 'Mutation', knowledgeGroupFavorToggle: boolean };

export type KnowledgePostCreateMutationVariables = Exact<{
  knowledgePostInput: CreateKnowledgePostInput;
}>;


export type KnowledgePostCreateMutation = { __typename?: 'Mutation', knowledgePostCreate: (
    { __typename?: 'KnowledgePost' }
    & RequestedKnowledgePostFragment
  ) };

export type KnowledgePostUpdateMutationVariables = Exact<{
  knowledgePostInput: UpdateKnowledgePostInput;
  knowledgePostId: Scalars['Int'];
}>;


export type KnowledgePostUpdateMutation = { __typename?: 'Mutation', knowledgePostUpdate: (
    { __typename?: 'KnowledgePost' }
    & RequestedKnowledgePostFragment
  ) };

export type KnowledgePostDeleteMutationVariables = Exact<{
  knowledgePostId: Scalars['Int'];
}>;


export type KnowledgePostDeleteMutation = { __typename?: 'Mutation', knowledgePostDelete: boolean };

export type KnowledgeSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type KnowledgeSyncMutation = { __typename?: 'Mutation', knowledgeSync: boolean };

export type KnowledgeGroupDeleteMutationVariables = Exact<{
  knowledgeGroupId: Scalars['Int'];
}>;


export type KnowledgeGroupDeleteMutation = { __typename?: 'Mutation', knowledgeGroupDelete: boolean };

export type SwitchKnowledgeGroupMutationVariables = Exact<{
  sourceId: Scalars['Int'];
  targetId: Scalars['Int'];
  includeTarget: Scalars['Boolean'];
  parentId?: Maybe<Scalars['Int']>;
}>;


export type SwitchKnowledgeGroupMutation = { __typename?: 'Mutation', switchKnowledgeGroup: boolean };

export type StatisticValueInfoFragment = { __typename?: 'StatisticValue', year?: Maybe<string>, yearMonth?: Maybe<string>, yearWeek?: Maybe<string>, date?: Maybe<string>, value: number };

export type StatisticCentralTendencyImpactInfoFragment = { __typename?: 'StatisticCentralTendencyImpactValue', median: number, mode: number, mean: number, date?: Maybe<string> };

export type StatisticUserInfoFragment = { __typename?: 'StatisticUserValue', userId: number, name: string, email: string, date?: Maybe<string>, yearMonth?: Maybe<string>, year?: Maybe<string>, landingCount?: Maybe<number>, landingDayCount?: Maybe<number>, postingCount?: Maybe<number>, interactionCount?: Maybe<number>, beenVisitedCount?: Maybe<number>, visitCount?: Maybe<number> };

export type StatisticImpactInfoFragment = { __typename?: 'StatisticImpactValue', userId: number, name: string, email: string, impact: number, date: any };

export type StatisticPostTagTypePercentageInfoFragment = { __typename?: 'StatisticPostContentTagValue', year?: Maybe<string>, yearMonth?: Maybe<string>, yearWeek?: Maybe<string>, date?: Maybe<string>, data: Array<{ __typename?: 'StatisticPostContentTypeBasicValue', tag: PostTagType, tagName: string, count: number }> };

export type GetStatisticsQueryVariables = Exact<{
  withPostCount?: Maybe<Scalars['Boolean']>;
  withWeeklyPostCount?: Maybe<Scalars['Boolean']>;
  withPostPeopleCount?: Maybe<Scalars['Boolean']>;
  withLandingCount?: Maybe<Scalars['Boolean']>;
  withLandingPeopleCount?: Maybe<Scalars['Boolean']>;
  withWeeklyLandingPeopleCount?: Maybe<Scalars['Boolean']>;
  withLandingRate?: Maybe<Scalars['Boolean']>;
  withPostingRate?: Maybe<Scalars['Boolean']>;
  withUserInfo?: Maybe<Scalars['Boolean']>;
  withContributedImpact?: Maybe<Scalars['Boolean']>;
  withImpact?: Maybe<Scalars['Boolean']>;
  withYesterdayImpact?: Maybe<Scalars['Boolean']>;
  withPostContentTagPercentage?: Maybe<Scalars['Boolean']>;
  withPostContentTagTrend?: Maybe<Scalars['Boolean']>;
  input: StatisticInput;
}>;


export type GetStatisticsQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', postsCount: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, weeklyPostsCount: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, peopleCount: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, contributedImpact: Maybe<Array<(
      { __typename?: 'StatisticCentralTendencyImpactValue' }
      & StatisticCentralTendencyImpactInfoFragment
    )>>, impact: Maybe<Array<(
      { __typename?: 'StatisticCentralTendencyImpactValue' }
      & StatisticCentralTendencyImpactInfoFragment
    )>>, yesterdayImpact: Maybe<Array<(
      { __typename?: 'StatisticImpactValue' }
      & StatisticImpactInfoFragment
    )>>, landingCount: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, landingPeopleCount: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, weeklyLandingPeopleCount: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, landingRate: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, postingRate: Maybe<Array<(
      { __typename?: 'StatisticValue' }
      & StatisticValueInfoFragment
    )>>, userInfo: Maybe<Array<(
      { __typename?: 'StatisticUserValue' }
      & StatisticUserInfoFragment
    )>>, postContentTagPercentage: Maybe<(
      { __typename?: 'StatisticPostContentTagValue' }
      & StatisticPostTagTypePercentageInfoFragment
    )>, postContentTagTrend: Maybe<Array<(
      { __typename?: 'StatisticPostContentTagValue' }
      & StatisticPostTagTypePercentageInfoFragment
    )>> } };

export type GetFeaturedJournalBarChartQueryVariables = Exact<{
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  session: Scalars['Int'];
}>;


export type GetFeaturedJournalBarChartQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', featuredJournalData?: Maybe<Array<{ __typename?: 'StatisticFeaturedJournalValue', url: string, count: number }>> } };

export type GetFeaturedJournalLineChartQueryVariables = Exact<{
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  session: Scalars['Int'];
}>;


export type GetFeaturedJournalLineChartQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', featuredJournalTrendData?: Maybe<Array<{ __typename?: 'StatisticFeaturedJournalTrendValue', date: string, count: number }>> } };

export type GetUserPageVisitsStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPageVisitsStatisticsQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', userPageVisitsTotalCount: number, userPageVisitsYesterdayCount: number } };

export type VisitPageMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type VisitPageMutation = { __typename?: 'Mutation', visitPage: boolean };

export type RequestedNotificationSettingFragment = { __typename?: 'NotificationSetting', notificationSettingId: number, contentType: NotificationContentType, outletType: NotificationOutletType, isActive: boolean };

export type GetNotifcationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotifcationSettingsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, notificationSettings: Array<(
      { __typename?: 'NotificationSetting' }
      & RequestedNotificationSettingFragment
    )> } };

export type NotificationSettingUpdateMutationVariables = Exact<{
  notificationSettingId: Scalars['Int'];
  notificationSetting: UpdateNotificationSettingInput;
}>;


export type NotificationSettingUpdateMutation = { __typename?: 'Mutation', notificationSettingUpdate: (
    { __typename?: 'NotificationSetting' }
    & RequestedNotificationSettingFragment
  ) };

export type NotificationUserFragment = { __typename?: 'User', userId: number, name: string, avatarUrl: string, email: string };

export type NotificationGroupFragment = { __typename?: 'Group', groupId: number, name: string, description: string };

export type RequestedNotificationFragment = { __typename?: 'Notification', notificationId: number, actionType: NotificationActionType, createdAt: any, message?: Maybe<{ __typename?: 'NotificationMessage', phrase: string, content: string, targetKind?: Maybe<string>, targetId?: Maybe<string> }>, creators: Array<Maybe<(
    { __typename?: 'User' }
    & NotificationUserFragment
  )>> };

export type GetNotifcationsQueryVariables = Exact<{
  pagination: PaginationInput;
  isRead?: Maybe<Scalars['Boolean']>;
}>;


export type GetNotifcationsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, notifications: { __typename?: 'NotificationPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'NotificationEdge', node: (
          { __typename?: 'Notification' }
          & RequestedNotificationFragment
        ) }> } } };

export type NotificationReadMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationReadMutation = { __typename?: 'Mutation', notificationRead: boolean };

export type NotificationCountChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationCountChangedSubscription = { __typename?: 'Subscription', notificationCountChanged: number };

export type AnnouncementInfoFragment = { __typename?: 'Announcement', announcementId: number, title: string, type: AnnouncementType, content: string, postId: number, repliedType?: Maybe<AnnouncementReplyType> };

export type GetAnnouncementQueryVariables = Exact<{
  announcementId: Scalars['Int'];
}>;


export type GetAnnouncementQuery = { __typename?: 'Query', announcement: (
    { __typename?: 'Announcement' }
    & AnnouncementInfoFragment
  ) };

export type AnnouncementCreateMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;


export type AnnouncementCreateMutation = { __typename?: 'Mutation', announcementCreate: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type AnnouncementUpdateMutationVariables = Exact<{
  input: UpdateAnnouncementInput;
}>;


export type AnnouncementUpdateMutation = { __typename?: 'Mutation', announcementUpdate: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type RequestedCommentFragment = { __typename?: 'Comment', commentId: number, postId: number, parentCommentId?: Maybe<number>, content: string, createdAt: any, updatedAt: any, liked: boolean, likedCount: number, isViewerCreated: boolean, isAnonymous: boolean, creator?: Maybe<(
    { __typename?: 'User' }
    & UserInfoFragment
  )>, mentions: Array<(
    { __typename?: 'Mention' }
    & RequestedPostMentionFragment
  )> };

export type ParentCommentsFragment = { __typename?: 'Post', comments: { __typename?: 'CommentsPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'CommentEdge', cursor: string, node: (
        { __typename?: 'Comment' }
        & RequestedCommentFragment
        & ChildCommentsFragment
      ) }> } };

export type ChildCommentsFragment = { __typename?: 'Comment', comments: { __typename?: 'CommentsPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'CommentEdge', cursor: string, node: (
        { __typename?: 'Comment' }
        & RequestedCommentFragment
      ) }> } };

export type GetPostCommentsQueryVariables = Exact<{
  postId: Scalars['Int'];
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetPostCommentsQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post', postId: number }
    & ParentCommentsFragment
  ) };

export type GetPostChildCommentsQueryVariables = Exact<{
  postId: Scalars['Int'];
  commentId: Scalars['Int'];
  childCommentPagination: PaginationInput;
}>;


export type GetPostChildCommentsQuery = { __typename?: 'Query', post: { __typename?: 'Post', postId: number, comment: (
      { __typename?: 'Comment', commentId: number }
      & ChildCommentsFragment
    ) } };

export type GetCommentLikedUsersQueryVariables = Exact<{
  postId: Scalars['Int'];
  commentId: Scalars['Int'];
  commentLikedUsersPagination?: Maybe<PaginationInput>;
}>;


export type GetCommentLikedUsersQuery = { __typename?: 'Query', post: { __typename?: 'Post', postId: number, comment: { __typename?: 'Comment', commentId: number, likedUsers: (
        { __typename?: 'UsersPaginated', totalCount: number }
        & RequestedUsersPaginatedFragment
      ) } } };

export type CommentCreateMutationVariables = Exact<{
  comment: CreateCommentInput;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type CommentCreateMutation = { __typename?: 'Mutation', commentCreate: (
    { __typename?: 'Comment' }
    & RequestedCommentFragment
    & ChildCommentsFragment
  ) };

export type CommentUpdateMutationVariables = Exact<{
  comment: UpdateCommentInput;
}>;


export type CommentUpdateMutation = { __typename?: 'Mutation', commentUpdate: (
    { __typename?: 'Comment' }
    & RequestedCommentFragment
  ) };

export type CommentDeleteMutationVariables = Exact<{
  comment: DeleteCommentInput;
}>;


export type CommentDeleteMutation = { __typename?: 'Mutation', commentDelete: boolean };

export type CommentLikeToggleMutationVariables = Exact<{
  commentId: Scalars['Int'];
  like: Scalars['Boolean'];
}>;


export type CommentLikeToggleMutation = { __typename?: 'Mutation', commentLikeToggle: { __typename?: 'Comment', commentId: number, liked: boolean, likedCount: number } };

export type CommentAddedSubscriptionVariables = Exact<{
  postId: Scalars['Int'];
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type CommentAddedSubscription = { __typename?: 'Subscription', commentAdded: (
    { __typename?: 'Comment' }
    & RequestedCommentFragment
    & ChildCommentsFragment
  ) };

export type CommentUpdatedSubscriptionVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type CommentUpdatedSubscription = { __typename?: 'Subscription', commentUpdated: { __typename?: 'Comment', commentId: number, postId: number, content: string, updatedAt: any, likedCount: number } };

export type CommentDeletedSubscriptionVariables = Exact<{
  postId: Scalars['Int'];
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type CommentDeletedSubscription = { __typename?: 'Subscription', commentDeleted: (
    { __typename?: 'Comment' }
    & RequestedCommentFragment
    & ChildCommentsFragment
  ) };

export type RequestedRecommendPostInfoFragment = { __typename?: 'RecommendPostInfo', commentFolloweeIds: Array<number>, likedFolloweeIds: Array<number>, commentFollowees: Array<(
    { __typename?: 'User' }
    & UserInfoFragment
  )>, likedFollowees: Array<(
    { __typename?: 'User' }
    & UserInfoFragment
  )> };

export type TimelinePostsFragment = { __typename?: 'PostsPaginated', pageInfo: (
    { __typename?: 'PageInfo' }
    & RequestedPageInfoFragment
  ), edges: Array<{ __typename?: 'PostEdge', cursor: string, node: (
      { __typename?: 'Post', recommendPostInfo: (
        { __typename?: 'RecommendPostInfo' }
        & RequestedRecommendPostInfoFragment
      ) }
      & RequestedPostFragment
      & ParentCommentsFragment
    ) }> };

export type PostsFragment = { __typename?: 'PostsPaginated', pageInfo: (
    { __typename?: 'PageInfo' }
    & RequestedPageInfoFragment
  ), edges: Array<{ __typename?: 'PostEdge', cursor: string, node: (
      { __typename?: 'Post' }
      & RequestedPostFragment
      & ParentCommentsFragment
    ) }> };

export type RequestedPostLinkFragment = { __typename?: 'PostLink', title: string, description: string, logo: string, url: string };

export type RequestedPostMentionFragment = { __typename?: 'Mention', mentionId: number, user: { __typename?: 'User', userId: number, email: string, name: string, avatarUrl: string } };

export type RequestedPostGroupFragment = { __typename?: 'Group', groupId: number, name: string, creatorUserId: number, privateSetting: GroupPrivateSetting, canPostAnonymously: boolean };

export type ThanksPostInfoFragment = { __typename?: 'Post', postType: PostType, receiver?: Maybe<{ __typename?: 'User', userId: number, name: string, gender: string, email: string }> };

export type HonorPostInfoFragment = { __typename?: 'Honor', honorId: number, postId: number, title: string, commendation: string, honoredProjects?: Maybe<string>, honoredIndividuals: Array<{ __typename?: 'Mention', user: (
      { __typename?: 'User' }
      & UserInfoFragment
    ) }>, honoredSignificants?: Maybe<Array<{ __typename?: 'Mention', user: (
      { __typename?: 'User' }
      & UserInfoFragment
    ) }>> };

export type RequestedLikedUsersFragment = { __typename?: 'Post', likedUsers: { __typename?: 'UsersPaginated', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', userId: number, avatarUrl: string, email: string } }> } };

export type RequestedPostFragment = (
  { __typename?: 'Post', postId: number, originalPostId?: Maybe<number>, content: string, groupId?: Maybe<number>, sectionId?: Maybe<SectionType>, isMarkdown: boolean, createdAt: any, updatedAt: any, archivedAt?: Maybe<any>, featuredAt?: Maybe<any>, liked: boolean, likedCount: number, isFeaturedTop?: Maybe<boolean>, isCommentDisplayable?: Maybe<boolean>, readCount: number, commentCount: number, isRead: boolean, isAnonymous: boolean, sharedCount: number, isFavored: boolean, isViewerCreated: boolean, isUseful: boolean, usefulCount: number, tags: Array<PostTagType>, creator?: Maybe<(
    { __typename?: 'User' }
    & UserInfoFragment
  )>, files: Array<(
    { __typename?: 'File' }
    & LocalFileFragment
  )>, links: Array<(
    { __typename?: 'PostLink' }
    & RequestedPostLinkFragment
  )>, group?: Maybe<(
    { __typename?: 'Group' }
    & RequestedPostGroupFragment
  )>, mentions: Array<(
    { __typename?: 'Mention' }
    & RequestedPostMentionFragment
  )>, event?: Maybe<(
    { __typename?: 'Event' }
    & EventInfoWithExtraFragment
  )>, honor?: Maybe<(
    { __typename?: 'Honor' }
    & HonorPostInfoFragment
  )>, announcement?: Maybe<(
    { __typename?: 'Announcement' }
    & AnnouncementInfoFragment
  )>, originalPost?: Maybe<(
    { __typename?: 'Post', postId: number, content: string, isViewerCreated: boolean, isMarkdown: boolean, createdAt: any, updatedAt: any, group?: Maybe<(
      { __typename?: 'Group' }
      & RequestedPostGroupFragment
    )>, creator?: Maybe<(
      { __typename?: 'User' }
      & UserInfoFragment
    )>, files: Array<(
      { __typename?: 'File' }
      & LocalFileFragment
    )>, links: Array<(
      { __typename?: 'PostLink' }
      & RequestedPostLinkFragment
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & EventInfoWithExtraFragment
    )> }
    & ThanksPostInfoFragment
  )> }
  & RequestedLikedUsersFragment
  & ThanksPostInfoFragment
);

export type GetPostQueryVariables = Exact<{
  postId: Scalars['Int'];
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetPostQuery = { __typename?: 'Query', post: (
    { __typename?: 'Post' }
    & RequestedPostFragment
    & ParentCommentsFragment
  ) };

export type GetSinglePostRecommendedPostsQueryVariables = Exact<{
  postId: Scalars['Int'];
  pagination: PaginationInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetSinglePostRecommendedPostsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', recommendedPosts: { __typename?: 'PostsPaginated', edges: Array<{ __typename?: 'PostEdge', node: (
          { __typename?: 'Post' }
          & RequestedPostFragment
          & ParentCommentsFragment
        ) }> } } };

export type GetTimelineNewestPageInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimelineNewestPageInfoQuery = { __typename?: 'Query', section: { __typename?: 'Section', sectionId: SectionType, posts: { __typename?: 'PostsPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) } } };

export type GetTimelinePostsQueryVariables = Exact<{
  groupId: Scalars['Int'];
  userId: Scalars['Int'];
  sectionId: SectionType;
  departmentId: Scalars['Int'];
  withViewerFollowing: Scalars['Boolean'];
  withUserCreated: Scalars['Boolean'];
  withGroup: Scalars['Boolean'];
  withSection: Scalars['Boolean'];
  withDepartmentJournal: Scalars['Boolean'];
  withAllPosts: Scalars['Boolean'];
  pagination: PaginationInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
  filter: GetPostsFilter;
  useRecommendation?: Maybe<Scalars['Boolean']>;
}>;


export type GetTimelinePostsQuery = { __typename?: 'Query', viewer: Maybe<{ __typename?: 'User', userId: number, posts: Maybe<(
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    )>, allPosts: Maybe<(
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    )> }>, user: Maybe<{ __typename?: 'User', userId: number, posts: (
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    ) }>, section: Maybe<{ __typename?: 'Section', sectionId: SectionType, hasUnread: boolean, posts: (
      { __typename?: 'PostsPaginated' }
      & TimelinePostsFragment
    ), topPost?: Maybe<(
      { __typename?: 'Post' }
      & RequestedPostFragment
    )> }>, group: Maybe<{ __typename?: 'Group', groupId: number, posts: (
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    ) }>, department: Maybe<{ __typename?: 'Department', departmentId: number, posts: (
      { __typename?: 'PostsPaginated' }
      & PostsFragment
    ) }> };

export type GetTopPostQueryVariables = Exact<{
  groupId: Scalars['Int'];
  sectionId: SectionType;
  withGroupPost?: Maybe<Scalars['Boolean']>;
  withSectionPost?: Maybe<Scalars['Boolean']>;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetTopPostQuery = { __typename?: 'Query', group: Maybe<{ __typename?: 'Group', groupId: number, topPost?: Maybe<(
      { __typename?: 'Post' }
      & RequestedPostFragment
      & ParentCommentsFragment
    )> }>, section: Maybe<{ __typename?: 'Section', sectionId: SectionType, topPost?: Maybe<(
      { __typename?: 'Post' }
      & RequestedPostFragment
      & ParentCommentsFragment
    )> }> };

export type GetThanksPostQueryVariables = Exact<{
  userId: Scalars['Int'];
  pagination: PaginationInput;
}>;


export type GetThanksPostQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, thanksPosts: { __typename?: 'PostsPaginated', totalCount: number, edges: Array<{ __typename?: 'PostEdge', node: (
          { __typename?: 'Post' }
          & RequestedPostFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) } } };

export type PostCreateMutationVariables = Exact<{
  post: CreatePostInput;
}>;


export type PostCreateMutation = { __typename?: 'Mutation', postCreate: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type PostBatchCreateMutationVariables = Exact<{
  post: CreatePostInput;
  receiverUserIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type PostBatchCreateMutation = { __typename?: 'Mutation', postBatchCreate: Array<(
    { __typename?: 'Post' }
    & RequestedPostFragment
  )> };

export type PostUpdateMutationVariables = Exact<{
  postId: Scalars['Int'];
  post: UpdatePostInput;
}>;


export type PostUpdateMutation = { __typename?: 'Mutation', postUpdate: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type PostArchiveMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostArchiveMutation = { __typename?: 'Mutation', postArchive: boolean };

export type PostUnArchiveMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostUnArchiveMutation = { __typename?: 'Mutation', postUnArchive: boolean };

export type PostShareMutationVariables = Exact<{
  post: SharePostInput;
}>;


export type PostShareMutation = { __typename?: 'Mutation', postShare: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type PostLikeToggleMutationVariables = Exact<{
  postId: Scalars['Int'];
  like: Scalars['Boolean'];
}>;


export type PostLikeToggleMutation = { __typename?: 'Mutation', postLikeToggle: (
    { __typename?: 'Post', postId: number, liked: boolean, likedCount: number }
    & RequestedLikedUsersFragment
  ) };

export type PostTopMutationVariables = Exact<{
  postId: Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type PostTopMutation = { __typename?: 'Mutation', postTop: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type PostUnTopMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type PostUnTopMutation = { __typename?: 'Mutation', postUnTop: boolean };

export type PostReadMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostReadMutation = { __typename?: 'Mutation', postRead: { __typename?: 'Post', postId: number, isRead: boolean } };

export type PostFavorToggleMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostFavorToggleMutation = { __typename?: 'Mutation', postFavorToggle: { __typename?: 'Post', postId: number, isFavored: boolean } };

export type PostTagUpdateMutationVariables = Exact<{
  postId: Scalars['Int'];
  tags: Array<PostTagType> | PostTagType;
}>;


export type PostTagUpdateMutation = { __typename?: 'Mutation', postTagUpdate: { __typename?: 'Post', postId: number, tags: Array<PostTagType> } };

export type PostUsefulToggleMutationVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostUsefulToggleMutation = { __typename?: 'Mutation', postUsefulToggle: { __typename?: 'Post', postId: number, isUseful: boolean, usefulCount: number } };

export type PostAddedSubscriptionVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
}>;


export type PostAddedSubscription = { __typename?: 'Subscription', postAdded: (
    { __typename?: 'Post' }
    & RequestedPostFragment
  ) };

export type PostUpdatedSubscriptionVariables = Exact<{
  postId: Scalars['Int'];
}>;


export type PostUpdatedSubscription = { __typename?: 'Subscription', postUpdated: (
    { __typename?: 'Post', postId: number, content: string, updatedAt: any, liked: boolean, likedCount: number, sharedCount: number, commentCount: number, readCount: number, usefulCount: number, isMarkdown: boolean, impact: number, files: Array<(
      { __typename?: 'File' }
      & LocalFileFragment
    )>, links: Array<(
      { __typename?: 'PostLink' }
      & RequestedPostLinkFragment
    )>, event?: Maybe<(
      { __typename?: 'Event' }
      & EventInfoFragment
    )> }
    & ThanksPostInfoFragment
  ) };

export type PostDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PostDeletedSubscription = { __typename?: 'Subscription', postDeleted: number };

export type GetBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBannersQuery = { __typename?: 'Query', banners: { __typename?: 'BannerPaginated', edges: Array<{ __typename?: 'BannerEdge', node: { __typename?: 'Banner', bannerId: number, index?: Maybe<number>, link?: Maybe<string>, file: (
          { __typename?: 'File' }
          & LocalFileFragment
        ) } }> } };

export type AddBannerMutationVariables = Exact<{
  fileId: Scalars['Int'];
}>;


export type AddBannerMutation = { __typename?: 'Mutation', addBanner: boolean };

export type SetBannerMutationVariables = Exact<{
  input: Array<SetBannerInput> | SetBannerInput;
}>;


export type SetBannerMutation = { __typename?: 'Mutation', setBanner: boolean };

export type DeleteBannerMutationVariables = Exact<{
  bannerId: Scalars['Int'];
}>;


export type DeleteBannerMutation = { __typename?: 'Mutation', deleteBanner: boolean };

export type GetFeedsRecommendedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedsRecommendedQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', trendingPosts: { __typename?: 'PostsPaginated', edges: Array<{ __typename?: 'PostEdge', node: { __typename?: 'Post', postId: number, content: string, creator?: Maybe<(
            { __typename?: 'User' }
            & UserInfoFragment
          )> } }> }, trendingGroups: { __typename?: 'GroupsPaginated', edges: Array<{ __typename?: 'GroupEdge', node: (
          { __typename?: 'Group' }
          & RequestedGroupFragment
        ) }> }, trendingUsers: Array<(
      { __typename?: 'User' }
      & UserInfoFragment
      & UserCardUsageFragment
    )>, banners: { __typename?: 'BannerPaginated', edges: Array<{ __typename?: 'BannerEdge', node: { __typename?: 'Banner', bannerId: number, index?: Maybe<number>, link?: Maybe<string>, file: (
            { __typename?: 'File' }
            & LocalFileFragment
          ) } }> } } };

export type GetOnboardingRecomGroupsQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetOnboardingRecomGroupsQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', onboardingRecommendedGroups: Array<(
      { __typename?: 'Group' }
      & RequestedGroupFragment
    )> } };

export type GetOnboardingRecomUsersQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type GetOnboardingRecomUsersQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', onboardingRecommendedUsers: Array<(
      { __typename?: 'User' }
      & UserWithExtrasFragment
    )> } };

export type SearchStateQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchStateQuery = { __typename?: 'Query', searchState: { __typename?: 'SearchState', search: string, input: string } };

export type SearchSuggestionsQueryVariables = Exact<{
  search: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
}>;


export type SearchSuggestionsQuery = { __typename?: 'Query', search: { __typename?: 'Search', suggestions: { __typename?: 'SearchSuggestions', users: Array<{ __typename?: 'SearchSuggestionUser', keyword: string, id: number, user?: Maybe<{ __typename?: 'User', userId: number, avatarUrl: string, name: string, alias: string }>, fields: Array<{ __typename?: 'SearchSuggestionField', key: string, value: string }> }>, groups: Array<{ __typename?: 'SearchSuggestion', keyword: string, id: number }>, confluence: Array<{ __typename?: 'SearchSuggestion', keyword: string }> } } };

export type SearchContentsQueryVariables = Exact<{
  search: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  orderBy?: Maybe<Scalars['String']>;
  docSource: Array<Scalars['String']> | Scalars['String'];
  docType: Array<Scalars['String']> | Scalars['String'];
}>;


export type SearchContentsQuery = { __typename?: 'Query', search: { __typename?: 'Search', contents: { __typename?: 'SearchResult', total: number, facets: Array<{ __typename?: 'SearchFacet', name: string, showName: string, values: Array<{ __typename?: 'SearchFacetValue', value: string, count: number, selected: boolean }> }>, items: Array<{ __typename?: 'SearchItem', author?: Maybe<string>, title?: Maybe<string>, body?: Maybe<string>, docSource: string, redirectLink: string, spaceName?: Maybe<string>, lastModDate?: Maybe<any>, contentId: number, authorUser?: Maybe<{ __typename?: 'User', userId: number, avatarUrl: string, name: string, email: string }> }> } } };

export type SearchUrlMetaDataQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type SearchUrlMetaDataQuery = { __typename?: 'Query', search: { __typename?: 'Search', urlMetaData: { __typename?: 'SearchUrlMetaData', failedReason?: Maybe<string>, title?: Maybe<string>, description?: Maybe<string>, logo?: Maybe<string>, url: string } } };

export type GetSectionRecentUnreadCountQueryVariables = Exact<{
  sectionIds: Array<SectionType> | SectionType;
}>;


export type GetSectionRecentUnreadCountQuery = { __typename?: 'Query', sections: Array<{ __typename?: 'Section', sectionId: SectionType, hasUnread: boolean }> };

export type SectionPostTopMutationVariables = Exact<{
  sectionId: SectionType;
  postId: Scalars['Int'];
}>;


export type SectionPostTopMutation = { __typename?: 'Mutation', sectionPostTop: { __typename?: 'Post', postId: number, sectionId?: Maybe<SectionType> } };

export type SectionPostUnTopMutationVariables = Exact<{
  sectionId: SectionType;
  postId: Scalars['Int'];
}>;


export type SectionPostUnTopMutation = { __typename?: 'Mutation', sectionPostUnTop: { __typename?: 'Post', postId: number, sectionId?: Maybe<SectionType> } };

export type SectionUnReadUpdateSubscriptionVariables = Exact<{
  sectionId: SectionType;
}>;


export type SectionUnReadUpdateSubscription = { __typename?: 'Subscription', sectionUnreadUpdate: { __typename?: 'Section', sectionId: SectionType, hasUnread: boolean } };

export type RequestedProjectFragment = { __typename?: 'Project', projectId: string, name: string, projectRole: string, priority?: Maybe<string>, status: string, url: string, progress: number };

export type GetUserProjectsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserProjectsQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, projects: Array<(
      { __typename?: 'Project' }
      & RequestedProjectFragment
    )> } };

export type RequestedUserTimelineEventFragment = { __typename?: 'UserTimelineEvent', userTimelineEventId: number, createdAt: any, actionType: UserTimelineActionType, entity?: Maybe<(
    { __typename?: 'AnniversaryCard' }
    & AnniversaryCardInfoFragment
  ) | (
    { __typename?: 'Post' }
    & RequestedPostFragment
    & ParentCommentsFragment
  )> };

export type GetUserTimelineQueryVariables = Exact<{
  userId: Scalars['Int'];
  type: Scalars['String'];
  pagination: PaginationInput;
  parentCommentPagination?: Maybe<PaginationInput>;
  childCommentPagination?: Maybe<PaginationInput>;
}>;


export type GetUserTimelineQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, timelineEvents: { __typename?: 'UserTimelineEventPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'UserTimelineEventEdge', node: (
          { __typename?: 'UserTimelineEvent' }
          & RequestedUserTimelineEventFragment
        ) }> } } };

export type RequestedKeyResultFragment = { __typename?: 'KeyResult', krId: number, name: string, score: number, importance: number, progress: number };

export type RequestedObjectiveFragment = { __typename?: 'Objective', objectiveId: number, name: string, user?: Maybe<{ __typename?: 'OKRUser', iamId: number, name: string, avatar: string, email: string, alias: string }>, krs: Array<(
    { __typename?: 'KeyResult' }
    & RequestedKeyResultFragment
  )>, parent?: Maybe<{ __typename?: 'Objective', objectiveId: number, name: string, user?: Maybe<{ __typename?: 'OKRUser', iamId: number, name: string, avatar: string, email: string, alias: string }>, krs: Array<(
      { __typename?: 'KeyResult' }
      & RequestedKeyResultFragment
    )>, department?: Maybe<{ __typename?: 'OKRDepartment', id: number, name: string }>, note?: Maybe<{ __typename?: 'OKRNote', content: string }> }>, department?: Maybe<{ __typename?: 'OKRDepartment', id: number, name: string }>, note?: Maybe<{ __typename?: 'OKRNote', content: string }> };

export type UserImpactFragment = { __typename?: 'User', impact: number, yesterdayImpact: number, contributedImpact: number };

export type UserInfoFragment = { __typename?: 'User', userId: number, email: string, name: string, alias: string, avatarUrl: string, hasUnReadEvent: boolean, isFollowing: boolean, createdAt: any };

export type RequestedUserSkillFragment = { __typename?: 'Skill', skillId: number, name: string, evaluatedUsers?: Maybe<{ __typename?: 'UsersPaginated', pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'UserEdge', node: (
        { __typename?: 'User' }
        & UserInfoFragment
      ) }> }> };

export type RequestedUserHobbyFragment = { __typename?: 'Hobby', hobbyId: number, name: string };

export type GetViewerQueryVariables = Exact<{
  url?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  withImpact?: Maybe<Scalars['Boolean']>;
  isInitialLoad?: Maybe<Scalars['Boolean']>;
  showAnnouncement?: Maybe<Scalars['Boolean']>;
  withIsAnniversaryCardCreator?: Maybe<Scalars['Boolean']>;
  withIsAnniversaryCardValidator?: Maybe<Scalars['Boolean']>;
  withHireDate?: Maybe<Scalars['Boolean']>;
  withPageVisitors?: Maybe<Scalars['Boolean']>;
  withYesterdayPageVisitors?: Maybe<Scalars['Boolean']>;
  pageVisitorPagination?: Maybe<PaginationInput>;
  yesterdayPageVisitorPagination?: Maybe<PaginationInput>;
}>;


export type GetViewerQuery = { __typename?: 'Query', viewer: (
    { __typename?: 'User', mobile: string, language: string, hasOnboarding: boolean, shouldBeAnnounced?: Maybe<boolean>, anonymousCount: number, hireDate?: Maybe<any>, latestAnniversary?: Maybe<string>, createdAt: any, updatedAt: any, isAnniversaryCardCreator?: Maybe<boolean>, isAnniversaryCardValidator?: Maybe<boolean>, departments: Array<{ __typename?: 'Department', name: string, departmentId: number, parentDepartmentId: number }>, roles: Array<{ __typename?: 'UserRole', role: Role, groupId?: Maybe<number> }>, viewedUsers: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) }>, yesterdayVisitors: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) }> }
    & UserInfoFragment
    & UserImpactFragment
  ), featureToggles: Array<{ __typename?: 'FeatureToggle', feature: string, value: string }> };

export type GetViewerJournalProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerJournalProjectsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, journalProjects: Array<string> } };

export type UserWithExtrasFragment = (
  { __typename?: 'User', departments: Array<(
    { __typename?: 'Department' }
    & RequestedDepartmentFragment
  )>, createdPosts: { __typename?: 'PostsPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'PostEdge', node: { __typename?: 'Post', postId: number } }> }, followedUsers: { __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', userId: number } }> } }
  & UserInfoFragment
);

export type GetIntroductionInfoQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetIntroductionInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, name: string, createdAt: any, departments: Array<{ __typename?: 'Department', name: string }>, basicProfile: { __typename?: 'BasicProfile', business: { __typename?: 'ValueVisibility', value: string }, skillSet: { __typename?: 'ValueVisibility', value: string }, hobbies: { __typename?: 'ValueVisibility', value: string } }, companyProfile: { __typename?: 'CompanyProfile', location: { __typename?: 'ValueVisibility', value: string } } } };

export type GetLikedUsersQueryVariables = Exact<{
  pagination: PaginationInput;
  timeSpan: Scalars['Int'];
}>;


export type GetLikedUsersQuery = { __typename?: 'Query', recommend: { __typename?: 'Recommend', usersRankedByLikes: { __typename?: 'UsersPaginated', edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User', likedCount: number }
          & UserWithExtrasFragment
        ) }> } } };

export type GetUserQueryVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
  withPageVisitors?: Maybe<Scalars['Boolean']>;
  pageVisitorPagination?: Maybe<PaginationInput>;
}>;


export type GetUserQuery = { __typename?: 'Query', user: (
    { __typename?: 'User', mobile: string, gender: string, isPinned: boolean, isFollowing: boolean, isFollowingEachOther: boolean, viewedUsers: Maybe<{ __typename?: 'UsersPaginated', totalCount: number, edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }>, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ) }> }
    & UserInfoFragment
  ) };

export type GetUserFollowingStatusQueryVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
}>;


export type GetUserFollowingStatusQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, isFollowing: boolean, isFollowingEachOther: boolean } };

export type GetViewerFollowingUsersQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetViewerFollowingUsersQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, followingUsers: { __typename?: 'UsersPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }> } } };

export type GetUserFollowingUsersQueryVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  pagination: PaginationInput;
}>;


export type GetUserFollowingUsersQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, users: { __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }> } } };

export type GetUserFollowedUsersQueryVariables = Exact<{
  userId?: Maybe<Scalars['Int']>;
  pagination: PaginationInput;
}>;


export type GetUserFollowedUsersQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, users: { __typename?: 'UsersPaginated', totalCount: number, pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User' }
          & UserInfoFragment
        ) }> } } };

export type GetUsersQueryVariables = Exact<{
  pagination: PaginationInput;
  filter: GetUsersFilter;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersPaginated', pageInfo: (
      { __typename?: 'PageInfo' }
      & RequestedPageInfoFragment
    ), edges: Array<{ __typename?: 'UserEdge', node: (
        { __typename?: 'User' }
        & UserInfoFragment
      ) }> } };

export type GetUserSidebarQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserSidebarQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, name: string, departments: Array<(
      { __typename?: 'Department' }
      & RequestedDepartmentFragment
    )>, basicProfile: (
      { __typename?: 'BasicProfile' }
      & BasicProfileFragment
    ), companyProfile: (
      { __typename?: 'CompanyProfile' }
      & CompanyProfileFragment
    ) } };

export type GetUserTaleUsageQueryVariables = Exact<{
  userId: Scalars['Int'];
  limit: Scalars['Float'];
  pagination: PaginationInput;
}>;


export type GetUserTaleUsageQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, activeGroups: Array<(
      { __typename?: 'Group' }
      & RequestedGroupFragment
    )>, featuredPosts: { __typename?: 'PostsPaginated', edges: Array<{ __typename?: 'PostEdge', node: (
          { __typename?: 'Post' }
          & RequestedPostFragment
        ) }> }, contributedKnowledge?: Maybe<{ __typename?: 'KnowledgePostPaginated', edges: Array<{ __typename?: 'KnowledgePostEdge', node: { __typename?: 'KnowledgePost', knowledgePostId: number, title: string, link?: Maybe<{ __typename?: 'KnowledgeLink', url: string }> } }> }> } };

export type GetViewerPinnedUsersQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetViewerPinnedUsersQuery = { __typename?: 'Query', viewer: { __typename?: 'User', userId: number, followingUsers: { __typename?: 'UsersPaginated', edges: Array<{ __typename?: 'UserEdge', node: (
          { __typename?: 'User', isPinned: boolean }
          & UserInfoFragment
        ) }> } } };

export type ViewerLanguageUpdateMutationVariables = Exact<{
  language: Scalars['String'];
}>;


export type ViewerLanguageUpdateMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'User', userId: number, language: string } };

export type ViewerOnboardingUpdateMutationVariables = Exact<{
  hasOnboarding?: Maybe<Scalars['Boolean']>;
}>;


export type ViewerOnboardingUpdateMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'User', userId: number, hasOnboarding: boolean } };

export type ViewerAnnouncementUpdateMutationVariables = Exact<{
  shouldBeAnnounced?: Maybe<Scalars['Boolean']>;
}>;


export type ViewerAnnouncementUpdateMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'User', userId: number, shouldBeAnnounced: boolean } };

export type UserUpdatedSubscriptionVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserUpdatedSubscription = { __typename?: 'Subscription', userUpdated: { __typename?: 'User', userId: number, impact: number, anonymousCount: number } };

export type BasicProfileFragment = { __typename?: 'BasicProfile', gender: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, englishName: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, educationBackground: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, major: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, university: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, hobbies: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, speciality: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, skillSet: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, github: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, linkedin: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, beganWorkDate: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, aboutMe: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, business: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, seatNumber: { __typename?: 'ValueVisibility', value: string, isVisible: boolean } };

export type CompanyProfileFragment = { __typename?: 'CompanyProfile', floor: string, address: string, departmentName: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, orgLeader: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, mentor: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, employedDate: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, jobType: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, email: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, workPhone: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, hrbpContact: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, financialContact: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, location: { __typename?: 'ValueVisibility', value: string, isVisible: boolean } };

export type CareerProfileFragment = { __typename?: 'CareerProfile', pastExperienceId?: Maybe<number>, organization: string, position: string, experienceType: ExperienceType, jobDescription: string, duration: string };

export type GetBasicProfileQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetBasicProfileQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, name: string, alias: string, basicProfile: (
      { __typename?: 'BasicProfile' }
      & BasicProfileFragment
    ) } };

export type GetBasicProfileAboutMeQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetBasicProfileAboutMeQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, deletedAt?: Maybe<any>, basicProfile: { __typename?: 'BasicProfile', createdAt: any, github: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, linkedin: { __typename?: 'ValueVisibility', value: string, isVisible: boolean }, aboutMe: { __typename?: 'ValueVisibility', value: string, isVisible: boolean } } } };

export type GetUserWorkCircleQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserWorkCircleQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, workCircle: { __typename?: 'WorkCircle', status: WorkCircleStatus, users: Array<Array<(
        { __typename?: 'User', departments: Array<(
          { __typename?: 'Department' }
          & RequestedDepartmentFragment
        )> }
        & UserInfoFragment
      )>> }, basicProfile: { __typename?: 'BasicProfile', createdAt: any, workCircleFeedback?: Maybe<boolean> } } };

export type GetCompanyProfileQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetCompanyProfileQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, colleagues: Array<(
      { __typename?: 'User' }
      & UserInfoFragment
    )>, leaders: Array<(
      { __typename?: 'User' }
      & UserInfoFragment
    )>, departments: Array<(
      { __typename?: 'Department' }
      & RequestedDepartmentFragment
    )>, companyProfile: (
      { __typename?: 'CompanyProfile' }
      & CompanyProfileFragment
    ), hrbp?: Maybe<(
      { __typename?: 'User' }
      & UserInfoFragment
    )>, financePartner?: Maybe<(
      { __typename?: 'User' }
      & UserInfoFragment
    )> } };

export type GetCareerProfileQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetCareerProfileQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, careerProfile: Array<(
      { __typename?: 'CareerProfile' }
      & CareerProfileFragment
    )> } };

export type GetSkillSearchQueryVariables = Exact<{
  input: SkillInput;
  userId: Scalars['Int'];
}>;


export type GetSkillSearchQuery = { __typename?: 'Query', skills: Array<{ __typename?: 'Skill', skillId: number, name: string }> };

export type GetFrequentSkillsQueryVariables = Exact<{
  input: SkillInput;
  userId: Scalars['Int'];
}>;


export type GetFrequentSkillsQuery = { __typename?: 'Query', skills: Array<{ __typename?: 'Skill', skillId: number, name: string }> };

export type GetUserSkillQueryVariables = Exact<{
  userId: Scalars['Int'];
  skillPagination: PaginationInput;
  evaluatedUserPagination: PaginationInput;
}>;


export type GetUserSkillQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, skills?: Maybe<{ __typename?: 'SkillsPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'SkillEdge', node: (
          { __typename?: 'Skill' }
          & RequestedUserSkillFragment
        ) }> }> } };

export type GetHobbySearchQueryVariables = Exact<{
  input: HobbyInput;
  userId: Scalars['Int'];
}>;


export type GetHobbySearchQuery = { __typename?: 'Query', hobbies: Array<{ __typename?: 'Hobby', hobbyId: number, name: string }> };

export type GetFrequentHobbiesQueryVariables = Exact<{
  input: HobbyInput;
  userId: Scalars['Int'];
}>;


export type GetFrequentHobbiesQuery = { __typename?: 'Query', hobbies: Array<{ __typename?: 'Hobby', hobbyId: number, name: string }> };

export type GetUserHobbiesQueryVariables = Exact<{
  userId: Scalars['Int'];
  hobbyPagination: PaginationInput;
}>;


export type GetUserHobbiesQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, hobbies?: Maybe<{ __typename?: 'HobbyPaginated', pageInfo: (
        { __typename?: 'PageInfo' }
        & RequestedPageInfoFragment
      ), edges: Array<{ __typename?: 'HobbyEdge', node: (
          { __typename?: 'Hobby' }
          & RequestedUserHobbyFragment
        ) }> }> } };

export type GetNewAgoranCardInfoQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetNewAgoranCardInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, email: string, name: string, avatarUrl: string, alias: string, isFollowing: boolean, departments: Array<{ __typename?: 'Department', departmentId: number, name: string }>, skills?: Maybe<{ __typename?: 'SkillsPaginated', edges: Array<{ __typename?: 'SkillEdge', node: { __typename?: 'Skill', skillId: number, name: string } }> }>, hobbies?: Maybe<{ __typename?: 'HobbyPaginated', edges: Array<{ __typename?: 'HobbyEdge', node: { __typename?: 'Hobby', hobbyId: number, name: string } }> }>, companyProfile: { __typename?: 'CompanyProfile', location: { __typename?: 'ValueVisibility', value: string } }, basicProfile: { __typename?: 'BasicProfile', aboutMe: { __typename?: 'ValueVisibility', value: string } } } };

export type GetUserOkrQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserOkrQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, objectivesFeature?: Maybe<{ __typename?: 'ObjectivesPaginatedFeature', objectives: Array<(
        { __typename?: 'Objective' }
        & RequestedObjectiveFragment
      )> }>, currentCycle?: Maybe<{ __typename?: 'OKRCycle', cycleId: number, name: string }> } };

export type GetUserPageInfoQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserPageInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: number, email: string, name: string, avatarUrl: string, alias: string, createdAt: any, departments: Array<{ __typename?: 'Department', departmentId: number, name: string }>, basicProfile: (
      { __typename?: 'BasicProfile', photo: { __typename?: 'PhotoIdValueVisibility', value?: Maybe<number>, isVisible: boolean }, photoFile?: Maybe<(
        { __typename?: 'File' }
        & LocalFileFragment
      )> }
      & BasicProfileFragment
    ), companyProfile: (
      { __typename?: 'CompanyProfile' }
      & CompanyProfileFragment
    ) } };

export type BasicProfileUpdateMutationVariables = Exact<{
  basicProfile: BasicProfileInput;
}>;


export type BasicProfileUpdateMutation = { __typename?: 'Mutation', basicProfileUpdate: (
    { __typename?: 'BasicProfile' }
    & BasicProfileFragment
  ) };

export type CompanyProfileUpdateMutationVariables = Exact<{
  companyProfile: CompanyProfileInput;
}>;


export type CompanyProfileUpdateMutation = { __typename?: 'Mutation', companyProfileUpdate: (
    { __typename?: 'CompanyProfile' }
    & CompanyProfileFragment
  ) };

export type CareerProfileUpdateMutationVariables = Exact<{
  careerProfile: CareerProfileInput;
}>;


export type CareerProfileUpdateMutation = { __typename?: 'Mutation', careerProfileUpdate: Array<(
    { __typename?: 'CareerProfile' }
    & CareerProfileFragment
  )> };

export type CareerProfileDeleteMutationVariables = Exact<{
  careerProfileId: Scalars['Int'];
}>;


export type CareerProfileDeleteMutation = { __typename?: 'Mutation', careerProfileDelete: number };

export type BasicProfileAboutMeUpdateMutationVariables = Exact<{
  aboutMe: ValueVisibilityInput;
}>;


export type BasicProfileAboutMeUpdateMutation = { __typename?: 'Mutation', basicProfileAboutMeUpdate: (
    { __typename?: 'BasicProfile' }
    & BasicProfileFragment
  ) };

export type ProfilePhotoUpdateMutationVariables = Exact<{
  userId: Scalars['Int'];
  fileId?: Maybe<Scalars['Int']>;
  visible: Scalars['Boolean'];
}>;


export type ProfilePhotoUpdateMutation = { __typename?: 'Mutation', photoUpdate: (
    { __typename?: 'BasicProfile', photo: { __typename?: 'PhotoIdValueVisibility', value?: Maybe<number>, isVisible: boolean } }
    & BasicProfileFragment
  ) };

export type CreateJournalProjectMutationVariables = Exact<{
  userId: Scalars['Int'];
  project: Scalars['String'];
}>;


export type CreateJournalProjectMutation = { __typename?: 'Mutation', createJournalProject: boolean };

export type DeleteJournalProjectMutationVariables = Exact<{
  userId: Scalars['Int'];
  project: Scalars['String'];
}>;


export type DeleteJournalProjectMutation = { __typename?: 'Mutation', deleteJournalProject: boolean };

export type UpdateEventReadTimestampMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateEventReadTimestampMutation = { __typename?: 'Mutation', updateEventReadTimestamp: { __typename?: 'User', userId: number, hasUnReadEvent: boolean } };

export type UserPinUpdateMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserPinUpdateMutation = { __typename?: 'Mutation', userPinUpdate: { __typename?: 'User', userId: number, isPinned: boolean } };

export type UserSkillUpdateMutationVariables = Exact<{
  userId: Scalars['Int'];
  skillId: Scalars['Int'];
}>;


export type UserSkillUpdateMutation = { __typename?: 'Mutation', userSkillUpdate: string };

export type UserSkillBatchUpdateMutationVariables = Exact<{
  userId: Scalars['Int'];
  skillIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UserSkillBatchUpdateMutation = { __typename?: 'Mutation', userSkillBatchUpdate: { __typename?: 'User', userId: number } };

export type UserHobbyUpdateMutationVariables = Exact<{
  userId: Scalars['Int'];
  hobbyId: Scalars['Int'];
}>;


export type UserHobbyUpdateMutation = { __typename?: 'Mutation', userHobbyUpdate: boolean };

export type UserHobbyBatchUpdateMutationVariables = Exact<{
  userId: Scalars['Int'];
  hobbyIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UserHobbyBatchUpdateMutation = { __typename?: 'Mutation', userHobbyBatchUpdate: { __typename?: 'User', userId: number } };

export type UserAboutMePartUpdateMutationVariables = Exact<{
  input: UserInfoAboutMePartInput;
}>;


export type UserAboutMePartUpdateMutation = { __typename?: 'Mutation', userAboutMePartUpdate: string };

export type SkillCreateMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type SkillCreateMutation = { __typename?: 'Mutation', skillCreate?: Maybe<{ __typename?: 'Skill', skillId: number, name: string }> };

export type HobbyCreateMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type HobbyCreateMutation = { __typename?: 'Mutation', hobbyCreate?: Maybe<{ __typename?: 'Hobby', hobbyId: number, name: string }> };

export type UserInfoHeaderUpdateMutationVariables = Exact<{
  input: UserInfoHeaderInput;
}>;


export type UserInfoHeaderUpdateMutation = { __typename?: 'Mutation', userInfoHeaderUpdate: boolean };

export type UserInfoEditModalUpdateMutationVariables = Exact<{
  input: UserInfoEditModalInput;
}>;


export type UserInfoEditModalUpdateMutation = { __typename?: 'Mutation', userInfoEditModalUpdate: boolean };

export type UserInfoWorkCircleFeedBackUpdateMutationVariables = Exact<{
  feedback: Scalars['Boolean'];
}>;


export type UserInfoWorkCircleFeedBackUpdateMutation = { __typename?: 'Mutation', userInfoWorkCircleFeedBackUpdate: boolean };

export type WebsiteCategoryInfoFragment = { __typename?: 'WebsiteCategory', websiteCategoryId: number, title: string };

export type WebsiteCategoryInfoWithPaginatedFragment = (
  { __typename?: 'WebsiteCategory', websites: { __typename?: 'WebsitePaginated', edges: Array<{ __typename?: 'WebsiteEdge', node: (
        { __typename?: 'Website' }
        & WebsiteInfoFragment
      ) }> } }
  & WebsiteCategoryInfoFragment
);

export type WebsiteInfoFragment = { __typename?: 'Website', websiteId: number, title: string, description: string, url: string, isCommon: boolean, faviconUrl?: Maybe<string>, websiteCategoryId: number, maintainers: Array<(
    { __typename?: 'User' }
    & UserInfoFragment
  )> };

export type GetWebsiteCategoriesQueryVariables = Exact<{
  categoryPagination: PaginationInput;
  pagination: PaginationInput;
}>;


export type GetWebsiteCategoriesQuery = { __typename?: 'Query', website: { __typename?: 'WebsiteNS', categories: { __typename?: 'WebsiteCategoryPaginated', edges: Array<{ __typename?: 'WebsiteCategoryEdge', node: (
          { __typename?: 'WebsiteCategory' }
          & WebsiteCategoryInfoWithPaginatedFragment
        ) }> } } };

export type GetWebsitesQueryVariables = Exact<{
  pagination: PaginationInput;
  isCommon?: Maybe<Scalars['Boolean']>;
}>;


export type GetWebsitesQuery = { __typename?: 'Query', website: { __typename?: 'WebsiteNS', entities: { __typename?: 'WebsitePaginated', edges: Array<{ __typename?: 'WebsiteEdge', node: (
          { __typename?: 'Website' }
          & WebsiteInfoFragment
        ) }> } } };

export type WebsiteAddMutationVariables = Exact<{
  websiteCreateInput: WebsiteCreateInput;
}>;


export type WebsiteAddMutation = { __typename?: 'Mutation', websiteAdd: (
    { __typename?: 'Website' }
    & WebsiteInfoFragment
  ) };

export type WebsiteUpdateMutationVariables = Exact<{
  websiteId: Scalars['Int'];
  websiteUpdateInput: WebsiteUpdateInput;
}>;


export type WebsiteUpdateMutation = { __typename?: 'Mutation', websiteUpdate: (
    { __typename?: 'Website' }
    & WebsiteInfoFragment
  ) };

export type WebsiteDeleteMutationVariables = Exact<{
  websiteId: Scalars['Int'];
}>;


export type WebsiteDeleteMutation = { __typename?: 'Mutation', websiteDelete: boolean };

export type WebsiteCategoryAddMutationVariables = Exact<{
  websiteCategoryCreateInput: WebsiteCategoryCreateInput;
}>;


export type WebsiteCategoryAddMutation = { __typename?: 'Mutation', websiteCategoryAdd: (
    { __typename?: 'WebsiteCategory' }
    & WebsiteCategoryInfoFragment
  ) };

export type WebsiteCategoryUpdateMutationVariables = Exact<{
  websiteCategoryId: Scalars['Int'];
  websiteCategoryUpdateInput: WebsiteCategoryUpdateInput;
}>;


export type WebsiteCategoryUpdateMutation = { __typename?: 'Mutation', websiteCategoryUpdate: (
    { __typename?: 'WebsiteCategory' }
    & WebsiteCategoryInfoFragment
  ) };

export type WebsiteCommonToggleMutationVariables = Exact<{
  websiteId: Scalars['Int'];
}>;


export type WebsiteCommonToggleMutation = { __typename?: 'Mutation', toggleWebsiteCommon: { __typename?: 'Website', websiteId: number, isCommon: boolean } };

export type RequestedPageInfoFragment = { __typename?: 'PageInfo', startCursor?: Maybe<string>, endCursor?: Maybe<string>, hasPreviousPage: boolean, hasNextPage: boolean };

export const RequestedPageInfoFragmentDoc = gql`
    fragment RequestedPageInfo on PageInfo {
  startCursor
  endCursor
  hasPreviousPage
  hasNextPage
}
    `;
export const RequestedGroupFragmentDoc = gql`
    fragment RequestedGroup on Group {
  groupId
  name
  isPinned
  description
  creatorUserId
  privateSetting
  isOfficial
  isFollowing
  canUnfollow
  canPostAnonymously
  whoCanPost
  groupCategoryId
  featuredAt
  category {
    groupCategoryId
    name
  }
  pmoProjectId
  pmoLink
}
    `;
export const RequestedGroupsPaginatedFragmentDoc = gql`
    fragment RequestedGroupsPaginated on GroupsPaginated {
  pageInfo {
    ...RequestedPageInfo
  }
  edges {
    node {
      ...RequestedGroup
      creator {
        userId
      }
    }
  }
  totalCount
}
    ${RequestedPageInfoFragmentDoc}
${RequestedGroupFragmentDoc}`;
export const UserCardUsageFragmentDoc = gql`
    fragment UserCardUsage on User {
  createdPosts(filter: {}, pagination: {last: 0}) {
    totalCount
  }
  followedUsers(filter: {}, pagination: {last: 0}) {
    totalCount
  }
  featuredPosts(pagination: {last: 0}) {
    totalCount
  }
  contributedKnowledge(pagination: {last: 0}) {
    totalCount
  }
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  userId
  email
  name
  alias
  avatarUrl
  hasUnReadEvent
  isFollowing
  createdAt
}
    `;
export const RequestedDepartmentFragmentDoc = gql`
    fragment RequestedDepartment on Department {
  departmentId
  parentDepartmentId
  name
}
    `;
export const UserWithExtrasFragmentDoc = gql`
    fragment UserWithExtras on User {
  ...UserInfo
  departments {
    ...RequestedDepartment
  }
  createdPosts(pagination: {last: 0}, filter: {isArchived: false}) {
    totalCount
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        postId
      }
    }
  }
  followedUsers(pagination: {last: 0}, filter: {}) {
    totalCount
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        userId
      }
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedDepartmentFragmentDoc}
${RequestedPageInfoFragmentDoc}`;
export const RequestedUsersPaginatedFragmentDoc = gql`
    fragment RequestedUsersPaginated on UsersPaginated {
  pageInfo {
    ...RequestedPageInfo
  }
  edges {
    node {
      ...UserWithExtras
    }
  }
  totalCount
}
    ${RequestedPageInfoFragmentDoc}
${UserWithExtrasFragmentDoc}`;
export const AnniversaryCardInfoFragmentDoc = gql`
    fragment AnniversaryCardInfo on AnniversaryCard {
  anniversaryCardId
  anniversary
  creatorUserId
  createdAt
  updatedAt
  hireDate
  cardCreator: creator {
    ...UserInfo
    departments {
      ...RequestedDepartment
    }
  }
  cardReceiver: receiver {
    ...UserInfo
    departments {
      ...RequestedDepartment
    }
  }
  receiverUserId
  header
  content
  footer
  isRead
}
    ${UserInfoFragmentDoc}
${RequestedDepartmentFragmentDoc}`;
export const UserInfoWithAnniversaryCardFragmentDoc = gql`
    fragment UserInfoWithAnniversaryCard on User {
  ...UserInfo
  requestedAnniversary
  hireDate
  anniversaryCards {
    ...AnniversaryCardInfo
  }
}
    ${UserInfoFragmentDoc}
${AnniversaryCardInfoFragmentDoc}`;
export const RequestedAnnualReportFragmentDoc = gql`
    fragment RequestedAnnualReport on AnnualReport {
  firstLandingDate
  firstPostingDate
  totalLandingCount
  totalLandingDateCount
  totalPostCount
  totalPostCommentCount
  totalPostLikedCount
  totalFollowedGroupCount
  totalFollowedEachOtherCount
  totalEventParticipatedCount
  highestRateLandingDate
  totalGroupCount
  identity
  totalCommonGroupWithWorkCircleCount {
    groupId
    name
    followers(filter: {}, pagination: {last: 0}) {
      totalCount
    }
  }
  okr {
    total
    firstContent
  }
  project {
    participatedCount
    ownedCount
  }
}
    `;
export const RequestedDepartmentWithMembersFragmentDoc = gql`
    fragment RequestedDepartmentWithMembers on Department {
  departmentId
  parentDepartmentId
  name
  members {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export const GroupWithExtrasFragmentDoc = gql`
    fragment GroupWithExtras on Group {
  ...RequestedGroup
  createdAt
  creator {
    ...UserInfo
  }
  posts(pagination: {last: 0}, filter: {}) @include(if: $withPosts) {
    totalCount
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        postId
      }
    }
  }
  followers(pagination: {last: 0}, filter: {}) @include(if: $withFollowers) {
    totalCount
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        userId
      }
    }
  }
}
    ${RequestedGroupFragmentDoc}
${UserInfoFragmentDoc}
${RequestedPageInfoFragmentDoc}`;
export const RequestedKnowledgeGroupFragmentDoc = gql`
    fragment RequestedKnowledgeGroup on KnowledgeGroup {
  knowledgeGroupId
  parentKnowledgeGroupId
  creatorUserId
  creator {
    ...UserInfo
  }
  name
  description
  path
  parentGroups {
    knowledgeGroupId
    name
  }
}
    ${UserInfoFragmentDoc}`;
export const LocalFileFragmentDoc = gql`
    fragment LocalFile on File {
  fileId
  name
  size
  type
  url
  oss {
    uploadUrl
    expireAt
    key
    OSSAccessKeyId
    Signature
    policy
    success_action_status
  }
}
    `;
export const RequestedKnowledgePostFragmentDoc = gql`
    fragment RequestedKnowledgePost on KnowledgePost {
  knowledgePostId
  knowledgeGroupId
  creatorUserId
  authorId
  author {
    ...UserInfo
  }
  title
  link {
    knowledgePostLinkId
    url
  }
  description
  files {
    ...LocalFile
  }
}
    ${UserInfoFragmentDoc}
${LocalFileFragmentDoc}`;
export const StatisticValueInfoFragmentDoc = gql`
    fragment StatisticValueInfo on StatisticValue {
  year
  yearMonth
  yearWeek
  date
  value
}
    `;
export const StatisticCentralTendencyImpactInfoFragmentDoc = gql`
    fragment StatisticCentralTendencyImpactInfo on StatisticCentralTendencyImpactValue {
  median
  mode
  mean
  date
}
    `;
export const StatisticUserInfoFragmentDoc = gql`
    fragment StatisticUserInfo on StatisticUserValue {
  userId
  name
  email
  date
  yearMonth
  year
  landingCount
  landingDayCount
  postingCount
  interactionCount
  beenVisitedCount
  visitCount
}
    `;
export const StatisticImpactInfoFragmentDoc = gql`
    fragment StatisticImpactInfo on StatisticImpactValue {
  userId
  name
  email
  impact
  date
}
    `;
export const StatisticPostTagTypePercentageInfoFragmentDoc = gql`
    fragment StatisticPostTagTypePercentageInfo on StatisticPostContentTagValue {
  year
  yearMonth
  yearWeek
  date
  data {
    tag
    tagName
    count
  }
}
    `;
export const RequestedNotificationSettingFragmentDoc = gql`
    fragment RequestedNotificationSetting on NotificationSetting {
  notificationSettingId
  contentType
  outletType
  isActive
}
    `;
export const NotificationGroupFragmentDoc = gql`
    fragment NotificationGroup on Group {
  groupId
  name
  description
}
    `;
export const NotificationUserFragmentDoc = gql`
    fragment NotificationUser on User {
  userId
  name
  avatarUrl
  email
}
    `;
export const RequestedNotificationFragmentDoc = gql`
    fragment RequestedNotification on Notification {
  notificationId
  actionType
  message {
    phrase
    content
    targetKind
    targetId
  }
  creators {
    ...NotificationUser
  }
  createdAt
}
    ${NotificationUserFragmentDoc}`;
export const RequestedLikedUsersFragmentDoc = gql`
    fragment RequestedLikedUsers on Post {
  likedUsers(pagination: {last: 9}) {
    edges {
      node {
        userId
        avatarUrl
        email
      }
    }
  }
}
    `;
export const ThanksPostInfoFragmentDoc = gql`
    fragment ThanksPostInfo on Post {
  receiver {
    userId
    name
    gender
    email
  }
  postType
}
    `;
export const RequestedPostLinkFragmentDoc = gql`
    fragment RequestedPostLink on PostLink {
  title
  description
  logo
  url
}
    `;
export const RequestedPostGroupFragmentDoc = gql`
    fragment RequestedPostGroup on Group {
  groupId
  name
  creatorUserId
  privateSetting
  canPostAnonymously
}
    `;
export const RequestedPostMentionFragmentDoc = gql`
    fragment RequestedPostMention on Mention {
  mentionId
  user {
    userId
    email
    name
    avatarUrl
  }
}
    `;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on Event {
  eventId
  topic
  isParticipated
  isInterested
  startTime
  endTime
  deadline
  postId
}
    `;
export const EventInfoWithExtraFragmentDoc = gql`
    fragment EventInfoWithExtra on Event {
  ...EventInfo
  content
  location
  openPosition
  restriction
  foreignGuests
  guests {
    user {
      ...UserInfo
    }
  }
  avcRoom
  avcPassword
  avcLink
  participatedCount
  interestedCount
}
    ${EventInfoFragmentDoc}
${UserInfoFragmentDoc}`;
export const HonorPostInfoFragmentDoc = gql`
    fragment HonorPostInfo on Honor {
  honorId
  postId
  title
  commendation
  honoredProjects
  honoredIndividuals {
    user {
      ...UserInfo
    }
  }
  honoredSignificants {
    user {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}`;
export const AnnouncementInfoFragmentDoc = gql`
    fragment AnnouncementInfo on Announcement {
  announcementId
  title
  type
  content
  postId
  repliedType
}
    `;
export const RequestedPostFragmentDoc = gql`
    fragment RequestedPost on Post {
  postId
  originalPostId
  content
  groupId
  sectionId
  isMarkdown
  createdAt
  updatedAt
  archivedAt
  featuredAt
  liked
  likedCount
  isFeaturedTop
  isCommentDisplayable
  readCount
  commentCount
  isRead
  isAnonymous
  sharedCount
  isFavored
  isViewerCreated
  isUseful
  usefulCount
  tags
  ...RequestedLikedUsers
  ...ThanksPostInfo
  creator {
    ...UserInfo
  }
  files {
    ...LocalFile
  }
  links {
    ...RequestedPostLink
  }
  group {
    ...RequestedPostGroup
  }
  mentions {
    ...RequestedPostMention
  }
  event {
    ...EventInfoWithExtra
  }
  honor {
    ...HonorPostInfo
  }
  announcement {
    ...AnnouncementInfo
  }
  originalPost {
    postId
    content
    isViewerCreated
    isMarkdown
    createdAt
    updatedAt
    ...ThanksPostInfo
    group {
      ...RequestedPostGroup
    }
    creator {
      ...UserInfo
    }
    files {
      ...LocalFile
    }
    links {
      ...RequestedPostLink
    }
    event {
      ...EventInfoWithExtra
    }
  }
}
    ${RequestedLikedUsersFragmentDoc}
${ThanksPostInfoFragmentDoc}
${UserInfoFragmentDoc}
${LocalFileFragmentDoc}
${RequestedPostLinkFragmentDoc}
${RequestedPostGroupFragmentDoc}
${RequestedPostMentionFragmentDoc}
${EventInfoWithExtraFragmentDoc}
${HonorPostInfoFragmentDoc}
${AnnouncementInfoFragmentDoc}`;
export const RequestedCommentFragmentDoc = gql`
    fragment RequestedComment on Comment {
  commentId
  postId
  parentCommentId
  content
  createdAt
  updatedAt
  liked
  likedCount
  isViewerCreated
  isAnonymous
  creator {
    ...UserInfo
  }
  mentions {
    ...RequestedPostMention
  }
}
    ${UserInfoFragmentDoc}
${RequestedPostMentionFragmentDoc}`;
export const ChildCommentsFragmentDoc = gql`
    fragment ChildComments on Comment {
  comments(pagination: $childCommentPagination) {
    totalCount
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      cursor
      node {
        ...RequestedComment
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedCommentFragmentDoc}`;
export const ParentCommentsFragmentDoc = gql`
    fragment ParentComments on Post {
  comments(pagination: $parentCommentPagination) {
    totalCount
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      cursor
      node {
        ...RequestedComment
        ...ChildComments
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedCommentFragmentDoc}
${ChildCommentsFragmentDoc}`;
export const RequestedRecommendPostInfoFragmentDoc = gql`
    fragment RequestedRecommendPostInfo on RecommendPostInfo {
  commentFolloweeIds
  likedFolloweeIds
  commentFollowees {
    ...UserInfo
  }
  likedFollowees {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export const TimelinePostsFragmentDoc = gql`
    fragment TimelinePosts on PostsPaginated {
  pageInfo {
    ...RequestedPageInfo
  }
  edges {
    cursor
    node {
      ...RequestedPost
      ...ParentComments
      recommendPostInfo {
        ...RequestedRecommendPostInfo
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}
${RequestedRecommendPostInfoFragmentDoc}`;
export const PostsFragmentDoc = gql`
    fragment Posts on PostsPaginated {
  pageInfo {
    ...RequestedPageInfo
  }
  edges {
    cursor
    node {
      ...RequestedPost
      ...ParentComments
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}`;
export const RequestedProjectFragmentDoc = gql`
    fragment RequestedProject on Project {
  projectId
  name
  projectRole
  priority
  status
  url
  progress
}
    `;
export const RequestedUserTimelineEventFragmentDoc = gql`
    fragment RequestedUserTimelineEvent on UserTimelineEvent {
  userTimelineEventId
  createdAt
  actionType
  entity {
    ... on Post {
      ...RequestedPost
      ...ParentComments
    }
    ... on AnniversaryCard {
      ...AnniversaryCardInfo
    }
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}
${AnniversaryCardInfoFragmentDoc}`;
export const RequestedKeyResultFragmentDoc = gql`
    fragment RequestedKeyResult on KeyResult {
  krId
  name
  score
  importance
  progress
}
    `;
export const RequestedObjectiveFragmentDoc = gql`
    fragment RequestedObjective on Objective {
  objectiveId
  name
  user {
    iamId
    name
    avatar
    email
    alias
  }
  krs {
    ...RequestedKeyResult
  }
  parent {
    objectiveId
    name
    user {
      iamId
      name
      avatar
      email
      alias
    }
    krs {
      ...RequestedKeyResult
    }
    department {
      id
      name
    }
    note {
      content
    }
  }
  department {
    id
    name
  }
  note {
    content
  }
}
    ${RequestedKeyResultFragmentDoc}`;
export const UserImpactFragmentDoc = gql`
    fragment UserImpact on User {
  impact
  yesterdayImpact
  contributedImpact
}
    `;
export const RequestedUserSkillFragmentDoc = gql`
    fragment RequestedUserSkill on Skill {
  skillId
  name
  evaluatedUsers(userId: $userId, pagination: $evaluatedUserPagination) {
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        ...UserInfo
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}`;
export const RequestedUserHobbyFragmentDoc = gql`
    fragment RequestedUserHobby on Hobby {
  hobbyId
  name
}
    `;
export const BasicProfileFragmentDoc = gql`
    fragment BasicProfile on BasicProfile {
  gender {
    value
    isVisible
  }
  englishName {
    value
    isVisible
  }
  educationBackground {
    value
    isVisible
  }
  major {
    value
    isVisible
  }
  university {
    value
    isVisible
  }
  hobbies {
    value
    isVisible
  }
  speciality {
    value
    isVisible
  }
  skillSet {
    value
    isVisible
  }
  github {
    value
    isVisible
  }
  linkedin {
    value
    isVisible
  }
  beganWorkDate {
    value
    isVisible
  }
  aboutMe {
    value
    isVisible
  }
  business {
    value
    isVisible
  }
  seatNumber {
    value
    isVisible
  }
}
    `;
export const CompanyProfileFragmentDoc = gql`
    fragment CompanyProfile on CompanyProfile {
  departmentName {
    value
    isVisible
  }
  orgLeader {
    value
    isVisible
  }
  mentor {
    value
    isVisible
  }
  employedDate {
    value
    isVisible
  }
  jobType {
    value
    isVisible
  }
  email {
    value
    isVisible
  }
  workPhone {
    value
    isVisible
  }
  hrbpContact {
    value
    isVisible
  }
  financialContact {
    value
    isVisible
  }
  location {
    value
    isVisible
  }
  floor
  address
}
    `;
export const CareerProfileFragmentDoc = gql`
    fragment CareerProfile on CareerProfile {
  pastExperienceId
  organization
  position
  experienceType
  jobDescription
  duration
}
    `;
export const WebsiteCategoryInfoFragmentDoc = gql`
    fragment WebsiteCategoryInfo on WebsiteCategory {
  websiteCategoryId
  title
}
    `;
export const WebsiteInfoFragmentDoc = gql`
    fragment WebsiteInfo on Website {
  websiteId
  title
  description
  url
  isCommon
  faviconUrl
  websiteCategoryId
  maintainers {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export const WebsiteCategoryInfoWithPaginatedFragmentDoc = gql`
    fragment WebsiteCategoryInfoWithPaginated on WebsiteCategory {
  ...WebsiteCategoryInfo
  websites(pagination: $pagination) {
    edges {
      node {
        ...WebsiteInfo
      }
    }
  }
}
    ${WebsiteCategoryInfoFragmentDoc}
${WebsiteInfoFragmentDoc}`;
export const GetGroupCardInfoDocument = gql`
    query GetGroupCardInfo($groupId: Int!) {
  group(groupId: $groupId) {
    ...RequestedGroup
    isFollowing
    isPinned
    creator {
      userId
      name
      avatarUrl
      departments {
        departmentId
        name
      }
    }
    followers(filter: {}, pagination: {last: 0}) {
      totalCount
    }
    posts(filter: {}, pagination: {last: 0}) {
      totalCount
    }
  }
}
    ${RequestedGroupFragmentDoc}`;

/**
 * __useGetGroupCardInfoQuery__
 *
 * To run a query within a React component, call `useGetGroupCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupCardInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupCardInfoQuery(baseOptions: Apollo.QueryHookOptions<GetGroupCardInfoQuery, GetGroupCardInfoQueryVariables>) {
        return Apollo.useQuery<GetGroupCardInfoQuery, GetGroupCardInfoQueryVariables>(GetGroupCardInfoDocument, baseOptions);
      }
export function useGetGroupCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupCardInfoQuery, GetGroupCardInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupCardInfoQuery, GetGroupCardInfoQueryVariables>(GetGroupCardInfoDocument, baseOptions);
        }
export type GetGroupCardInfoQueryHookResult = ReturnType<typeof useGetGroupCardInfoQuery>;
export type GetGroupCardInfoLazyQueryHookResult = ReturnType<typeof useGetGroupCardInfoLazyQuery>;
export type GetGroupCardInfoQueryResult = Apollo.QueryResult<GetGroupCardInfoQuery, GetGroupCardInfoQueryVariables>;
export const GetGroupListDocument = gql`
    query GetGroupList($userId: Int!, $pagination: PaginationInput!, $filter: GetGroupsFilter!, $withViewer: Boolean = false, $withUser: Boolean = false, $withFollowing: Boolean = false, $withCreated: Boolean = false, $withActive: Boolean = false) {
  viewer @include(if: $withViewer) {
    userId
    activeGroups(limit: 5) @include(if: $withActive) {
      ...RequestedGroup
    }
    followingGroups(pagination: $pagination, filter: $filter) @include(if: $withFollowing) {
      ...RequestedGroupsPaginated
    }
    createdGroups(pagination: $pagination, filter: $filter) @include(if: $withCreated) {
      ...RequestedGroupsPaginated
    }
  }
  user(userId: $userId) @include(if: $withUser) {
    userId
    followingGroups(pagination: $pagination, filter: $filter) @include(if: $withFollowing) {
      ...RequestedGroupsPaginated
    }
    createdGroups(pagination: $pagination, filter: $filter) @include(if: $withCreated) {
      ...RequestedGroupsPaginated
    }
  }
}
    ${RequestedGroupFragmentDoc}
${RequestedGroupsPaginatedFragmentDoc}`;

/**
 * __useGetGroupListQuery__
 *
 * To run a query within a React component, call `useGetGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      withViewer: // value for 'withViewer'
 *      withUser: // value for 'withUser'
 *      withFollowing: // value for 'withFollowing'
 *      withCreated: // value for 'withCreated'
 *      withActive: // value for 'withActive'
 *   },
 * });
 */
export function useGetGroupListQuery(baseOptions: Apollo.QueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>) {
        return Apollo.useQuery<GetGroupListQuery, GetGroupListQueryVariables>(GetGroupListDocument, baseOptions);
      }
export function useGetGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupListQuery, GetGroupListQueryVariables>(GetGroupListDocument, baseOptions);
        }
export type GetGroupListQueryHookResult = ReturnType<typeof useGetGroupListQuery>;
export type GetGroupListLazyQueryHookResult = ReturnType<typeof useGetGroupListLazyQuery>;
export type GetGroupListQueryResult = Apollo.QueryResult<GetGroupListQuery, GetGroupListQueryVariables>;
export const GetGroupSelectorListDocument = gql`
    query GetGroupSelectorList {
  viewer {
    userId
    activeGroups(limit: 3) {
      ...RequestedGroup
    }
  }
  recommend {
    selectorsRecommendedGroups {
      ...RequestedGroup
    }
  }
}
    ${RequestedGroupFragmentDoc}`;

/**
 * __useGetGroupSelectorListQuery__
 *
 * To run a query within a React component, call `useGetGroupSelectorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupSelectorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupSelectorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupSelectorListQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupSelectorListQuery, GetGroupSelectorListQueryVariables>) {
        return Apollo.useQuery<GetGroupSelectorListQuery, GetGroupSelectorListQueryVariables>(GetGroupSelectorListDocument, baseOptions);
      }
export function useGetGroupSelectorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupSelectorListQuery, GetGroupSelectorListQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupSelectorListQuery, GetGroupSelectorListQueryVariables>(GetGroupSelectorListDocument, baseOptions);
        }
export type GetGroupSelectorListQueryHookResult = ReturnType<typeof useGetGroupSelectorListQuery>;
export type GetGroupSelectorListLazyQueryHookResult = ReturnType<typeof useGetGroupSelectorListLazyQuery>;
export type GetGroupSelectorListQueryResult = Apollo.QueryResult<GetGroupSelectorListQuery, GetGroupSelectorListQueryVariables>;
export const SearchUserDocument = gql`
    query SearchUser($pagination: PaginationInput!, $filter: GetUsersFilter!) {
  users(pagination: $pagination, filter: $filter) {
    edges {
      node {
        ...UserInfo
      }
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: Apollo.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
        return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, baseOptions);
      }
export function useSearchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, baseOptions);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const GetPostListDocument = gql`
    query GetPostList($pagination: PaginationInput!, $parentCommentPagination: PaginationInput = {last: 0}, $childCommentPagination: PaginationInput = {last: 0}, $withCommentedPosts: Boolean = false, $withFavoredPosts: Boolean = false, $withLikedPosts: Boolean = false, $withUsefulPosts: Boolean = false) {
  viewer {
    userId
    commentedPosts(pagination: $pagination) @include(if: $withCommentedPosts) {
      ...Posts
    }
    favoredPosts(pagination: $pagination) @include(if: $withFavoredPosts) {
      ...Posts
    }
    likedPosts(pagination: $pagination) @include(if: $withLikedPosts) {
      ...Posts
    }
    userfulPosts(pagination: $pagination) @include(if: $withUsefulPosts) {
      ...Posts
    }
  }
}
    ${PostsFragmentDoc}`;

/**
 * __useGetPostListQuery__
 *
 * To run a query within a React component, call `useGetPostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostListQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *      withCommentedPosts: // value for 'withCommentedPosts'
 *      withFavoredPosts: // value for 'withFavoredPosts'
 *      withLikedPosts: // value for 'withLikedPosts'
 *      withUsefulPosts: // value for 'withUsefulPosts'
 *   },
 * });
 */
export function useGetPostListQuery(baseOptions: Apollo.QueryHookOptions<GetPostListQuery, GetPostListQueryVariables>) {
        return Apollo.useQuery<GetPostListQuery, GetPostListQueryVariables>(GetPostListDocument, baseOptions);
      }
export function useGetPostListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostListQuery, GetPostListQueryVariables>) {
          return Apollo.useLazyQuery<GetPostListQuery, GetPostListQueryVariables>(GetPostListDocument, baseOptions);
        }
export type GetPostListQueryHookResult = ReturnType<typeof useGetPostListQuery>;
export type GetPostListLazyQueryHookResult = ReturnType<typeof useGetPostListLazyQuery>;
export type GetPostListQueryResult = Apollo.QueryResult<GetPostListQuery, GetPostListQueryVariables>;
export const GetDescendantPostDocument = gql`
    query GetDescendantPost($postId: Int!, $pagination: PaginationInput!) {
  post(postId: $postId) {
    postId
    descendantPosts(pagination: $pagination) {
      edges {
        node {
          postId
          content
          createdAt
          creator {
            ...UserInfo
          }
          group {
            groupId
            name
          }
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetDescendantPostQuery__
 *
 * To run a query within a React component, call `useGetDescendantPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDescendantPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDescendantPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetDescendantPostQuery(baseOptions: Apollo.QueryHookOptions<GetDescendantPostQuery, GetDescendantPostQueryVariables>) {
        return Apollo.useQuery<GetDescendantPostQuery, GetDescendantPostQueryVariables>(GetDescendantPostDocument, baseOptions);
      }
export function useGetDescendantPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDescendantPostQuery, GetDescendantPostQueryVariables>) {
          return Apollo.useLazyQuery<GetDescendantPostQuery, GetDescendantPostQueryVariables>(GetDescendantPostDocument, baseOptions);
        }
export type GetDescendantPostQueryHookResult = ReturnType<typeof useGetDescendantPostQuery>;
export type GetDescendantPostLazyQueryHookResult = ReturnType<typeof useGetDescendantPostLazyQuery>;
export type GetDescendantPostQueryResult = Apollo.QueryResult<GetDescendantPostQuery, GetDescendantPostQueryVariables>;
export const GetUserCardInfoDocument = gql`
    query GetUserCardInfo($userId: Int, $userName: String) {
  user(userId: $userId, userName: $userName) {
    userId
    email
  }
}
    `;

/**
 * __useGetUserCardInfoQuery__
 *
 * To run a query within a React component, call `useGetUserCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCardInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useGetUserCardInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCardInfoQuery, GetUserCardInfoQueryVariables>) {
        return Apollo.useQuery<GetUserCardInfoQuery, GetUserCardInfoQueryVariables>(GetUserCardInfoDocument, baseOptions);
      }
export function useGetUserCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCardInfoQuery, GetUserCardInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetUserCardInfoQuery, GetUserCardInfoQueryVariables>(GetUserCardInfoDocument, baseOptions);
        }
export type GetUserCardInfoQueryHookResult = ReturnType<typeof useGetUserCardInfoQuery>;
export type GetUserCardInfoLazyQueryHookResult = ReturnType<typeof useGetUserCardInfoLazyQuery>;
export type GetUserCardInfoQueryResult = Apollo.QueryResult<GetUserCardInfoQuery, GetUserCardInfoQueryVariables>;
export const GetUserListDocument = gql`
    query GetUserList($userId: Int!, $groupId: Int!, $postId: Int!, $eventId: Int!, $pagination: PaginationInput!, $filter: GetUsersFilter!, $withAllUsers: Boolean = false, $withUser: Boolean = false, $withGroup: Boolean = false, $withPost: Boolean = false, $withEvent: Boolean = false, $withFollowingUsers: Boolean = false, $withFollowedUsers: Boolean = false, $withGroupMembers: Boolean = false, $withGroupAdmins: Boolean = false, $withPostLikedUsers: Boolean = false, $withPostReadUsers: Boolean = false, $withPostSharedUsers: Boolean = false, $withPostFeltUsefulUsers: Boolean = false, $withEventParticipants: Boolean = false, $withEventInterestedUsers: Boolean = false, $withYesterdayVisitors: Boolean = false, $withUserPageVisitors: Boolean = false) {
  users(pagination: $pagination, filter: $filter) @include(if: $withAllUsers) {
    ...RequestedUsersPaginated
  }
  user(userId: $userId) @include(if: $withUser) {
    userId
    followingUsers(pagination: $pagination, filter: $filter) @include(if: $withFollowingUsers) {
      ...RequestedUsersPaginated
    }
    followedUsers(pagination: $pagination, filter: $filter) @include(if: $withFollowedUsers) {
      ...RequestedUsersPaginated
    }
    yesterdayVisitors(pagination: $pagination) @include(if: $withYesterdayVisitors) {
      ...RequestedUsersPaginated
    }
    viewedUsers(pagination: $pagination) @include(if: $withUserPageVisitors) {
      ...RequestedUsersPaginated
    }
  }
  group(groupId: $groupId) @include(if: $withGroup) {
    groupId
    followers(pagination: $pagination, filter: $filter) @include(if: $withGroupMembers) {
      ...RequestedUsersPaginated
    }
    admins(pagination: $pagination, filter: $filter) @include(if: $withGroupAdmins) {
      ...RequestedUsersPaginated
    }
  }
  post(postId: $postId) @include(if: $withPost) {
    postId
    likedUsers(pagination: $pagination) @include(if: $withPostLikedUsers) {
      ...RequestedUsersPaginated
    }
    readUsers(pagination: $pagination) @include(if: $withPostReadUsers) {
      ...RequestedUsersPaginated
    }
    sharedUsers(pagination: $pagination) @include(if: $withPostSharedUsers) {
      ...RequestedUsersPaginated
    }
    feltUsefulUsers(pagination: $pagination) @include(if: $withPostFeltUsefulUsers) {
      ...RequestedUsersPaginated
    }
  }
  event(eventId: $eventId) @include(if: $withEvent) {
    eventId
    topic
    participants(pagination: $pagination, filter: $filter) @include(if: $withEventParticipants) {
      ...RequestedUsersPaginated
    }
    interestedUsers(pagination: $pagination, filter: $filter) @include(if: $withEventInterestedUsers) {
      ...RequestedUsersPaginated
    }
  }
}
    ${RequestedUsersPaginatedFragmentDoc}`;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      postId: // value for 'postId'
 *      eventId: // value for 'eventId'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      withAllUsers: // value for 'withAllUsers'
 *      withUser: // value for 'withUser'
 *      withGroup: // value for 'withGroup'
 *      withPost: // value for 'withPost'
 *      withEvent: // value for 'withEvent'
 *      withFollowingUsers: // value for 'withFollowingUsers'
 *      withFollowedUsers: // value for 'withFollowedUsers'
 *      withGroupMembers: // value for 'withGroupMembers'
 *      withGroupAdmins: // value for 'withGroupAdmins'
 *      withPostLikedUsers: // value for 'withPostLikedUsers'
 *      withPostReadUsers: // value for 'withPostReadUsers'
 *      withPostSharedUsers: // value for 'withPostSharedUsers'
 *      withPostFeltUsefulUsers: // value for 'withPostFeltUsefulUsers'
 *      withEventParticipants: // value for 'withEventParticipants'
 *      withEventInterestedUsers: // value for 'withEventInterestedUsers'
 *      withYesterdayVisitors: // value for 'withYesterdayVisitors'
 *      withUserPageVisitors: // value for 'withUserPageVisitors'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions: Apollo.QueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
        return Apollo.useQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, baseOptions);
      }
export function useGetUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
          return Apollo.useLazyQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, baseOptions);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<GetUserListQuery, GetUserListQueryVariables>;
export const GetFeatureTogglesDocument = gql`
    query GetFeatureToggles {
  featureToggles {
    feature
    value
  }
}
    `;

/**
 * __useGetFeatureTogglesQuery__
 *
 * To run a query within a React component, call `useGetFeatureTogglesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureTogglesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureTogglesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureTogglesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureTogglesQuery, GetFeatureTogglesQueryVariables>) {
        return Apollo.useQuery<GetFeatureTogglesQuery, GetFeatureTogglesQueryVariables>(GetFeatureTogglesDocument, baseOptions);
      }
export function useGetFeatureTogglesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureTogglesQuery, GetFeatureTogglesQueryVariables>) {
          return Apollo.useLazyQuery<GetFeatureTogglesQuery, GetFeatureTogglesQueryVariables>(GetFeatureTogglesDocument, baseOptions);
        }
export type GetFeatureTogglesQueryHookResult = ReturnType<typeof useGetFeatureTogglesQuery>;
export type GetFeatureTogglesLazyQueryHookResult = ReturnType<typeof useGetFeatureTogglesLazyQuery>;
export type GetFeatureTogglesQueryResult = Apollo.QueryResult<GetFeatureTogglesQuery, GetFeatureTogglesQueryVariables>;
export const FeatureToggleUpateDocument = gql`
    mutation FeatureToggleUpate($feature: String!) {
  featureToggleUpdate(feature: $feature) {
    feature
    value
  }
}
    `;
export type FeatureToggleUpateMutationFn = Apollo.MutationFunction<FeatureToggleUpateMutation, FeatureToggleUpateMutationVariables>;

/**
 * __useFeatureToggleUpateMutation__
 *
 * To run a mutation, you first call `useFeatureToggleUpateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureToggleUpateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureToggleUpateMutation, { data, loading, error }] = useFeatureToggleUpateMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useFeatureToggleUpateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureToggleUpateMutation, FeatureToggleUpateMutationVariables>) {
        return Apollo.useMutation<FeatureToggleUpateMutation, FeatureToggleUpateMutationVariables>(FeatureToggleUpateDocument, baseOptions);
      }
export type FeatureToggleUpateMutationHookResult = ReturnType<typeof useFeatureToggleUpateMutation>;
export type FeatureToggleUpateMutationResult = Apollo.MutationResult<FeatureToggleUpateMutation>;
export type FeatureToggleUpateMutationOptions = Apollo.BaseMutationOptions<FeatureToggleUpateMutation, FeatureToggleUpateMutationVariables>;
export const SystemAdminAddDocument = gql`
    mutation SystemAdminAdd($userId: Int!) {
  systemAdminAdd(userId: $userId)
}
    `;
export type SystemAdminAddMutationFn = Apollo.MutationFunction<SystemAdminAddMutation, SystemAdminAddMutationVariables>;

/**
 * __useSystemAdminAddMutation__
 *
 * To run a mutation, you first call `useSystemAdminAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemAdminAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemAdminAddMutation, { data, loading, error }] = useSystemAdminAddMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSystemAdminAddMutation(baseOptions?: Apollo.MutationHookOptions<SystemAdminAddMutation, SystemAdminAddMutationVariables>) {
        return Apollo.useMutation<SystemAdminAddMutation, SystemAdminAddMutationVariables>(SystemAdminAddDocument, baseOptions);
      }
export type SystemAdminAddMutationHookResult = ReturnType<typeof useSystemAdminAddMutation>;
export type SystemAdminAddMutationResult = Apollo.MutationResult<SystemAdminAddMutation>;
export type SystemAdminAddMutationOptions = Apollo.BaseMutationOptions<SystemAdminAddMutation, SystemAdminAddMutationVariables>;
export const SystemAdminRemoveDocument = gql`
    mutation SystemAdminRemove($userId: Int!) {
  systemAdminRemove(userId: $userId)
}
    `;
export type SystemAdminRemoveMutationFn = Apollo.MutationFunction<SystemAdminRemoveMutation, SystemAdminRemoveMutationVariables>;

/**
 * __useSystemAdminRemoveMutation__
 *
 * To run a mutation, you first call `useSystemAdminRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemAdminRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemAdminRemoveMutation, { data, loading, error }] = useSystemAdminRemoveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSystemAdminRemoveMutation(baseOptions?: Apollo.MutationHookOptions<SystemAdminRemoveMutation, SystemAdminRemoveMutationVariables>) {
        return Apollo.useMutation<SystemAdminRemoveMutation, SystemAdminRemoveMutationVariables>(SystemAdminRemoveDocument, baseOptions);
      }
export type SystemAdminRemoveMutationHookResult = ReturnType<typeof useSystemAdminRemoveMutation>;
export type SystemAdminRemoveMutationResult = Apollo.MutationResult<SystemAdminRemoveMutation>;
export type SystemAdminRemoveMutationOptions = Apollo.BaseMutationOptions<SystemAdminRemoveMutation, SystemAdminRemoveMutationVariables>;
export const GroupAdminAddDocument = gql`
    mutation GroupAdminAdd($userId: Int!, $groupId: Int!) {
  groupAdminAdd(userId: $userId, groupId: $groupId)
}
    `;
export type GroupAdminAddMutationFn = Apollo.MutationFunction<GroupAdminAddMutation, GroupAdminAddMutationVariables>;

/**
 * __useGroupAdminAddMutation__
 *
 * To run a mutation, you first call `useGroupAdminAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupAdminAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupAdminAddMutation, { data, loading, error }] = useGroupAdminAddMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupAdminAddMutation(baseOptions?: Apollo.MutationHookOptions<GroupAdminAddMutation, GroupAdminAddMutationVariables>) {
        return Apollo.useMutation<GroupAdminAddMutation, GroupAdminAddMutationVariables>(GroupAdminAddDocument, baseOptions);
      }
export type GroupAdminAddMutationHookResult = ReturnType<typeof useGroupAdminAddMutation>;
export type GroupAdminAddMutationResult = Apollo.MutationResult<GroupAdminAddMutation>;
export type GroupAdminAddMutationOptions = Apollo.BaseMutationOptions<GroupAdminAddMutation, GroupAdminAddMutationVariables>;
export const GroupAdminRemoveDocument = gql`
    mutation GroupAdminRemove($userId: Int!, $groupId: Int!) {
  groupAdminRemove(userId: $userId, groupId: $groupId)
}
    `;
export type GroupAdminRemoveMutationFn = Apollo.MutationFunction<GroupAdminRemoveMutation, GroupAdminRemoveMutationVariables>;

/**
 * __useGroupAdminRemoveMutation__
 *
 * To run a mutation, you first call `useGroupAdminRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupAdminRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupAdminRemoveMutation, { data, loading, error }] = useGroupAdminRemoveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupAdminRemoveMutation(baseOptions?: Apollo.MutationHookOptions<GroupAdminRemoveMutation, GroupAdminRemoveMutationVariables>) {
        return Apollo.useMutation<GroupAdminRemoveMutation, GroupAdminRemoveMutationVariables>(GroupAdminRemoveDocument, baseOptions);
      }
export type GroupAdminRemoveMutationHookResult = ReturnType<typeof useGroupAdminRemoveMutation>;
export type GroupAdminRemoveMutationResult = Apollo.MutationResult<GroupAdminRemoveMutation>;
export type GroupAdminRemoveMutationOptions = Apollo.BaseMutationOptions<GroupAdminRemoveMutation, GroupAdminRemoveMutationVariables>;
export const GetAnniversaryCardsDocument = gql`
    query GetAnniversaryCards($anniversary: String!, $creatorUserId: Int!, $pagination: PaginationInput!, $leaderEmail: String!, $hrbpEmail: String, $withFinished: Boolean = false, $withUnfinished: Boolean = false, $withBlocked: Boolean = false) {
  user(userId: $creatorUserId) {
    userId
    anniversaryCardSet(
      anniversary: $anniversary
      pagination: $pagination
      creatorUserId: $creatorUserId
      leaderEmail: $leaderEmail
      hrbpEmail: $hrbpEmail
    ) {
      anniversary
      unFinishedUsers @include(if: $withUnfinished) {
        totalCount
        edges {
          node {
            ...UserInfoWithAnniversaryCard
          }
        }
      }
      finishedUsers @include(if: $withFinished) {
        totalCount
        edges {
          node {
            ...UserInfoWithAnniversaryCard
          }
        }
      }
      blockedUsers @include(if: $withBlocked) {
        totalCount
        edges {
          node {
            ...UserInfoWithAnniversaryCard
          }
        }
      }
    }
  }
}
    ${UserInfoWithAnniversaryCardFragmentDoc}`;

/**
 * __useGetAnniversaryCardsQuery__
 *
 * To run a query within a React component, call `useGetAnniversaryCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnniversaryCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnniversaryCardsQuery({
 *   variables: {
 *      anniversary: // value for 'anniversary'
 *      creatorUserId: // value for 'creatorUserId'
 *      pagination: // value for 'pagination'
 *      leaderEmail: // value for 'leaderEmail'
 *      hrbpEmail: // value for 'hrbpEmail'
 *      withFinished: // value for 'withFinished'
 *      withUnfinished: // value for 'withUnfinished'
 *      withBlocked: // value for 'withBlocked'
 *   },
 * });
 */
export function useGetAnniversaryCardsQuery(baseOptions: Apollo.QueryHookOptions<GetAnniversaryCardsQuery, GetAnniversaryCardsQueryVariables>) {
        return Apollo.useQuery<GetAnniversaryCardsQuery, GetAnniversaryCardsQueryVariables>(GetAnniversaryCardsDocument, baseOptions);
      }
export function useGetAnniversaryCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnniversaryCardsQuery, GetAnniversaryCardsQueryVariables>) {
          return Apollo.useLazyQuery<GetAnniversaryCardsQuery, GetAnniversaryCardsQueryVariables>(GetAnniversaryCardsDocument, baseOptions);
        }
export type GetAnniversaryCardsQueryHookResult = ReturnType<typeof useGetAnniversaryCardsQuery>;
export type GetAnniversaryCardsLazyQueryHookResult = ReturnType<typeof useGetAnniversaryCardsLazyQuery>;
export type GetAnniversaryCardsQueryResult = Apollo.QueryResult<GetAnniversaryCardsQuery, GetAnniversaryCardsQueryVariables>;
export const GetUserAnniversaryCardsDocument = gql`
    query GetUserAnniversaryCards($userId: Int!, $anniversary: String) {
  user(userId: $userId) {
    ...UserInfo
    hireDate
    anniversaryCards(anniversary: $anniversary) {
      ...AnniversaryCardInfo
    }
  }
}
    ${UserInfoFragmentDoc}
${AnniversaryCardInfoFragmentDoc}`;

/**
 * __useGetUserAnniversaryCardsQuery__
 *
 * To run a query within a React component, call `useGetUserAnniversaryCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAnniversaryCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAnniversaryCardsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      anniversary: // value for 'anniversary'
 *   },
 * });
 */
export function useGetUserAnniversaryCardsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAnniversaryCardsQuery, GetUserAnniversaryCardsQueryVariables>) {
        return Apollo.useQuery<GetUserAnniversaryCardsQuery, GetUserAnniversaryCardsQueryVariables>(GetUserAnniversaryCardsDocument, baseOptions);
      }
export function useGetUserAnniversaryCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAnniversaryCardsQuery, GetUserAnniversaryCardsQueryVariables>) {
          return Apollo.useLazyQuery<GetUserAnniversaryCardsQuery, GetUserAnniversaryCardsQueryVariables>(GetUserAnniversaryCardsDocument, baseOptions);
        }
export type GetUserAnniversaryCardsQueryHookResult = ReturnType<typeof useGetUserAnniversaryCardsQuery>;
export type GetUserAnniversaryCardsLazyQueryHookResult = ReturnType<typeof useGetUserAnniversaryCardsLazyQuery>;
export type GetUserAnniversaryCardsQueryResult = Apollo.QueryResult<GetUserAnniversaryCardsQuery, GetUserAnniversaryCardsQueryVariables>;
export const GetHrbpRelatedLeadersDocument = gql`
    query GetHRBPRelatedLeaders {
  viewer {
    userId
    hrbpRelatedLeaders {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useGetHrbpRelatedLeadersQuery__
 *
 * To run a query within a React component, call `useGetHrbpRelatedLeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHrbpRelatedLeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHrbpRelatedLeadersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHrbpRelatedLeadersQuery(baseOptions?: Apollo.QueryHookOptions<GetHrbpRelatedLeadersQuery, GetHrbpRelatedLeadersQueryVariables>) {
        return Apollo.useQuery<GetHrbpRelatedLeadersQuery, GetHrbpRelatedLeadersQueryVariables>(GetHrbpRelatedLeadersDocument, baseOptions);
      }
export function useGetHrbpRelatedLeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHrbpRelatedLeadersQuery, GetHrbpRelatedLeadersQueryVariables>) {
          return Apollo.useLazyQuery<GetHrbpRelatedLeadersQuery, GetHrbpRelatedLeadersQueryVariables>(GetHrbpRelatedLeadersDocument, baseOptions);
        }
export type GetHrbpRelatedLeadersQueryHookResult = ReturnType<typeof useGetHrbpRelatedLeadersQuery>;
export type GetHrbpRelatedLeadersLazyQueryHookResult = ReturnType<typeof useGetHrbpRelatedLeadersLazyQuery>;
export type GetHrbpRelatedLeadersQueryResult = Apollo.QueryResult<GetHrbpRelatedLeadersQuery, GetHrbpRelatedLeadersQueryVariables>;
export const AnniversaryCardCreateDocument = gql`
    mutation AnniversaryCardCreate($input: AnniversaryCardCreateInput!) {
  anniversaryCardCreate(input: $input) {
    ...AnniversaryCardInfo
  }
}
    ${AnniversaryCardInfoFragmentDoc}`;
export type AnniversaryCardCreateMutationFn = Apollo.MutationFunction<AnniversaryCardCreateMutation, AnniversaryCardCreateMutationVariables>;

/**
 * __useAnniversaryCardCreateMutation__
 *
 * To run a mutation, you first call `useAnniversaryCardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnniversaryCardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [anniversaryCardCreateMutation, { data, loading, error }] = useAnniversaryCardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnniversaryCardCreateMutation(baseOptions?: Apollo.MutationHookOptions<AnniversaryCardCreateMutation, AnniversaryCardCreateMutationVariables>) {
        return Apollo.useMutation<AnniversaryCardCreateMutation, AnniversaryCardCreateMutationVariables>(AnniversaryCardCreateDocument, baseOptions);
      }
export type AnniversaryCardCreateMutationHookResult = ReturnType<typeof useAnniversaryCardCreateMutation>;
export type AnniversaryCardCreateMutationResult = Apollo.MutationResult<AnniversaryCardCreateMutation>;
export type AnniversaryCardCreateMutationOptions = Apollo.BaseMutationOptions<AnniversaryCardCreateMutation, AnniversaryCardCreateMutationVariables>;
export const AnniversaryCardUpdateDocument = gql`
    mutation AnniversaryCardUpdate($input: AnniversaryCardUpdateInput!) {
  anniversaryCardUpdate(input: $input) {
    ...AnniversaryCardInfo
  }
}
    ${AnniversaryCardInfoFragmentDoc}`;
export type AnniversaryCardUpdateMutationFn = Apollo.MutationFunction<AnniversaryCardUpdateMutation, AnniversaryCardUpdateMutationVariables>;

/**
 * __useAnniversaryCardUpdateMutation__
 *
 * To run a mutation, you first call `useAnniversaryCardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnniversaryCardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [anniversaryCardUpdateMutation, { data, loading, error }] = useAnniversaryCardUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnniversaryCardUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AnniversaryCardUpdateMutation, AnniversaryCardUpdateMutationVariables>) {
        return Apollo.useMutation<AnniversaryCardUpdateMutation, AnniversaryCardUpdateMutationVariables>(AnniversaryCardUpdateDocument, baseOptions);
      }
export type AnniversaryCardUpdateMutationHookResult = ReturnType<typeof useAnniversaryCardUpdateMutation>;
export type AnniversaryCardUpdateMutationResult = Apollo.MutationResult<AnniversaryCardUpdateMutation>;
export type AnniversaryCardUpdateMutationOptions = Apollo.BaseMutationOptions<AnniversaryCardUpdateMutation, AnniversaryCardUpdateMutationVariables>;
export const GetAnnouncementPostsDocument = gql`
    query GetAnnouncementPosts($pagination: PaginationInput!) {
  posts: announcementPosts(pagination: $pagination) {
    pageInfo {
      ...RequestedPageInfo
    }
    totalCount
    edges {
      node {
        ...RequestedPost
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedPostFragmentDoc}`;

/**
 * __useGetAnnouncementPostsQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAnnouncementPostsQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementPostsQuery, GetAnnouncementPostsQueryVariables>) {
        return Apollo.useQuery<GetAnnouncementPostsQuery, GetAnnouncementPostsQueryVariables>(GetAnnouncementPostsDocument, baseOptions);
      }
export function useGetAnnouncementPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementPostsQuery, GetAnnouncementPostsQueryVariables>) {
          return Apollo.useLazyQuery<GetAnnouncementPostsQuery, GetAnnouncementPostsQueryVariables>(GetAnnouncementPostsDocument, baseOptions);
        }
export type GetAnnouncementPostsQueryHookResult = ReturnType<typeof useGetAnnouncementPostsQuery>;
export type GetAnnouncementPostsLazyQueryHookResult = ReturnType<typeof useGetAnnouncementPostsLazyQuery>;
export type GetAnnouncementPostsQueryResult = Apollo.QueryResult<GetAnnouncementPostsQuery, GetAnnouncementPostsQueryVariables>;
export const AnnouncementReplyCreateDocument = gql`
    mutation AnnouncementReplyCreate($input: CreateAnnouncementReplyInput!, $parentCommentPagination: PaginationInput = {last: 2}, $childCommentPagination: PaginationInput = {last: 2}) {
  announcementReplyCreate(input: $input) {
    ...RequestedPost
    ...ParentComments
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}`;
export type AnnouncementReplyCreateMutationFn = Apollo.MutationFunction<AnnouncementReplyCreateMutation, AnnouncementReplyCreateMutationVariables>;

/**
 * __useAnnouncementReplyCreateMutation__
 *
 * To run a mutation, you first call `useAnnouncementReplyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementReplyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementReplyCreateMutation, { data, loading, error }] = useAnnouncementReplyCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useAnnouncementReplyCreateMutation(baseOptions?: Apollo.MutationHookOptions<AnnouncementReplyCreateMutation, AnnouncementReplyCreateMutationVariables>) {
        return Apollo.useMutation<AnnouncementReplyCreateMutation, AnnouncementReplyCreateMutationVariables>(AnnouncementReplyCreateDocument, baseOptions);
      }
export type AnnouncementReplyCreateMutationHookResult = ReturnType<typeof useAnnouncementReplyCreateMutation>;
export type AnnouncementReplyCreateMutationResult = Apollo.MutationResult<AnnouncementReplyCreateMutation>;
export type AnnouncementReplyCreateMutationOptions = Apollo.BaseMutationOptions<AnnouncementReplyCreateMutation, AnnouncementReplyCreateMutationVariables>;
export const GetViewerAnnualReportDocument = gql`
    query GetViewerAnnualReport {
  viewer {
    userId
    name
    email
    annualReport {
      ...RequestedAnnualReport
    }
  }
}
    ${RequestedAnnualReportFragmentDoc}`;

/**
 * __useGetViewerAnnualReportQuery__
 *
 * To run a query within a React component, call `useGetViewerAnnualReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerAnnualReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerAnnualReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerAnnualReportQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerAnnualReportQuery, GetViewerAnnualReportQueryVariables>) {
        return Apollo.useQuery<GetViewerAnnualReportQuery, GetViewerAnnualReportQueryVariables>(GetViewerAnnualReportDocument, baseOptions);
      }
export function useGetViewerAnnualReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerAnnualReportQuery, GetViewerAnnualReportQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerAnnualReportQuery, GetViewerAnnualReportQueryVariables>(GetViewerAnnualReportDocument, baseOptions);
        }
export type GetViewerAnnualReportQueryHookResult = ReturnType<typeof useGetViewerAnnualReportQuery>;
export type GetViewerAnnualReportLazyQueryHookResult = ReturnType<typeof useGetViewerAnnualReportLazyQuery>;
export type GetViewerAnnualReportQueryResult = Apollo.QueryResult<GetViewerAnnualReportQuery, GetViewerAnnualReportQueryVariables>;
export const GetUserAnnualReportDocument = gql`
    query GetUserAnnualReport($userId: Int, $userName: String) {
  user(userId: $userId, userName: $userName) {
    userId
    name
    email
    annualReport {
      ...RequestedAnnualReport
    }
  }
}
    ${RequestedAnnualReportFragmentDoc}`;

/**
 * __useGetUserAnnualReportQuery__
 *
 * To run a query within a React component, call `useGetUserAnnualReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAnnualReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAnnualReportQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useGetUserAnnualReportQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAnnualReportQuery, GetUserAnnualReportQueryVariables>) {
        return Apollo.useQuery<GetUserAnnualReportQuery, GetUserAnnualReportQueryVariables>(GetUserAnnualReportDocument, baseOptions);
      }
export function useGetUserAnnualReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAnnualReportQuery, GetUserAnnualReportQueryVariables>) {
          return Apollo.useLazyQuery<GetUserAnnualReportQuery, GetUserAnnualReportQueryVariables>(GetUserAnnualReportDocument, baseOptions);
        }
export type GetUserAnnualReportQueryHookResult = ReturnType<typeof useGetUserAnnualReportQuery>;
export type GetUserAnnualReportLazyQueryHookResult = ReturnType<typeof useGetUserAnnualReportLazyQuery>;
export type GetUserAnnualReportQueryResult = Apollo.QueryResult<GetUserAnnualReportQuery, GetUserAnnualReportQueryVariables>;
export const AppStateDocument = gql`
    query AppState {
  appState {
    showSidebar
    showSearchHeader
  }
}
    `;

/**
 * __useAppStateQuery__
 *
 * To run a query within a React component, call `useAppStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppStateQuery(baseOptions?: Apollo.QueryHookOptions<AppStateQuery, AppStateQueryVariables>) {
        return Apollo.useQuery<AppStateQuery, AppStateQueryVariables>(AppStateDocument, baseOptions);
      }
export function useAppStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppStateQuery, AppStateQueryVariables>) {
          return Apollo.useLazyQuery<AppStateQuery, AppStateQueryVariables>(AppStateDocument, baseOptions);
        }
export type AppStateQueryHookResult = ReturnType<typeof useAppStateQuery>;
export type AppStateLazyQueryHookResult = ReturnType<typeof useAppStateLazyQuery>;
export type AppStateQueryResult = Apollo.QueryResult<AppStateQuery, AppStateQueryVariables>;
export const GetMonthlyEventsDocument = gql`
    query GetMonthlyEvents($startDate: String!, $endDate: String!, $pagination: PaginationInput! = {last: 1000}) {
  events(startDate: $startDate, endDate: $endDate, pagination: $pagination) {
    edges {
      node {
        ...EventInfo
      }
    }
  }
}
    ${EventInfoFragmentDoc}`;

/**
 * __useGetMonthlyEventsQuery__
 *
 * To run a query within a React component, call `useGetMonthlyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyEventsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMonthlyEventsQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyEventsQuery, GetMonthlyEventsQueryVariables>) {
        return Apollo.useQuery<GetMonthlyEventsQuery, GetMonthlyEventsQueryVariables>(GetMonthlyEventsDocument, baseOptions);
      }
export function useGetMonthlyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyEventsQuery, GetMonthlyEventsQueryVariables>) {
          return Apollo.useLazyQuery<GetMonthlyEventsQuery, GetMonthlyEventsQueryVariables>(GetMonthlyEventsDocument, baseOptions);
        }
export type GetMonthlyEventsQueryHookResult = ReturnType<typeof useGetMonthlyEventsQuery>;
export type GetMonthlyEventsLazyQueryHookResult = ReturnType<typeof useGetMonthlyEventsLazyQuery>;
export type GetMonthlyEventsQueryResult = Apollo.QueryResult<GetMonthlyEventsQuery, GetMonthlyEventsQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($eventId: Int!, $participantPagination: PaginationInput! = {last: 5}) {
  event(eventId: $eventId) {
    ...EventInfoWithExtra
    participants(pagination: $participantPagination) {
      totalCount
      edges {
        node {
          ...UserInfo
        }
      }
    }
  }
}
    ${EventInfoWithExtraFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      participantPagination: // value for 'participantPagination'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetViewerUnStartEventsDocument = gql`
    query GetViewerUnStartEvents($pagination: PaginationInput!) {
  viewer {
    ...UserInfo
    unStartEvents(pagination: $pagination) {
      pageInfo {
        ...RequestedPageInfo
      }
      totalCount
      edges {
        node {
          ...EventInfo
        }
      }
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedPageInfoFragmentDoc}
${EventInfoFragmentDoc}`;

/**
 * __useGetViewerUnStartEventsQuery__
 *
 * To run a query within a React component, call `useGetViewerUnStartEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerUnStartEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerUnStartEventsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetViewerUnStartEventsQuery(baseOptions: Apollo.QueryHookOptions<GetViewerUnStartEventsQuery, GetViewerUnStartEventsQueryVariables>) {
        return Apollo.useQuery<GetViewerUnStartEventsQuery, GetViewerUnStartEventsQueryVariables>(GetViewerUnStartEventsDocument, baseOptions);
      }
export function useGetViewerUnStartEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerUnStartEventsQuery, GetViewerUnStartEventsQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerUnStartEventsQuery, GetViewerUnStartEventsQueryVariables>(GetViewerUnStartEventsDocument, baseOptions);
        }
export type GetViewerUnStartEventsQueryHookResult = ReturnType<typeof useGetViewerUnStartEventsQuery>;
export type GetViewerUnStartEventsLazyQueryHookResult = ReturnType<typeof useGetViewerUnStartEventsLazyQuery>;
export type GetViewerUnStartEventsQueryResult = Apollo.QueryResult<GetViewerUnStartEventsQuery, GetViewerUnStartEventsQueryVariables>;
export const GetViewerFinishedEventsDocument = gql`
    query GetViewerFinishedEvents($pagination: PaginationInput!) {
  viewer {
    ...UserInfo
    finishedEvents(pagination: $pagination) {
      pageInfo {
        ...RequestedPageInfo
      }
      totalCount
      edges {
        node {
          ...EventInfo
        }
      }
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedPageInfoFragmentDoc}
${EventInfoFragmentDoc}`;

/**
 * __useGetViewerFinishedEventsQuery__
 *
 * To run a query within a React component, call `useGetViewerFinishedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerFinishedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerFinishedEventsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetViewerFinishedEventsQuery(baseOptions: Apollo.QueryHookOptions<GetViewerFinishedEventsQuery, GetViewerFinishedEventsQueryVariables>) {
        return Apollo.useQuery<GetViewerFinishedEventsQuery, GetViewerFinishedEventsQueryVariables>(GetViewerFinishedEventsDocument, baseOptions);
      }
export function useGetViewerFinishedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerFinishedEventsQuery, GetViewerFinishedEventsQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerFinishedEventsQuery, GetViewerFinishedEventsQueryVariables>(GetViewerFinishedEventsDocument, baseOptions);
        }
export type GetViewerFinishedEventsQueryHookResult = ReturnType<typeof useGetViewerFinishedEventsQuery>;
export type GetViewerFinishedEventsLazyQueryHookResult = ReturnType<typeof useGetViewerFinishedEventsLazyQuery>;
export type GetViewerFinishedEventsQueryResult = Apollo.QueryResult<GetViewerFinishedEventsQuery, GetViewerFinishedEventsQueryVariables>;
export const EventParticipantCreateUpdateDocument = gql`
    mutation EventParticipantCreateUpdate($input: CreateEventParticipantInput!) {
  eventParticipantCreateUpdate(input: $input) {
    eventId
    isParticipated
    isInterested
    participatedCount
    interestedCount
  }
}
    `;
export type EventParticipantCreateUpdateMutationFn = Apollo.MutationFunction<EventParticipantCreateUpdateMutation, EventParticipantCreateUpdateMutationVariables>;

/**
 * __useEventParticipantCreateUpdateMutation__
 *
 * To run a mutation, you first call `useEventParticipantCreateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventParticipantCreateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventParticipantCreateUpdateMutation, { data, loading, error }] = useEventParticipantCreateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventParticipantCreateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EventParticipantCreateUpdateMutation, EventParticipantCreateUpdateMutationVariables>) {
        return Apollo.useMutation<EventParticipantCreateUpdateMutation, EventParticipantCreateUpdateMutationVariables>(EventParticipantCreateUpdateDocument, baseOptions);
      }
export type EventParticipantCreateUpdateMutationHookResult = ReturnType<typeof useEventParticipantCreateUpdateMutation>;
export type EventParticipantCreateUpdateMutationResult = Apollo.MutationResult<EventParticipantCreateUpdateMutation>;
export type EventParticipantCreateUpdateMutationOptions = Apollo.BaseMutationOptions<EventParticipantCreateUpdateMutation, EventParticipantCreateUpdateMutationVariables>;
export const GetDepartmentsDocument = gql`
    query GetDepartments {
  departments(filter: {}) {
    ...RequestedDepartment
  }
}
    ${RequestedDepartmentFragmentDoc}`;

/**
 * __useGetDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
        return Apollo.useQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, baseOptions);
      }
export function useGetDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          return Apollo.useLazyQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, baseOptions);
        }
export type GetDepartmentsQueryHookResult = ReturnType<typeof useGetDepartmentsQuery>;
export type GetDepartmentsLazyQueryHookResult = ReturnType<typeof useGetDepartmentsLazyQuery>;
export type GetDepartmentsQueryResult = Apollo.QueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetMembersByDepartmentDocument = gql`
    query GetMembersByDepartment($departmentId: Int!) {
  department(departmentId: $departmentId) {
    ...RequestedDepartmentWithMembers
  }
}
    ${RequestedDepartmentWithMembersFragmentDoc}`;

/**
 * __useGetMembersByDepartmentQuery__
 *
 * To run a query within a React component, call `useGetMembersByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersByDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useGetMembersByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<GetMembersByDepartmentQuery, GetMembersByDepartmentQueryVariables>) {
        return Apollo.useQuery<GetMembersByDepartmentQuery, GetMembersByDepartmentQueryVariables>(GetMembersByDepartmentDocument, baseOptions);
      }
export function useGetMembersByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersByDepartmentQuery, GetMembersByDepartmentQueryVariables>) {
          return Apollo.useLazyQuery<GetMembersByDepartmentQuery, GetMembersByDepartmentQueryVariables>(GetMembersByDepartmentDocument, baseOptions);
        }
export type GetMembersByDepartmentQueryHookResult = ReturnType<typeof useGetMembersByDepartmentQuery>;
export type GetMembersByDepartmentLazyQueryHookResult = ReturnType<typeof useGetMembersByDepartmentLazyQuery>;
export type GetMembersByDepartmentQueryResult = Apollo.QueryResult<GetMembersByDepartmentQuery, GetMembersByDepartmentQueryVariables>;
export const GetTrendingGroupsDocument = gql`
    query GetTrendingGroups($pagination: PaginationInput!, $withPosts: Boolean = false, $withFollowers: Boolean = false) {
  recommend {
    trendingGroups(pagination: $pagination) {
      edges {
        node {
          ...GroupWithExtras
          isFollowing
        }
      }
    }
  }
}
    ${GroupWithExtrasFragmentDoc}`;

/**
 * __useGetTrendingGroupsQuery__
 *
 * To run a query within a React component, call `useGetTrendingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      withPosts: // value for 'withPosts'
 *      withFollowers: // value for 'withFollowers'
 *   },
 * });
 */
export function useGetTrendingGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingGroupsQuery, GetTrendingGroupsQueryVariables>) {
        return Apollo.useQuery<GetTrendingGroupsQuery, GetTrendingGroupsQueryVariables>(GetTrendingGroupsDocument, baseOptions);
      }
export function useGetTrendingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingGroupsQuery, GetTrendingGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetTrendingGroupsQuery, GetTrendingGroupsQueryVariables>(GetTrendingGroupsDocument, baseOptions);
        }
export type GetTrendingGroupsQueryHookResult = ReturnType<typeof useGetTrendingGroupsQuery>;
export type GetTrendingGroupsLazyQueryHookResult = ReturnType<typeof useGetTrendingGroupsLazyQuery>;
export type GetTrendingGroupsQueryResult = Apollo.QueryResult<GetTrendingGroupsQuery, GetTrendingGroupsQueryVariables>;
export const GetTrendingPostsDocument = gql`
    query GetTrendingPosts($pagination: PaginationInput!, $parentCommentPagination: PaginationInput = {last: 0}, $childCommentPagination: PaginationInput = {last: 0}, $timeSpan: Int!) {
  recommend {
    trendingPosts(pagination: $pagination, timeSpan: $timeSpan) {
      edges {
        node {
          ...RequestedPost
          ...ParentComments
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetTrendingPostsQuery__
 *
 * To run a query within a React component, call `useGetTrendingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *      timeSpan: // value for 'timeSpan'
 *   },
 * });
 */
export function useGetTrendingPostsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>) {
        return Apollo.useQuery<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>(GetTrendingPostsDocument, baseOptions);
      }
export function useGetTrendingPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>) {
          return Apollo.useLazyQuery<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>(GetTrendingPostsDocument, baseOptions);
        }
export type GetTrendingPostsQueryHookResult = ReturnType<typeof useGetTrendingPostsQuery>;
export type GetTrendingPostsLazyQueryHookResult = ReturnType<typeof useGetTrendingPostsLazyQuery>;
export type GetTrendingPostsQueryResult = Apollo.QueryResult<GetTrendingPostsQuery, GetTrendingPostsQueryVariables>;
export const GetFeaturedPostsDocument = gql`
    query GetFeaturedPosts($pagination: PaginationInput!, $parentCommentPagination: PaginationInput = {last: 0}, $childCommentPagination: PaginationInput = {last: 0}) {
  recommend {
    featuredPosts(pagination: $pagination) {
      edges {
        node {
          ...RequestedPost
          ...ParentComments
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetFeaturedPostsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetFeaturedPostsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPostsQuery, GetFeaturedPostsQueryVariables>) {
        return Apollo.useQuery<GetFeaturedPostsQuery, GetFeaturedPostsQueryVariables>(GetFeaturedPostsDocument, baseOptions);
      }
export function useGetFeaturedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPostsQuery, GetFeaturedPostsQueryVariables>) {
          return Apollo.useLazyQuery<GetFeaturedPostsQuery, GetFeaturedPostsQueryVariables>(GetFeaturedPostsDocument, baseOptions);
        }
export type GetFeaturedPostsQueryHookResult = ReturnType<typeof useGetFeaturedPostsQuery>;
export type GetFeaturedPostsLazyQueryHookResult = ReturnType<typeof useGetFeaturedPostsLazyQuery>;
export type GetFeaturedPostsQueryResult = Apollo.QueryResult<GetFeaturedPostsQuery, GetFeaturedPostsQueryVariables>;
export const GetFeaturedGroupsDocument = gql`
    query GetFeaturedGroups($count: Int!, $categoryId: Int, $withPosts: Boolean = true, $withFollowers: Boolean = true) {
  recommend {
    featuredGroups(count: $count, categoryId: $categoryId) {
      ...GroupWithExtras
    }
  }
}
    ${GroupWithExtrasFragmentDoc}`;

/**
 * __useGetFeaturedGroupsQuery__
 *
 * To run a query within a React component, call `useGetFeaturedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedGroupsQuery({
 *   variables: {
 *      count: // value for 'count'
 *      categoryId: // value for 'categoryId'
 *      withPosts: // value for 'withPosts'
 *      withFollowers: // value for 'withFollowers'
 *   },
 * });
 */
export function useGetFeaturedGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedGroupsQuery, GetFeaturedGroupsQueryVariables>) {
        return Apollo.useQuery<GetFeaturedGroupsQuery, GetFeaturedGroupsQueryVariables>(GetFeaturedGroupsDocument, baseOptions);
      }
export function useGetFeaturedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedGroupsQuery, GetFeaturedGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetFeaturedGroupsQuery, GetFeaturedGroupsQueryVariables>(GetFeaturedGroupsDocument, baseOptions);
        }
export type GetFeaturedGroupsQueryHookResult = ReturnType<typeof useGetFeaturedGroupsQuery>;
export type GetFeaturedGroupsLazyQueryHookResult = ReturnType<typeof useGetFeaturedGroupsLazyQuery>;
export type GetFeaturedGroupsQueryResult = Apollo.QueryResult<GetFeaturedGroupsQuery, GetFeaturedGroupsQueryVariables>;
export const GetTopFeaturedPostsDocument = gql`
    query GetTopFeaturedPosts($parentCommentPagination: PaginationInput = {last: 0}, $childCommentPagination: PaginationInput = {last: 0}) {
  recommend {
    topFeaturedPosts {
      ...RequestedPost
      ...ParentComments
    }
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}`;

/**
 * __useGetTopFeaturedPostsQuery__
 *
 * To run a query within a React component, call `useGetTopFeaturedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFeaturedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFeaturedPostsQuery({
 *   variables: {
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetTopFeaturedPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFeaturedPostsQuery, GetTopFeaturedPostsQueryVariables>) {
        return Apollo.useQuery<GetTopFeaturedPostsQuery, GetTopFeaturedPostsQueryVariables>(GetTopFeaturedPostsDocument, baseOptions);
      }
export function useGetTopFeaturedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFeaturedPostsQuery, GetTopFeaturedPostsQueryVariables>) {
          return Apollo.useLazyQuery<GetTopFeaturedPostsQuery, GetTopFeaturedPostsQueryVariables>(GetTopFeaturedPostsDocument, baseOptions);
        }
export type GetTopFeaturedPostsQueryHookResult = ReturnType<typeof useGetTopFeaturedPostsQuery>;
export type GetTopFeaturedPostsLazyQueryHookResult = ReturnType<typeof useGetTopFeaturedPostsLazyQuery>;
export type GetTopFeaturedPostsQueryResult = Apollo.QueryResult<GetTopFeaturedPostsQuery, GetTopFeaturedPostsQueryVariables>;
export const PostFeatureDocument = gql`
    mutation PostFeature($postId: Int!) {
  postFeature(postId: $postId) {
    postId
    featuredAt
  }
}
    `;
export type PostFeatureMutationFn = Apollo.MutationFunction<PostFeatureMutation, PostFeatureMutationVariables>;

/**
 * __usePostFeatureMutation__
 *
 * To run a mutation, you first call `usePostFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postFeatureMutation, { data, loading, error }] = usePostFeatureMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostFeatureMutation(baseOptions?: Apollo.MutationHookOptions<PostFeatureMutation, PostFeatureMutationVariables>) {
        return Apollo.useMutation<PostFeatureMutation, PostFeatureMutationVariables>(PostFeatureDocument, baseOptions);
      }
export type PostFeatureMutationHookResult = ReturnType<typeof usePostFeatureMutation>;
export type PostFeatureMutationResult = Apollo.MutationResult<PostFeatureMutation>;
export type PostFeatureMutationOptions = Apollo.BaseMutationOptions<PostFeatureMutation, PostFeatureMutationVariables>;
export const PostUnFeatureDocument = gql`
    mutation PostUnFeature($postId: Int!) {
  postUnFeature(postId: $postId) {
    postId
    featuredAt
  }
}
    `;
export type PostUnFeatureMutationFn = Apollo.MutationFunction<PostUnFeatureMutation, PostUnFeatureMutationVariables>;

/**
 * __usePostUnFeatureMutation__
 *
 * To run a mutation, you first call `usePostUnFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUnFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUnFeatureMutation, { data, loading, error }] = usePostUnFeatureMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostUnFeatureMutation(baseOptions?: Apollo.MutationHookOptions<PostUnFeatureMutation, PostUnFeatureMutationVariables>) {
        return Apollo.useMutation<PostUnFeatureMutation, PostUnFeatureMutationVariables>(PostUnFeatureDocument, baseOptions);
      }
export type PostUnFeatureMutationHookResult = ReturnType<typeof usePostUnFeatureMutation>;
export type PostUnFeatureMutationResult = Apollo.MutationResult<PostUnFeatureMutation>;
export type PostUnFeatureMutationOptions = Apollo.BaseMutationOptions<PostUnFeatureMutation, PostUnFeatureMutationVariables>;
export const FeaturedPostTopDocument = gql`
    mutation FeaturedPostTop($postId: Int!) {
  featuredPostTop(postId: $postId) {
    postId
    isFeaturedTop
  }
}
    `;
export type FeaturedPostTopMutationFn = Apollo.MutationFunction<FeaturedPostTopMutation, FeaturedPostTopMutationVariables>;

/**
 * __useFeaturedPostTopMutation__
 *
 * To run a mutation, you first call `useFeaturedPostTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeaturedPostTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featuredPostTopMutation, { data, loading, error }] = useFeaturedPostTopMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useFeaturedPostTopMutation(baseOptions?: Apollo.MutationHookOptions<FeaturedPostTopMutation, FeaturedPostTopMutationVariables>) {
        return Apollo.useMutation<FeaturedPostTopMutation, FeaturedPostTopMutationVariables>(FeaturedPostTopDocument, baseOptions);
      }
export type FeaturedPostTopMutationHookResult = ReturnType<typeof useFeaturedPostTopMutation>;
export type FeaturedPostTopMutationResult = Apollo.MutationResult<FeaturedPostTopMutation>;
export type FeaturedPostTopMutationOptions = Apollo.BaseMutationOptions<FeaturedPostTopMutation, FeaturedPostTopMutationVariables>;
export const FeaturedPostUnTopDocument = gql`
    mutation FeaturedPostUnTop($postId: Int!) {
  featuredPostUnTop(postId: $postId) {
    postId
    isFeaturedTop
  }
}
    `;
export type FeaturedPostUnTopMutationFn = Apollo.MutationFunction<FeaturedPostUnTopMutation, FeaturedPostUnTopMutationVariables>;

/**
 * __useFeaturedPostUnTopMutation__
 *
 * To run a mutation, you first call `useFeaturedPostUnTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeaturedPostUnTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featuredPostUnTopMutation, { data, loading, error }] = useFeaturedPostUnTopMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useFeaturedPostUnTopMutation(baseOptions?: Apollo.MutationHookOptions<FeaturedPostUnTopMutation, FeaturedPostUnTopMutationVariables>) {
        return Apollo.useMutation<FeaturedPostUnTopMutation, FeaturedPostUnTopMutationVariables>(FeaturedPostUnTopDocument, baseOptions);
      }
export type FeaturedPostUnTopMutationHookResult = ReturnType<typeof useFeaturedPostUnTopMutation>;
export type FeaturedPostUnTopMutationResult = Apollo.MutationResult<FeaturedPostUnTopMutation>;
export type FeaturedPostUnTopMutationOptions = Apollo.BaseMutationOptions<FeaturedPostUnTopMutation, FeaturedPostUnTopMutationVariables>;
export const FeaturedCommentDisplayDocument = gql`
    mutation FeaturedCommentDisplay($postId: Int!) {
  featuredCommentDisplay(postId: $postId)
}
    `;
export type FeaturedCommentDisplayMutationFn = Apollo.MutationFunction<FeaturedCommentDisplayMutation, FeaturedCommentDisplayMutationVariables>;

/**
 * __useFeaturedCommentDisplayMutation__
 *
 * To run a mutation, you first call `useFeaturedCommentDisplayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeaturedCommentDisplayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featuredCommentDisplayMutation, { data, loading, error }] = useFeaturedCommentDisplayMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useFeaturedCommentDisplayMutation(baseOptions?: Apollo.MutationHookOptions<FeaturedCommentDisplayMutation, FeaturedCommentDisplayMutationVariables>) {
        return Apollo.useMutation<FeaturedCommentDisplayMutation, FeaturedCommentDisplayMutationVariables>(FeaturedCommentDisplayDocument, baseOptions);
      }
export type FeaturedCommentDisplayMutationHookResult = ReturnType<typeof useFeaturedCommentDisplayMutation>;
export type FeaturedCommentDisplayMutationResult = Apollo.MutationResult<FeaturedCommentDisplayMutation>;
export type FeaturedCommentDisplayMutationOptions = Apollo.BaseMutationOptions<FeaturedCommentDisplayMutation, FeaturedCommentDisplayMutationVariables>;
export const FeaturedCommentHideDocument = gql`
    mutation FeaturedCommentHide($postId: Int!) {
  featuredCommentHide(postId: $postId)
}
    `;
export type FeaturedCommentHideMutationFn = Apollo.MutationFunction<FeaturedCommentHideMutation, FeaturedCommentHideMutationVariables>;

/**
 * __useFeaturedCommentHideMutation__
 *
 * To run a mutation, you first call `useFeaturedCommentHideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeaturedCommentHideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featuredCommentHideMutation, { data, loading, error }] = useFeaturedCommentHideMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useFeaturedCommentHideMutation(baseOptions?: Apollo.MutationHookOptions<FeaturedCommentHideMutation, FeaturedCommentHideMutationVariables>) {
        return Apollo.useMutation<FeaturedCommentHideMutation, FeaturedCommentHideMutationVariables>(FeaturedCommentHideDocument, baseOptions);
      }
export type FeaturedCommentHideMutationHookResult = ReturnType<typeof useFeaturedCommentHideMutation>;
export type FeaturedCommentHideMutationResult = Apollo.MutationResult<FeaturedCommentHideMutation>;
export type FeaturedCommentHideMutationOptions = Apollo.BaseMutationOptions<FeaturedCommentHideMutation, FeaturedCommentHideMutationVariables>;
export const GroupFeatureDocument = gql`
    mutation GroupFeature($groupId: Int!) {
  groupFeature(groupId: $groupId)
}
    `;
export type GroupFeatureMutationFn = Apollo.MutationFunction<GroupFeatureMutation, GroupFeatureMutationVariables>;

/**
 * __useGroupFeatureMutation__
 *
 * To run a mutation, you first call `useGroupFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupFeatureMutation, { data, loading, error }] = useGroupFeatureMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupFeatureMutation(baseOptions?: Apollo.MutationHookOptions<GroupFeatureMutation, GroupFeatureMutationVariables>) {
        return Apollo.useMutation<GroupFeatureMutation, GroupFeatureMutationVariables>(GroupFeatureDocument, baseOptions);
      }
export type GroupFeatureMutationHookResult = ReturnType<typeof useGroupFeatureMutation>;
export type GroupFeatureMutationResult = Apollo.MutationResult<GroupFeatureMutation>;
export type GroupFeatureMutationOptions = Apollo.BaseMutationOptions<GroupFeatureMutation, GroupFeatureMutationVariables>;
export const GroupUnFeatureDocument = gql`
    mutation GroupUnFeature($groupId: Int!) {
  groupUnFeature(groupId: $groupId)
}
    `;
export type GroupUnFeatureMutationFn = Apollo.MutationFunction<GroupUnFeatureMutation, GroupUnFeatureMutationVariables>;

/**
 * __useGroupUnFeatureMutation__
 *
 * To run a mutation, you first call `useGroupUnFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUnFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUnFeatureMutation, { data, loading, error }] = useGroupUnFeatureMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupUnFeatureMutation(baseOptions?: Apollo.MutationHookOptions<GroupUnFeatureMutation, GroupUnFeatureMutationVariables>) {
        return Apollo.useMutation<GroupUnFeatureMutation, GroupUnFeatureMutationVariables>(GroupUnFeatureDocument, baseOptions);
      }
export type GroupUnFeatureMutationHookResult = ReturnType<typeof useGroupUnFeatureMutation>;
export type GroupUnFeatureMutationResult = Apollo.MutationResult<GroupUnFeatureMutation>;
export type GroupUnFeatureMutationOptions = Apollo.BaseMutationOptions<GroupUnFeatureMutation, GroupUnFeatureMutationVariables>;
export const GetViewerFilesDocument = gql`
    query GetViewerFiles($pagination: PaginationInput!, $fileIds: [Int!]) {
  viewer {
    userId
    files(pagination: $pagination, fileIds: $fileIds) {
      edges {
        node {
          ...LocalFile
          postId
        }
      }
    }
  }
}
    ${LocalFileFragmentDoc}`;

/**
 * __useGetViewerFilesQuery__
 *
 * To run a query within a React component, call `useGetViewerFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerFilesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useGetViewerFilesQuery(baseOptions: Apollo.QueryHookOptions<GetViewerFilesQuery, GetViewerFilesQueryVariables>) {
        return Apollo.useQuery<GetViewerFilesQuery, GetViewerFilesQueryVariables>(GetViewerFilesDocument, baseOptions);
      }
export function useGetViewerFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerFilesQuery, GetViewerFilesQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerFilesQuery, GetViewerFilesQueryVariables>(GetViewerFilesDocument, baseOptions);
        }
export type GetViewerFilesQueryHookResult = ReturnType<typeof useGetViewerFilesQuery>;
export type GetViewerFilesLazyQueryHookResult = ReturnType<typeof useGetViewerFilesLazyQuery>;
export type GetViewerFilesQueryResult = Apollo.QueryResult<GetViewerFilesQuery, GetViewerFilesQueryVariables>;
export const FileCreateDocument = gql`
    mutation FileCreate($file: CreateFileInput!) {
  fileCreate(file: $file) {
    ...LocalFile
  }
}
    ${LocalFileFragmentDoc}`;
export type FileCreateMutationFn = Apollo.MutationFunction<FileCreateMutation, FileCreateMutationVariables>;

/**
 * __useFileCreateMutation__
 *
 * To run a mutation, you first call `useFileCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileCreateMutation, { data, loading, error }] = useFileCreateMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useFileCreateMutation(baseOptions?: Apollo.MutationHookOptions<FileCreateMutation, FileCreateMutationVariables>) {
        return Apollo.useMutation<FileCreateMutation, FileCreateMutationVariables>(FileCreateDocument, baseOptions);
      }
export type FileCreateMutationHookResult = ReturnType<typeof useFileCreateMutation>;
export type FileCreateMutationResult = Apollo.MutationResult<FileCreateMutation>;
export type FileCreateMutationOptions = Apollo.BaseMutationOptions<FileCreateMutation, FileCreateMutationVariables>;
export const UserFollowDocument = gql`
    mutation UserFollow($followeeUserId: Int!) {
  userFollow(followeeUserId: $followeeUserId) {
    userId
    isFollowing
    isFollowingEachOther
  }
}
    `;
export type UserFollowMutationFn = Apollo.MutationFunction<UserFollowMutation, UserFollowMutationVariables>;

/**
 * __useUserFollowMutation__
 *
 * To run a mutation, you first call `useUserFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userFollowMutation, { data, loading, error }] = useUserFollowMutation({
 *   variables: {
 *      followeeUserId: // value for 'followeeUserId'
 *   },
 * });
 */
export function useUserFollowMutation(baseOptions?: Apollo.MutationHookOptions<UserFollowMutation, UserFollowMutationVariables>) {
        return Apollo.useMutation<UserFollowMutation, UserFollowMutationVariables>(UserFollowDocument, baseOptions);
      }
export type UserFollowMutationHookResult = ReturnType<typeof useUserFollowMutation>;
export type UserFollowMutationResult = Apollo.MutationResult<UserFollowMutation>;
export type UserFollowMutationOptions = Apollo.BaseMutationOptions<UserFollowMutation, UserFollowMutationVariables>;
export const UserUnfollowDocument = gql`
    mutation UserUnfollow($followeeUserId: Int!) {
  userUnfollow(followeeUserId: $followeeUserId) {
    userId
    isFollowing
    isFollowingEachOther
  }
}
    `;
export type UserUnfollowMutationFn = Apollo.MutationFunction<UserUnfollowMutation, UserUnfollowMutationVariables>;

/**
 * __useUserUnfollowMutation__
 *
 * To run a mutation, you first call `useUserUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUnfollowMutation, { data, loading, error }] = useUserUnfollowMutation({
 *   variables: {
 *      followeeUserId: // value for 'followeeUserId'
 *   },
 * });
 */
export function useUserUnfollowMutation(baseOptions?: Apollo.MutationHookOptions<UserUnfollowMutation, UserUnfollowMutationVariables>) {
        return Apollo.useMutation<UserUnfollowMutation, UserUnfollowMutationVariables>(UserUnfollowDocument, baseOptions);
      }
export type UserUnfollowMutationHookResult = ReturnType<typeof useUserUnfollowMutation>;
export type UserUnfollowMutationResult = Apollo.MutationResult<UserUnfollowMutation>;
export type UserUnfollowMutationOptions = Apollo.BaseMutationOptions<UserUnfollowMutation, UserUnfollowMutationVariables>;
export const GroupFollowDocument = gql`
    mutation GroupFollow($followeeGroupId: Int!, $followerUserId: Int) {
  groupFollow(followeeGroupId: $followeeGroupId, followerUserId: $followerUserId) {
    groupId
    isFollowing
  }
}
    `;
export type GroupFollowMutationFn = Apollo.MutationFunction<GroupFollowMutation, GroupFollowMutationVariables>;

/**
 * __useGroupFollowMutation__
 *
 * To run a mutation, you first call `useGroupFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupFollowMutation, { data, loading, error }] = useGroupFollowMutation({
 *   variables: {
 *      followeeGroupId: // value for 'followeeGroupId'
 *      followerUserId: // value for 'followerUserId'
 *   },
 * });
 */
export function useGroupFollowMutation(baseOptions?: Apollo.MutationHookOptions<GroupFollowMutation, GroupFollowMutationVariables>) {
        return Apollo.useMutation<GroupFollowMutation, GroupFollowMutationVariables>(GroupFollowDocument, baseOptions);
      }
export type GroupFollowMutationHookResult = ReturnType<typeof useGroupFollowMutation>;
export type GroupFollowMutationResult = Apollo.MutationResult<GroupFollowMutation>;
export type GroupFollowMutationOptions = Apollo.BaseMutationOptions<GroupFollowMutation, GroupFollowMutationVariables>;
export const GroupUnfollowDocument = gql`
    mutation GroupUnfollow($followeeGroupId: Int!) {
  groupUnfollow(followeeGroupId: $followeeGroupId) {
    groupId
    isFollowing
  }
}
    `;
export type GroupUnfollowMutationFn = Apollo.MutationFunction<GroupUnfollowMutation, GroupUnfollowMutationVariables>;

/**
 * __useGroupUnfollowMutation__
 *
 * To run a mutation, you first call `useGroupUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUnfollowMutation, { data, loading, error }] = useGroupUnfollowMutation({
 *   variables: {
 *      followeeGroupId: // value for 'followeeGroupId'
 *   },
 * });
 */
export function useGroupUnfollowMutation(baseOptions?: Apollo.MutationHookOptions<GroupUnfollowMutation, GroupUnfollowMutationVariables>) {
        return Apollo.useMutation<GroupUnfollowMutation, GroupUnfollowMutationVariables>(GroupUnfollowDocument, baseOptions);
      }
export type GroupUnfollowMutationHookResult = ReturnType<typeof useGroupUnfollowMutation>;
export type GroupUnfollowMutationResult = Apollo.MutationResult<GroupUnfollowMutation>;
export type GroupUnfollowMutationOptions = Apollo.BaseMutationOptions<GroupUnfollowMutation, GroupUnfollowMutationVariables>;
export const UserBatchFollowDocument = gql`
    mutation UserBatchFollow($followeeUserIds: [Int!]) {
  userBatchFollow(followeeUserIds: $followeeUserIds) {
    userId
    isFollowing
  }
}
    `;
export type UserBatchFollowMutationFn = Apollo.MutationFunction<UserBatchFollowMutation, UserBatchFollowMutationVariables>;

/**
 * __useUserBatchFollowMutation__
 *
 * To run a mutation, you first call `useUserBatchFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBatchFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBatchFollowMutation, { data, loading, error }] = useUserBatchFollowMutation({
 *   variables: {
 *      followeeUserIds: // value for 'followeeUserIds'
 *   },
 * });
 */
export function useUserBatchFollowMutation(baseOptions?: Apollo.MutationHookOptions<UserBatchFollowMutation, UserBatchFollowMutationVariables>) {
        return Apollo.useMutation<UserBatchFollowMutation, UserBatchFollowMutationVariables>(UserBatchFollowDocument, baseOptions);
      }
export type UserBatchFollowMutationHookResult = ReturnType<typeof useUserBatchFollowMutation>;
export type UserBatchFollowMutationResult = Apollo.MutationResult<UserBatchFollowMutation>;
export type UserBatchFollowMutationOptions = Apollo.BaseMutationOptions<UserBatchFollowMutation, UserBatchFollowMutationVariables>;
export const GroupBatchFollowDocument = gql`
    mutation GroupBatchFollow($followeeGroupIds: [Int!]) {
  groupBatchFollow(followeeGroupIds: $followeeGroupIds) {
    groupId
    isFollowing
  }
}
    `;
export type GroupBatchFollowMutationFn = Apollo.MutationFunction<GroupBatchFollowMutation, GroupBatchFollowMutationVariables>;

/**
 * __useGroupBatchFollowMutation__
 *
 * To run a mutation, you first call `useGroupBatchFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupBatchFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupBatchFollowMutation, { data, loading, error }] = useGroupBatchFollowMutation({
 *   variables: {
 *      followeeGroupIds: // value for 'followeeGroupIds'
 *   },
 * });
 */
export function useGroupBatchFollowMutation(baseOptions?: Apollo.MutationHookOptions<GroupBatchFollowMutation, GroupBatchFollowMutationVariables>) {
        return Apollo.useMutation<GroupBatchFollowMutation, GroupBatchFollowMutationVariables>(GroupBatchFollowDocument, baseOptions);
      }
export type GroupBatchFollowMutationHookResult = ReturnType<typeof useGroupBatchFollowMutation>;
export type GroupBatchFollowMutationResult = Apollo.MutationResult<GroupBatchFollowMutation>;
export type GroupBatchFollowMutationOptions = Apollo.BaseMutationOptions<GroupBatchFollowMutation, GroupBatchFollowMutationVariables>;
export const DepartmentBatchFollowDocument = gql`
    mutation DepartmentBatchFollow($followeeDepartmentIds: [Int!]) {
  departmentBatchFollow(followeeDepartmentIds: $followeeDepartmentIds)
}
    `;
export type DepartmentBatchFollowMutationFn = Apollo.MutationFunction<DepartmentBatchFollowMutation, DepartmentBatchFollowMutationVariables>;

/**
 * __useDepartmentBatchFollowMutation__
 *
 * To run a mutation, you first call `useDepartmentBatchFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartmentBatchFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departmentBatchFollowMutation, { data, loading, error }] = useDepartmentBatchFollowMutation({
 *   variables: {
 *      followeeDepartmentIds: // value for 'followeeDepartmentIds'
 *   },
 * });
 */
export function useDepartmentBatchFollowMutation(baseOptions?: Apollo.MutationHookOptions<DepartmentBatchFollowMutation, DepartmentBatchFollowMutationVariables>) {
        return Apollo.useMutation<DepartmentBatchFollowMutation, DepartmentBatchFollowMutationVariables>(DepartmentBatchFollowDocument, baseOptions);
      }
export type DepartmentBatchFollowMutationHookResult = ReturnType<typeof useDepartmentBatchFollowMutation>;
export type DepartmentBatchFollowMutationResult = Apollo.MutationResult<DepartmentBatchFollowMutation>;
export type DepartmentBatchFollowMutationOptions = Apollo.BaseMutationOptions<DepartmentBatchFollowMutation, DepartmentBatchFollowMutationVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($pagination: PaginationInput!, $filter: GetGroupsFilter!) {
  groups(pagination: $pagination, filter: $filter) {
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      cursor
      node {
        ...RequestedGroup
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedGroupFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, baseOptions);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, baseOptions);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($groupId: Int!, $withAdmins: Boolean!, $pagination: PaginationInput!) {
  group(groupId: $groupId) {
    ...RequestedGroup
    isPinned
    isFollowing
    creator {
      ...UserInfo
    }
    admins(pagination: $pagination, filter: {}) @include(if: $withAdmins) {
      edges {
        node {
          ...UserInfo
        }
      }
    }
  }
}
    ${RequestedGroupFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      withAdmins: // value for 'withAdmins'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, baseOptions);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, baseOptions);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetGroupCreatorDocument = gql`
    query GetGroupCreator($groupId: Int!) {
  group(groupId: $groupId) {
    groupId
    creator {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useGetGroupCreatorQuery__
 *
 * To run a query within a React component, call `useGetGroupCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupCreatorQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupCreatorQuery(baseOptions: Apollo.QueryHookOptions<GetGroupCreatorQuery, GetGroupCreatorQueryVariables>) {
        return Apollo.useQuery<GetGroupCreatorQuery, GetGroupCreatorQueryVariables>(GetGroupCreatorDocument, baseOptions);
      }
export function useGetGroupCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupCreatorQuery, GetGroupCreatorQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupCreatorQuery, GetGroupCreatorQueryVariables>(GetGroupCreatorDocument, baseOptions);
        }
export type GetGroupCreatorQueryHookResult = ReturnType<typeof useGetGroupCreatorQuery>;
export type GetGroupCreatorLazyQueryHookResult = ReturnType<typeof useGetGroupCreatorLazyQuery>;
export type GetGroupCreatorQueryResult = Apollo.QueryResult<GetGroupCreatorQuery, GetGroupCreatorQueryVariables>;
export const GetGroupFollowersDocument = gql`
    query GetGroupFollowers($groupId: Int!, $pagination: PaginationInput!, $usersFilter: GetUsersFilter!) {
  group(groupId: $groupId) {
    groupId
    users: followers(pagination: $pagination, filter: $usersFilter) {
      totalCount
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...UserInfo
          departments {
            ...RequestedDepartment
          }
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}
${RequestedDepartmentFragmentDoc}`;

/**
 * __useGetGroupFollowersQuery__
 *
 * To run a query within a React component, call `useGetGroupFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupFollowersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *      usersFilter: // value for 'usersFilter'
 *   },
 * });
 */
export function useGetGroupFollowersQuery(baseOptions: Apollo.QueryHookOptions<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>) {
        return Apollo.useQuery<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>(GetGroupFollowersDocument, baseOptions);
      }
export function useGetGroupFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>(GetGroupFollowersDocument, baseOptions);
        }
export type GetGroupFollowersQueryHookResult = ReturnType<typeof useGetGroupFollowersQuery>;
export type GetGroupFollowersLazyQueryHookResult = ReturnType<typeof useGetGroupFollowersLazyQuery>;
export type GetGroupFollowersQueryResult = Apollo.QueryResult<GetGroupFollowersQuery, GetGroupFollowersQueryVariables>;
export const GetGroupAdminsDocument = gql`
    query GetGroupAdmins($groupId: Int!, $pagination: PaginationInput!, $usersFilter: GetUsersFilter!) {
  group(groupId: $groupId) {
    groupId
    users: admins(pagination: $pagination, filter: $usersFilter) {
      totalCount
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...UserInfo
          departments {
            ...RequestedDepartment
          }
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}
${RequestedDepartmentFragmentDoc}`;

/**
 * __useGetGroupAdminsQuery__
 *
 * To run a query within a React component, call `useGetGroupAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupAdminsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *      usersFilter: // value for 'usersFilter'
 *   },
 * });
 */
export function useGetGroupAdminsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupAdminsQuery, GetGroupAdminsQueryVariables>) {
        return Apollo.useQuery<GetGroupAdminsQuery, GetGroupAdminsQueryVariables>(GetGroupAdminsDocument, baseOptions);
      }
export function useGetGroupAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupAdminsQuery, GetGroupAdminsQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupAdminsQuery, GetGroupAdminsQueryVariables>(GetGroupAdminsDocument, baseOptions);
        }
export type GetGroupAdminsQueryHookResult = ReturnType<typeof useGetGroupAdminsQuery>;
export type GetGroupAdminsLazyQueryHookResult = ReturnType<typeof useGetGroupAdminsLazyQuery>;
export type GetGroupAdminsQueryResult = Apollo.QueryResult<GetGroupAdminsQuery, GetGroupAdminsQueryVariables>;
export const GetGroupFilesDocument = gql`
    query GetGroupFiles($groupId: Int!, $pagination: PaginationInput!) {
  group(groupId: $groupId) {
    groupId
    files(pagination: $pagination) {
      edges {
        node {
          ...LocalFile
          postId
          createdAt
          creator {
            userId
            name
            email
            avatarUrl
          }
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
      totalCount
    }
  }
}
    ${LocalFileFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetGroupFilesQuery__
 *
 * To run a query within a React component, call `useGetGroupFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupFilesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetGroupFilesQuery(baseOptions: Apollo.QueryHookOptions<GetGroupFilesQuery, GetGroupFilesQueryVariables>) {
        return Apollo.useQuery<GetGroupFilesQuery, GetGroupFilesQueryVariables>(GetGroupFilesDocument, baseOptions);
      }
export function useGetGroupFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupFilesQuery, GetGroupFilesQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupFilesQuery, GetGroupFilesQueryVariables>(GetGroupFilesDocument, baseOptions);
        }
export type GetGroupFilesQueryHookResult = ReturnType<typeof useGetGroupFilesQuery>;
export type GetGroupFilesLazyQueryHookResult = ReturnType<typeof useGetGroupFilesLazyQuery>;
export type GetGroupFilesQueryResult = Apollo.QueryResult<GetGroupFilesQuery, GetGroupFilesQueryVariables>;
export const GetNewestsGroupsDocument = gql`
    query GetNewestsGroups($pagination: PaginationInput!, $filter: GetGroupsFilter!, $withPosts: Boolean = false, $withFollowers: Boolean = false) {
  groups(pagination: $pagination, filter: $filter) {
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        ...GroupWithExtras
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${GroupWithExtrasFragmentDoc}`;

/**
 * __useGetNewestsGroupsQuery__
 *
 * To run a query within a React component, call `useGetNewestsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewestsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewestsGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      withPosts: // value for 'withPosts'
 *      withFollowers: // value for 'withFollowers'
 *   },
 * });
 */
export function useGetNewestsGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetNewestsGroupsQuery, GetNewestsGroupsQueryVariables>) {
        return Apollo.useQuery<GetNewestsGroupsQuery, GetNewestsGroupsQueryVariables>(GetNewestsGroupsDocument, baseOptions);
      }
export function useGetNewestsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewestsGroupsQuery, GetNewestsGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetNewestsGroupsQuery, GetNewestsGroupsQueryVariables>(GetNewestsGroupsDocument, baseOptions);
        }
export type GetNewestsGroupsQueryHookResult = ReturnType<typeof useGetNewestsGroupsQuery>;
export type GetNewestsGroupsLazyQueryHookResult = ReturnType<typeof useGetNewestsGroupsLazyQuery>;
export type GetNewestsGroupsQueryResult = Apollo.QueryResult<GetNewestsGroupsQuery, GetNewestsGroupsQueryVariables>;
export const GetViewerFollowingGroupsDocument = gql`
    query GetViewerFollowingGroups($pagination: PaginationInput!, $filter: GetGroupsFilter!, $withPosts: Boolean = false, $withFollowers: Boolean = false) {
  viewer {
    userId
    groups: followingGroups(pagination: $pagination, filter: $filter) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...GroupWithExtras
          recentUnreadCount
          isPinned
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${GroupWithExtrasFragmentDoc}`;

/**
 * __useGetViewerFollowingGroupsQuery__
 *
 * To run a query within a React component, call `useGetViewerFollowingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerFollowingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerFollowingGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      withPosts: // value for 'withPosts'
 *      withFollowers: // value for 'withFollowers'
 *   },
 * });
 */
export function useGetViewerFollowingGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetViewerFollowingGroupsQuery, GetViewerFollowingGroupsQueryVariables>) {
        return Apollo.useQuery<GetViewerFollowingGroupsQuery, GetViewerFollowingGroupsQueryVariables>(GetViewerFollowingGroupsDocument, baseOptions);
      }
export function useGetViewerFollowingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerFollowingGroupsQuery, GetViewerFollowingGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerFollowingGroupsQuery, GetViewerFollowingGroupsQueryVariables>(GetViewerFollowingGroupsDocument, baseOptions);
        }
export type GetViewerFollowingGroupsQueryHookResult = ReturnType<typeof useGetViewerFollowingGroupsQuery>;
export type GetViewerFollowingGroupsLazyQueryHookResult = ReturnType<typeof useGetViewerFollowingGroupsLazyQuery>;
export type GetViewerFollowingGroupsQueryResult = Apollo.QueryResult<GetViewerFollowingGroupsQuery, GetViewerFollowingGroupsQueryVariables>;
export const GetViewerCreatedGroupsDocument = gql`
    query GetViewerCreatedGroups($pagination: PaginationInput!, $filter: GetGroupsFilter!, $withPosts: Boolean = false, $withFollowers: Boolean = false) {
  viewer {
    userId
    groups: createdGroups(pagination: $pagination, filter: $filter) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...GroupWithExtras
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${GroupWithExtrasFragmentDoc}`;

/**
 * __useGetViewerCreatedGroupsQuery__
 *
 * To run a query within a React component, call `useGetViewerCreatedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerCreatedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerCreatedGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      withPosts: // value for 'withPosts'
 *      withFollowers: // value for 'withFollowers'
 *   },
 * });
 */
export function useGetViewerCreatedGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetViewerCreatedGroupsQuery, GetViewerCreatedGroupsQueryVariables>) {
        return Apollo.useQuery<GetViewerCreatedGroupsQuery, GetViewerCreatedGroupsQueryVariables>(GetViewerCreatedGroupsDocument, baseOptions);
      }
export function useGetViewerCreatedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerCreatedGroupsQuery, GetViewerCreatedGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerCreatedGroupsQuery, GetViewerCreatedGroupsQueryVariables>(GetViewerCreatedGroupsDocument, baseOptions);
        }
export type GetViewerCreatedGroupsQueryHookResult = ReturnType<typeof useGetViewerCreatedGroupsQuery>;
export type GetViewerCreatedGroupsLazyQueryHookResult = ReturnType<typeof useGetViewerCreatedGroupsLazyQuery>;
export type GetViewerCreatedGroupsQueryResult = Apollo.QueryResult<GetViewerCreatedGroupsQuery, GetViewerCreatedGroupsQueryVariables>;
export const GetGroupCategoriesDocument = gql`
    query GetGroupCategories {
  groupCategories {
    groupCategoryId
    name
  }
}
    `;

/**
 * __useGetGroupCategoriesQuery__
 *
 * To run a query within a React component, call `useGetGroupCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>) {
        return Apollo.useQuery<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>(GetGroupCategoriesDocument, baseOptions);
      }
export function useGetGroupCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>(GetGroupCategoriesDocument, baseOptions);
        }
export type GetGroupCategoriesQueryHookResult = ReturnType<typeof useGetGroupCategoriesQuery>;
export type GetGroupCategoriesLazyQueryHookResult = ReturnType<typeof useGetGroupCategoriesLazyQuery>;
export type GetGroupCategoriesQueryResult = Apollo.QueryResult<GetGroupCategoriesQuery, GetGroupCategoriesQueryVariables>;
export const GetUnreadMemberRequestsDocument = gql`
    query GetUnreadMemberRequests($groupId: Int!, $pagination: PaginationInput!) {
  group(groupId: $groupId) {
    groupId
    unreadMemberRequests(pagination: $pagination) {
      totalCount
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          requestId
          creator {
            ...UserWithExtras
          }
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserWithExtrasFragmentDoc}`;

/**
 * __useGetUnreadMemberRequestsQuery__
 *
 * To run a query within a React component, call `useGetUnreadMemberRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadMemberRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadMemberRequestsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUnreadMemberRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetUnreadMemberRequestsQuery, GetUnreadMemberRequestsQueryVariables>) {
        return Apollo.useQuery<GetUnreadMemberRequestsQuery, GetUnreadMemberRequestsQueryVariables>(GetUnreadMemberRequestsDocument, baseOptions);
      }
export function useGetUnreadMemberRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadMemberRequestsQuery, GetUnreadMemberRequestsQueryVariables>) {
          return Apollo.useLazyQuery<GetUnreadMemberRequestsQuery, GetUnreadMemberRequestsQueryVariables>(GetUnreadMemberRequestsDocument, baseOptions);
        }
export type GetUnreadMemberRequestsQueryHookResult = ReturnType<typeof useGetUnreadMemberRequestsQuery>;
export type GetUnreadMemberRequestsLazyQueryHookResult = ReturnType<typeof useGetUnreadMemberRequestsLazyQuery>;
export type GetUnreadMemberRequestsQueryResult = Apollo.QueryResult<GetUnreadMemberRequestsQuery, GetUnreadMemberRequestsQueryVariables>;
export const GetGroupMemberRequestDocument = gql`
    query GetGroupMemberRequest($requestId: Int!) {
  groupMemberRequest(requestId: $requestId) {
    requestId
    isApproved
    creator {
      ...UserInfo
    }
    group {
      ...RequestedGroup
    }
    approver {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedGroupFragmentDoc}`;

/**
 * __useGetGroupMemberRequestQuery__
 *
 * To run a query within a React component, call `useGetGroupMemberRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMemberRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMemberRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetGroupMemberRequestQuery(baseOptions: Apollo.QueryHookOptions<GetGroupMemberRequestQuery, GetGroupMemberRequestQueryVariables>) {
        return Apollo.useQuery<GetGroupMemberRequestQuery, GetGroupMemberRequestQueryVariables>(GetGroupMemberRequestDocument, baseOptions);
      }
export function useGetGroupMemberRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupMemberRequestQuery, GetGroupMemberRequestQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupMemberRequestQuery, GetGroupMemberRequestQueryVariables>(GetGroupMemberRequestDocument, baseOptions);
        }
export type GetGroupMemberRequestQueryHookResult = ReturnType<typeof useGetGroupMemberRequestQuery>;
export type GetGroupMemberRequestLazyQueryHookResult = ReturnType<typeof useGetGroupMemberRequestLazyQuery>;
export type GetGroupMemberRequestQueryResult = Apollo.QueryResult<GetGroupMemberRequestQuery, GetGroupMemberRequestQueryVariables>;
export const GroupCreateDocument = gql`
    mutation GroupCreate($group: CreateGroupInput!) {
  groupCreate(group: $group) {
    ...RequestedGroup
  }
}
    ${RequestedGroupFragmentDoc}`;
export type GroupCreateMutationFn = Apollo.MutationFunction<GroupCreateMutation, GroupCreateMutationVariables>;

/**
 * __useGroupCreateMutation__
 *
 * To run a mutation, you first call `useGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupCreateMutation, { data, loading, error }] = useGroupCreateMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<GroupCreateMutation, GroupCreateMutationVariables>) {
        return Apollo.useMutation<GroupCreateMutation, GroupCreateMutationVariables>(GroupCreateDocument, baseOptions);
      }
export type GroupCreateMutationHookResult = ReturnType<typeof useGroupCreateMutation>;
export type GroupCreateMutationResult = Apollo.MutationResult<GroupCreateMutation>;
export type GroupCreateMutationOptions = Apollo.BaseMutationOptions<GroupCreateMutation, GroupCreateMutationVariables>;
export const GroupUpdateDocument = gql`
    mutation GroupUpdate($groupId: Int!, $group: UpdateGroupInput!) {
  groupUpdate(groupId: $groupId, group: $group) {
    ...RequestedGroup
  }
}
    ${RequestedGroupFragmentDoc}`;
export type GroupUpdateMutationFn = Apollo.MutationFunction<GroupUpdateMutation, GroupUpdateMutationVariables>;

/**
 * __useGroupUpdateMutation__
 *
 * To run a mutation, you first call `useGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUpdateMutation, { data, loading, error }] = useGroupUpdateMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GroupUpdateMutation, GroupUpdateMutationVariables>) {
        return Apollo.useMutation<GroupUpdateMutation, GroupUpdateMutationVariables>(GroupUpdateDocument, baseOptions);
      }
export type GroupUpdateMutationHookResult = ReturnType<typeof useGroupUpdateMutation>;
export type GroupUpdateMutationResult = Apollo.MutationResult<GroupUpdateMutation>;
export type GroupUpdateMutationOptions = Apollo.BaseMutationOptions<GroupUpdateMutation, GroupUpdateMutationVariables>;
export const GroupArchiveDocument = gql`
    mutation GroupArchive($groupId: Int!) {
  groupArchive(groupId: $groupId)
}
    `;
export type GroupArchiveMutationFn = Apollo.MutationFunction<GroupArchiveMutation, GroupArchiveMutationVariables>;

/**
 * __useGroupArchiveMutation__
 *
 * To run a mutation, you first call `useGroupArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupArchiveMutation, { data, loading, error }] = useGroupArchiveMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupArchiveMutation(baseOptions?: Apollo.MutationHookOptions<GroupArchiveMutation, GroupArchiveMutationVariables>) {
        return Apollo.useMutation<GroupArchiveMutation, GroupArchiveMutationVariables>(GroupArchiveDocument, baseOptions);
      }
export type GroupArchiveMutationHookResult = ReturnType<typeof useGroupArchiveMutation>;
export type GroupArchiveMutationResult = Apollo.MutationResult<GroupArchiveMutation>;
export type GroupArchiveMutationOptions = Apollo.BaseMutationOptions<GroupArchiveMutation, GroupArchiveMutationVariables>;
export const GroupUnArchiveDocument = gql`
    mutation GroupUnArchive($groupId: Int!) {
  groupUnArchive(groupId: $groupId)
}
    `;
export type GroupUnArchiveMutationFn = Apollo.MutationFunction<GroupUnArchiveMutation, GroupUnArchiveMutationVariables>;

/**
 * __useGroupUnArchiveMutation__
 *
 * To run a mutation, you first call `useGroupUnArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupUnArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupUnArchiveMutation, { data, loading, error }] = useGroupUnArchiveMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupUnArchiveMutation(baseOptions?: Apollo.MutationHookOptions<GroupUnArchiveMutation, GroupUnArchiveMutationVariables>) {
        return Apollo.useMutation<GroupUnArchiveMutation, GroupUnArchiveMutationVariables>(GroupUnArchiveDocument, baseOptions);
      }
export type GroupUnArchiveMutationHookResult = ReturnType<typeof useGroupUnArchiveMutation>;
export type GroupUnArchiveMutationResult = Apollo.MutationResult<GroupUnArchiveMutation>;
export type GroupUnArchiveMutationOptions = Apollo.BaseMutationOptions<GroupUnArchiveMutation, GroupUnArchiveMutationVariables>;
export const GroupInviteDocument = gql`
    mutation GroupInvite($followeeGroupId: Int!, $followerUserIds: [Int!], $departmentIds: [Int!]) {
  groupInvite(
    followeeGroupId: $followeeGroupId
    followerUserIds: $followerUserIds
    departmentIds: $departmentIds
  )
}
    `;
export type GroupInviteMutationFn = Apollo.MutationFunction<GroupInviteMutation, GroupInviteMutationVariables>;

/**
 * __useGroupInviteMutation__
 *
 * To run a mutation, you first call `useGroupInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupInviteMutation, { data, loading, error }] = useGroupInviteMutation({
 *   variables: {
 *      followeeGroupId: // value for 'followeeGroupId'
 *      followerUserIds: // value for 'followerUserIds'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useGroupInviteMutation(baseOptions?: Apollo.MutationHookOptions<GroupInviteMutation, GroupInviteMutationVariables>) {
        return Apollo.useMutation<GroupInviteMutation, GroupInviteMutationVariables>(GroupInviteDocument, baseOptions);
      }
export type GroupInviteMutationHookResult = ReturnType<typeof useGroupInviteMutation>;
export type GroupInviteMutationResult = Apollo.MutationResult<GroupInviteMutation>;
export type GroupInviteMutationOptions = Apollo.BaseMutationOptions<GroupInviteMutation, GroupInviteMutationVariables>;
export const GroupApplyDocument = gql`
    mutation GroupApply($groupId: Int!) {
  groupApply(groupId: $groupId)
}
    `;
export type GroupApplyMutationFn = Apollo.MutationFunction<GroupApplyMutation, GroupApplyMutationVariables>;

/**
 * __useGroupApplyMutation__
 *
 * To run a mutation, you first call `useGroupApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupApplyMutation, { data, loading, error }] = useGroupApplyMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupApplyMutation(baseOptions?: Apollo.MutationHookOptions<GroupApplyMutation, GroupApplyMutationVariables>) {
        return Apollo.useMutation<GroupApplyMutation, GroupApplyMutationVariables>(GroupApplyDocument, baseOptions);
      }
export type GroupApplyMutationHookResult = ReturnType<typeof useGroupApplyMutation>;
export type GroupApplyMutationResult = Apollo.MutationResult<GroupApplyMutation>;
export type GroupApplyMutationOptions = Apollo.BaseMutationOptions<GroupApplyMutation, GroupApplyMutationVariables>;
export const GroupPinUpdateDocument = gql`
    mutation GroupPinUpdate($groupId: Int!) {
  groupPinUpdate(groupId: $groupId) {
    groupId
    isPinned
  }
}
    `;
export type GroupPinUpdateMutationFn = Apollo.MutationFunction<GroupPinUpdateMutation, GroupPinUpdateMutationVariables>;

/**
 * __useGroupPinUpdateMutation__
 *
 * To run a mutation, you first call `useGroupPinUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupPinUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupPinUpdateMutation, { data, loading, error }] = useGroupPinUpdateMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPinUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GroupPinUpdateMutation, GroupPinUpdateMutationVariables>) {
        return Apollo.useMutation<GroupPinUpdateMutation, GroupPinUpdateMutationVariables>(GroupPinUpdateDocument, baseOptions);
      }
export type GroupPinUpdateMutationHookResult = ReturnType<typeof useGroupPinUpdateMutation>;
export type GroupPinUpdateMutationResult = Apollo.MutationResult<GroupPinUpdateMutation>;
export type GroupPinUpdateMutationOptions = Apollo.BaseMutationOptions<GroupPinUpdateMutation, GroupPinUpdateMutationVariables>;
export const GroupMemberRequestApproveDocument = gql`
    mutation GroupMemberRequestApprove($requestId: Int!, $isApproved: Boolean!) {
  groupMemberRequestApprove(requestId: $requestId, isApproved: $isApproved) {
    alreadyApproved
    requesetHandled
  }
}
    `;
export type GroupMemberRequestApproveMutationFn = Apollo.MutationFunction<GroupMemberRequestApproveMutation, GroupMemberRequestApproveMutationVariables>;

/**
 * __useGroupMemberRequestApproveMutation__
 *
 * To run a mutation, you first call `useGroupMemberRequestApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupMemberRequestApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupMemberRequestApproveMutation, { data, loading, error }] = useGroupMemberRequestApproveMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      isApproved: // value for 'isApproved'
 *   },
 * });
 */
export function useGroupMemberRequestApproveMutation(baseOptions?: Apollo.MutationHookOptions<GroupMemberRequestApproveMutation, GroupMemberRequestApproveMutationVariables>) {
        return Apollo.useMutation<GroupMemberRequestApproveMutation, GroupMemberRequestApproveMutationVariables>(GroupMemberRequestApproveDocument, baseOptions);
      }
export type GroupMemberRequestApproveMutationHookResult = ReturnType<typeof useGroupMemberRequestApproveMutation>;
export type GroupMemberRequestApproveMutationResult = Apollo.MutationResult<GroupMemberRequestApproveMutation>;
export type GroupMemberRequestApproveMutationOptions = Apollo.BaseMutationOptions<GroupMemberRequestApproveMutation, GroupMemberRequestApproveMutationVariables>;
export const GroupFollowerRemoveDocument = gql`
    mutation GroupFollowerRemove($followeeGroupId: Int!, $followerUserId: Int!) {
  groupFollowerRemove(
    followeeGroupId: $followeeGroupId
    followerUserId: $followerUserId
  )
}
    `;
export type GroupFollowerRemoveMutationFn = Apollo.MutationFunction<GroupFollowerRemoveMutation, GroupFollowerRemoveMutationVariables>;

/**
 * __useGroupFollowerRemoveMutation__
 *
 * To run a mutation, you first call `useGroupFollowerRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupFollowerRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupFollowerRemoveMutation, { data, loading, error }] = useGroupFollowerRemoveMutation({
 *   variables: {
 *      followeeGroupId: // value for 'followeeGroupId'
 *      followerUserId: // value for 'followerUserId'
 *   },
 * });
 */
export function useGroupFollowerRemoveMutation(baseOptions?: Apollo.MutationHookOptions<GroupFollowerRemoveMutation, GroupFollowerRemoveMutationVariables>) {
        return Apollo.useMutation<GroupFollowerRemoveMutation, GroupFollowerRemoveMutationVariables>(GroupFollowerRemoveDocument, baseOptions);
      }
export type GroupFollowerRemoveMutationHookResult = ReturnType<typeof useGroupFollowerRemoveMutation>;
export type GroupFollowerRemoveMutationResult = Apollo.MutationResult<GroupFollowerRemoveMutation>;
export type GroupFollowerRemoveMutationOptions = Apollo.BaseMutationOptions<GroupFollowerRemoveMutation, GroupFollowerRemoveMutationVariables>;
export const GroupUpdatedDocument = gql`
    subscription GroupUpdated($groupId: Int!) {
  groupUpdated(groupId: $groupId) {
    ...RequestedGroup
  }
}
    ${RequestedGroupFragmentDoc}`;

/**
 * __useGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupUpdatedSubscription({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables>) {
        return Apollo.useSubscription<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables>(GroupUpdatedDocument, baseOptions);
      }
export type GroupUpdatedSubscriptionHookResult = ReturnType<typeof useGroupUpdatedSubscription>;
export type GroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<GroupUpdatedSubscription>;
export const GroupAddedDocument = gql`
    subscription GroupAdded {
  groupAdded {
    ...RequestedGroup
  }
}
    ${RequestedGroupFragmentDoc}`;

/**
 * __useGroupAddedSubscription__
 *
 * To run a query within a React component, call `useGroupAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAddedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGroupAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GroupAddedSubscription, GroupAddedSubscriptionVariables>) {
        return Apollo.useSubscription<GroupAddedSubscription, GroupAddedSubscriptionVariables>(GroupAddedDocument, baseOptions);
      }
export type GroupAddedSubscriptionHookResult = ReturnType<typeof useGroupAddedSubscription>;
export type GroupAddedSubscriptionResult = Apollo.SubscriptionResult<GroupAddedSubscription>;
export const GroupMemberRequestChangedDocument = gql`
    subscription GroupMemberRequestChanged($groupId: Int!) {
  groupMemeberRequestChanged(groupId: $groupId) {
    groupId
    unreadMemberRequests(pagination: {last: 2}) {
      totalCount
    }
  }
}
    `;

/**
 * __useGroupMemberRequestChangedSubscription__
 *
 * To run a query within a React component, call `useGroupMemberRequestChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupMemberRequestChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMemberRequestChangedSubscription({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupMemberRequestChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GroupMemberRequestChangedSubscription, GroupMemberRequestChangedSubscriptionVariables>) {
        return Apollo.useSubscription<GroupMemberRequestChangedSubscription, GroupMemberRequestChangedSubscriptionVariables>(GroupMemberRequestChangedDocument, baseOptions);
      }
export type GroupMemberRequestChangedSubscriptionHookResult = ReturnType<typeof useGroupMemberRequestChangedSubscription>;
export type GroupMemberRequestChangedSubscriptionResult = Apollo.SubscriptionResult<GroupMemberRequestChangedSubscription>;
export const GetKnowledgeGroupsDocument = gql`
    query GetKnowledgeGroups($pagination: PaginationInput!) {
  knowledge {
    groups(pagination: $pagination) {
      edges {
        node {
          knowledgeGroupId
          parentKnowledgeGroupId
          path
          name
          position
          posts(pagination: {last: 0}) {
            totalCount
          }
          childGroupIds
          childPositions
        }
      }
    }
  }
}
    `;

/**
 * __useGetKnowledgeGroupsQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeGroupsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetKnowledgeGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeGroupsQuery, GetKnowledgeGroupsQueryVariables>) {
        return Apollo.useQuery<GetKnowledgeGroupsQuery, GetKnowledgeGroupsQueryVariables>(GetKnowledgeGroupsDocument, baseOptions);
      }
export function useGetKnowledgeGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeGroupsQuery, GetKnowledgeGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetKnowledgeGroupsQuery, GetKnowledgeGroupsQueryVariables>(GetKnowledgeGroupsDocument, baseOptions);
        }
export type GetKnowledgeGroupsQueryHookResult = ReturnType<typeof useGetKnowledgeGroupsQuery>;
export type GetKnowledgeGroupsLazyQueryHookResult = ReturnType<typeof useGetKnowledgeGroupsLazyQuery>;
export type GetKnowledgeGroupsQueryResult = Apollo.QueryResult<GetKnowledgeGroupsQuery, GetKnowledgeGroupsQueryVariables>;
export const GetKnowledgeGroupDocument = gql`
    query GetKnowledgeGroup($knowledgeGroupId: Int!) {
  knowledge {
    group(knowledgeGroupId: $knowledgeGroupId) {
      knowledgeGroupId
      name
      parentGroups {
        knowledgeGroupId
        name
      }
    }
  }
}
    `;

/**
 * __useGetKnowledgeGroupQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeGroupQuery({
 *   variables: {
 *      knowledgeGroupId: // value for 'knowledgeGroupId'
 *   },
 * });
 */
export function useGetKnowledgeGroupQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeGroupQuery, GetKnowledgeGroupQueryVariables>) {
        return Apollo.useQuery<GetKnowledgeGroupQuery, GetKnowledgeGroupQueryVariables>(GetKnowledgeGroupDocument, baseOptions);
      }
export function useGetKnowledgeGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeGroupQuery, GetKnowledgeGroupQueryVariables>) {
          return Apollo.useLazyQuery<GetKnowledgeGroupQuery, GetKnowledgeGroupQueryVariables>(GetKnowledgeGroupDocument, baseOptions);
        }
export type GetKnowledgeGroupQueryHookResult = ReturnType<typeof useGetKnowledgeGroupQuery>;
export type GetKnowledgeGroupLazyQueryHookResult = ReturnType<typeof useGetKnowledgeGroupLazyQuery>;
export type GetKnowledgeGroupQueryResult = Apollo.QueryResult<GetKnowledgeGroupQuery, GetKnowledgeGroupQueryVariables>;
export const GetKnowledgeGroupPostsDocument = gql`
    query GetKnowledgeGroupPosts($pagination: PaginationInput!, $search: String, $knowledgeGroupId: Int!) {
  knowledge {
    group(knowledgeGroupId: $knowledgeGroupId) {
      ...RequestedKnowledgeGroup
      posts(pagination: $pagination, search: $search) {
        pageInfo {
          ...RequestedPageInfo
        }
        edges {
          node {
            ...RequestedKnowledgePost
          }
        }
      }
    }
  }
}
    ${RequestedKnowledgeGroupFragmentDoc}
${RequestedPageInfoFragmentDoc}
${RequestedKnowledgePostFragmentDoc}`;

/**
 * __useGetKnowledgeGroupPostsQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeGroupPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeGroupPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeGroupPostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *      knowledgeGroupId: // value for 'knowledgeGroupId'
 *   },
 * });
 */
export function useGetKnowledgeGroupPostsQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeGroupPostsQuery, GetKnowledgeGroupPostsQueryVariables>) {
        return Apollo.useQuery<GetKnowledgeGroupPostsQuery, GetKnowledgeGroupPostsQueryVariables>(GetKnowledgeGroupPostsDocument, baseOptions);
      }
export function useGetKnowledgeGroupPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeGroupPostsQuery, GetKnowledgeGroupPostsQueryVariables>) {
          return Apollo.useLazyQuery<GetKnowledgeGroupPostsQuery, GetKnowledgeGroupPostsQueryVariables>(GetKnowledgeGroupPostsDocument, baseOptions);
        }
export type GetKnowledgeGroupPostsQueryHookResult = ReturnType<typeof useGetKnowledgeGroupPostsQuery>;
export type GetKnowledgeGroupPostsLazyQueryHookResult = ReturnType<typeof useGetKnowledgeGroupPostsLazyQuery>;
export type GetKnowledgeGroupPostsQueryResult = Apollo.QueryResult<GetKnowledgeGroupPostsQuery, GetKnowledgeGroupPostsQueryVariables>;
export const GetKnowledgePostsDocument = gql`
    query GetKnowledgePosts($pagination: PaginationInput!, $search: String!) {
  knowledge {
    posts(pagination: $pagination, search: $search) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...RequestedKnowledgePost
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedKnowledgePostFragmentDoc}`;

/**
 * __useGetKnowledgePostsQuery__
 *
 * To run a query within a React component, call `useGetKnowledgePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgePostsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetKnowledgePostsQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgePostsQuery, GetKnowledgePostsQueryVariables>) {
        return Apollo.useQuery<GetKnowledgePostsQuery, GetKnowledgePostsQueryVariables>(GetKnowledgePostsDocument, baseOptions);
      }
export function useGetKnowledgePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgePostsQuery, GetKnowledgePostsQueryVariables>) {
          return Apollo.useLazyQuery<GetKnowledgePostsQuery, GetKnowledgePostsQueryVariables>(GetKnowledgePostsDocument, baseOptions);
        }
export type GetKnowledgePostsQueryHookResult = ReturnType<typeof useGetKnowledgePostsQuery>;
export type GetKnowledgePostsLazyQueryHookResult = ReturnType<typeof useGetKnowledgePostsLazyQuery>;
export type GetKnowledgePostsQueryResult = Apollo.QueryResult<GetKnowledgePostsQuery, GetKnowledgePostsQueryVariables>;
export const GetKnowledgePostDocument = gql`
    query GetKnowledgePost($knowledgePostId: Int!) {
  knowledge {
    post(knowledgePostId: $knowledgePostId) {
      ...RequestedKnowledgePost
    }
  }
}
    ${RequestedKnowledgePostFragmentDoc}`;

/**
 * __useGetKnowledgePostQuery__
 *
 * To run a query within a React component, call `useGetKnowledgePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgePostQuery({
 *   variables: {
 *      knowledgePostId: // value for 'knowledgePostId'
 *   },
 * });
 */
export function useGetKnowledgePostQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgePostQuery, GetKnowledgePostQueryVariables>) {
        return Apollo.useQuery<GetKnowledgePostQuery, GetKnowledgePostQueryVariables>(GetKnowledgePostDocument, baseOptions);
      }
export function useGetKnowledgePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgePostQuery, GetKnowledgePostQueryVariables>) {
          return Apollo.useLazyQuery<GetKnowledgePostQuery, GetKnowledgePostQueryVariables>(GetKnowledgePostDocument, baseOptions);
        }
export type GetKnowledgePostQueryHookResult = ReturnType<typeof useGetKnowledgePostQuery>;
export type GetKnowledgePostLazyQueryHookResult = ReturnType<typeof useGetKnowledgePostLazyQuery>;
export type GetKnowledgePostQueryResult = Apollo.QueryResult<GetKnowledgePostQuery, GetKnowledgePostQueryVariables>;
export const GetFavoredKnowledgeGroupsDocument = gql`
    query GetFavoredKnowledgeGroups {
  viewer {
    userId
    favoredKnowledgeGroups {
      ...RequestedKnowledgeGroup
      posts(pagination: {last: 0}) {
        totalCount
      }
    }
  }
}
    ${RequestedKnowledgeGroupFragmentDoc}`;

/**
 * __useGetFavoredKnowledgeGroupsQuery__
 *
 * To run a query within a React component, call `useGetFavoredKnowledgeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoredKnowledgeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoredKnowledgeGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoredKnowledgeGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoredKnowledgeGroupsQuery, GetFavoredKnowledgeGroupsQueryVariables>) {
        return Apollo.useQuery<GetFavoredKnowledgeGroupsQuery, GetFavoredKnowledgeGroupsQueryVariables>(GetFavoredKnowledgeGroupsDocument, baseOptions);
      }
export function useGetFavoredKnowledgeGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoredKnowledgeGroupsQuery, GetFavoredKnowledgeGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetFavoredKnowledgeGroupsQuery, GetFavoredKnowledgeGroupsQueryVariables>(GetFavoredKnowledgeGroupsDocument, baseOptions);
        }
export type GetFavoredKnowledgeGroupsQueryHookResult = ReturnType<typeof useGetFavoredKnowledgeGroupsQuery>;
export type GetFavoredKnowledgeGroupsLazyQueryHookResult = ReturnType<typeof useGetFavoredKnowledgeGroupsLazyQuery>;
export type GetFavoredKnowledgeGroupsQueryResult = Apollo.QueryResult<GetFavoredKnowledgeGroupsQuery, GetFavoredKnowledgeGroupsQueryVariables>;
export const KnowledgeGroupCreateDocument = gql`
    mutation KnowledgeGroupCreate($knowledgeGroupInput: CreateKnowledgeGroupInput!) {
  knowledgeGroupCreate(knowledgeGroupInput: $knowledgeGroupInput) {
    ...RequestedKnowledgeGroup
  }
}
    ${RequestedKnowledgeGroupFragmentDoc}`;
export type KnowledgeGroupCreateMutationFn = Apollo.MutationFunction<KnowledgeGroupCreateMutation, KnowledgeGroupCreateMutationVariables>;

/**
 * __useKnowledgeGroupCreateMutation__
 *
 * To run a mutation, you first call `useKnowledgeGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgeGroupCreateMutation, { data, loading, error }] = useKnowledgeGroupCreateMutation({
 *   variables: {
 *      knowledgeGroupInput: // value for 'knowledgeGroupInput'
 *   },
 * });
 */
export function useKnowledgeGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgeGroupCreateMutation, KnowledgeGroupCreateMutationVariables>) {
        return Apollo.useMutation<KnowledgeGroupCreateMutation, KnowledgeGroupCreateMutationVariables>(KnowledgeGroupCreateDocument, baseOptions);
      }
export type KnowledgeGroupCreateMutationHookResult = ReturnType<typeof useKnowledgeGroupCreateMutation>;
export type KnowledgeGroupCreateMutationResult = Apollo.MutationResult<KnowledgeGroupCreateMutation>;
export type KnowledgeGroupCreateMutationOptions = Apollo.BaseMutationOptions<KnowledgeGroupCreateMutation, KnowledgeGroupCreateMutationVariables>;
export const KnowledgeGroupUpdateDocument = gql`
    mutation KnowledgeGroupUpdate($knowledgeGroupInput: UpdateKnowledgeGroupInput!, $knowledgeGroupId: Int!) {
  knowledgeGroupUpdate(
    knowledgeGroupInput: $knowledgeGroupInput
    knowledgeGroupId: $knowledgeGroupId
  ) {
    ...RequestedKnowledgeGroup
  }
}
    ${RequestedKnowledgeGroupFragmentDoc}`;
export type KnowledgeGroupUpdateMutationFn = Apollo.MutationFunction<KnowledgeGroupUpdateMutation, KnowledgeGroupUpdateMutationVariables>;

/**
 * __useKnowledgeGroupUpdateMutation__
 *
 * To run a mutation, you first call `useKnowledgeGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgeGroupUpdateMutation, { data, loading, error }] = useKnowledgeGroupUpdateMutation({
 *   variables: {
 *      knowledgeGroupInput: // value for 'knowledgeGroupInput'
 *      knowledgeGroupId: // value for 'knowledgeGroupId'
 *   },
 * });
 */
export function useKnowledgeGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgeGroupUpdateMutation, KnowledgeGroupUpdateMutationVariables>) {
        return Apollo.useMutation<KnowledgeGroupUpdateMutation, KnowledgeGroupUpdateMutationVariables>(KnowledgeGroupUpdateDocument, baseOptions);
      }
export type KnowledgeGroupUpdateMutationHookResult = ReturnType<typeof useKnowledgeGroupUpdateMutation>;
export type KnowledgeGroupUpdateMutationResult = Apollo.MutationResult<KnowledgeGroupUpdateMutation>;
export type KnowledgeGroupUpdateMutationOptions = Apollo.BaseMutationOptions<KnowledgeGroupUpdateMutation, KnowledgeGroupUpdateMutationVariables>;
export const KnowledgeGroupFavorToggleDocument = gql`
    mutation KnowledgeGroupFavorToggle($knowledgeGroupId: Int!) {
  knowledgeGroupFavorToggle(knowledgeGroupId: $knowledgeGroupId)
}
    `;
export type KnowledgeGroupFavorToggleMutationFn = Apollo.MutationFunction<KnowledgeGroupFavorToggleMutation, KnowledgeGroupFavorToggleMutationVariables>;

/**
 * __useKnowledgeGroupFavorToggleMutation__
 *
 * To run a mutation, you first call `useKnowledgeGroupFavorToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeGroupFavorToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgeGroupFavorToggleMutation, { data, loading, error }] = useKnowledgeGroupFavorToggleMutation({
 *   variables: {
 *      knowledgeGroupId: // value for 'knowledgeGroupId'
 *   },
 * });
 */
export function useKnowledgeGroupFavorToggleMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgeGroupFavorToggleMutation, KnowledgeGroupFavorToggleMutationVariables>) {
        return Apollo.useMutation<KnowledgeGroupFavorToggleMutation, KnowledgeGroupFavorToggleMutationVariables>(KnowledgeGroupFavorToggleDocument, baseOptions);
      }
export type KnowledgeGroupFavorToggleMutationHookResult = ReturnType<typeof useKnowledgeGroupFavorToggleMutation>;
export type KnowledgeGroupFavorToggleMutationResult = Apollo.MutationResult<KnowledgeGroupFavorToggleMutation>;
export type KnowledgeGroupFavorToggleMutationOptions = Apollo.BaseMutationOptions<KnowledgeGroupFavorToggleMutation, KnowledgeGroupFavorToggleMutationVariables>;
export const KnowledgePostCreateDocument = gql`
    mutation KnowledgePostCreate($knowledgePostInput: CreateKnowledgePostInput!) {
  knowledgePostCreate(knowledgePostInput: $knowledgePostInput) {
    ...RequestedKnowledgePost
  }
}
    ${RequestedKnowledgePostFragmentDoc}`;
export type KnowledgePostCreateMutationFn = Apollo.MutationFunction<KnowledgePostCreateMutation, KnowledgePostCreateMutationVariables>;

/**
 * __useKnowledgePostCreateMutation__
 *
 * To run a mutation, you first call `useKnowledgePostCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgePostCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgePostCreateMutation, { data, loading, error }] = useKnowledgePostCreateMutation({
 *   variables: {
 *      knowledgePostInput: // value for 'knowledgePostInput'
 *   },
 * });
 */
export function useKnowledgePostCreateMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgePostCreateMutation, KnowledgePostCreateMutationVariables>) {
        return Apollo.useMutation<KnowledgePostCreateMutation, KnowledgePostCreateMutationVariables>(KnowledgePostCreateDocument, baseOptions);
      }
export type KnowledgePostCreateMutationHookResult = ReturnType<typeof useKnowledgePostCreateMutation>;
export type KnowledgePostCreateMutationResult = Apollo.MutationResult<KnowledgePostCreateMutation>;
export type KnowledgePostCreateMutationOptions = Apollo.BaseMutationOptions<KnowledgePostCreateMutation, KnowledgePostCreateMutationVariables>;
export const KnowledgePostUpdateDocument = gql`
    mutation KnowledgePostUpdate($knowledgePostInput: UpdateKnowledgePostInput!, $knowledgePostId: Int!) {
  knowledgePostUpdate(
    knowledgePostInput: $knowledgePostInput
    knowledgePostId: $knowledgePostId
  ) {
    ...RequestedKnowledgePost
  }
}
    ${RequestedKnowledgePostFragmentDoc}`;
export type KnowledgePostUpdateMutationFn = Apollo.MutationFunction<KnowledgePostUpdateMutation, KnowledgePostUpdateMutationVariables>;

/**
 * __useKnowledgePostUpdateMutation__
 *
 * To run a mutation, you first call `useKnowledgePostUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgePostUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgePostUpdateMutation, { data, loading, error }] = useKnowledgePostUpdateMutation({
 *   variables: {
 *      knowledgePostInput: // value for 'knowledgePostInput'
 *      knowledgePostId: // value for 'knowledgePostId'
 *   },
 * });
 */
export function useKnowledgePostUpdateMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgePostUpdateMutation, KnowledgePostUpdateMutationVariables>) {
        return Apollo.useMutation<KnowledgePostUpdateMutation, KnowledgePostUpdateMutationVariables>(KnowledgePostUpdateDocument, baseOptions);
      }
export type KnowledgePostUpdateMutationHookResult = ReturnType<typeof useKnowledgePostUpdateMutation>;
export type KnowledgePostUpdateMutationResult = Apollo.MutationResult<KnowledgePostUpdateMutation>;
export type KnowledgePostUpdateMutationOptions = Apollo.BaseMutationOptions<KnowledgePostUpdateMutation, KnowledgePostUpdateMutationVariables>;
export const KnowledgePostDeleteDocument = gql`
    mutation KnowledgePostDelete($knowledgePostId: Int!) {
  knowledgePostDelete(knowledgePostId: $knowledgePostId)
}
    `;
export type KnowledgePostDeleteMutationFn = Apollo.MutationFunction<KnowledgePostDeleteMutation, KnowledgePostDeleteMutationVariables>;

/**
 * __useKnowledgePostDeleteMutation__
 *
 * To run a mutation, you first call `useKnowledgePostDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgePostDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgePostDeleteMutation, { data, loading, error }] = useKnowledgePostDeleteMutation({
 *   variables: {
 *      knowledgePostId: // value for 'knowledgePostId'
 *   },
 * });
 */
export function useKnowledgePostDeleteMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgePostDeleteMutation, KnowledgePostDeleteMutationVariables>) {
        return Apollo.useMutation<KnowledgePostDeleteMutation, KnowledgePostDeleteMutationVariables>(KnowledgePostDeleteDocument, baseOptions);
      }
export type KnowledgePostDeleteMutationHookResult = ReturnType<typeof useKnowledgePostDeleteMutation>;
export type KnowledgePostDeleteMutationResult = Apollo.MutationResult<KnowledgePostDeleteMutation>;
export type KnowledgePostDeleteMutationOptions = Apollo.BaseMutationOptions<KnowledgePostDeleteMutation, KnowledgePostDeleteMutationVariables>;
export const KnowledgeSyncDocument = gql`
    mutation KnowledgeSync {
  knowledgeSync
}
    `;
export type KnowledgeSyncMutationFn = Apollo.MutationFunction<KnowledgeSyncMutation, KnowledgeSyncMutationVariables>;

/**
 * __useKnowledgeSyncMutation__
 *
 * To run a mutation, you first call `useKnowledgeSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgeSyncMutation, { data, loading, error }] = useKnowledgeSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useKnowledgeSyncMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgeSyncMutation, KnowledgeSyncMutationVariables>) {
        return Apollo.useMutation<KnowledgeSyncMutation, KnowledgeSyncMutationVariables>(KnowledgeSyncDocument, baseOptions);
      }
export type KnowledgeSyncMutationHookResult = ReturnType<typeof useKnowledgeSyncMutation>;
export type KnowledgeSyncMutationResult = Apollo.MutationResult<KnowledgeSyncMutation>;
export type KnowledgeSyncMutationOptions = Apollo.BaseMutationOptions<KnowledgeSyncMutation, KnowledgeSyncMutationVariables>;
export const KnowledgeGroupDeleteDocument = gql`
    mutation KnowledgeGroupDelete($knowledgeGroupId: Int!) {
  knowledgeGroupDelete(knowledgeGroupId: $knowledgeGroupId)
}
    `;
export type KnowledgeGroupDeleteMutationFn = Apollo.MutationFunction<KnowledgeGroupDeleteMutation, KnowledgeGroupDeleteMutationVariables>;

/**
 * __useKnowledgeGroupDeleteMutation__
 *
 * To run a mutation, you first call `useKnowledgeGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [knowledgeGroupDeleteMutation, { data, loading, error }] = useKnowledgeGroupDeleteMutation({
 *   variables: {
 *      knowledgeGroupId: // value for 'knowledgeGroupId'
 *   },
 * });
 */
export function useKnowledgeGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<KnowledgeGroupDeleteMutation, KnowledgeGroupDeleteMutationVariables>) {
        return Apollo.useMutation<KnowledgeGroupDeleteMutation, KnowledgeGroupDeleteMutationVariables>(KnowledgeGroupDeleteDocument, baseOptions);
      }
export type KnowledgeGroupDeleteMutationHookResult = ReturnType<typeof useKnowledgeGroupDeleteMutation>;
export type KnowledgeGroupDeleteMutationResult = Apollo.MutationResult<KnowledgeGroupDeleteMutation>;
export type KnowledgeGroupDeleteMutationOptions = Apollo.BaseMutationOptions<KnowledgeGroupDeleteMutation, KnowledgeGroupDeleteMutationVariables>;
export const SwitchKnowledgeGroupDocument = gql`
    mutation SwitchKnowledgeGroup($sourceId: Int!, $targetId: Int!, $includeTarget: Boolean!, $parentId: Int) {
  switchKnowledgeGroup(
    sourceId: $sourceId
    targetId: $targetId
    includeTarget: $includeTarget
    parentId: $parentId
  )
}
    `;
export type SwitchKnowledgeGroupMutationFn = Apollo.MutationFunction<SwitchKnowledgeGroupMutation, SwitchKnowledgeGroupMutationVariables>;

/**
 * __useSwitchKnowledgeGroupMutation__
 *
 * To run a mutation, you first call `useSwitchKnowledgeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchKnowledgeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchKnowledgeGroupMutation, { data, loading, error }] = useSwitchKnowledgeGroupMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      targetId: // value for 'targetId'
 *      includeTarget: // value for 'includeTarget'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useSwitchKnowledgeGroupMutation(baseOptions?: Apollo.MutationHookOptions<SwitchKnowledgeGroupMutation, SwitchKnowledgeGroupMutationVariables>) {
        return Apollo.useMutation<SwitchKnowledgeGroupMutation, SwitchKnowledgeGroupMutationVariables>(SwitchKnowledgeGroupDocument, baseOptions);
      }
export type SwitchKnowledgeGroupMutationHookResult = ReturnType<typeof useSwitchKnowledgeGroupMutation>;
export type SwitchKnowledgeGroupMutationResult = Apollo.MutationResult<SwitchKnowledgeGroupMutation>;
export type SwitchKnowledgeGroupMutationOptions = Apollo.BaseMutationOptions<SwitchKnowledgeGroupMutation, SwitchKnowledgeGroupMutationVariables>;
export const GetStatisticsDocument = gql`
    query GetStatistics($withPostCount: Boolean = false, $withWeeklyPostCount: Boolean = false, $withPostPeopleCount: Boolean = false, $withLandingCount: Boolean = false, $withLandingPeopleCount: Boolean = false, $withWeeklyLandingPeopleCount: Boolean = false, $withLandingRate: Boolean = false, $withPostingRate: Boolean = false, $withUserInfo: Boolean = false, $withContributedImpact: Boolean = false, $withImpact: Boolean = false, $withYesterdayImpact: Boolean = false, $withPostContentTagPercentage: Boolean = false, $withPostContentTagTrend: Boolean = false, $input: StatisticInput!) {
  statistics {
    postsCount(input: $input) @include(if: $withPostCount) {
      ...StatisticValueInfo
    }
    weeklyPostsCount(input: $input) @include(if: $withWeeklyPostCount) {
      ...StatisticValueInfo
    }
    peopleCount(input: $input) @include(if: $withPostPeopleCount) {
      ...StatisticValueInfo
    }
    contributedImpact(input: $input) @include(if: $withContributedImpact) {
      ...StatisticCentralTendencyImpactInfo
    }
    impact(input: $input) @include(if: $withImpact) {
      ...StatisticCentralTendencyImpactInfo
    }
    yesterdayImpact @include(if: $withYesterdayImpact) {
      ...StatisticImpactInfo
    }
    landingCount(input: $input) @include(if: $withLandingCount) {
      ...StatisticValueInfo
    }
    landingPeopleCount(input: $input) @include(if: $withLandingPeopleCount) {
      ...StatisticValueInfo
    }
    weeklyLandingPeopleCount(input: $input) @include(if: $withWeeklyLandingPeopleCount) {
      ...StatisticValueInfo
    }
    landingRate(input: $input) @include(if: $withLandingRate) {
      ...StatisticValueInfo
    }
    postingRate(input: $input) @include(if: $withPostingRate) {
      ...StatisticValueInfo
    }
    userInfo(input: $input) @include(if: $withUserInfo) {
      ...StatisticUserInfo
    }
    postContentTagPercentage(input: $input) @include(if: $withPostContentTagPercentage) {
      ...StatisticPostTagTypePercentageInfo
    }
    postContentTagTrend(input: $input) @include(if: $withPostContentTagTrend) {
      ...StatisticPostTagTypePercentageInfo
    }
  }
}
    ${StatisticValueInfoFragmentDoc}
${StatisticCentralTendencyImpactInfoFragmentDoc}
${StatisticImpactInfoFragmentDoc}
${StatisticUserInfoFragmentDoc}
${StatisticPostTagTypePercentageInfoFragmentDoc}`;

/**
 * __useGetStatisticsQuery__
 *
 * To run a query within a React component, call `useGetStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsQuery({
 *   variables: {
 *      withPostCount: // value for 'withPostCount'
 *      withWeeklyPostCount: // value for 'withWeeklyPostCount'
 *      withPostPeopleCount: // value for 'withPostPeopleCount'
 *      withLandingCount: // value for 'withLandingCount'
 *      withLandingPeopleCount: // value for 'withLandingPeopleCount'
 *      withWeeklyLandingPeopleCount: // value for 'withWeeklyLandingPeopleCount'
 *      withLandingRate: // value for 'withLandingRate'
 *      withPostingRate: // value for 'withPostingRate'
 *      withUserInfo: // value for 'withUserInfo'
 *      withContributedImpact: // value for 'withContributedImpact'
 *      withImpact: // value for 'withImpact'
 *      withYesterdayImpact: // value for 'withYesterdayImpact'
 *      withPostContentTagPercentage: // value for 'withPostContentTagPercentage'
 *      withPostContentTagTrend: // value for 'withPostContentTagTrend'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
        return Apollo.useQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, baseOptions);
      }
export function useGetStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
          return Apollo.useLazyQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, baseOptions);
        }
export type GetStatisticsQueryHookResult = ReturnType<typeof useGetStatisticsQuery>;
export type GetStatisticsLazyQueryHookResult = ReturnType<typeof useGetStatisticsLazyQuery>;
export type GetStatisticsQueryResult = Apollo.QueryResult<GetStatisticsQuery, GetStatisticsQueryVariables>;
export const GetFeaturedJournalBarChartDocument = gql`
    query GetFeaturedJournalBarChart($startTime: String!, $endTime: String!, $session: Int!) {
  statistics {
    featuredJournalData(startTime: $startTime, endTime: $endTime, session: $session) {
      url
      count
    }
  }
}
    `;

/**
 * __useGetFeaturedJournalBarChartQuery__
 *
 * To run a query within a React component, call `useGetFeaturedJournalBarChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedJournalBarChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedJournalBarChartQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useGetFeaturedJournalBarChartQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedJournalBarChartQuery, GetFeaturedJournalBarChartQueryVariables>) {
        return Apollo.useQuery<GetFeaturedJournalBarChartQuery, GetFeaturedJournalBarChartQueryVariables>(GetFeaturedJournalBarChartDocument, baseOptions);
      }
export function useGetFeaturedJournalBarChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedJournalBarChartQuery, GetFeaturedJournalBarChartQueryVariables>) {
          return Apollo.useLazyQuery<GetFeaturedJournalBarChartQuery, GetFeaturedJournalBarChartQueryVariables>(GetFeaturedJournalBarChartDocument, baseOptions);
        }
export type GetFeaturedJournalBarChartQueryHookResult = ReturnType<typeof useGetFeaturedJournalBarChartQuery>;
export type GetFeaturedJournalBarChartLazyQueryHookResult = ReturnType<typeof useGetFeaturedJournalBarChartLazyQuery>;
export type GetFeaturedJournalBarChartQueryResult = Apollo.QueryResult<GetFeaturedJournalBarChartQuery, GetFeaturedJournalBarChartQueryVariables>;
export const GetFeaturedJournalLineChartDocument = gql`
    query GetFeaturedJournalLineChart($startTime: String!, $endTime: String!, $session: Int!) {
  statistics {
    featuredJournalTrendData(
      startTime: $startTime
      endTime: $endTime
      session: $session
    ) {
      date
      count
    }
  }
}
    `;

/**
 * __useGetFeaturedJournalLineChartQuery__
 *
 * To run a query within a React component, call `useGetFeaturedJournalLineChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedJournalLineChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedJournalLineChartQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useGetFeaturedJournalLineChartQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedJournalLineChartQuery, GetFeaturedJournalLineChartQueryVariables>) {
        return Apollo.useQuery<GetFeaturedJournalLineChartQuery, GetFeaturedJournalLineChartQueryVariables>(GetFeaturedJournalLineChartDocument, baseOptions);
      }
export function useGetFeaturedJournalLineChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedJournalLineChartQuery, GetFeaturedJournalLineChartQueryVariables>) {
          return Apollo.useLazyQuery<GetFeaturedJournalLineChartQuery, GetFeaturedJournalLineChartQueryVariables>(GetFeaturedJournalLineChartDocument, baseOptions);
        }
export type GetFeaturedJournalLineChartQueryHookResult = ReturnType<typeof useGetFeaturedJournalLineChartQuery>;
export type GetFeaturedJournalLineChartLazyQueryHookResult = ReturnType<typeof useGetFeaturedJournalLineChartLazyQuery>;
export type GetFeaturedJournalLineChartQueryResult = Apollo.QueryResult<GetFeaturedJournalLineChartQuery, GetFeaturedJournalLineChartQueryVariables>;
export const GetUserPageVisitsStatisticsDocument = gql`
    query GetUserPageVisitsStatistics {
  statistics {
    userPageVisitsTotalCount
    userPageVisitsYesterdayCount
  }
}
    `;

/**
 * __useGetUserPageVisitsStatisticsQuery__
 *
 * To run a query within a React component, call `useGetUserPageVisitsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPageVisitsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPageVisitsStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPageVisitsStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPageVisitsStatisticsQuery, GetUserPageVisitsStatisticsQueryVariables>) {
        return Apollo.useQuery<GetUserPageVisitsStatisticsQuery, GetUserPageVisitsStatisticsQueryVariables>(GetUserPageVisitsStatisticsDocument, baseOptions);
      }
export function useGetUserPageVisitsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPageVisitsStatisticsQuery, GetUserPageVisitsStatisticsQueryVariables>) {
          return Apollo.useLazyQuery<GetUserPageVisitsStatisticsQuery, GetUserPageVisitsStatisticsQueryVariables>(GetUserPageVisitsStatisticsDocument, baseOptions);
        }
export type GetUserPageVisitsStatisticsQueryHookResult = ReturnType<typeof useGetUserPageVisitsStatisticsQuery>;
export type GetUserPageVisitsStatisticsLazyQueryHookResult = ReturnType<typeof useGetUserPageVisitsStatisticsLazyQuery>;
export type GetUserPageVisitsStatisticsQueryResult = Apollo.QueryResult<GetUserPageVisitsStatisticsQuery, GetUserPageVisitsStatisticsQueryVariables>;
export const VisitPageDocument = gql`
    mutation VisitPage($userId: Int!) {
  visitPage(userId: $userId)
}
    `;
export type VisitPageMutationFn = Apollo.MutationFunction<VisitPageMutation, VisitPageMutationVariables>;

/**
 * __useVisitPageMutation__
 *
 * To run a mutation, you first call `useVisitPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitPageMutation, { data, loading, error }] = useVisitPageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useVisitPageMutation(baseOptions?: Apollo.MutationHookOptions<VisitPageMutation, VisitPageMutationVariables>) {
        return Apollo.useMutation<VisitPageMutation, VisitPageMutationVariables>(VisitPageDocument, baseOptions);
      }
export type VisitPageMutationHookResult = ReturnType<typeof useVisitPageMutation>;
export type VisitPageMutationResult = Apollo.MutationResult<VisitPageMutation>;
export type VisitPageMutationOptions = Apollo.BaseMutationOptions<VisitPageMutation, VisitPageMutationVariables>;
export const GetNotifcationSettingsDocument = gql`
    query GetNotifcationSettings {
  viewer {
    userId
    notificationSettings {
      ...RequestedNotificationSetting
    }
  }
}
    ${RequestedNotificationSettingFragmentDoc}`;

/**
 * __useGetNotifcationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotifcationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotifcationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotifcationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotifcationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotifcationSettingsQuery, GetNotifcationSettingsQueryVariables>) {
        return Apollo.useQuery<GetNotifcationSettingsQuery, GetNotifcationSettingsQueryVariables>(GetNotifcationSettingsDocument, baseOptions);
      }
export function useGetNotifcationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotifcationSettingsQuery, GetNotifcationSettingsQueryVariables>) {
          return Apollo.useLazyQuery<GetNotifcationSettingsQuery, GetNotifcationSettingsQueryVariables>(GetNotifcationSettingsDocument, baseOptions);
        }
export type GetNotifcationSettingsQueryHookResult = ReturnType<typeof useGetNotifcationSettingsQuery>;
export type GetNotifcationSettingsLazyQueryHookResult = ReturnType<typeof useGetNotifcationSettingsLazyQuery>;
export type GetNotifcationSettingsQueryResult = Apollo.QueryResult<GetNotifcationSettingsQuery, GetNotifcationSettingsQueryVariables>;
export const NotificationSettingUpdateDocument = gql`
    mutation NotificationSettingUpdate($notificationSettingId: Int!, $notificationSetting: UpdateNotificationSettingInput!) {
  notificationSettingUpdate(
    notificationSettingId: $notificationSettingId
    notificationSetting: $notificationSetting
  ) {
    ...RequestedNotificationSetting
  }
}
    ${RequestedNotificationSettingFragmentDoc}`;
export type NotificationSettingUpdateMutationFn = Apollo.MutationFunction<NotificationSettingUpdateMutation, NotificationSettingUpdateMutationVariables>;

/**
 * __useNotificationSettingUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationSettingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationSettingUpdateMutation, { data, loading, error }] = useNotificationSettingUpdateMutation({
 *   variables: {
 *      notificationSettingId: // value for 'notificationSettingId'
 *      notificationSetting: // value for 'notificationSetting'
 *   },
 * });
 */
export function useNotificationSettingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NotificationSettingUpdateMutation, NotificationSettingUpdateMutationVariables>) {
        return Apollo.useMutation<NotificationSettingUpdateMutation, NotificationSettingUpdateMutationVariables>(NotificationSettingUpdateDocument, baseOptions);
      }
export type NotificationSettingUpdateMutationHookResult = ReturnType<typeof useNotificationSettingUpdateMutation>;
export type NotificationSettingUpdateMutationResult = Apollo.MutationResult<NotificationSettingUpdateMutation>;
export type NotificationSettingUpdateMutationOptions = Apollo.BaseMutationOptions<NotificationSettingUpdateMutation, NotificationSettingUpdateMutationVariables>;
export const GetNotifcationsDocument = gql`
    query GetNotifcations($pagination: PaginationInput!, $isRead: Boolean) {
  viewer {
    userId
    notifications(pagination: $pagination, isRead: $isRead) {
      pageInfo {
        ...RequestedPageInfo
      }
      totalCount
      edges {
        node {
          ...RequestedNotification
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedNotificationFragmentDoc}`;

/**
 * __useGetNotifcationsQuery__
 *
 * To run a query within a React component, call `useGetNotifcationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotifcationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotifcationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      isRead: // value for 'isRead'
 *   },
 * });
 */
export function useGetNotifcationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotifcationsQuery, GetNotifcationsQueryVariables>) {
        return Apollo.useQuery<GetNotifcationsQuery, GetNotifcationsQueryVariables>(GetNotifcationsDocument, baseOptions);
      }
export function useGetNotifcationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotifcationsQuery, GetNotifcationsQueryVariables>) {
          return Apollo.useLazyQuery<GetNotifcationsQuery, GetNotifcationsQueryVariables>(GetNotifcationsDocument, baseOptions);
        }
export type GetNotifcationsQueryHookResult = ReturnType<typeof useGetNotifcationsQuery>;
export type GetNotifcationsLazyQueryHookResult = ReturnType<typeof useGetNotifcationsLazyQuery>;
export type GetNotifcationsQueryResult = Apollo.QueryResult<GetNotifcationsQuery, GetNotifcationsQueryVariables>;
export const NotificationReadDocument = gql`
    mutation NotificationRead {
  notificationRead
}
    `;
export type NotificationReadMutationFn = Apollo.MutationFunction<NotificationReadMutation, NotificationReadMutationVariables>;

/**
 * __useNotificationReadMutation__
 *
 * To run a mutation, you first call `useNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationReadMutation, { data, loading, error }] = useNotificationReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationReadMutation(baseOptions?: Apollo.MutationHookOptions<NotificationReadMutation, NotificationReadMutationVariables>) {
        return Apollo.useMutation<NotificationReadMutation, NotificationReadMutationVariables>(NotificationReadDocument, baseOptions);
      }
export type NotificationReadMutationHookResult = ReturnType<typeof useNotificationReadMutation>;
export type NotificationReadMutationResult = Apollo.MutationResult<NotificationReadMutation>;
export type NotificationReadMutationOptions = Apollo.BaseMutationOptions<NotificationReadMutation, NotificationReadMutationVariables>;
export const NotificationCountChangedDocument = gql`
    subscription NotificationCountChanged {
  notificationCountChanged
}
    `;

/**
 * __useNotificationCountChangedSubscription__
 *
 * To run a query within a React component, call `useNotificationCountChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCountChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCountChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCountChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationCountChangedSubscription, NotificationCountChangedSubscriptionVariables>) {
        return Apollo.useSubscription<NotificationCountChangedSubscription, NotificationCountChangedSubscriptionVariables>(NotificationCountChangedDocument, baseOptions);
      }
export type NotificationCountChangedSubscriptionHookResult = ReturnType<typeof useNotificationCountChangedSubscription>;
export type NotificationCountChangedSubscriptionResult = Apollo.SubscriptionResult<NotificationCountChangedSubscription>;
export const GetAnnouncementDocument = gql`
    query GetAnnouncement($announcementId: Int!) {
  announcement(announcementId: $announcementId) {
    ...AnnouncementInfo
  }
}
    ${AnnouncementInfoFragmentDoc}`;

/**
 * __useGetAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementQuery({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useGetAnnouncementQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementQuery, GetAnnouncementQueryVariables>) {
        return Apollo.useQuery<GetAnnouncementQuery, GetAnnouncementQueryVariables>(GetAnnouncementDocument, baseOptions);
      }
export function useGetAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementQuery, GetAnnouncementQueryVariables>) {
          return Apollo.useLazyQuery<GetAnnouncementQuery, GetAnnouncementQueryVariables>(GetAnnouncementDocument, baseOptions);
        }
export type GetAnnouncementQueryHookResult = ReturnType<typeof useGetAnnouncementQuery>;
export type GetAnnouncementLazyQueryHookResult = ReturnType<typeof useGetAnnouncementLazyQuery>;
export type GetAnnouncementQueryResult = Apollo.QueryResult<GetAnnouncementQuery, GetAnnouncementQueryVariables>;
export const AnnouncementCreateDocument = gql`
    mutation AnnouncementCreate($input: CreateAnnouncementInput!) {
  announcementCreate(input: $input) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type AnnouncementCreateMutationFn = Apollo.MutationFunction<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>;

/**
 * __useAnnouncementCreateMutation__
 *
 * To run a mutation, you first call `useAnnouncementCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementCreateMutation, { data, loading, error }] = useAnnouncementCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnnouncementCreateMutation(baseOptions?: Apollo.MutationHookOptions<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>) {
        return Apollo.useMutation<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>(AnnouncementCreateDocument, baseOptions);
      }
export type AnnouncementCreateMutationHookResult = ReturnType<typeof useAnnouncementCreateMutation>;
export type AnnouncementCreateMutationResult = Apollo.MutationResult<AnnouncementCreateMutation>;
export type AnnouncementCreateMutationOptions = Apollo.BaseMutationOptions<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>;
export const AnnouncementUpdateDocument = gql`
    mutation AnnouncementUpdate($input: UpdateAnnouncementInput!) {
  announcementUpdate(input: $input) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type AnnouncementUpdateMutationFn = Apollo.MutationFunction<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>;

/**
 * __useAnnouncementUpdateMutation__
 *
 * To run a mutation, you first call `useAnnouncementUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementUpdateMutation, { data, loading, error }] = useAnnouncementUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnnouncementUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>) {
        return Apollo.useMutation<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>(AnnouncementUpdateDocument, baseOptions);
      }
export type AnnouncementUpdateMutationHookResult = ReturnType<typeof useAnnouncementUpdateMutation>;
export type AnnouncementUpdateMutationResult = Apollo.MutationResult<AnnouncementUpdateMutation>;
export type AnnouncementUpdateMutationOptions = Apollo.BaseMutationOptions<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>;
export const GetPostCommentsDocument = gql`
    query GetPostComments($postId: Int!, $parentCommentPagination: PaginationInput = {last: 2}, $childCommentPagination: PaginationInput = {last: 2}) {
  post(postId: $postId) {
    postId
    ...ParentComments
  }
}
    ${ParentCommentsFragmentDoc}`;

/**
 * __useGetPostCommentsQuery__
 *
 * To run a query within a React component, call `useGetPostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCommentsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetPostCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables>) {
        return Apollo.useQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, baseOptions);
      }
export function useGetPostCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCommentsQuery, GetPostCommentsQueryVariables>) {
          return Apollo.useLazyQuery<GetPostCommentsQuery, GetPostCommentsQueryVariables>(GetPostCommentsDocument, baseOptions);
        }
export type GetPostCommentsQueryHookResult = ReturnType<typeof useGetPostCommentsQuery>;
export type GetPostCommentsLazyQueryHookResult = ReturnType<typeof useGetPostCommentsLazyQuery>;
export type GetPostCommentsQueryResult = Apollo.QueryResult<GetPostCommentsQuery, GetPostCommentsQueryVariables>;
export const GetPostChildCommentsDocument = gql`
    query GetPostChildComments($postId: Int!, $commentId: Int!, $childCommentPagination: PaginationInput!) {
  post(postId: $postId) {
    postId
    comment(commentId: $commentId) {
      commentId
      ...ChildComments
    }
  }
}
    ${ChildCommentsFragmentDoc}`;

/**
 * __useGetPostChildCommentsQuery__
 *
 * To run a query within a React component, call `useGetPostChildCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostChildCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostChildCommentsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetPostChildCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetPostChildCommentsQuery, GetPostChildCommentsQueryVariables>) {
        return Apollo.useQuery<GetPostChildCommentsQuery, GetPostChildCommentsQueryVariables>(GetPostChildCommentsDocument, baseOptions);
      }
export function useGetPostChildCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostChildCommentsQuery, GetPostChildCommentsQueryVariables>) {
          return Apollo.useLazyQuery<GetPostChildCommentsQuery, GetPostChildCommentsQueryVariables>(GetPostChildCommentsDocument, baseOptions);
        }
export type GetPostChildCommentsQueryHookResult = ReturnType<typeof useGetPostChildCommentsQuery>;
export type GetPostChildCommentsLazyQueryHookResult = ReturnType<typeof useGetPostChildCommentsLazyQuery>;
export type GetPostChildCommentsQueryResult = Apollo.QueryResult<GetPostChildCommentsQuery, GetPostChildCommentsQueryVariables>;
export const GetCommentLikedUsersDocument = gql`
    query GetCommentLikedUsers($postId: Int!, $commentId: Int!, $commentLikedUsersPagination: PaginationInput = {last: 8}) {
  post(postId: $postId) {
    postId
    comment(commentId: $commentId) {
      commentId
      likedUsers(pagination: $commentLikedUsersPagination) {
        ...RequestedUsersPaginated
        totalCount
      }
    }
  }
}
    ${RequestedUsersPaginatedFragmentDoc}`;

/**
 * __useGetCommentLikedUsersQuery__
 *
 * To run a query within a React component, call `useGetCommentLikedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentLikedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentLikedUsersQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      commentLikedUsersPagination: // value for 'commentLikedUsersPagination'
 *   },
 * });
 */
export function useGetCommentLikedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetCommentLikedUsersQuery, GetCommentLikedUsersQueryVariables>) {
        return Apollo.useQuery<GetCommentLikedUsersQuery, GetCommentLikedUsersQueryVariables>(GetCommentLikedUsersDocument, baseOptions);
      }
export function useGetCommentLikedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentLikedUsersQuery, GetCommentLikedUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetCommentLikedUsersQuery, GetCommentLikedUsersQueryVariables>(GetCommentLikedUsersDocument, baseOptions);
        }
export type GetCommentLikedUsersQueryHookResult = ReturnType<typeof useGetCommentLikedUsersQuery>;
export type GetCommentLikedUsersLazyQueryHookResult = ReturnType<typeof useGetCommentLikedUsersLazyQuery>;
export type GetCommentLikedUsersQueryResult = Apollo.QueryResult<GetCommentLikedUsersQuery, GetCommentLikedUsersQueryVariables>;
export const CommentCreateDocument = gql`
    mutation CommentCreate($comment: CreateCommentInput!, $childCommentPagination: PaginationInput = {last: 0}) {
  commentCreate(comment: $comment) {
    ...RequestedComment
    ...ChildComments
  }
}
    ${RequestedCommentFragmentDoc}
${ChildCommentsFragmentDoc}`;
export type CommentCreateMutationFn = Apollo.MutationFunction<CommentCreateMutation, CommentCreateMutationVariables>;

/**
 * __useCommentCreateMutation__
 *
 * To run a mutation, you first call `useCommentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentCreateMutation, { data, loading, error }] = useCommentCreateMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useCommentCreateMutation(baseOptions?: Apollo.MutationHookOptions<CommentCreateMutation, CommentCreateMutationVariables>) {
        return Apollo.useMutation<CommentCreateMutation, CommentCreateMutationVariables>(CommentCreateDocument, baseOptions);
      }
export type CommentCreateMutationHookResult = ReturnType<typeof useCommentCreateMutation>;
export type CommentCreateMutationResult = Apollo.MutationResult<CommentCreateMutation>;
export type CommentCreateMutationOptions = Apollo.BaseMutationOptions<CommentCreateMutation, CommentCreateMutationVariables>;
export const CommentUpdateDocument = gql`
    mutation CommentUpdate($comment: UpdateCommentInput!) {
  commentUpdate(comment: $comment) {
    ...RequestedComment
  }
}
    ${RequestedCommentFragmentDoc}`;
export type CommentUpdateMutationFn = Apollo.MutationFunction<CommentUpdateMutation, CommentUpdateMutationVariables>;

/**
 * __useCommentUpdateMutation__
 *
 * To run a mutation, you first call `useCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentUpdateMutation, { data, loading, error }] = useCommentUpdateMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCommentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CommentUpdateMutation, CommentUpdateMutationVariables>) {
        return Apollo.useMutation<CommentUpdateMutation, CommentUpdateMutationVariables>(CommentUpdateDocument, baseOptions);
      }
export type CommentUpdateMutationHookResult = ReturnType<typeof useCommentUpdateMutation>;
export type CommentUpdateMutationResult = Apollo.MutationResult<CommentUpdateMutation>;
export type CommentUpdateMutationOptions = Apollo.BaseMutationOptions<CommentUpdateMutation, CommentUpdateMutationVariables>;
export const CommentDeleteDocument = gql`
    mutation CommentDelete($comment: DeleteCommentInput!) {
  commentDelete(comment: $comment)
}
    `;
export type CommentDeleteMutationFn = Apollo.MutationFunction<CommentDeleteMutation, CommentDeleteMutationVariables>;

/**
 * __useCommentDeleteMutation__
 *
 * To run a mutation, you first call `useCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentDeleteMutation, { data, loading, error }] = useCommentDeleteMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCommentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CommentDeleteMutation, CommentDeleteMutationVariables>) {
        return Apollo.useMutation<CommentDeleteMutation, CommentDeleteMutationVariables>(CommentDeleteDocument, baseOptions);
      }
export type CommentDeleteMutationHookResult = ReturnType<typeof useCommentDeleteMutation>;
export type CommentDeleteMutationResult = Apollo.MutationResult<CommentDeleteMutation>;
export type CommentDeleteMutationOptions = Apollo.BaseMutationOptions<CommentDeleteMutation, CommentDeleteMutationVariables>;
export const CommentLikeToggleDocument = gql`
    mutation CommentLikeToggle($commentId: Int!, $like: Boolean!) {
  commentLikeToggle(commentId: $commentId, like: $like) {
    commentId
    liked
    likedCount
  }
}
    `;
export type CommentLikeToggleMutationFn = Apollo.MutationFunction<CommentLikeToggleMutation, CommentLikeToggleMutationVariables>;

/**
 * __useCommentLikeToggleMutation__
 *
 * To run a mutation, you first call `useCommentLikeToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentLikeToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentLikeToggleMutation, { data, loading, error }] = useCommentLikeToggleMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      like: // value for 'like'
 *   },
 * });
 */
export function useCommentLikeToggleMutation(baseOptions?: Apollo.MutationHookOptions<CommentLikeToggleMutation, CommentLikeToggleMutationVariables>) {
        return Apollo.useMutation<CommentLikeToggleMutation, CommentLikeToggleMutationVariables>(CommentLikeToggleDocument, baseOptions);
      }
export type CommentLikeToggleMutationHookResult = ReturnType<typeof useCommentLikeToggleMutation>;
export type CommentLikeToggleMutationResult = Apollo.MutationResult<CommentLikeToggleMutation>;
export type CommentLikeToggleMutationOptions = Apollo.BaseMutationOptions<CommentLikeToggleMutation, CommentLikeToggleMutationVariables>;
export const CommentAddedDocument = gql`
    subscription commentAdded($postId: Int!, $childCommentPagination: PaginationInput = {last: 0}) {
  commentAdded(postId: $postId) {
    ...RequestedComment
    ...ChildComments
  }
}
    ${RequestedCommentFragmentDoc}
${ChildCommentsFragmentDoc}`;

/**
 * __useCommentAddedSubscription__
 *
 * To run a query within a React component, call `useCommentAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAddedSubscription({
 *   variables: {
 *      postId: // value for 'postId'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useCommentAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CommentAddedSubscription, CommentAddedSubscriptionVariables>) {
        return Apollo.useSubscription<CommentAddedSubscription, CommentAddedSubscriptionVariables>(CommentAddedDocument, baseOptions);
      }
export type CommentAddedSubscriptionHookResult = ReturnType<typeof useCommentAddedSubscription>;
export type CommentAddedSubscriptionResult = Apollo.SubscriptionResult<CommentAddedSubscription>;
export const CommentUpdatedDocument = gql`
    subscription commentUpdated($postId: Int!) {
  commentUpdated(postId: $postId) {
    commentId
    postId
    content
    updatedAt
    likedCount
  }
}
    `;

/**
 * __useCommentUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentUpdatedSubscription({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useCommentUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CommentUpdatedSubscription, CommentUpdatedSubscriptionVariables>) {
        return Apollo.useSubscription<CommentUpdatedSubscription, CommentUpdatedSubscriptionVariables>(CommentUpdatedDocument, baseOptions);
      }
export type CommentUpdatedSubscriptionHookResult = ReturnType<typeof useCommentUpdatedSubscription>;
export type CommentUpdatedSubscriptionResult = Apollo.SubscriptionResult<CommentUpdatedSubscription>;
export const CommentDeletedDocument = gql`
    subscription commentDeleted($postId: Int!, $childCommentPagination: PaginationInput = {last: 0}) {
  commentDeleted(postId: $postId) {
    ...RequestedComment
    ...ChildComments
  }
}
    ${RequestedCommentFragmentDoc}
${ChildCommentsFragmentDoc}`;

/**
 * __useCommentDeletedSubscription__
 *
 * To run a query within a React component, call `useCommentDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentDeletedSubscription({
 *   variables: {
 *      postId: // value for 'postId'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useCommentDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>) {
        return Apollo.useSubscription<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>(CommentDeletedDocument, baseOptions);
      }
export type CommentDeletedSubscriptionHookResult = ReturnType<typeof useCommentDeletedSubscription>;
export type CommentDeletedSubscriptionResult = Apollo.SubscriptionResult<CommentDeletedSubscription>;
export const GetPostDocument = gql`
    query GetPost($postId: Int!, $parentCommentPagination: PaginationInput = {last: 2}, $childCommentPagination: PaginationInput = {last: 2}) {
  post(postId: $postId) {
    ...RequestedPost
    ...ParentComments
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}`;

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetPostQuery(baseOptions: Apollo.QueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
        return Apollo.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, baseOptions);
      }
export function useGetPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          return Apollo.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, baseOptions);
        }
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostQueryResult = Apollo.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const GetSinglePostRecommendedPostsDocument = gql`
    query GetSinglePostRecommendedPosts($postId: Int!, $pagination: PaginationInput!, $parentCommentPagination: PaginationInput = {last: 0}, $childCommentPagination: PaginationInput = {last: 0}) {
  recommend {
    recommendedPosts(postId: $postId, pagination: $pagination) {
      edges {
        node {
          ...RequestedPost
          ...ParentComments
        }
      }
    }
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}`;

/**
 * __useGetSinglePostRecommendedPostsQuery__
 *
 * To run a query within a React component, call `useGetSinglePostRecommendedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSinglePostRecommendedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSinglePostRecommendedPostsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      pagination: // value for 'pagination'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetSinglePostRecommendedPostsQuery(baseOptions: Apollo.QueryHookOptions<GetSinglePostRecommendedPostsQuery, GetSinglePostRecommendedPostsQueryVariables>) {
        return Apollo.useQuery<GetSinglePostRecommendedPostsQuery, GetSinglePostRecommendedPostsQueryVariables>(GetSinglePostRecommendedPostsDocument, baseOptions);
      }
export function useGetSinglePostRecommendedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSinglePostRecommendedPostsQuery, GetSinglePostRecommendedPostsQueryVariables>) {
          return Apollo.useLazyQuery<GetSinglePostRecommendedPostsQuery, GetSinglePostRecommendedPostsQueryVariables>(GetSinglePostRecommendedPostsDocument, baseOptions);
        }
export type GetSinglePostRecommendedPostsQueryHookResult = ReturnType<typeof useGetSinglePostRecommendedPostsQuery>;
export type GetSinglePostRecommendedPostsLazyQueryHookResult = ReturnType<typeof useGetSinglePostRecommendedPostsLazyQuery>;
export type GetSinglePostRecommendedPostsQueryResult = Apollo.QueryResult<GetSinglePostRecommendedPostsQuery, GetSinglePostRecommendedPostsQueryVariables>;
export const GetTimelineNewestPageInfoDocument = gql`
    query GetTimelineNewestPageInfo {
  section(sectionId: Synthesis) {
    sectionId
    posts(pagination: {last: 1}, filter: {}) {
      pageInfo {
        ...RequestedPageInfo
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetTimelineNewestPageInfoQuery__
 *
 * To run a query within a React component, call `useGetTimelineNewestPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelineNewestPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelineNewestPageInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimelineNewestPageInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetTimelineNewestPageInfoQuery, GetTimelineNewestPageInfoQueryVariables>) {
        return Apollo.useQuery<GetTimelineNewestPageInfoQuery, GetTimelineNewestPageInfoQueryVariables>(GetTimelineNewestPageInfoDocument, baseOptions);
      }
export function useGetTimelineNewestPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimelineNewestPageInfoQuery, GetTimelineNewestPageInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetTimelineNewestPageInfoQuery, GetTimelineNewestPageInfoQueryVariables>(GetTimelineNewestPageInfoDocument, baseOptions);
        }
export type GetTimelineNewestPageInfoQueryHookResult = ReturnType<typeof useGetTimelineNewestPageInfoQuery>;
export type GetTimelineNewestPageInfoLazyQueryHookResult = ReturnType<typeof useGetTimelineNewestPageInfoLazyQuery>;
export type GetTimelineNewestPageInfoQueryResult = Apollo.QueryResult<GetTimelineNewestPageInfoQuery, GetTimelineNewestPageInfoQueryVariables>;
export const GetTimelinePostsDocument = gql`
    query GetTimelinePosts($groupId: Int!, $userId: Int!, $sectionId: SectionType!, $departmentId: Int!, $withViewerFollowing: Boolean!, $withUserCreated: Boolean!, $withGroup: Boolean!, $withSection: Boolean!, $withDepartmentJournal: Boolean!, $withAllPosts: Boolean!, $pagination: PaginationInput!, $parentCommentPagination: PaginationInput = {last: 2}, $childCommentPagination: PaginationInput = {last: 2}, $filter: GetPostsFilter!, $useRecommendation: Boolean) {
  viewer @include(if: $withViewerFollowing) {
    userId
    posts: followingPosts(
      pagination: $pagination
      filter: $filter
      useRecommendation: $useRecommendation
    ) @skip(if: $withAllPosts) {
      ...Posts
    }
    allPosts(pagination: $pagination, filter: $filter) @include(if: $withAllPosts) {
      ...Posts
    }
  }
  user(userId: $userId) @include(if: $withUserCreated) {
    userId
    posts: createdPosts(pagination: $pagination, filter: $filter) {
      ...Posts
    }
  }
  section(sectionId: $sectionId) @include(if: $withSection) {
    sectionId
    hasUnread
    posts(pagination: $pagination, filter: $filter) {
      ...TimelinePosts
    }
    topPost {
      ...RequestedPost
    }
  }
  group(groupId: $groupId) @include(if: $withGroup) {
    groupId
    posts(pagination: $pagination, filter: $filter) {
      ...Posts
    }
  }
  department(departmentId: $departmentId) @include(if: $withDepartmentJournal) {
    departmentId
    posts: journals(pagination: $pagination, filter: $filter) {
      ...Posts
    }
  }
}
    ${PostsFragmentDoc}
${TimelinePostsFragmentDoc}
${RequestedPostFragmentDoc}`;

/**
 * __useGetTimelinePostsQuery__
 *
 * To run a query within a React component, call `useGetTimelinePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelinePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelinePostsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      sectionId: // value for 'sectionId'
 *      departmentId: // value for 'departmentId'
 *      withViewerFollowing: // value for 'withViewerFollowing'
 *      withUserCreated: // value for 'withUserCreated'
 *      withGroup: // value for 'withGroup'
 *      withSection: // value for 'withSection'
 *      withDepartmentJournal: // value for 'withDepartmentJournal'
 *      withAllPosts: // value for 'withAllPosts'
 *      pagination: // value for 'pagination'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *      filter: // value for 'filter'
 *      useRecommendation: // value for 'useRecommendation'
 *   },
 * });
 */
export function useGetTimelinePostsQuery(baseOptions: Apollo.QueryHookOptions<GetTimelinePostsQuery, GetTimelinePostsQueryVariables>) {
        return Apollo.useQuery<GetTimelinePostsQuery, GetTimelinePostsQueryVariables>(GetTimelinePostsDocument, baseOptions);
      }
export function useGetTimelinePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimelinePostsQuery, GetTimelinePostsQueryVariables>) {
          return Apollo.useLazyQuery<GetTimelinePostsQuery, GetTimelinePostsQueryVariables>(GetTimelinePostsDocument, baseOptions);
        }
export type GetTimelinePostsQueryHookResult = ReturnType<typeof useGetTimelinePostsQuery>;
export type GetTimelinePostsLazyQueryHookResult = ReturnType<typeof useGetTimelinePostsLazyQuery>;
export type GetTimelinePostsQueryResult = Apollo.QueryResult<GetTimelinePostsQuery, GetTimelinePostsQueryVariables>;
export const GetTopPostDocument = gql`
    query GetTopPost($groupId: Int!, $sectionId: SectionType!, $withGroupPost: Boolean = false, $withSectionPost: Boolean = false, $parentCommentPagination: PaginationInput = {last: 2}, $childCommentPagination: PaginationInput = {last: 0}) {
  group(groupId: $groupId) @include(if: $withGroupPost) {
    groupId
    topPost {
      ...RequestedPost
      ...ParentComments
    }
  }
  section(sectionId: $sectionId) @include(if: $withSectionPost) {
    sectionId
    topPost {
      ...RequestedPost
      ...ParentComments
    }
  }
}
    ${RequestedPostFragmentDoc}
${ParentCommentsFragmentDoc}`;

/**
 * __useGetTopPostQuery__
 *
 * To run a query within a React component, call `useGetTopPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopPostQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      sectionId: // value for 'sectionId'
 *      withGroupPost: // value for 'withGroupPost'
 *      withSectionPost: // value for 'withSectionPost'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetTopPostQuery(baseOptions: Apollo.QueryHookOptions<GetTopPostQuery, GetTopPostQueryVariables>) {
        return Apollo.useQuery<GetTopPostQuery, GetTopPostQueryVariables>(GetTopPostDocument, baseOptions);
      }
export function useGetTopPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopPostQuery, GetTopPostQueryVariables>) {
          return Apollo.useLazyQuery<GetTopPostQuery, GetTopPostQueryVariables>(GetTopPostDocument, baseOptions);
        }
export type GetTopPostQueryHookResult = ReturnType<typeof useGetTopPostQuery>;
export type GetTopPostLazyQueryHookResult = ReturnType<typeof useGetTopPostLazyQuery>;
export type GetTopPostQueryResult = Apollo.QueryResult<GetTopPostQuery, GetTopPostQueryVariables>;
export const GetThanksPostDocument = gql`
    query GetThanksPost($userId: Int!, $pagination: PaginationInput!) {
  user(userId: $userId) {
    userId
    thanksPosts(pagination: $pagination) {
      totalCount
      edges {
        node {
          ...RequestedPost
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
  }
}
    ${RequestedPostFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetThanksPostQuery__
 *
 * To run a query within a React component, call `useGetThanksPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThanksPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThanksPostQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetThanksPostQuery(baseOptions: Apollo.QueryHookOptions<GetThanksPostQuery, GetThanksPostQueryVariables>) {
        return Apollo.useQuery<GetThanksPostQuery, GetThanksPostQueryVariables>(GetThanksPostDocument, baseOptions);
      }
export function useGetThanksPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThanksPostQuery, GetThanksPostQueryVariables>) {
          return Apollo.useLazyQuery<GetThanksPostQuery, GetThanksPostQueryVariables>(GetThanksPostDocument, baseOptions);
        }
export type GetThanksPostQueryHookResult = ReturnType<typeof useGetThanksPostQuery>;
export type GetThanksPostLazyQueryHookResult = ReturnType<typeof useGetThanksPostLazyQuery>;
export type GetThanksPostQueryResult = Apollo.QueryResult<GetThanksPostQuery, GetThanksPostQueryVariables>;
export const PostCreateDocument = gql`
    mutation PostCreate($post: CreatePostInput!) {
  postCreate(post: $post) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type PostCreateMutationFn = Apollo.MutationFunction<PostCreateMutation, PostCreateMutationVariables>;

/**
 * __usePostCreateMutation__
 *
 * To run a mutation, you first call `usePostCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCreateMutation, { data, loading, error }] = usePostCreateMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function usePostCreateMutation(baseOptions?: Apollo.MutationHookOptions<PostCreateMutation, PostCreateMutationVariables>) {
        return Apollo.useMutation<PostCreateMutation, PostCreateMutationVariables>(PostCreateDocument, baseOptions);
      }
export type PostCreateMutationHookResult = ReturnType<typeof usePostCreateMutation>;
export type PostCreateMutationResult = Apollo.MutationResult<PostCreateMutation>;
export type PostCreateMutationOptions = Apollo.BaseMutationOptions<PostCreateMutation, PostCreateMutationVariables>;
export const PostBatchCreateDocument = gql`
    mutation PostBatchCreate($post: CreatePostInput!, $receiverUserIds: [Int!]!) {
  postBatchCreate(post: $post, receiverUserIds: $receiverUserIds) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type PostBatchCreateMutationFn = Apollo.MutationFunction<PostBatchCreateMutation, PostBatchCreateMutationVariables>;

/**
 * __usePostBatchCreateMutation__
 *
 * To run a mutation, you first call `usePostBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postBatchCreateMutation, { data, loading, error }] = usePostBatchCreateMutation({
 *   variables: {
 *      post: // value for 'post'
 *      receiverUserIds: // value for 'receiverUserIds'
 *   },
 * });
 */
export function usePostBatchCreateMutation(baseOptions?: Apollo.MutationHookOptions<PostBatchCreateMutation, PostBatchCreateMutationVariables>) {
        return Apollo.useMutation<PostBatchCreateMutation, PostBatchCreateMutationVariables>(PostBatchCreateDocument, baseOptions);
      }
export type PostBatchCreateMutationHookResult = ReturnType<typeof usePostBatchCreateMutation>;
export type PostBatchCreateMutationResult = Apollo.MutationResult<PostBatchCreateMutation>;
export type PostBatchCreateMutationOptions = Apollo.BaseMutationOptions<PostBatchCreateMutation, PostBatchCreateMutationVariables>;
export const PostUpdateDocument = gql`
    mutation PostUpdate($postId: Int!, $post: UpdatePostInput!) {
  postUpdate(postId: $postId, post: $post) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type PostUpdateMutationFn = Apollo.MutationFunction<PostUpdateMutation, PostUpdateMutationVariables>;

/**
 * __usePostUpdateMutation__
 *
 * To run a mutation, you first call `usePostUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUpdateMutation, { data, loading, error }] = usePostUpdateMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      post: // value for 'post'
 *   },
 * });
 */
export function usePostUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PostUpdateMutation, PostUpdateMutationVariables>) {
        return Apollo.useMutation<PostUpdateMutation, PostUpdateMutationVariables>(PostUpdateDocument, baseOptions);
      }
export type PostUpdateMutationHookResult = ReturnType<typeof usePostUpdateMutation>;
export type PostUpdateMutationResult = Apollo.MutationResult<PostUpdateMutation>;
export type PostUpdateMutationOptions = Apollo.BaseMutationOptions<PostUpdateMutation, PostUpdateMutationVariables>;
export const PostArchiveDocument = gql`
    mutation PostArchive($postId: Int!) {
  postArchive(postId: $postId)
}
    `;
export type PostArchiveMutationFn = Apollo.MutationFunction<PostArchiveMutation, PostArchiveMutationVariables>;

/**
 * __usePostArchiveMutation__
 *
 * To run a mutation, you first call `usePostArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postArchiveMutation, { data, loading, error }] = usePostArchiveMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostArchiveMutation(baseOptions?: Apollo.MutationHookOptions<PostArchiveMutation, PostArchiveMutationVariables>) {
        return Apollo.useMutation<PostArchiveMutation, PostArchiveMutationVariables>(PostArchiveDocument, baseOptions);
      }
export type PostArchiveMutationHookResult = ReturnType<typeof usePostArchiveMutation>;
export type PostArchiveMutationResult = Apollo.MutationResult<PostArchiveMutation>;
export type PostArchiveMutationOptions = Apollo.BaseMutationOptions<PostArchiveMutation, PostArchiveMutationVariables>;
export const PostUnArchiveDocument = gql`
    mutation PostUnArchive($postId: Int!) {
  postUnArchive(postId: $postId)
}
    `;
export type PostUnArchiveMutationFn = Apollo.MutationFunction<PostUnArchiveMutation, PostUnArchiveMutationVariables>;

/**
 * __usePostUnArchiveMutation__
 *
 * To run a mutation, you first call `usePostUnArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUnArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUnArchiveMutation, { data, loading, error }] = usePostUnArchiveMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostUnArchiveMutation(baseOptions?: Apollo.MutationHookOptions<PostUnArchiveMutation, PostUnArchiveMutationVariables>) {
        return Apollo.useMutation<PostUnArchiveMutation, PostUnArchiveMutationVariables>(PostUnArchiveDocument, baseOptions);
      }
export type PostUnArchiveMutationHookResult = ReturnType<typeof usePostUnArchiveMutation>;
export type PostUnArchiveMutationResult = Apollo.MutationResult<PostUnArchiveMutation>;
export type PostUnArchiveMutationOptions = Apollo.BaseMutationOptions<PostUnArchiveMutation, PostUnArchiveMutationVariables>;
export const PostShareDocument = gql`
    mutation PostShare($post: SharePostInput!) {
  postShare(post: $post) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type PostShareMutationFn = Apollo.MutationFunction<PostShareMutation, PostShareMutationVariables>;

/**
 * __usePostShareMutation__
 *
 * To run a mutation, you first call `usePostShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postShareMutation, { data, loading, error }] = usePostShareMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function usePostShareMutation(baseOptions?: Apollo.MutationHookOptions<PostShareMutation, PostShareMutationVariables>) {
        return Apollo.useMutation<PostShareMutation, PostShareMutationVariables>(PostShareDocument, baseOptions);
      }
export type PostShareMutationHookResult = ReturnType<typeof usePostShareMutation>;
export type PostShareMutationResult = Apollo.MutationResult<PostShareMutation>;
export type PostShareMutationOptions = Apollo.BaseMutationOptions<PostShareMutation, PostShareMutationVariables>;
export const PostLikeToggleDocument = gql`
    mutation PostLikeToggle($postId: Int!, $like: Boolean!) {
  postLikeToggle(postId: $postId, like: $like) {
    postId
    liked
    likedCount
    ...RequestedLikedUsers
  }
}
    ${RequestedLikedUsersFragmentDoc}`;
export type PostLikeToggleMutationFn = Apollo.MutationFunction<PostLikeToggleMutation, PostLikeToggleMutationVariables>;

/**
 * __usePostLikeToggleMutation__
 *
 * To run a mutation, you first call `usePostLikeToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostLikeToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postLikeToggleMutation, { data, loading, error }] = usePostLikeToggleMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      like: // value for 'like'
 *   },
 * });
 */
export function usePostLikeToggleMutation(baseOptions?: Apollo.MutationHookOptions<PostLikeToggleMutation, PostLikeToggleMutationVariables>) {
        return Apollo.useMutation<PostLikeToggleMutation, PostLikeToggleMutationVariables>(PostLikeToggleDocument, baseOptions);
      }
export type PostLikeToggleMutationHookResult = ReturnType<typeof usePostLikeToggleMutation>;
export type PostLikeToggleMutationResult = Apollo.MutationResult<PostLikeToggleMutation>;
export type PostLikeToggleMutationOptions = Apollo.BaseMutationOptions<PostLikeToggleMutation, PostLikeToggleMutationVariables>;
export const PostTopDocument = gql`
    mutation PostTop($postId: Int!, $groupId: Int!) {
  postTop(postId: $postId, groupId: $groupId) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;
export type PostTopMutationFn = Apollo.MutationFunction<PostTopMutation, PostTopMutationVariables>;

/**
 * __usePostTopMutation__
 *
 * To run a mutation, you first call `usePostTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postTopMutation, { data, loading, error }] = usePostTopMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function usePostTopMutation(baseOptions?: Apollo.MutationHookOptions<PostTopMutation, PostTopMutationVariables>) {
        return Apollo.useMutation<PostTopMutation, PostTopMutationVariables>(PostTopDocument, baseOptions);
      }
export type PostTopMutationHookResult = ReturnType<typeof usePostTopMutation>;
export type PostTopMutationResult = Apollo.MutationResult<PostTopMutation>;
export type PostTopMutationOptions = Apollo.BaseMutationOptions<PostTopMutation, PostTopMutationVariables>;
export const PostUnTopDocument = gql`
    mutation PostUnTop($groupId: Int!) {
  postUnTop(groupId: $groupId)
}
    `;
export type PostUnTopMutationFn = Apollo.MutationFunction<PostUnTopMutation, PostUnTopMutationVariables>;

/**
 * __usePostUnTopMutation__
 *
 * To run a mutation, you first call `usePostUnTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUnTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUnTopMutation, { data, loading, error }] = usePostUnTopMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function usePostUnTopMutation(baseOptions?: Apollo.MutationHookOptions<PostUnTopMutation, PostUnTopMutationVariables>) {
        return Apollo.useMutation<PostUnTopMutation, PostUnTopMutationVariables>(PostUnTopDocument, baseOptions);
      }
export type PostUnTopMutationHookResult = ReturnType<typeof usePostUnTopMutation>;
export type PostUnTopMutationResult = Apollo.MutationResult<PostUnTopMutation>;
export type PostUnTopMutationOptions = Apollo.BaseMutationOptions<PostUnTopMutation, PostUnTopMutationVariables>;
export const PostReadDocument = gql`
    mutation PostRead($postId: Int!) {
  postRead(postId: $postId) {
    postId
    isRead
  }
}
    `;
export type PostReadMutationFn = Apollo.MutationFunction<PostReadMutation, PostReadMutationVariables>;

/**
 * __usePostReadMutation__
 *
 * To run a mutation, you first call `usePostReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postReadMutation, { data, loading, error }] = usePostReadMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostReadMutation(baseOptions?: Apollo.MutationHookOptions<PostReadMutation, PostReadMutationVariables>) {
        return Apollo.useMutation<PostReadMutation, PostReadMutationVariables>(PostReadDocument, baseOptions);
      }
export type PostReadMutationHookResult = ReturnType<typeof usePostReadMutation>;
export type PostReadMutationResult = Apollo.MutationResult<PostReadMutation>;
export type PostReadMutationOptions = Apollo.BaseMutationOptions<PostReadMutation, PostReadMutationVariables>;
export const PostFavorToggleDocument = gql`
    mutation PostFavorToggle($postId: Int!) {
  postFavorToggle(postId: $postId) {
    postId
    isFavored
  }
}
    `;
export type PostFavorToggleMutationFn = Apollo.MutationFunction<PostFavorToggleMutation, PostFavorToggleMutationVariables>;

/**
 * __usePostFavorToggleMutation__
 *
 * To run a mutation, you first call `usePostFavorToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostFavorToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postFavorToggleMutation, { data, loading, error }] = usePostFavorToggleMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostFavorToggleMutation(baseOptions?: Apollo.MutationHookOptions<PostFavorToggleMutation, PostFavorToggleMutationVariables>) {
        return Apollo.useMutation<PostFavorToggleMutation, PostFavorToggleMutationVariables>(PostFavorToggleDocument, baseOptions);
      }
export type PostFavorToggleMutationHookResult = ReturnType<typeof usePostFavorToggleMutation>;
export type PostFavorToggleMutationResult = Apollo.MutationResult<PostFavorToggleMutation>;
export type PostFavorToggleMutationOptions = Apollo.BaseMutationOptions<PostFavorToggleMutation, PostFavorToggleMutationVariables>;
export const PostTagUpdateDocument = gql`
    mutation PostTagUpdate($postId: Int!, $tags: [PostTagType!]!) {
  postTagUpdate(postId: $postId, tags: $tags) {
    postId
    tags
  }
}
    `;
export type PostTagUpdateMutationFn = Apollo.MutationFunction<PostTagUpdateMutation, PostTagUpdateMutationVariables>;

/**
 * __usePostTagUpdateMutation__
 *
 * To run a mutation, you first call `usePostTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postTagUpdateMutation, { data, loading, error }] = usePostTagUpdateMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function usePostTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PostTagUpdateMutation, PostTagUpdateMutationVariables>) {
        return Apollo.useMutation<PostTagUpdateMutation, PostTagUpdateMutationVariables>(PostTagUpdateDocument, baseOptions);
      }
export type PostTagUpdateMutationHookResult = ReturnType<typeof usePostTagUpdateMutation>;
export type PostTagUpdateMutationResult = Apollo.MutationResult<PostTagUpdateMutation>;
export type PostTagUpdateMutationOptions = Apollo.BaseMutationOptions<PostTagUpdateMutation, PostTagUpdateMutationVariables>;
export const PostUsefulToggleDocument = gql`
    mutation PostUsefulToggle($postId: Int!) {
  postUsefulToggle(postId: $postId) {
    postId
    isUseful
    usefulCount
  }
}
    `;
export type PostUsefulToggleMutationFn = Apollo.MutationFunction<PostUsefulToggleMutation, PostUsefulToggleMutationVariables>;

/**
 * __usePostUsefulToggleMutation__
 *
 * To run a mutation, you first call `usePostUsefulToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUsefulToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUsefulToggleMutation, { data, loading, error }] = usePostUsefulToggleMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostUsefulToggleMutation(baseOptions?: Apollo.MutationHookOptions<PostUsefulToggleMutation, PostUsefulToggleMutationVariables>) {
        return Apollo.useMutation<PostUsefulToggleMutation, PostUsefulToggleMutationVariables>(PostUsefulToggleDocument, baseOptions);
      }
export type PostUsefulToggleMutationHookResult = ReturnType<typeof usePostUsefulToggleMutation>;
export type PostUsefulToggleMutationResult = Apollo.MutationResult<PostUsefulToggleMutation>;
export type PostUsefulToggleMutationOptions = Apollo.BaseMutationOptions<PostUsefulToggleMutation, PostUsefulToggleMutationVariables>;
export const PostAddedDocument = gql`
    subscription PostAdded($userId: Int, $groupId: Int) {
  postAdded(userId: $userId, groupId: $groupId) {
    ...RequestedPost
  }
}
    ${RequestedPostFragmentDoc}`;

/**
 * __usePostAddedSubscription__
 *
 * To run a query within a React component, call `usePostAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePostAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostAddedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function usePostAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PostAddedSubscription, PostAddedSubscriptionVariables>) {
        return Apollo.useSubscription<PostAddedSubscription, PostAddedSubscriptionVariables>(PostAddedDocument, baseOptions);
      }
export type PostAddedSubscriptionHookResult = ReturnType<typeof usePostAddedSubscription>;
export type PostAddedSubscriptionResult = Apollo.SubscriptionResult<PostAddedSubscription>;
export const PostUpdatedDocument = gql`
    subscription PostUpdated($postId: Int!) {
  postUpdated(postId: $postId) {
    postId
    content
    updatedAt
    liked
    likedCount
    sharedCount
    commentCount
    readCount
    usefulCount
    isMarkdown
    impact
    ...ThanksPostInfo
    files {
      ...LocalFile
    }
    links {
      ...RequestedPostLink
    }
    event {
      ...EventInfo
    }
  }
}
    ${ThanksPostInfoFragmentDoc}
${LocalFileFragmentDoc}
${RequestedPostLinkFragmentDoc}
${EventInfoFragmentDoc}`;

/**
 * __usePostUpdatedSubscription__
 *
 * To run a query within a React component, call `usePostUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePostUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostUpdatedSubscription({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PostUpdatedSubscription, PostUpdatedSubscriptionVariables>) {
        return Apollo.useSubscription<PostUpdatedSubscription, PostUpdatedSubscriptionVariables>(PostUpdatedDocument, baseOptions);
      }
export type PostUpdatedSubscriptionHookResult = ReturnType<typeof usePostUpdatedSubscription>;
export type PostUpdatedSubscriptionResult = Apollo.SubscriptionResult<PostUpdatedSubscription>;
export const PostDeletedDocument = gql`
    subscription PostDeleted {
  postDeleted
}
    `;

/**
 * __usePostDeletedSubscription__
 *
 * To run a query within a React component, call `usePostDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePostDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePostDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PostDeletedSubscription, PostDeletedSubscriptionVariables>) {
        return Apollo.useSubscription<PostDeletedSubscription, PostDeletedSubscriptionVariables>(PostDeletedDocument, baseOptions);
      }
export type PostDeletedSubscriptionHookResult = ReturnType<typeof usePostDeletedSubscription>;
export type PostDeletedSubscriptionResult = Apollo.SubscriptionResult<PostDeletedSubscription>;
export const GetBannersDocument = gql`
    query GetBanners {
  banners(pagination: {last: 100}) {
    edges {
      node {
        bannerId
        file {
          ...LocalFile
        }
        index
        link
      }
    }
  }
}
    ${LocalFileFragmentDoc}`;

/**
 * __useGetBannersQuery__
 *
 * To run a query within a React component, call `useGetBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBannersQuery(baseOptions?: Apollo.QueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
        return Apollo.useQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, baseOptions);
      }
export function useGetBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
          return Apollo.useLazyQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, baseOptions);
        }
export type GetBannersQueryHookResult = ReturnType<typeof useGetBannersQuery>;
export type GetBannersLazyQueryHookResult = ReturnType<typeof useGetBannersLazyQuery>;
export type GetBannersQueryResult = Apollo.QueryResult<GetBannersQuery, GetBannersQueryVariables>;
export const AddBannerDocument = gql`
    mutation AddBanner($fileId: Int!) {
  addBanner(fileId: $fileId)
}
    `;
export type AddBannerMutationFn = Apollo.MutationFunction<AddBannerMutation, AddBannerMutationVariables>;

/**
 * __useAddBannerMutation__
 *
 * To run a mutation, you first call `useAddBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBannerMutation, { data, loading, error }] = useAddBannerMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAddBannerMutation(baseOptions?: Apollo.MutationHookOptions<AddBannerMutation, AddBannerMutationVariables>) {
        return Apollo.useMutation<AddBannerMutation, AddBannerMutationVariables>(AddBannerDocument, baseOptions);
      }
export type AddBannerMutationHookResult = ReturnType<typeof useAddBannerMutation>;
export type AddBannerMutationResult = Apollo.MutationResult<AddBannerMutation>;
export type AddBannerMutationOptions = Apollo.BaseMutationOptions<AddBannerMutation, AddBannerMutationVariables>;
export const SetBannerDocument = gql`
    mutation SetBanner($input: [SetBannerInput!]!) {
  setBanner(input: $input)
}
    `;
export type SetBannerMutationFn = Apollo.MutationFunction<SetBannerMutation, SetBannerMutationVariables>;

/**
 * __useSetBannerMutation__
 *
 * To run a mutation, you first call `useSetBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBannerMutation, { data, loading, error }] = useSetBannerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBannerMutation(baseOptions?: Apollo.MutationHookOptions<SetBannerMutation, SetBannerMutationVariables>) {
        return Apollo.useMutation<SetBannerMutation, SetBannerMutationVariables>(SetBannerDocument, baseOptions);
      }
export type SetBannerMutationHookResult = ReturnType<typeof useSetBannerMutation>;
export type SetBannerMutationResult = Apollo.MutationResult<SetBannerMutation>;
export type SetBannerMutationOptions = Apollo.BaseMutationOptions<SetBannerMutation, SetBannerMutationVariables>;
export const DeleteBannerDocument = gql`
    mutation DeleteBanner($bannerId: Int!) {
  deleteBanner(bannerId: $bannerId)
}
    `;
export type DeleteBannerMutationFn = Apollo.MutationFunction<DeleteBannerMutation, DeleteBannerMutationVariables>;

/**
 * __useDeleteBannerMutation__
 *
 * To run a mutation, you first call `useDeleteBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerMutation, { data, loading, error }] = useDeleteBannerMutation({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useDeleteBannerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBannerMutation, DeleteBannerMutationVariables>) {
        return Apollo.useMutation<DeleteBannerMutation, DeleteBannerMutationVariables>(DeleteBannerDocument, baseOptions);
      }
export type DeleteBannerMutationHookResult = ReturnType<typeof useDeleteBannerMutation>;
export type DeleteBannerMutationResult = Apollo.MutationResult<DeleteBannerMutation>;
export type DeleteBannerMutationOptions = Apollo.BaseMutationOptions<DeleteBannerMutation, DeleteBannerMutationVariables>;
export const GetFeedsRecommendedDocument = gql`
    query GetFeedsRecommended {
  recommend {
    trendingPosts(pagination: {last: 4}, timeSpan: 3) {
      edges {
        node {
          postId
          content
          creator {
            ...UserInfo
          }
        }
      }
    }
    trendingGroups(pagination: {last: 4}, timeSpan: 7) {
      edges {
        node {
          ...RequestedGroup
        }
      }
    }
    trendingUsers(limit: 4) {
      ...UserInfo
      ...UserCardUsage
    }
    banners(pagination: {last: 100}) {
      edges {
        node {
          bannerId
          file {
            ...LocalFile
          }
          index
          link
        }
      }
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedGroupFragmentDoc}
${UserCardUsageFragmentDoc}
${LocalFileFragmentDoc}`;

/**
 * __useGetFeedsRecommendedQuery__
 *
 * To run a query within a React component, call `useGetFeedsRecommendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedsRecommendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedsRecommendedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedsRecommendedQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedsRecommendedQuery, GetFeedsRecommendedQueryVariables>) {
        return Apollo.useQuery<GetFeedsRecommendedQuery, GetFeedsRecommendedQueryVariables>(GetFeedsRecommendedDocument, baseOptions);
      }
export function useGetFeedsRecommendedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedsRecommendedQuery, GetFeedsRecommendedQueryVariables>) {
          return Apollo.useLazyQuery<GetFeedsRecommendedQuery, GetFeedsRecommendedQueryVariables>(GetFeedsRecommendedDocument, baseOptions);
        }
export type GetFeedsRecommendedQueryHookResult = ReturnType<typeof useGetFeedsRecommendedQuery>;
export type GetFeedsRecommendedLazyQueryHookResult = ReturnType<typeof useGetFeedsRecommendedLazyQuery>;
export type GetFeedsRecommendedQueryResult = Apollo.QueryResult<GetFeedsRecommendedQuery, GetFeedsRecommendedQueryVariables>;
export const GetOnboardingRecomGroupsDocument = gql`
    query GetOnboardingRecomGroups($limit: Int!) {
  recommend {
    onboardingRecommendedGroups(limit: $limit, isOnboarding: true) {
      ...RequestedGroup
    }
  }
}
    ${RequestedGroupFragmentDoc}`;

/**
 * __useGetOnboardingRecomGroupsQuery__
 *
 * To run a query within a React component, call `useGetOnboardingRecomGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingRecomGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingRecomGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOnboardingRecomGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetOnboardingRecomGroupsQuery, GetOnboardingRecomGroupsQueryVariables>) {
        return Apollo.useQuery<GetOnboardingRecomGroupsQuery, GetOnboardingRecomGroupsQueryVariables>(GetOnboardingRecomGroupsDocument, baseOptions);
      }
export function useGetOnboardingRecomGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingRecomGroupsQuery, GetOnboardingRecomGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetOnboardingRecomGroupsQuery, GetOnboardingRecomGroupsQueryVariables>(GetOnboardingRecomGroupsDocument, baseOptions);
        }
export type GetOnboardingRecomGroupsQueryHookResult = ReturnType<typeof useGetOnboardingRecomGroupsQuery>;
export type GetOnboardingRecomGroupsLazyQueryHookResult = ReturnType<typeof useGetOnboardingRecomGroupsLazyQuery>;
export type GetOnboardingRecomGroupsQueryResult = Apollo.QueryResult<GetOnboardingRecomGroupsQuery, GetOnboardingRecomGroupsQueryVariables>;
export const GetOnboardingRecomUsersDocument = gql`
    query GetOnboardingRecomUsers($limit: Int!) {
  recommend {
    onboardingRecommendedUsers(limit: $limit, isOnboarding: true) {
      ...UserWithExtras
    }
  }
}
    ${UserWithExtrasFragmentDoc}`;

/**
 * __useGetOnboardingRecomUsersQuery__
 *
 * To run a query within a React component, call `useGetOnboardingRecomUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingRecomUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingRecomUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOnboardingRecomUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOnboardingRecomUsersQuery, GetOnboardingRecomUsersQueryVariables>) {
        return Apollo.useQuery<GetOnboardingRecomUsersQuery, GetOnboardingRecomUsersQueryVariables>(GetOnboardingRecomUsersDocument, baseOptions);
      }
export function useGetOnboardingRecomUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingRecomUsersQuery, GetOnboardingRecomUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetOnboardingRecomUsersQuery, GetOnboardingRecomUsersQueryVariables>(GetOnboardingRecomUsersDocument, baseOptions);
        }
export type GetOnboardingRecomUsersQueryHookResult = ReturnType<typeof useGetOnboardingRecomUsersQuery>;
export type GetOnboardingRecomUsersLazyQueryHookResult = ReturnType<typeof useGetOnboardingRecomUsersLazyQuery>;
export type GetOnboardingRecomUsersQueryResult = Apollo.QueryResult<GetOnboardingRecomUsersQuery, GetOnboardingRecomUsersQueryVariables>;
export const SearchStateDocument = gql`
    query SearchState {
  searchState {
    search
    input
  }
}
    `;

/**
 * __useSearchStateQuery__
 *
 * To run a query within a React component, call `useSearchStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchStateQuery(baseOptions?: Apollo.QueryHookOptions<SearchStateQuery, SearchStateQueryVariables>) {
        return Apollo.useQuery<SearchStateQuery, SearchStateQueryVariables>(SearchStateDocument, baseOptions);
      }
export function useSearchStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchStateQuery, SearchStateQueryVariables>) {
          return Apollo.useLazyQuery<SearchStateQuery, SearchStateQueryVariables>(SearchStateDocument, baseOptions);
        }
export type SearchStateQueryHookResult = ReturnType<typeof useSearchStateQuery>;
export type SearchStateLazyQueryHookResult = ReturnType<typeof useSearchStateLazyQuery>;
export type SearchStateQueryResult = Apollo.QueryResult<SearchStateQuery, SearchStateQueryVariables>;
export const SearchSuggestionsDocument = gql`
    query SearchSuggestions($search: String!, $count: Int = 10) {
  search {
    suggestions(search: $search, count: $count) {
      users {
        keyword
        id
        user {
          userId
          avatarUrl
          name
          alias
        }
        fields {
          key
          value
        }
      }
      groups {
        keyword
        id
      }
      confluence {
        keyword
      }
    }
  }
}
    `;

/**
 * __useSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>) {
        return Apollo.useQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, baseOptions);
      }
export function useSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>) {
          return Apollo.useLazyQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, baseOptions);
        }
export type SearchSuggestionsQueryHookResult = ReturnType<typeof useSearchSuggestionsQuery>;
export type SearchSuggestionsLazyQueryHookResult = ReturnType<typeof useSearchSuggestionsLazyQuery>;
export type SearchSuggestionsQueryResult = Apollo.QueryResult<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>;
export const SearchContentsDocument = gql`
    query SearchContents($search: String!, $count: Int = 10, $page: Int!, $orderBy: String, $docSource: [String!]!, $docType: [String!]!) {
  search {
    contents(
      search: $search
      count: $count
      page: $page
      orderBy: $orderBy
      docSource: $docSource
      docType: $docType
    ) {
      facets {
        name
        showName
        values {
          value
          count
          selected
        }
      }
      items {
        author
        title
        body
        docSource
        redirectLink
        spaceName
        lastModDate
        contentId
        authorUser {
          userId
          avatarUrl
          name
          email
        }
      }
      total
    }
  }
}
    `;

/**
 * __useSearchContentsQuery__
 *
 * To run a query within a React component, call `useSearchContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      count: // value for 'count'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *      docSource: // value for 'docSource'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useSearchContentsQuery(baseOptions: Apollo.QueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
        return Apollo.useQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, baseOptions);
      }
export function useSearchContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
          return Apollo.useLazyQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, baseOptions);
        }
export type SearchContentsQueryHookResult = ReturnType<typeof useSearchContentsQuery>;
export type SearchContentsLazyQueryHookResult = ReturnType<typeof useSearchContentsLazyQuery>;
export type SearchContentsQueryResult = Apollo.QueryResult<SearchContentsQuery, SearchContentsQueryVariables>;
export const SearchUrlMetaDataDocument = gql`
    query SearchUrlMetaData($url: String!) {
  search {
    urlMetaData(url: $url) {
      failedReason
      title
      description
      logo
      url
    }
  }
}
    `;

/**
 * __useSearchUrlMetaDataQuery__
 *
 * To run a query within a React component, call `useSearchUrlMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUrlMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUrlMetaDataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSearchUrlMetaDataQuery(baseOptions: Apollo.QueryHookOptions<SearchUrlMetaDataQuery, SearchUrlMetaDataQueryVariables>) {
        return Apollo.useQuery<SearchUrlMetaDataQuery, SearchUrlMetaDataQueryVariables>(SearchUrlMetaDataDocument, baseOptions);
      }
export function useSearchUrlMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUrlMetaDataQuery, SearchUrlMetaDataQueryVariables>) {
          return Apollo.useLazyQuery<SearchUrlMetaDataQuery, SearchUrlMetaDataQueryVariables>(SearchUrlMetaDataDocument, baseOptions);
        }
export type SearchUrlMetaDataQueryHookResult = ReturnType<typeof useSearchUrlMetaDataQuery>;
export type SearchUrlMetaDataLazyQueryHookResult = ReturnType<typeof useSearchUrlMetaDataLazyQuery>;
export type SearchUrlMetaDataQueryResult = Apollo.QueryResult<SearchUrlMetaDataQuery, SearchUrlMetaDataQueryVariables>;
export const GetSectionRecentUnreadCountDocument = gql`
    query GetSectionRecentUnreadCount($sectionIds: [SectionType!]!) {
  sections(sectionIds: $sectionIds) {
    sectionId
    hasUnread
  }
}
    `;

/**
 * __useGetSectionRecentUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetSectionRecentUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionRecentUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionRecentUnreadCountQuery({
 *   variables: {
 *      sectionIds: // value for 'sectionIds'
 *   },
 * });
 */
export function useGetSectionRecentUnreadCountQuery(baseOptions: Apollo.QueryHookOptions<GetSectionRecentUnreadCountQuery, GetSectionRecentUnreadCountQueryVariables>) {
        return Apollo.useQuery<GetSectionRecentUnreadCountQuery, GetSectionRecentUnreadCountQueryVariables>(GetSectionRecentUnreadCountDocument, baseOptions);
      }
export function useGetSectionRecentUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionRecentUnreadCountQuery, GetSectionRecentUnreadCountQueryVariables>) {
          return Apollo.useLazyQuery<GetSectionRecentUnreadCountQuery, GetSectionRecentUnreadCountQueryVariables>(GetSectionRecentUnreadCountDocument, baseOptions);
        }
export type GetSectionRecentUnreadCountQueryHookResult = ReturnType<typeof useGetSectionRecentUnreadCountQuery>;
export type GetSectionRecentUnreadCountLazyQueryHookResult = ReturnType<typeof useGetSectionRecentUnreadCountLazyQuery>;
export type GetSectionRecentUnreadCountQueryResult = Apollo.QueryResult<GetSectionRecentUnreadCountQuery, GetSectionRecentUnreadCountQueryVariables>;
export const SectionPostTopDocument = gql`
    mutation SectionPostTop($sectionId: SectionType!, $postId: Int!) {
  sectionPostTop(sectionId: $sectionId, postId: $postId) {
    postId
    sectionId
  }
}
    `;
export type SectionPostTopMutationFn = Apollo.MutationFunction<SectionPostTopMutation, SectionPostTopMutationVariables>;

/**
 * __useSectionPostTopMutation__
 *
 * To run a mutation, you first call `useSectionPostTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectionPostTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectionPostTopMutation, { data, loading, error }] = useSectionPostTopMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useSectionPostTopMutation(baseOptions?: Apollo.MutationHookOptions<SectionPostTopMutation, SectionPostTopMutationVariables>) {
        return Apollo.useMutation<SectionPostTopMutation, SectionPostTopMutationVariables>(SectionPostTopDocument, baseOptions);
      }
export type SectionPostTopMutationHookResult = ReturnType<typeof useSectionPostTopMutation>;
export type SectionPostTopMutationResult = Apollo.MutationResult<SectionPostTopMutation>;
export type SectionPostTopMutationOptions = Apollo.BaseMutationOptions<SectionPostTopMutation, SectionPostTopMutationVariables>;
export const SectionPostUnTopDocument = gql`
    mutation SectionPostUnTop($sectionId: SectionType!, $postId: Int!) {
  sectionPostUnTop(sectionId: $sectionId, postId: $postId) {
    postId
    sectionId
  }
}
    `;
export type SectionPostUnTopMutationFn = Apollo.MutationFunction<SectionPostUnTopMutation, SectionPostUnTopMutationVariables>;

/**
 * __useSectionPostUnTopMutation__
 *
 * To run a mutation, you first call `useSectionPostUnTopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectionPostUnTopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectionPostUnTopMutation, { data, loading, error }] = useSectionPostUnTopMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useSectionPostUnTopMutation(baseOptions?: Apollo.MutationHookOptions<SectionPostUnTopMutation, SectionPostUnTopMutationVariables>) {
        return Apollo.useMutation<SectionPostUnTopMutation, SectionPostUnTopMutationVariables>(SectionPostUnTopDocument, baseOptions);
      }
export type SectionPostUnTopMutationHookResult = ReturnType<typeof useSectionPostUnTopMutation>;
export type SectionPostUnTopMutationResult = Apollo.MutationResult<SectionPostUnTopMutation>;
export type SectionPostUnTopMutationOptions = Apollo.BaseMutationOptions<SectionPostUnTopMutation, SectionPostUnTopMutationVariables>;
export const SectionUnReadUpdateDocument = gql`
    subscription SectionUnReadUpdate($sectionId: SectionType!) {
  sectionUnreadUpdate(sectionId: $sectionId) {
    sectionId
    hasUnread
  }
}
    `;

/**
 * __useSectionUnReadUpdateSubscription__
 *
 * To run a query within a React component, call `useSectionUnReadUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSectionUnReadUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionUnReadUpdateSubscription({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useSectionUnReadUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<SectionUnReadUpdateSubscription, SectionUnReadUpdateSubscriptionVariables>) {
        return Apollo.useSubscription<SectionUnReadUpdateSubscription, SectionUnReadUpdateSubscriptionVariables>(SectionUnReadUpdateDocument, baseOptions);
      }
export type SectionUnReadUpdateSubscriptionHookResult = ReturnType<typeof useSectionUnReadUpdateSubscription>;
export type SectionUnReadUpdateSubscriptionResult = Apollo.SubscriptionResult<SectionUnReadUpdateSubscription>;
export const GetUserProjectsDocument = gql`
    query GetUserProjects($userId: Int!) {
  user(userId: $userId) {
    userId
    projects {
      ...RequestedProject
    }
  }
}
    ${RequestedProjectFragmentDoc}`;

/**
 * __useGetUserProjectsQuery__
 *
 * To run a query within a React component, call `useGetUserProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetUserProjectsQuery, GetUserProjectsQueryVariables>) {
        return Apollo.useQuery<GetUserProjectsQuery, GetUserProjectsQueryVariables>(GetUserProjectsDocument, baseOptions);
      }
export function useGetUserProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProjectsQuery, GetUserProjectsQueryVariables>) {
          return Apollo.useLazyQuery<GetUserProjectsQuery, GetUserProjectsQueryVariables>(GetUserProjectsDocument, baseOptions);
        }
export type GetUserProjectsQueryHookResult = ReturnType<typeof useGetUserProjectsQuery>;
export type GetUserProjectsLazyQueryHookResult = ReturnType<typeof useGetUserProjectsLazyQuery>;
export type GetUserProjectsQueryResult = Apollo.QueryResult<GetUserProjectsQuery, GetUserProjectsQueryVariables>;
export const GetUserTimelineDocument = gql`
    query GetUserTimeline($userId: Int!, $type: String!, $pagination: PaginationInput!, $parentCommentPagination: PaginationInput = {last: 2}, $childCommentPagination: PaginationInput = {last: 2}) {
  user(userId: $userId) {
    userId
    timelineEvents(type: $type, pagination: $pagination) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...RequestedUserTimelineEvent
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedUserTimelineEventFragmentDoc}`;

/**
 * __useGetUserTimelineQuery__
 *
 * To run a query within a React component, call `useGetUserTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTimelineQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      pagination: // value for 'pagination'
 *      parentCommentPagination: // value for 'parentCommentPagination'
 *      childCommentPagination: // value for 'childCommentPagination'
 *   },
 * });
 */
export function useGetUserTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetUserTimelineQuery, GetUserTimelineQueryVariables>) {
        return Apollo.useQuery<GetUserTimelineQuery, GetUserTimelineQueryVariables>(GetUserTimelineDocument, baseOptions);
      }
export function useGetUserTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTimelineQuery, GetUserTimelineQueryVariables>) {
          return Apollo.useLazyQuery<GetUserTimelineQuery, GetUserTimelineQueryVariables>(GetUserTimelineDocument, baseOptions);
        }
export type GetUserTimelineQueryHookResult = ReturnType<typeof useGetUserTimelineQuery>;
export type GetUserTimelineLazyQueryHookResult = ReturnType<typeof useGetUserTimelineLazyQuery>;
export type GetUserTimelineQueryResult = Apollo.QueryResult<GetUserTimelineQuery, GetUserTimelineQueryVariables>;
export const GetViewerDocument = gql`
    query GetViewer($url: String, $userAgent: String, $withImpact: Boolean = false, $isInitialLoad: Boolean = false, $showAnnouncement: Boolean = false, $withIsAnniversaryCardCreator: Boolean = false, $withIsAnniversaryCardValidator: Boolean = false, $withHireDate: Boolean = false, $withPageVisitors: Boolean = false, $withYesterdayPageVisitors: Boolean = false, $pageVisitorPagination: PaginationInput = {last: 10}, $yesterdayPageVisitorPagination: PaginationInput = {last: 10}) {
  viewer(isInitialLoad: $isInitialLoad, url: $url, userAgent: $userAgent) {
    ...UserInfo
    ...UserImpact @include(if: $withImpact)
    mobile
    language
    hasOnboarding
    shouldBeAnnounced @include(if: $showAnnouncement)
    anonymousCount
    hireDate @include(if: $withHireDate)
    latestAnniversary @include(if: $withHireDate)
    createdAt
    updatedAt
    departments {
      name
      departmentId
      parentDepartmentId
    }
    roles {
      role
      groupId
    }
    viewedUsers(pagination: $pageVisitorPagination) @include(if: $withPageVisitors) {
      totalCount
      edges {
        node {
          ...UserInfo
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
    yesterdayVisitors(pagination: $yesterdayPageVisitorPagination) @include(if: $withYesterdayPageVisitors) {
      totalCount
      edges {
        node {
          ...UserInfo
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
    isAnniversaryCardCreator @include(if: $withIsAnniversaryCardCreator)
    isAnniversaryCardValidator @include(if: $withIsAnniversaryCardValidator)
  }
  featureToggles {
    feature
    value
  }
}
    ${UserInfoFragmentDoc}
${UserImpactFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetViewerQuery__
 *
 * To run a query within a React component, call `useGetViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerQuery({
 *   variables: {
 *      url: // value for 'url'
 *      userAgent: // value for 'userAgent'
 *      withImpact: // value for 'withImpact'
 *      isInitialLoad: // value for 'isInitialLoad'
 *      showAnnouncement: // value for 'showAnnouncement'
 *      withIsAnniversaryCardCreator: // value for 'withIsAnniversaryCardCreator'
 *      withIsAnniversaryCardValidator: // value for 'withIsAnniversaryCardValidator'
 *      withHireDate: // value for 'withHireDate'
 *      withPageVisitors: // value for 'withPageVisitors'
 *      withYesterdayPageVisitors: // value for 'withYesterdayPageVisitors'
 *      pageVisitorPagination: // value for 'pageVisitorPagination'
 *      yesterdayPageVisitorPagination: // value for 'yesterdayPageVisitorPagination'
 *   },
 * });
 */
export function useGetViewerQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
        return Apollo.useQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, baseOptions);
      }
export function useGetViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, baseOptions);
        }
export type GetViewerQueryHookResult = ReturnType<typeof useGetViewerQuery>;
export type GetViewerLazyQueryHookResult = ReturnType<typeof useGetViewerLazyQuery>;
export type GetViewerQueryResult = Apollo.QueryResult<GetViewerQuery, GetViewerQueryVariables>;
export const GetViewerJournalProjectsDocument = gql`
    query GetViewerJournalProjects {
  viewer {
    userId
    journalProjects
  }
}
    `;

/**
 * __useGetViewerJournalProjectsQuery__
 *
 * To run a query within a React component, call `useGetViewerJournalProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerJournalProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerJournalProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerJournalProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerJournalProjectsQuery, GetViewerJournalProjectsQueryVariables>) {
        return Apollo.useQuery<GetViewerJournalProjectsQuery, GetViewerJournalProjectsQueryVariables>(GetViewerJournalProjectsDocument, baseOptions);
      }
export function useGetViewerJournalProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerJournalProjectsQuery, GetViewerJournalProjectsQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerJournalProjectsQuery, GetViewerJournalProjectsQueryVariables>(GetViewerJournalProjectsDocument, baseOptions);
        }
export type GetViewerJournalProjectsQueryHookResult = ReturnType<typeof useGetViewerJournalProjectsQuery>;
export type GetViewerJournalProjectsLazyQueryHookResult = ReturnType<typeof useGetViewerJournalProjectsLazyQuery>;
export type GetViewerJournalProjectsQueryResult = Apollo.QueryResult<GetViewerJournalProjectsQuery, GetViewerJournalProjectsQueryVariables>;
export const GetIntroductionInfoDocument = gql`
    query GetIntroductionInfo($userId: Int!) {
  user(userId: $userId) {
    userId
    name
    createdAt
    departments {
      name
    }
    basicProfile {
      business {
        value
      }
      skillSet {
        value
      }
      hobbies {
        value
      }
    }
    companyProfile {
      location {
        value
      }
    }
  }
}
    `;

/**
 * __useGetIntroductionInfoQuery__
 *
 * To run a query within a React component, call `useGetIntroductionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntroductionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntroductionInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetIntroductionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetIntroductionInfoQuery, GetIntroductionInfoQueryVariables>) {
        return Apollo.useQuery<GetIntroductionInfoQuery, GetIntroductionInfoQueryVariables>(GetIntroductionInfoDocument, baseOptions);
      }
export function useGetIntroductionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntroductionInfoQuery, GetIntroductionInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetIntroductionInfoQuery, GetIntroductionInfoQueryVariables>(GetIntroductionInfoDocument, baseOptions);
        }
export type GetIntroductionInfoQueryHookResult = ReturnType<typeof useGetIntroductionInfoQuery>;
export type GetIntroductionInfoLazyQueryHookResult = ReturnType<typeof useGetIntroductionInfoLazyQuery>;
export type GetIntroductionInfoQueryResult = Apollo.QueryResult<GetIntroductionInfoQuery, GetIntroductionInfoQueryVariables>;
export const GetLikedUsersDocument = gql`
    query GetLikedUsers($pagination: PaginationInput!, $timeSpan: Int!) {
  recommend {
    usersRankedByLikes(pagination: $pagination, timeSpan: $timeSpan) {
      edges {
        node {
          ...UserWithExtras
          likedCount
        }
      }
    }
  }
}
    ${UserWithExtrasFragmentDoc}`;

/**
 * __useGetLikedUsersQuery__
 *
 * To run a query within a React component, call `useGetLikedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLikedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLikedUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      timeSpan: // value for 'timeSpan'
 *   },
 * });
 */
export function useGetLikedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetLikedUsersQuery, GetLikedUsersQueryVariables>) {
        return Apollo.useQuery<GetLikedUsersQuery, GetLikedUsersQueryVariables>(GetLikedUsersDocument, baseOptions);
      }
export function useGetLikedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLikedUsersQuery, GetLikedUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetLikedUsersQuery, GetLikedUsersQueryVariables>(GetLikedUsersDocument, baseOptions);
        }
export type GetLikedUsersQueryHookResult = ReturnType<typeof useGetLikedUsersQuery>;
export type GetLikedUsersLazyQueryHookResult = ReturnType<typeof useGetLikedUsersLazyQuery>;
export type GetLikedUsersQueryResult = Apollo.QueryResult<GetLikedUsersQuery, GetLikedUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($userId: Int, $userName: String, $withPageVisitors: Boolean = false, $pageVisitorPagination: PaginationInput = {last: 10}) {
  user(userId: $userId, userName: $userName) {
    ...UserInfo
    mobile
    gender
    isPinned
    isFollowing
    isFollowingEachOther
    viewedUsers(pagination: $pageVisitorPagination) @include(if: $withPageVisitors) {
      totalCount
      edges {
        node {
          ...UserInfo
        }
      }
      pageInfo {
        ...RequestedPageInfo
      }
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedPageInfoFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *      withPageVisitors: // value for 'withPageVisitors'
 *      pageVisitorPagination: // value for 'pageVisitorPagination'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserFollowingStatusDocument = gql`
    query GetUserFollowingStatus($userId: Int, $userName: String) {
  user(userId: $userId, userName: $userName) {
    userId
    isFollowing
    isFollowingEachOther
  }
}
    `;

/**
 * __useGetUserFollowingStatusQuery__
 *
 * To run a query within a React component, call `useGetUserFollowingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowingStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useGetUserFollowingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFollowingStatusQuery, GetUserFollowingStatusQueryVariables>) {
        return Apollo.useQuery<GetUserFollowingStatusQuery, GetUserFollowingStatusQueryVariables>(GetUserFollowingStatusDocument, baseOptions);
      }
export function useGetUserFollowingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFollowingStatusQuery, GetUserFollowingStatusQueryVariables>) {
          return Apollo.useLazyQuery<GetUserFollowingStatusQuery, GetUserFollowingStatusQueryVariables>(GetUserFollowingStatusDocument, baseOptions);
        }
export type GetUserFollowingStatusQueryHookResult = ReturnType<typeof useGetUserFollowingStatusQuery>;
export type GetUserFollowingStatusLazyQueryHookResult = ReturnType<typeof useGetUserFollowingStatusLazyQuery>;
export type GetUserFollowingStatusQueryResult = Apollo.QueryResult<GetUserFollowingStatusQuery, GetUserFollowingStatusQueryVariables>;
export const GetViewerFollowingUsersDocument = gql`
    query GetViewerFollowingUsers($pagination: PaginationInput!) {
  viewer {
    userId
    followingUsers(pagination: $pagination, filter: {}) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...UserInfo
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useGetViewerFollowingUsersQuery__
 *
 * To run a query within a React component, call `useGetViewerFollowingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerFollowingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerFollowingUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetViewerFollowingUsersQuery(baseOptions: Apollo.QueryHookOptions<GetViewerFollowingUsersQuery, GetViewerFollowingUsersQueryVariables>) {
        return Apollo.useQuery<GetViewerFollowingUsersQuery, GetViewerFollowingUsersQueryVariables>(GetViewerFollowingUsersDocument, baseOptions);
      }
export function useGetViewerFollowingUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerFollowingUsersQuery, GetViewerFollowingUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerFollowingUsersQuery, GetViewerFollowingUsersQueryVariables>(GetViewerFollowingUsersDocument, baseOptions);
        }
export type GetViewerFollowingUsersQueryHookResult = ReturnType<typeof useGetViewerFollowingUsersQuery>;
export type GetViewerFollowingUsersLazyQueryHookResult = ReturnType<typeof useGetViewerFollowingUsersLazyQuery>;
export type GetViewerFollowingUsersQueryResult = Apollo.QueryResult<GetViewerFollowingUsersQuery, GetViewerFollowingUsersQueryVariables>;
export const GetUserFollowingUsersDocument = gql`
    query GetUserFollowingUsers($userId: Int, $pagination: PaginationInput!) {
  user(userId: $userId) {
    userId
    users: followingUsers(pagination: $pagination, filter: {}) {
      totalCount
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...UserInfo
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useGetUserFollowingUsersQuery__
 *
 * To run a query within a React component, call `useGetUserFollowingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowingUsersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserFollowingUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUserFollowingUsersQuery, GetUserFollowingUsersQueryVariables>) {
        return Apollo.useQuery<GetUserFollowingUsersQuery, GetUserFollowingUsersQueryVariables>(GetUserFollowingUsersDocument, baseOptions);
      }
export function useGetUserFollowingUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFollowingUsersQuery, GetUserFollowingUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetUserFollowingUsersQuery, GetUserFollowingUsersQueryVariables>(GetUserFollowingUsersDocument, baseOptions);
        }
export type GetUserFollowingUsersQueryHookResult = ReturnType<typeof useGetUserFollowingUsersQuery>;
export type GetUserFollowingUsersLazyQueryHookResult = ReturnType<typeof useGetUserFollowingUsersLazyQuery>;
export type GetUserFollowingUsersQueryResult = Apollo.QueryResult<GetUserFollowingUsersQuery, GetUserFollowingUsersQueryVariables>;
export const GetUserFollowedUsersDocument = gql`
    query GetUserFollowedUsers($userId: Int, $pagination: PaginationInput!) {
  user(userId: $userId) {
    userId
    users: followedUsers(pagination: $pagination, filter: {}) {
      totalCount
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...UserInfo
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useGetUserFollowedUsersQuery__
 *
 * To run a query within a React component, call `useGetUserFollowedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowedUsersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserFollowedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUserFollowedUsersQuery, GetUserFollowedUsersQueryVariables>) {
        return Apollo.useQuery<GetUserFollowedUsersQuery, GetUserFollowedUsersQueryVariables>(GetUserFollowedUsersDocument, baseOptions);
      }
export function useGetUserFollowedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFollowedUsersQuery, GetUserFollowedUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetUserFollowedUsersQuery, GetUserFollowedUsersQueryVariables>(GetUserFollowedUsersDocument, baseOptions);
        }
export type GetUserFollowedUsersQueryHookResult = ReturnType<typeof useGetUserFollowedUsersQuery>;
export type GetUserFollowedUsersLazyQueryHookResult = ReturnType<typeof useGetUserFollowedUsersLazyQuery>;
export type GetUserFollowedUsersQueryResult = Apollo.QueryResult<GetUserFollowedUsersQuery, GetUserFollowedUsersQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($pagination: PaginationInput!, $filter: GetUsersFilter!) {
  users(pagination: $pagination, filter: $filter) {
    pageInfo {
      ...RequestedPageInfo
    }
    edges {
      node {
        ...UserInfo
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, baseOptions);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, baseOptions);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserSidebarDocument = gql`
    query GetUserSidebar($userId: Int!) {
  user(userId: $userId) {
    userId
    name
    departments {
      ...RequestedDepartment
    }
    basicProfile {
      ...BasicProfile
    }
    companyProfile {
      ...CompanyProfile
    }
  }
}
    ${RequestedDepartmentFragmentDoc}
${BasicProfileFragmentDoc}
${CompanyProfileFragmentDoc}`;

/**
 * __useGetUserSidebarQuery__
 *
 * To run a query within a React component, call `useGetUserSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSidebarQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserSidebarQuery(baseOptions: Apollo.QueryHookOptions<GetUserSidebarQuery, GetUserSidebarQueryVariables>) {
        return Apollo.useQuery<GetUserSidebarQuery, GetUserSidebarQueryVariables>(GetUserSidebarDocument, baseOptions);
      }
export function useGetUserSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSidebarQuery, GetUserSidebarQueryVariables>) {
          return Apollo.useLazyQuery<GetUserSidebarQuery, GetUserSidebarQueryVariables>(GetUserSidebarDocument, baseOptions);
        }
export type GetUserSidebarQueryHookResult = ReturnType<typeof useGetUserSidebarQuery>;
export type GetUserSidebarLazyQueryHookResult = ReturnType<typeof useGetUserSidebarLazyQuery>;
export type GetUserSidebarQueryResult = Apollo.QueryResult<GetUserSidebarQuery, GetUserSidebarQueryVariables>;
export const GetUserTaleUsageDocument = gql`
    query GetUserTaleUsage($userId: Int!, $limit: Float!, $pagination: PaginationInput!) {
  user(userId: $userId) {
    userId
    activeGroups(limit: $limit) {
      ...RequestedGroup
    }
    featuredPosts(pagination: $pagination) {
      edges {
        node {
          ...RequestedPost
        }
      }
    }
    contributedKnowledge(pagination: $pagination) {
      edges {
        node {
          knowledgePostId
          title
          link {
            url
          }
        }
      }
    }
  }
}
    ${RequestedGroupFragmentDoc}
${RequestedPostFragmentDoc}`;

/**
 * __useGetUserTaleUsageQuery__
 *
 * To run a query within a React component, call `useGetUserTaleUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTaleUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTaleUsageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserTaleUsageQuery(baseOptions: Apollo.QueryHookOptions<GetUserTaleUsageQuery, GetUserTaleUsageQueryVariables>) {
        return Apollo.useQuery<GetUserTaleUsageQuery, GetUserTaleUsageQueryVariables>(GetUserTaleUsageDocument, baseOptions);
      }
export function useGetUserTaleUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTaleUsageQuery, GetUserTaleUsageQueryVariables>) {
          return Apollo.useLazyQuery<GetUserTaleUsageQuery, GetUserTaleUsageQueryVariables>(GetUserTaleUsageDocument, baseOptions);
        }
export type GetUserTaleUsageQueryHookResult = ReturnType<typeof useGetUserTaleUsageQuery>;
export type GetUserTaleUsageLazyQueryHookResult = ReturnType<typeof useGetUserTaleUsageLazyQuery>;
export type GetUserTaleUsageQueryResult = Apollo.QueryResult<GetUserTaleUsageQuery, GetUserTaleUsageQueryVariables>;
export const GetViewerPinnedUsersDocument = gql`
    query GetViewerPinnedUsers($pagination: PaginationInput!) {
  viewer {
    userId
    followingUsers(isPinned: true, pagination: $pagination, filter: {}) {
      edges {
        node {
          ...UserInfo
          isPinned
        }
      }
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useGetViewerPinnedUsersQuery__
 *
 * To run a query within a React component, call `useGetViewerPinnedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerPinnedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerPinnedUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetViewerPinnedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetViewerPinnedUsersQuery, GetViewerPinnedUsersQueryVariables>) {
        return Apollo.useQuery<GetViewerPinnedUsersQuery, GetViewerPinnedUsersQueryVariables>(GetViewerPinnedUsersDocument, baseOptions);
      }
export function useGetViewerPinnedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerPinnedUsersQuery, GetViewerPinnedUsersQueryVariables>) {
          return Apollo.useLazyQuery<GetViewerPinnedUsersQuery, GetViewerPinnedUsersQueryVariables>(GetViewerPinnedUsersDocument, baseOptions);
        }
export type GetViewerPinnedUsersQueryHookResult = ReturnType<typeof useGetViewerPinnedUsersQuery>;
export type GetViewerPinnedUsersLazyQueryHookResult = ReturnType<typeof useGetViewerPinnedUsersLazyQuery>;
export type GetViewerPinnedUsersQueryResult = Apollo.QueryResult<GetViewerPinnedUsersQuery, GetViewerPinnedUsersQueryVariables>;
export const ViewerLanguageUpdateDocument = gql`
    mutation ViewerLanguageUpdate($language: String!) {
  viewerUpdate(language: $language) {
    userId
    language
  }
}
    `;
export type ViewerLanguageUpdateMutationFn = Apollo.MutationFunction<ViewerLanguageUpdateMutation, ViewerLanguageUpdateMutationVariables>;

/**
 * __useViewerLanguageUpdateMutation__
 *
 * To run a mutation, you first call `useViewerLanguageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewerLanguageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewerLanguageUpdateMutation, { data, loading, error }] = useViewerLanguageUpdateMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useViewerLanguageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ViewerLanguageUpdateMutation, ViewerLanguageUpdateMutationVariables>) {
        return Apollo.useMutation<ViewerLanguageUpdateMutation, ViewerLanguageUpdateMutationVariables>(ViewerLanguageUpdateDocument, baseOptions);
      }
export type ViewerLanguageUpdateMutationHookResult = ReturnType<typeof useViewerLanguageUpdateMutation>;
export type ViewerLanguageUpdateMutationResult = Apollo.MutationResult<ViewerLanguageUpdateMutation>;
export type ViewerLanguageUpdateMutationOptions = Apollo.BaseMutationOptions<ViewerLanguageUpdateMutation, ViewerLanguageUpdateMutationVariables>;
export const ViewerOnboardingUpdateDocument = gql`
    mutation ViewerOnboardingUpdate($hasOnboarding: Boolean) {
  viewerUpdate(hasOnboarding: $hasOnboarding) {
    userId
    hasOnboarding
  }
}
    `;
export type ViewerOnboardingUpdateMutationFn = Apollo.MutationFunction<ViewerOnboardingUpdateMutation, ViewerOnboardingUpdateMutationVariables>;

/**
 * __useViewerOnboardingUpdateMutation__
 *
 * To run a mutation, you first call `useViewerOnboardingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewerOnboardingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewerOnboardingUpdateMutation, { data, loading, error }] = useViewerOnboardingUpdateMutation({
 *   variables: {
 *      hasOnboarding: // value for 'hasOnboarding'
 *   },
 * });
 */
export function useViewerOnboardingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ViewerOnboardingUpdateMutation, ViewerOnboardingUpdateMutationVariables>) {
        return Apollo.useMutation<ViewerOnboardingUpdateMutation, ViewerOnboardingUpdateMutationVariables>(ViewerOnboardingUpdateDocument, baseOptions);
      }
export type ViewerOnboardingUpdateMutationHookResult = ReturnType<typeof useViewerOnboardingUpdateMutation>;
export type ViewerOnboardingUpdateMutationResult = Apollo.MutationResult<ViewerOnboardingUpdateMutation>;
export type ViewerOnboardingUpdateMutationOptions = Apollo.BaseMutationOptions<ViewerOnboardingUpdateMutation, ViewerOnboardingUpdateMutationVariables>;
export const ViewerAnnouncementUpdateDocument = gql`
    mutation ViewerAnnouncementUpdate($shouldBeAnnounced: Boolean) {
  viewerUpdate(shouldBeAnnounced: $shouldBeAnnounced) {
    userId
    shouldBeAnnounced
  }
}
    `;
export type ViewerAnnouncementUpdateMutationFn = Apollo.MutationFunction<ViewerAnnouncementUpdateMutation, ViewerAnnouncementUpdateMutationVariables>;

/**
 * __useViewerAnnouncementUpdateMutation__
 *
 * To run a mutation, you first call `useViewerAnnouncementUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewerAnnouncementUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewerAnnouncementUpdateMutation, { data, loading, error }] = useViewerAnnouncementUpdateMutation({
 *   variables: {
 *      shouldBeAnnounced: // value for 'shouldBeAnnounced'
 *   },
 * });
 */
export function useViewerAnnouncementUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ViewerAnnouncementUpdateMutation, ViewerAnnouncementUpdateMutationVariables>) {
        return Apollo.useMutation<ViewerAnnouncementUpdateMutation, ViewerAnnouncementUpdateMutationVariables>(ViewerAnnouncementUpdateDocument, baseOptions);
      }
export type ViewerAnnouncementUpdateMutationHookResult = ReturnType<typeof useViewerAnnouncementUpdateMutation>;
export type ViewerAnnouncementUpdateMutationResult = Apollo.MutationResult<ViewerAnnouncementUpdateMutation>;
export type ViewerAnnouncementUpdateMutationOptions = Apollo.BaseMutationOptions<ViewerAnnouncementUpdateMutation, ViewerAnnouncementUpdateMutationVariables>;
export const UserUpdatedDocument = gql`
    subscription UserUpdated($userId: Int!) {
  userUpdated(userId: $userId) {
    userId
    impact
    anonymousCount
  }
}
    `;

/**
 * __useUserUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUpdatedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserUpdatedSubscription, UserUpdatedSubscriptionVariables>) {
        return Apollo.useSubscription<UserUpdatedSubscription, UserUpdatedSubscriptionVariables>(UserUpdatedDocument, baseOptions);
      }
export type UserUpdatedSubscriptionHookResult = ReturnType<typeof useUserUpdatedSubscription>;
export type UserUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserUpdatedSubscription>;
export const GetBasicProfileDocument = gql`
    query GetBasicProfile($userId: Int!) {
  user(userId: $userId) {
    userId
    name
    alias
    basicProfile {
      ...BasicProfile
    }
  }
}
    ${BasicProfileFragmentDoc}`;

/**
 * __useGetBasicProfileQuery__
 *
 * To run a query within a React component, call `useGetBasicProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetBasicProfileQuery(baseOptions: Apollo.QueryHookOptions<GetBasicProfileQuery, GetBasicProfileQueryVariables>) {
        return Apollo.useQuery<GetBasicProfileQuery, GetBasicProfileQueryVariables>(GetBasicProfileDocument, baseOptions);
      }
export function useGetBasicProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicProfileQuery, GetBasicProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetBasicProfileQuery, GetBasicProfileQueryVariables>(GetBasicProfileDocument, baseOptions);
        }
export type GetBasicProfileQueryHookResult = ReturnType<typeof useGetBasicProfileQuery>;
export type GetBasicProfileLazyQueryHookResult = ReturnType<typeof useGetBasicProfileLazyQuery>;
export type GetBasicProfileQueryResult = Apollo.QueryResult<GetBasicProfileQuery, GetBasicProfileQueryVariables>;
export const GetBasicProfileAboutMeDocument = gql`
    query GetBasicProfileAboutMe($userId: Int!) {
  user(userId: $userId) {
    userId
    deletedAt
    basicProfile {
      github {
        value
        isVisible
      }
      linkedin {
        value
        isVisible
      }
      aboutMe {
        value
        isVisible
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetBasicProfileAboutMeQuery__
 *
 * To run a query within a React component, call `useGetBasicProfileAboutMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicProfileAboutMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicProfileAboutMeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetBasicProfileAboutMeQuery(baseOptions: Apollo.QueryHookOptions<GetBasicProfileAboutMeQuery, GetBasicProfileAboutMeQueryVariables>) {
        return Apollo.useQuery<GetBasicProfileAboutMeQuery, GetBasicProfileAboutMeQueryVariables>(GetBasicProfileAboutMeDocument, baseOptions);
      }
export function useGetBasicProfileAboutMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicProfileAboutMeQuery, GetBasicProfileAboutMeQueryVariables>) {
          return Apollo.useLazyQuery<GetBasicProfileAboutMeQuery, GetBasicProfileAboutMeQueryVariables>(GetBasicProfileAboutMeDocument, baseOptions);
        }
export type GetBasicProfileAboutMeQueryHookResult = ReturnType<typeof useGetBasicProfileAboutMeQuery>;
export type GetBasicProfileAboutMeLazyQueryHookResult = ReturnType<typeof useGetBasicProfileAboutMeLazyQuery>;
export type GetBasicProfileAboutMeQueryResult = Apollo.QueryResult<GetBasicProfileAboutMeQuery, GetBasicProfileAboutMeQueryVariables>;
export const GetUserWorkCircleDocument = gql`
    query GetUserWorkCircle($userId: Int!) {
  user(userId: $userId) {
    userId
    workCircle {
      status
      users {
        ...UserInfo
        departments {
          ...RequestedDepartment
        }
      }
    }
    basicProfile {
      createdAt
      workCircleFeedback
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedDepartmentFragmentDoc}`;

/**
 * __useGetUserWorkCircleQuery__
 *
 * To run a query within a React component, call `useGetUserWorkCircleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWorkCircleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWorkCircleQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserWorkCircleQuery(baseOptions: Apollo.QueryHookOptions<GetUserWorkCircleQuery, GetUserWorkCircleQueryVariables>) {
        return Apollo.useQuery<GetUserWorkCircleQuery, GetUserWorkCircleQueryVariables>(GetUserWorkCircleDocument, baseOptions);
      }
export function useGetUserWorkCircleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWorkCircleQuery, GetUserWorkCircleQueryVariables>) {
          return Apollo.useLazyQuery<GetUserWorkCircleQuery, GetUserWorkCircleQueryVariables>(GetUserWorkCircleDocument, baseOptions);
        }
export type GetUserWorkCircleQueryHookResult = ReturnType<typeof useGetUserWorkCircleQuery>;
export type GetUserWorkCircleLazyQueryHookResult = ReturnType<typeof useGetUserWorkCircleLazyQuery>;
export type GetUserWorkCircleQueryResult = Apollo.QueryResult<GetUserWorkCircleQuery, GetUserWorkCircleQueryVariables>;
export const GetCompanyProfileDocument = gql`
    query GetCompanyProfile($userId: Int!) {
  user(userId: $userId) {
    userId
    colleagues {
      ...UserInfo
    }
    leaders {
      ...UserInfo
    }
    departments {
      ...RequestedDepartment
    }
    companyProfile {
      ...CompanyProfile
    }
    hrbp: businessPartner(role: HRBP) {
      ...UserInfo
    }
    financePartner: businessPartner(role: FINANCE) {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}
${RequestedDepartmentFragmentDoc}
${CompanyProfileFragmentDoc}`;

/**
 * __useGetCompanyProfileQuery__
 *
 * To run a query within a React component, call `useGetCompanyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCompanyProfileQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>) {
        return Apollo.useQuery<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>(GetCompanyProfileDocument, baseOptions);
      }
export function useGetCompanyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>(GetCompanyProfileDocument, baseOptions);
        }
export type GetCompanyProfileQueryHookResult = ReturnType<typeof useGetCompanyProfileQuery>;
export type GetCompanyProfileLazyQueryHookResult = ReturnType<typeof useGetCompanyProfileLazyQuery>;
export type GetCompanyProfileQueryResult = Apollo.QueryResult<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>;
export const GetCareerProfileDocument = gql`
    query GetCareerProfile($userId: Int!) {
  user(userId: $userId) {
    userId
    careerProfile {
      ...CareerProfile
    }
  }
}
    ${CareerProfileFragmentDoc}`;

/**
 * __useGetCareerProfileQuery__
 *
 * To run a query within a React component, call `useGetCareerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCareerProfileQuery(baseOptions: Apollo.QueryHookOptions<GetCareerProfileQuery, GetCareerProfileQueryVariables>) {
        return Apollo.useQuery<GetCareerProfileQuery, GetCareerProfileQueryVariables>(GetCareerProfileDocument, baseOptions);
      }
export function useGetCareerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerProfileQuery, GetCareerProfileQueryVariables>) {
          return Apollo.useLazyQuery<GetCareerProfileQuery, GetCareerProfileQueryVariables>(GetCareerProfileDocument, baseOptions);
        }
export type GetCareerProfileQueryHookResult = ReturnType<typeof useGetCareerProfileQuery>;
export type GetCareerProfileLazyQueryHookResult = ReturnType<typeof useGetCareerProfileLazyQuery>;
export type GetCareerProfileQueryResult = Apollo.QueryResult<GetCareerProfileQuery, GetCareerProfileQueryVariables>;
export const GetSkillSearchDocument = gql`
    query GetSkillSearch($input: SkillInput!, $userId: Int!) {
  skills(input: $input, userId: $userId) {
    skillId
    name
  }
}
    `;

/**
 * __useGetSkillSearchQuery__
 *
 * To run a query within a React component, call `useGetSkillSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSkillSearchQuery(baseOptions: Apollo.QueryHookOptions<GetSkillSearchQuery, GetSkillSearchQueryVariables>) {
        return Apollo.useQuery<GetSkillSearchQuery, GetSkillSearchQueryVariables>(GetSkillSearchDocument, baseOptions);
      }
export function useGetSkillSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillSearchQuery, GetSkillSearchQueryVariables>) {
          return Apollo.useLazyQuery<GetSkillSearchQuery, GetSkillSearchQueryVariables>(GetSkillSearchDocument, baseOptions);
        }
export type GetSkillSearchQueryHookResult = ReturnType<typeof useGetSkillSearchQuery>;
export type GetSkillSearchLazyQueryHookResult = ReturnType<typeof useGetSkillSearchLazyQuery>;
export type GetSkillSearchQueryResult = Apollo.QueryResult<GetSkillSearchQuery, GetSkillSearchQueryVariables>;
export const GetFrequentSkillsDocument = gql`
    query GetFrequentSkills($input: SkillInput!, $userId: Int!) {
  skills(input: $input, userId: $userId) {
    skillId
    name
  }
}
    `;

/**
 * __useGetFrequentSkillsQuery__
 *
 * To run a query within a React component, call `useGetFrequentSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrequentSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrequentSkillsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFrequentSkillsQuery(baseOptions: Apollo.QueryHookOptions<GetFrequentSkillsQuery, GetFrequentSkillsQueryVariables>) {
        return Apollo.useQuery<GetFrequentSkillsQuery, GetFrequentSkillsQueryVariables>(GetFrequentSkillsDocument, baseOptions);
      }
export function useGetFrequentSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrequentSkillsQuery, GetFrequentSkillsQueryVariables>) {
          return Apollo.useLazyQuery<GetFrequentSkillsQuery, GetFrequentSkillsQueryVariables>(GetFrequentSkillsDocument, baseOptions);
        }
export type GetFrequentSkillsQueryHookResult = ReturnType<typeof useGetFrequentSkillsQuery>;
export type GetFrequentSkillsLazyQueryHookResult = ReturnType<typeof useGetFrequentSkillsLazyQuery>;
export type GetFrequentSkillsQueryResult = Apollo.QueryResult<GetFrequentSkillsQuery, GetFrequentSkillsQueryVariables>;
export const GetUserSkillDocument = gql`
    query GetUserSkill($userId: Int!, $skillPagination: PaginationInput!, $evaluatedUserPagination: PaginationInput!) {
  user(userId: $userId) {
    userId
    skills(userId: $userId, pagination: $skillPagination) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...RequestedUserSkill
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedUserSkillFragmentDoc}`;

/**
 * __useGetUserSkillQuery__
 *
 * To run a query within a React component, call `useGetUserSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSkillQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      skillPagination: // value for 'skillPagination'
 *      evaluatedUserPagination: // value for 'evaluatedUserPagination'
 *   },
 * });
 */
export function useGetUserSkillQuery(baseOptions: Apollo.QueryHookOptions<GetUserSkillQuery, GetUserSkillQueryVariables>) {
        return Apollo.useQuery<GetUserSkillQuery, GetUserSkillQueryVariables>(GetUserSkillDocument, baseOptions);
      }
export function useGetUserSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSkillQuery, GetUserSkillQueryVariables>) {
          return Apollo.useLazyQuery<GetUserSkillQuery, GetUserSkillQueryVariables>(GetUserSkillDocument, baseOptions);
        }
export type GetUserSkillQueryHookResult = ReturnType<typeof useGetUserSkillQuery>;
export type GetUserSkillLazyQueryHookResult = ReturnType<typeof useGetUserSkillLazyQuery>;
export type GetUserSkillQueryResult = Apollo.QueryResult<GetUserSkillQuery, GetUserSkillQueryVariables>;
export const GetHobbySearchDocument = gql`
    query GetHobbySearch($input: HobbyInput!, $userId: Int!) {
  hobbies(input: $input, userId: $userId) {
    hobbyId
    name
  }
}
    `;

/**
 * __useGetHobbySearchQuery__
 *
 * To run a query within a React component, call `useGetHobbySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHobbySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHobbySearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHobbySearchQuery(baseOptions: Apollo.QueryHookOptions<GetHobbySearchQuery, GetHobbySearchQueryVariables>) {
        return Apollo.useQuery<GetHobbySearchQuery, GetHobbySearchQueryVariables>(GetHobbySearchDocument, baseOptions);
      }
export function useGetHobbySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHobbySearchQuery, GetHobbySearchQueryVariables>) {
          return Apollo.useLazyQuery<GetHobbySearchQuery, GetHobbySearchQueryVariables>(GetHobbySearchDocument, baseOptions);
        }
export type GetHobbySearchQueryHookResult = ReturnType<typeof useGetHobbySearchQuery>;
export type GetHobbySearchLazyQueryHookResult = ReturnType<typeof useGetHobbySearchLazyQuery>;
export type GetHobbySearchQueryResult = Apollo.QueryResult<GetHobbySearchQuery, GetHobbySearchQueryVariables>;
export const GetFrequentHobbiesDocument = gql`
    query GetFrequentHobbies($input: HobbyInput!, $userId: Int!) {
  hobbies(input: $input, userId: $userId) {
    hobbyId
    name
  }
}
    `;

/**
 * __useGetFrequentHobbiesQuery__
 *
 * To run a query within a React component, call `useGetFrequentHobbiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrequentHobbiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrequentHobbiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFrequentHobbiesQuery(baseOptions: Apollo.QueryHookOptions<GetFrequentHobbiesQuery, GetFrequentHobbiesQueryVariables>) {
        return Apollo.useQuery<GetFrequentHobbiesQuery, GetFrequentHobbiesQueryVariables>(GetFrequentHobbiesDocument, baseOptions);
      }
export function useGetFrequentHobbiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrequentHobbiesQuery, GetFrequentHobbiesQueryVariables>) {
          return Apollo.useLazyQuery<GetFrequentHobbiesQuery, GetFrequentHobbiesQueryVariables>(GetFrequentHobbiesDocument, baseOptions);
        }
export type GetFrequentHobbiesQueryHookResult = ReturnType<typeof useGetFrequentHobbiesQuery>;
export type GetFrequentHobbiesLazyQueryHookResult = ReturnType<typeof useGetFrequentHobbiesLazyQuery>;
export type GetFrequentHobbiesQueryResult = Apollo.QueryResult<GetFrequentHobbiesQuery, GetFrequentHobbiesQueryVariables>;
export const GetUserHobbiesDocument = gql`
    query GetUserHobbies($userId: Int!, $hobbyPagination: PaginationInput!) {
  user(userId: $userId) {
    userId
    hobbies(userId: $userId, pagination: $hobbyPagination) {
      pageInfo {
        ...RequestedPageInfo
      }
      edges {
        node {
          ...RequestedUserHobby
        }
      }
    }
  }
}
    ${RequestedPageInfoFragmentDoc}
${RequestedUserHobbyFragmentDoc}`;

/**
 * __useGetUserHobbiesQuery__
 *
 * To run a query within a React component, call `useGetUserHobbiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserHobbiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserHobbiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      hobbyPagination: // value for 'hobbyPagination'
 *   },
 * });
 */
export function useGetUserHobbiesQuery(baseOptions: Apollo.QueryHookOptions<GetUserHobbiesQuery, GetUserHobbiesQueryVariables>) {
        return Apollo.useQuery<GetUserHobbiesQuery, GetUserHobbiesQueryVariables>(GetUserHobbiesDocument, baseOptions);
      }
export function useGetUserHobbiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserHobbiesQuery, GetUserHobbiesQueryVariables>) {
          return Apollo.useLazyQuery<GetUserHobbiesQuery, GetUserHobbiesQueryVariables>(GetUserHobbiesDocument, baseOptions);
        }
export type GetUserHobbiesQueryHookResult = ReturnType<typeof useGetUserHobbiesQuery>;
export type GetUserHobbiesLazyQueryHookResult = ReturnType<typeof useGetUserHobbiesLazyQuery>;
export type GetUserHobbiesQueryResult = Apollo.QueryResult<GetUserHobbiesQuery, GetUserHobbiesQueryVariables>;
export const GetNewAgoranCardInfoDocument = gql`
    query GetNewAgoranCardInfo($userId: Int!) {
  user(userId: $userId) {
    userId
    email
    name
    avatarUrl
    alias
    isFollowing
    departments {
      departmentId
      name
    }
    skills(userId: $userId, pagination: {last: 5}, selfCreated: true) {
      edges {
        node {
          skillId
          name
        }
      }
    }
    hobbies(userId: $userId, pagination: {last: 5}) {
      edges {
        node {
          hobbyId
          name
        }
      }
    }
    companyProfile {
      location {
        value
      }
    }
    basicProfile {
      aboutMe {
        value
      }
    }
  }
}
    `;

/**
 * __useGetNewAgoranCardInfoQuery__
 *
 * To run a query within a React component, call `useGetNewAgoranCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewAgoranCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewAgoranCardInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNewAgoranCardInfoQuery(baseOptions: Apollo.QueryHookOptions<GetNewAgoranCardInfoQuery, GetNewAgoranCardInfoQueryVariables>) {
        return Apollo.useQuery<GetNewAgoranCardInfoQuery, GetNewAgoranCardInfoQueryVariables>(GetNewAgoranCardInfoDocument, baseOptions);
      }
export function useGetNewAgoranCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewAgoranCardInfoQuery, GetNewAgoranCardInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetNewAgoranCardInfoQuery, GetNewAgoranCardInfoQueryVariables>(GetNewAgoranCardInfoDocument, baseOptions);
        }
export type GetNewAgoranCardInfoQueryHookResult = ReturnType<typeof useGetNewAgoranCardInfoQuery>;
export type GetNewAgoranCardInfoLazyQueryHookResult = ReturnType<typeof useGetNewAgoranCardInfoLazyQuery>;
export type GetNewAgoranCardInfoQueryResult = Apollo.QueryResult<GetNewAgoranCardInfoQuery, GetNewAgoranCardInfoQueryVariables>;
export const GetUserOkrDocument = gql`
    query GetUserOKR($userId: Int!) {
  user(userId: $userId) {
    userId
    objectivesFeature {
      objectives {
        ...RequestedObjective
      }
    }
    currentCycle {
      cycleId
      name
    }
  }
}
    ${RequestedObjectiveFragmentDoc}`;

/**
 * __useGetUserOkrQuery__
 *
 * To run a query within a React component, call `useGetUserOkrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOkrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOkrQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserOkrQuery(baseOptions: Apollo.QueryHookOptions<GetUserOkrQuery, GetUserOkrQueryVariables>) {
        return Apollo.useQuery<GetUserOkrQuery, GetUserOkrQueryVariables>(GetUserOkrDocument, baseOptions);
      }
export function useGetUserOkrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOkrQuery, GetUserOkrQueryVariables>) {
          return Apollo.useLazyQuery<GetUserOkrQuery, GetUserOkrQueryVariables>(GetUserOkrDocument, baseOptions);
        }
export type GetUserOkrQueryHookResult = ReturnType<typeof useGetUserOkrQuery>;
export type GetUserOkrLazyQueryHookResult = ReturnType<typeof useGetUserOkrLazyQuery>;
export type GetUserOkrQueryResult = Apollo.QueryResult<GetUserOkrQuery, GetUserOkrQueryVariables>;
export const GetUserPageInfoDocument = gql`
    query GetUserPageInfo($userId: Int!) {
  user(userId: $userId) {
    userId
    email
    name
    avatarUrl
    alias
    createdAt
    departments {
      departmentId
      name
    }
    basicProfile {
      ...BasicProfile
      photo {
        value
        isVisible
      }
      photoFile {
        ...LocalFile
      }
    }
    companyProfile {
      ...CompanyProfile
    }
  }
}
    ${BasicProfileFragmentDoc}
${LocalFileFragmentDoc}
${CompanyProfileFragmentDoc}`;

/**
 * __useGetUserPageInfoQuery__
 *
 * To run a query within a React component, call `useGetUserPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPageInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPageInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserPageInfoQuery, GetUserPageInfoQueryVariables>) {
        return Apollo.useQuery<GetUserPageInfoQuery, GetUserPageInfoQueryVariables>(GetUserPageInfoDocument, baseOptions);
      }
export function useGetUserPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPageInfoQuery, GetUserPageInfoQueryVariables>) {
          return Apollo.useLazyQuery<GetUserPageInfoQuery, GetUserPageInfoQueryVariables>(GetUserPageInfoDocument, baseOptions);
        }
export type GetUserPageInfoQueryHookResult = ReturnType<typeof useGetUserPageInfoQuery>;
export type GetUserPageInfoLazyQueryHookResult = ReturnType<typeof useGetUserPageInfoLazyQuery>;
export type GetUserPageInfoQueryResult = Apollo.QueryResult<GetUserPageInfoQuery, GetUserPageInfoQueryVariables>;
export const BasicProfileUpdateDocument = gql`
    mutation BasicProfileUpdate($basicProfile: BasicProfileInput!) {
  basicProfileUpdate(basicProfile: $basicProfile) {
    ...BasicProfile
  }
}
    ${BasicProfileFragmentDoc}`;
export type BasicProfileUpdateMutationFn = Apollo.MutationFunction<BasicProfileUpdateMutation, BasicProfileUpdateMutationVariables>;

/**
 * __useBasicProfileUpdateMutation__
 *
 * To run a mutation, you first call `useBasicProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicProfileUpdateMutation, { data, loading, error }] = useBasicProfileUpdateMutation({
 *   variables: {
 *      basicProfile: // value for 'basicProfile'
 *   },
 * });
 */
export function useBasicProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BasicProfileUpdateMutation, BasicProfileUpdateMutationVariables>) {
        return Apollo.useMutation<BasicProfileUpdateMutation, BasicProfileUpdateMutationVariables>(BasicProfileUpdateDocument, baseOptions);
      }
export type BasicProfileUpdateMutationHookResult = ReturnType<typeof useBasicProfileUpdateMutation>;
export type BasicProfileUpdateMutationResult = Apollo.MutationResult<BasicProfileUpdateMutation>;
export type BasicProfileUpdateMutationOptions = Apollo.BaseMutationOptions<BasicProfileUpdateMutation, BasicProfileUpdateMutationVariables>;
export const CompanyProfileUpdateDocument = gql`
    mutation CompanyProfileUpdate($companyProfile: CompanyProfileInput!) {
  companyProfileUpdate(companyProfile: $companyProfile) {
    ...CompanyProfile
  }
}
    ${CompanyProfileFragmentDoc}`;
export type CompanyProfileUpdateMutationFn = Apollo.MutationFunction<CompanyProfileUpdateMutation, CompanyProfileUpdateMutationVariables>;

/**
 * __useCompanyProfileUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyProfileUpdateMutation, { data, loading, error }] = useCompanyProfileUpdateMutation({
 *   variables: {
 *      companyProfile: // value for 'companyProfile'
 *   },
 * });
 */
export function useCompanyProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyProfileUpdateMutation, CompanyProfileUpdateMutationVariables>) {
        return Apollo.useMutation<CompanyProfileUpdateMutation, CompanyProfileUpdateMutationVariables>(CompanyProfileUpdateDocument, baseOptions);
      }
export type CompanyProfileUpdateMutationHookResult = ReturnType<typeof useCompanyProfileUpdateMutation>;
export type CompanyProfileUpdateMutationResult = Apollo.MutationResult<CompanyProfileUpdateMutation>;
export type CompanyProfileUpdateMutationOptions = Apollo.BaseMutationOptions<CompanyProfileUpdateMutation, CompanyProfileUpdateMutationVariables>;
export const CareerProfileUpdateDocument = gql`
    mutation CareerProfileUpdate($careerProfile: CareerProfileInput!) {
  careerProfileUpdate(careerProfile: $careerProfile) {
    ...CareerProfile
  }
}
    ${CareerProfileFragmentDoc}`;
export type CareerProfileUpdateMutationFn = Apollo.MutationFunction<CareerProfileUpdateMutation, CareerProfileUpdateMutationVariables>;

/**
 * __useCareerProfileUpdateMutation__
 *
 * To run a mutation, you first call `useCareerProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCareerProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [careerProfileUpdateMutation, { data, loading, error }] = useCareerProfileUpdateMutation({
 *   variables: {
 *      careerProfile: // value for 'careerProfile'
 *   },
 * });
 */
export function useCareerProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CareerProfileUpdateMutation, CareerProfileUpdateMutationVariables>) {
        return Apollo.useMutation<CareerProfileUpdateMutation, CareerProfileUpdateMutationVariables>(CareerProfileUpdateDocument, baseOptions);
      }
export type CareerProfileUpdateMutationHookResult = ReturnType<typeof useCareerProfileUpdateMutation>;
export type CareerProfileUpdateMutationResult = Apollo.MutationResult<CareerProfileUpdateMutation>;
export type CareerProfileUpdateMutationOptions = Apollo.BaseMutationOptions<CareerProfileUpdateMutation, CareerProfileUpdateMutationVariables>;
export const CareerProfileDeleteDocument = gql`
    mutation CareerProfileDelete($careerProfileId: Int!) {
  careerProfileDelete(careerProfileId: $careerProfileId)
}
    `;
export type CareerProfileDeleteMutationFn = Apollo.MutationFunction<CareerProfileDeleteMutation, CareerProfileDeleteMutationVariables>;

/**
 * __useCareerProfileDeleteMutation__
 *
 * To run a mutation, you first call `useCareerProfileDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCareerProfileDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [careerProfileDeleteMutation, { data, loading, error }] = useCareerProfileDeleteMutation({
 *   variables: {
 *      careerProfileId: // value for 'careerProfileId'
 *   },
 * });
 */
export function useCareerProfileDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CareerProfileDeleteMutation, CareerProfileDeleteMutationVariables>) {
        return Apollo.useMutation<CareerProfileDeleteMutation, CareerProfileDeleteMutationVariables>(CareerProfileDeleteDocument, baseOptions);
      }
export type CareerProfileDeleteMutationHookResult = ReturnType<typeof useCareerProfileDeleteMutation>;
export type CareerProfileDeleteMutationResult = Apollo.MutationResult<CareerProfileDeleteMutation>;
export type CareerProfileDeleteMutationOptions = Apollo.BaseMutationOptions<CareerProfileDeleteMutation, CareerProfileDeleteMutationVariables>;
export const BasicProfileAboutMeUpdateDocument = gql`
    mutation BasicProfileAboutMeUpdate($aboutMe: ValueVisibilityInput!) {
  basicProfileAboutMeUpdate(aboutMe: $aboutMe) {
    ...BasicProfile
  }
}
    ${BasicProfileFragmentDoc}`;
export type BasicProfileAboutMeUpdateMutationFn = Apollo.MutationFunction<BasicProfileAboutMeUpdateMutation, BasicProfileAboutMeUpdateMutationVariables>;

/**
 * __useBasicProfileAboutMeUpdateMutation__
 *
 * To run a mutation, you first call `useBasicProfileAboutMeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicProfileAboutMeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicProfileAboutMeUpdateMutation, { data, loading, error }] = useBasicProfileAboutMeUpdateMutation({
 *   variables: {
 *      aboutMe: // value for 'aboutMe'
 *   },
 * });
 */
export function useBasicProfileAboutMeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BasicProfileAboutMeUpdateMutation, BasicProfileAboutMeUpdateMutationVariables>) {
        return Apollo.useMutation<BasicProfileAboutMeUpdateMutation, BasicProfileAboutMeUpdateMutationVariables>(BasicProfileAboutMeUpdateDocument, baseOptions);
      }
export type BasicProfileAboutMeUpdateMutationHookResult = ReturnType<typeof useBasicProfileAboutMeUpdateMutation>;
export type BasicProfileAboutMeUpdateMutationResult = Apollo.MutationResult<BasicProfileAboutMeUpdateMutation>;
export type BasicProfileAboutMeUpdateMutationOptions = Apollo.BaseMutationOptions<BasicProfileAboutMeUpdateMutation, BasicProfileAboutMeUpdateMutationVariables>;
export const ProfilePhotoUpdateDocument = gql`
    mutation ProfilePhotoUpdate($userId: Int!, $fileId: Int, $visible: Boolean!) {
  photoUpdate(userId: $userId, fileId: $fileId, visible: $visible) {
    ...BasicProfile
    photo {
      value
      isVisible
    }
  }
}
    ${BasicProfileFragmentDoc}`;
export type ProfilePhotoUpdateMutationFn = Apollo.MutationFunction<ProfilePhotoUpdateMutation, ProfilePhotoUpdateMutationVariables>;

/**
 * __useProfilePhotoUpdateMutation__
 *
 * To run a mutation, you first call `useProfilePhotoUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfilePhotoUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profilePhotoUpdateMutation, { data, loading, error }] = useProfilePhotoUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      fileId: // value for 'fileId'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useProfilePhotoUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfilePhotoUpdateMutation, ProfilePhotoUpdateMutationVariables>) {
        return Apollo.useMutation<ProfilePhotoUpdateMutation, ProfilePhotoUpdateMutationVariables>(ProfilePhotoUpdateDocument, baseOptions);
      }
export type ProfilePhotoUpdateMutationHookResult = ReturnType<typeof useProfilePhotoUpdateMutation>;
export type ProfilePhotoUpdateMutationResult = Apollo.MutationResult<ProfilePhotoUpdateMutation>;
export type ProfilePhotoUpdateMutationOptions = Apollo.BaseMutationOptions<ProfilePhotoUpdateMutation, ProfilePhotoUpdateMutationVariables>;
export const CreateJournalProjectDocument = gql`
    mutation CreateJournalProject($userId: Int!, $project: String!) {
  createJournalProject(userId: $userId, project: $project)
}
    `;
export type CreateJournalProjectMutationFn = Apollo.MutationFunction<CreateJournalProjectMutation, CreateJournalProjectMutationVariables>;

/**
 * __useCreateJournalProjectMutation__
 *
 * To run a mutation, you first call `useCreateJournalProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJournalProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJournalProjectMutation, { data, loading, error }] = useCreateJournalProjectMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      project: // value for 'project'
 *   },
 * });
 */
export function useCreateJournalProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateJournalProjectMutation, CreateJournalProjectMutationVariables>) {
        return Apollo.useMutation<CreateJournalProjectMutation, CreateJournalProjectMutationVariables>(CreateJournalProjectDocument, baseOptions);
      }
export type CreateJournalProjectMutationHookResult = ReturnType<typeof useCreateJournalProjectMutation>;
export type CreateJournalProjectMutationResult = Apollo.MutationResult<CreateJournalProjectMutation>;
export type CreateJournalProjectMutationOptions = Apollo.BaseMutationOptions<CreateJournalProjectMutation, CreateJournalProjectMutationVariables>;
export const DeleteJournalProjectDocument = gql`
    mutation DeleteJournalProject($userId: Int!, $project: String!) {
  deleteJournalProject(userId: $userId, project: $project)
}
    `;
export type DeleteJournalProjectMutationFn = Apollo.MutationFunction<DeleteJournalProjectMutation, DeleteJournalProjectMutationVariables>;

/**
 * __useDeleteJournalProjectMutation__
 *
 * To run a mutation, you first call `useDeleteJournalProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJournalProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJournalProjectMutation, { data, loading, error }] = useDeleteJournalProjectMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      project: // value for 'project'
 *   },
 * });
 */
export function useDeleteJournalProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJournalProjectMutation, DeleteJournalProjectMutationVariables>) {
        return Apollo.useMutation<DeleteJournalProjectMutation, DeleteJournalProjectMutationVariables>(DeleteJournalProjectDocument, baseOptions);
      }
export type DeleteJournalProjectMutationHookResult = ReturnType<typeof useDeleteJournalProjectMutation>;
export type DeleteJournalProjectMutationResult = Apollo.MutationResult<DeleteJournalProjectMutation>;
export type DeleteJournalProjectMutationOptions = Apollo.BaseMutationOptions<DeleteJournalProjectMutation, DeleteJournalProjectMutationVariables>;
export const UpdateEventReadTimestampDocument = gql`
    mutation UpdateEventReadTimestamp {
  updateEventReadTimestamp {
    userId
    hasUnReadEvent
  }
}
    `;
export type UpdateEventReadTimestampMutationFn = Apollo.MutationFunction<UpdateEventReadTimestampMutation, UpdateEventReadTimestampMutationVariables>;

/**
 * __useUpdateEventReadTimestampMutation__
 *
 * To run a mutation, you first call `useUpdateEventReadTimestampMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventReadTimestampMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventReadTimestampMutation, { data, loading, error }] = useUpdateEventReadTimestampMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateEventReadTimestampMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventReadTimestampMutation, UpdateEventReadTimestampMutationVariables>) {
        return Apollo.useMutation<UpdateEventReadTimestampMutation, UpdateEventReadTimestampMutationVariables>(UpdateEventReadTimestampDocument, baseOptions);
      }
export type UpdateEventReadTimestampMutationHookResult = ReturnType<typeof useUpdateEventReadTimestampMutation>;
export type UpdateEventReadTimestampMutationResult = Apollo.MutationResult<UpdateEventReadTimestampMutation>;
export type UpdateEventReadTimestampMutationOptions = Apollo.BaseMutationOptions<UpdateEventReadTimestampMutation, UpdateEventReadTimestampMutationVariables>;
export const UserPinUpdateDocument = gql`
    mutation UserPinUpdate($userId: Int!) {
  userPinUpdate(userId: $userId) {
    userId
    isPinned
  }
}
    `;
export type UserPinUpdateMutationFn = Apollo.MutationFunction<UserPinUpdateMutation, UserPinUpdateMutationVariables>;

/**
 * __useUserPinUpdateMutation__
 *
 * To run a mutation, you first call `useUserPinUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPinUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPinUpdateMutation, { data, loading, error }] = useUserPinUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPinUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserPinUpdateMutation, UserPinUpdateMutationVariables>) {
        return Apollo.useMutation<UserPinUpdateMutation, UserPinUpdateMutationVariables>(UserPinUpdateDocument, baseOptions);
      }
export type UserPinUpdateMutationHookResult = ReturnType<typeof useUserPinUpdateMutation>;
export type UserPinUpdateMutationResult = Apollo.MutationResult<UserPinUpdateMutation>;
export type UserPinUpdateMutationOptions = Apollo.BaseMutationOptions<UserPinUpdateMutation, UserPinUpdateMutationVariables>;
export const UserSkillUpdateDocument = gql`
    mutation UserSkillUpdate($userId: Int!, $skillId: Int!) {
  userSkillUpdate(userId: $userId, skillId: $skillId)
}
    `;
export type UserSkillUpdateMutationFn = Apollo.MutationFunction<UserSkillUpdateMutation, UserSkillUpdateMutationVariables>;

/**
 * __useUserSkillUpdateMutation__
 *
 * To run a mutation, you first call `useUserSkillUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSkillUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSkillUpdateMutation, { data, loading, error }] = useUserSkillUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useUserSkillUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserSkillUpdateMutation, UserSkillUpdateMutationVariables>) {
        return Apollo.useMutation<UserSkillUpdateMutation, UserSkillUpdateMutationVariables>(UserSkillUpdateDocument, baseOptions);
      }
export type UserSkillUpdateMutationHookResult = ReturnType<typeof useUserSkillUpdateMutation>;
export type UserSkillUpdateMutationResult = Apollo.MutationResult<UserSkillUpdateMutation>;
export type UserSkillUpdateMutationOptions = Apollo.BaseMutationOptions<UserSkillUpdateMutation, UserSkillUpdateMutationVariables>;
export const UserSkillBatchUpdateDocument = gql`
    mutation UserSkillBatchUpdate($userId: Int!, $skillIds: [Int!]!) {
  userSkillBatchUpdate(userId: $userId, skillIds: $skillIds) {
    userId
  }
}
    `;
export type UserSkillBatchUpdateMutationFn = Apollo.MutationFunction<UserSkillBatchUpdateMutation, UserSkillBatchUpdateMutationVariables>;

/**
 * __useUserSkillBatchUpdateMutation__
 *
 * To run a mutation, you first call `useUserSkillBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSkillBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSkillBatchUpdateMutation, { data, loading, error }] = useUserSkillBatchUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      skillIds: // value for 'skillIds'
 *   },
 * });
 */
export function useUserSkillBatchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserSkillBatchUpdateMutation, UserSkillBatchUpdateMutationVariables>) {
        return Apollo.useMutation<UserSkillBatchUpdateMutation, UserSkillBatchUpdateMutationVariables>(UserSkillBatchUpdateDocument, baseOptions);
      }
export type UserSkillBatchUpdateMutationHookResult = ReturnType<typeof useUserSkillBatchUpdateMutation>;
export type UserSkillBatchUpdateMutationResult = Apollo.MutationResult<UserSkillBatchUpdateMutation>;
export type UserSkillBatchUpdateMutationOptions = Apollo.BaseMutationOptions<UserSkillBatchUpdateMutation, UserSkillBatchUpdateMutationVariables>;
export const UserHobbyUpdateDocument = gql`
    mutation UserHobbyUpdate($userId: Int!, $hobbyId: Int!) {
  userHobbyUpdate(userId: $userId, hobbyId: $hobbyId)
}
    `;
export type UserHobbyUpdateMutationFn = Apollo.MutationFunction<UserHobbyUpdateMutation, UserHobbyUpdateMutationVariables>;

/**
 * __useUserHobbyUpdateMutation__
 *
 * To run a mutation, you first call `useUserHobbyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserHobbyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userHobbyUpdateMutation, { data, loading, error }] = useUserHobbyUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      hobbyId: // value for 'hobbyId'
 *   },
 * });
 */
export function useUserHobbyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserHobbyUpdateMutation, UserHobbyUpdateMutationVariables>) {
        return Apollo.useMutation<UserHobbyUpdateMutation, UserHobbyUpdateMutationVariables>(UserHobbyUpdateDocument, baseOptions);
      }
export type UserHobbyUpdateMutationHookResult = ReturnType<typeof useUserHobbyUpdateMutation>;
export type UserHobbyUpdateMutationResult = Apollo.MutationResult<UserHobbyUpdateMutation>;
export type UserHobbyUpdateMutationOptions = Apollo.BaseMutationOptions<UserHobbyUpdateMutation, UserHobbyUpdateMutationVariables>;
export const UserHobbyBatchUpdateDocument = gql`
    mutation UserHobbyBatchUpdate($userId: Int!, $hobbyIds: [Int!]!) {
  userHobbyBatchUpdate(userId: $userId, hobbyIds: $hobbyIds) {
    userId
  }
}
    `;
export type UserHobbyBatchUpdateMutationFn = Apollo.MutationFunction<UserHobbyBatchUpdateMutation, UserHobbyBatchUpdateMutationVariables>;

/**
 * __useUserHobbyBatchUpdateMutation__
 *
 * To run a mutation, you first call `useUserHobbyBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserHobbyBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userHobbyBatchUpdateMutation, { data, loading, error }] = useUserHobbyBatchUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      hobbyIds: // value for 'hobbyIds'
 *   },
 * });
 */
export function useUserHobbyBatchUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserHobbyBatchUpdateMutation, UserHobbyBatchUpdateMutationVariables>) {
        return Apollo.useMutation<UserHobbyBatchUpdateMutation, UserHobbyBatchUpdateMutationVariables>(UserHobbyBatchUpdateDocument, baseOptions);
      }
export type UserHobbyBatchUpdateMutationHookResult = ReturnType<typeof useUserHobbyBatchUpdateMutation>;
export type UserHobbyBatchUpdateMutationResult = Apollo.MutationResult<UserHobbyBatchUpdateMutation>;
export type UserHobbyBatchUpdateMutationOptions = Apollo.BaseMutationOptions<UserHobbyBatchUpdateMutation, UserHobbyBatchUpdateMutationVariables>;
export const UserAboutMePartUpdateDocument = gql`
    mutation UserAboutMePartUpdate($input: UserInfoAboutMePartInput!) {
  userAboutMePartUpdate(input: $input)
}
    `;
export type UserAboutMePartUpdateMutationFn = Apollo.MutationFunction<UserAboutMePartUpdateMutation, UserAboutMePartUpdateMutationVariables>;

/**
 * __useUserAboutMePartUpdateMutation__
 *
 * To run a mutation, you first call `useUserAboutMePartUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAboutMePartUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAboutMePartUpdateMutation, { data, loading, error }] = useUserAboutMePartUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAboutMePartUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserAboutMePartUpdateMutation, UserAboutMePartUpdateMutationVariables>) {
        return Apollo.useMutation<UserAboutMePartUpdateMutation, UserAboutMePartUpdateMutationVariables>(UserAboutMePartUpdateDocument, baseOptions);
      }
export type UserAboutMePartUpdateMutationHookResult = ReturnType<typeof useUserAboutMePartUpdateMutation>;
export type UserAboutMePartUpdateMutationResult = Apollo.MutationResult<UserAboutMePartUpdateMutation>;
export type UserAboutMePartUpdateMutationOptions = Apollo.BaseMutationOptions<UserAboutMePartUpdateMutation, UserAboutMePartUpdateMutationVariables>;
export const SkillCreateDocument = gql`
    mutation SkillCreate($name: String!) {
  skillCreate(name: $name) {
    skillId
    name
  }
}
    `;
export type SkillCreateMutationFn = Apollo.MutationFunction<SkillCreateMutation, SkillCreateMutationVariables>;

/**
 * __useSkillCreateMutation__
 *
 * To run a mutation, you first call `useSkillCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillCreateMutation, { data, loading, error }] = useSkillCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSkillCreateMutation(baseOptions?: Apollo.MutationHookOptions<SkillCreateMutation, SkillCreateMutationVariables>) {
        return Apollo.useMutation<SkillCreateMutation, SkillCreateMutationVariables>(SkillCreateDocument, baseOptions);
      }
export type SkillCreateMutationHookResult = ReturnType<typeof useSkillCreateMutation>;
export type SkillCreateMutationResult = Apollo.MutationResult<SkillCreateMutation>;
export type SkillCreateMutationOptions = Apollo.BaseMutationOptions<SkillCreateMutation, SkillCreateMutationVariables>;
export const HobbyCreateDocument = gql`
    mutation HobbyCreate($name: String!) {
  hobbyCreate(name: $name) {
    hobbyId
    name
  }
}
    `;
export type HobbyCreateMutationFn = Apollo.MutationFunction<HobbyCreateMutation, HobbyCreateMutationVariables>;

/**
 * __useHobbyCreateMutation__
 *
 * To run a mutation, you first call `useHobbyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHobbyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hobbyCreateMutation, { data, loading, error }] = useHobbyCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHobbyCreateMutation(baseOptions?: Apollo.MutationHookOptions<HobbyCreateMutation, HobbyCreateMutationVariables>) {
        return Apollo.useMutation<HobbyCreateMutation, HobbyCreateMutationVariables>(HobbyCreateDocument, baseOptions);
      }
export type HobbyCreateMutationHookResult = ReturnType<typeof useHobbyCreateMutation>;
export type HobbyCreateMutationResult = Apollo.MutationResult<HobbyCreateMutation>;
export type HobbyCreateMutationOptions = Apollo.BaseMutationOptions<HobbyCreateMutation, HobbyCreateMutationVariables>;
export const UserInfoHeaderUpdateDocument = gql`
    mutation UserInfoHeaderUpdate($input: UserInfoHeaderInput!) {
  userInfoHeaderUpdate(input: $input)
}
    `;
export type UserInfoHeaderUpdateMutationFn = Apollo.MutationFunction<UserInfoHeaderUpdateMutation, UserInfoHeaderUpdateMutationVariables>;

/**
 * __useUserInfoHeaderUpdateMutation__
 *
 * To run a mutation, you first call `useUserInfoHeaderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInfoHeaderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInfoHeaderUpdateMutation, { data, loading, error }] = useUserInfoHeaderUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserInfoHeaderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserInfoHeaderUpdateMutation, UserInfoHeaderUpdateMutationVariables>) {
        return Apollo.useMutation<UserInfoHeaderUpdateMutation, UserInfoHeaderUpdateMutationVariables>(UserInfoHeaderUpdateDocument, baseOptions);
      }
export type UserInfoHeaderUpdateMutationHookResult = ReturnType<typeof useUserInfoHeaderUpdateMutation>;
export type UserInfoHeaderUpdateMutationResult = Apollo.MutationResult<UserInfoHeaderUpdateMutation>;
export type UserInfoHeaderUpdateMutationOptions = Apollo.BaseMutationOptions<UserInfoHeaderUpdateMutation, UserInfoHeaderUpdateMutationVariables>;
export const UserInfoEditModalUpdateDocument = gql`
    mutation UserInfoEditModalUpdate($input: UserInfoEditModalInput!) {
  userInfoEditModalUpdate(input: $input)
}
    `;
export type UserInfoEditModalUpdateMutationFn = Apollo.MutationFunction<UserInfoEditModalUpdateMutation, UserInfoEditModalUpdateMutationVariables>;

/**
 * __useUserInfoEditModalUpdateMutation__
 *
 * To run a mutation, you first call `useUserInfoEditModalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInfoEditModalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInfoEditModalUpdateMutation, { data, loading, error }] = useUserInfoEditModalUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserInfoEditModalUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserInfoEditModalUpdateMutation, UserInfoEditModalUpdateMutationVariables>) {
        return Apollo.useMutation<UserInfoEditModalUpdateMutation, UserInfoEditModalUpdateMutationVariables>(UserInfoEditModalUpdateDocument, baseOptions);
      }
export type UserInfoEditModalUpdateMutationHookResult = ReturnType<typeof useUserInfoEditModalUpdateMutation>;
export type UserInfoEditModalUpdateMutationResult = Apollo.MutationResult<UserInfoEditModalUpdateMutation>;
export type UserInfoEditModalUpdateMutationOptions = Apollo.BaseMutationOptions<UserInfoEditModalUpdateMutation, UserInfoEditModalUpdateMutationVariables>;
export const UserInfoWorkCircleFeedBackUpdateDocument = gql`
    mutation UserInfoWorkCircleFeedBackUpdate($feedback: Boolean!) {
  userInfoWorkCircleFeedBackUpdate(feedback: $feedback)
}
    `;
export type UserInfoWorkCircleFeedBackUpdateMutationFn = Apollo.MutationFunction<UserInfoWorkCircleFeedBackUpdateMutation, UserInfoWorkCircleFeedBackUpdateMutationVariables>;

/**
 * __useUserInfoWorkCircleFeedBackUpdateMutation__
 *
 * To run a mutation, you first call `useUserInfoWorkCircleFeedBackUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInfoWorkCircleFeedBackUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInfoWorkCircleFeedBackUpdateMutation, { data, loading, error }] = useUserInfoWorkCircleFeedBackUpdateMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useUserInfoWorkCircleFeedBackUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserInfoWorkCircleFeedBackUpdateMutation, UserInfoWorkCircleFeedBackUpdateMutationVariables>) {
        return Apollo.useMutation<UserInfoWorkCircleFeedBackUpdateMutation, UserInfoWorkCircleFeedBackUpdateMutationVariables>(UserInfoWorkCircleFeedBackUpdateDocument, baseOptions);
      }
export type UserInfoWorkCircleFeedBackUpdateMutationHookResult = ReturnType<typeof useUserInfoWorkCircleFeedBackUpdateMutation>;
export type UserInfoWorkCircleFeedBackUpdateMutationResult = Apollo.MutationResult<UserInfoWorkCircleFeedBackUpdateMutation>;
export type UserInfoWorkCircleFeedBackUpdateMutationOptions = Apollo.BaseMutationOptions<UserInfoWorkCircleFeedBackUpdateMutation, UserInfoWorkCircleFeedBackUpdateMutationVariables>;
export const GetWebsiteCategoriesDocument = gql`
    query GetWebsiteCategories($categoryPagination: PaginationInput!, $pagination: PaginationInput!) {
  website {
    categories(pagination: $categoryPagination) {
      edges {
        node {
          ...WebsiteCategoryInfoWithPaginated
        }
      }
    }
  }
}
    ${WebsiteCategoryInfoWithPaginatedFragmentDoc}`;

/**
 * __useGetWebsiteCategoriesQuery__
 *
 * To run a query within a React component, call `useGetWebsiteCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsiteCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsiteCategoriesQuery({
 *   variables: {
 *      categoryPagination: // value for 'categoryPagination'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetWebsiteCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetWebsiteCategoriesQuery, GetWebsiteCategoriesQueryVariables>) {
        return Apollo.useQuery<GetWebsiteCategoriesQuery, GetWebsiteCategoriesQueryVariables>(GetWebsiteCategoriesDocument, baseOptions);
      }
export function useGetWebsiteCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsiteCategoriesQuery, GetWebsiteCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<GetWebsiteCategoriesQuery, GetWebsiteCategoriesQueryVariables>(GetWebsiteCategoriesDocument, baseOptions);
        }
export type GetWebsiteCategoriesQueryHookResult = ReturnType<typeof useGetWebsiteCategoriesQuery>;
export type GetWebsiteCategoriesLazyQueryHookResult = ReturnType<typeof useGetWebsiteCategoriesLazyQuery>;
export type GetWebsiteCategoriesQueryResult = Apollo.QueryResult<GetWebsiteCategoriesQuery, GetWebsiteCategoriesQueryVariables>;
export const GetWebsitesDocument = gql`
    query GetWebsites($pagination: PaginationInput!, $isCommon: Boolean) {
  website {
    entities(pagination: $pagination, isCommon: $isCommon) {
      edges {
        node {
          ...WebsiteInfo
        }
      }
    }
  }
}
    ${WebsiteInfoFragmentDoc}`;

/**
 * __useGetWebsitesQuery__
 *
 * To run a query within a React component, call `useGetWebsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebsitesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      isCommon: // value for 'isCommon'
 *   },
 * });
 */
export function useGetWebsitesQuery(baseOptions: Apollo.QueryHookOptions<GetWebsitesQuery, GetWebsitesQueryVariables>) {
        return Apollo.useQuery<GetWebsitesQuery, GetWebsitesQueryVariables>(GetWebsitesDocument, baseOptions);
      }
export function useGetWebsitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebsitesQuery, GetWebsitesQueryVariables>) {
          return Apollo.useLazyQuery<GetWebsitesQuery, GetWebsitesQueryVariables>(GetWebsitesDocument, baseOptions);
        }
export type GetWebsitesQueryHookResult = ReturnType<typeof useGetWebsitesQuery>;
export type GetWebsitesLazyQueryHookResult = ReturnType<typeof useGetWebsitesLazyQuery>;
export type GetWebsitesQueryResult = Apollo.QueryResult<GetWebsitesQuery, GetWebsitesQueryVariables>;
export const WebsiteAddDocument = gql`
    mutation WebsiteAdd($websiteCreateInput: WebsiteCreateInput!) {
  websiteAdd(websiteCreateInput: $websiteCreateInput) {
    ...WebsiteInfo
  }
}
    ${WebsiteInfoFragmentDoc}`;
export type WebsiteAddMutationFn = Apollo.MutationFunction<WebsiteAddMutation, WebsiteAddMutationVariables>;

/**
 * __useWebsiteAddMutation__
 *
 * To run a mutation, you first call `useWebsiteAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteAddMutation, { data, loading, error }] = useWebsiteAddMutation({
 *   variables: {
 *      websiteCreateInput: // value for 'websiteCreateInput'
 *   },
 * });
 */
export function useWebsiteAddMutation(baseOptions?: Apollo.MutationHookOptions<WebsiteAddMutation, WebsiteAddMutationVariables>) {
        return Apollo.useMutation<WebsiteAddMutation, WebsiteAddMutationVariables>(WebsiteAddDocument, baseOptions);
      }
export type WebsiteAddMutationHookResult = ReturnType<typeof useWebsiteAddMutation>;
export type WebsiteAddMutationResult = Apollo.MutationResult<WebsiteAddMutation>;
export type WebsiteAddMutationOptions = Apollo.BaseMutationOptions<WebsiteAddMutation, WebsiteAddMutationVariables>;
export const WebsiteUpdateDocument = gql`
    mutation WebsiteUpdate($websiteId: Int!, $websiteUpdateInput: WebsiteUpdateInput!) {
  websiteUpdate(websiteId: $websiteId, websiteUpdateInput: $websiteUpdateInput) {
    ...WebsiteInfo
  }
}
    ${WebsiteInfoFragmentDoc}`;
export type WebsiteUpdateMutationFn = Apollo.MutationFunction<WebsiteUpdateMutation, WebsiteUpdateMutationVariables>;

/**
 * __useWebsiteUpdateMutation__
 *
 * To run a mutation, you first call `useWebsiteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteUpdateMutation, { data, loading, error }] = useWebsiteUpdateMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *      websiteUpdateInput: // value for 'websiteUpdateInput'
 *   },
 * });
 */
export function useWebsiteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WebsiteUpdateMutation, WebsiteUpdateMutationVariables>) {
        return Apollo.useMutation<WebsiteUpdateMutation, WebsiteUpdateMutationVariables>(WebsiteUpdateDocument, baseOptions);
      }
export type WebsiteUpdateMutationHookResult = ReturnType<typeof useWebsiteUpdateMutation>;
export type WebsiteUpdateMutationResult = Apollo.MutationResult<WebsiteUpdateMutation>;
export type WebsiteUpdateMutationOptions = Apollo.BaseMutationOptions<WebsiteUpdateMutation, WebsiteUpdateMutationVariables>;
export const WebsiteDeleteDocument = gql`
    mutation WebsiteDelete($websiteId: Int!) {
  websiteDelete(websiteId: $websiteId)
}
    `;
export type WebsiteDeleteMutationFn = Apollo.MutationFunction<WebsiteDeleteMutation, WebsiteDeleteMutationVariables>;

/**
 * __useWebsiteDeleteMutation__
 *
 * To run a mutation, you first call `useWebsiteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteDeleteMutation, { data, loading, error }] = useWebsiteDeleteMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WebsiteDeleteMutation, WebsiteDeleteMutationVariables>) {
        return Apollo.useMutation<WebsiteDeleteMutation, WebsiteDeleteMutationVariables>(WebsiteDeleteDocument, baseOptions);
      }
export type WebsiteDeleteMutationHookResult = ReturnType<typeof useWebsiteDeleteMutation>;
export type WebsiteDeleteMutationResult = Apollo.MutationResult<WebsiteDeleteMutation>;
export type WebsiteDeleteMutationOptions = Apollo.BaseMutationOptions<WebsiteDeleteMutation, WebsiteDeleteMutationVariables>;
export const WebsiteCategoryAddDocument = gql`
    mutation WebsiteCategoryAdd($websiteCategoryCreateInput: WebsiteCategoryCreateInput!) {
  websiteCategoryAdd(websiteCategoryCreateInput: $websiteCategoryCreateInput) {
    ...WebsiteCategoryInfo
  }
}
    ${WebsiteCategoryInfoFragmentDoc}`;
export type WebsiteCategoryAddMutationFn = Apollo.MutationFunction<WebsiteCategoryAddMutation, WebsiteCategoryAddMutationVariables>;

/**
 * __useWebsiteCategoryAddMutation__
 *
 * To run a mutation, you first call `useWebsiteCategoryAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteCategoryAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteCategoryAddMutation, { data, loading, error }] = useWebsiteCategoryAddMutation({
 *   variables: {
 *      websiteCategoryCreateInput: // value for 'websiteCategoryCreateInput'
 *   },
 * });
 */
export function useWebsiteCategoryAddMutation(baseOptions?: Apollo.MutationHookOptions<WebsiteCategoryAddMutation, WebsiteCategoryAddMutationVariables>) {
        return Apollo.useMutation<WebsiteCategoryAddMutation, WebsiteCategoryAddMutationVariables>(WebsiteCategoryAddDocument, baseOptions);
      }
export type WebsiteCategoryAddMutationHookResult = ReturnType<typeof useWebsiteCategoryAddMutation>;
export type WebsiteCategoryAddMutationResult = Apollo.MutationResult<WebsiteCategoryAddMutation>;
export type WebsiteCategoryAddMutationOptions = Apollo.BaseMutationOptions<WebsiteCategoryAddMutation, WebsiteCategoryAddMutationVariables>;
export const WebsiteCategoryUpdateDocument = gql`
    mutation WebsiteCategoryUpdate($websiteCategoryId: Int!, $websiteCategoryUpdateInput: WebsiteCategoryUpdateInput!) {
  websiteCategoryUpdate(
    websiteCategoryId: $websiteCategoryId
    websiteCategoryUpdateInput: $websiteCategoryUpdateInput
  ) {
    ...WebsiteCategoryInfo
  }
}
    ${WebsiteCategoryInfoFragmentDoc}`;
export type WebsiteCategoryUpdateMutationFn = Apollo.MutationFunction<WebsiteCategoryUpdateMutation, WebsiteCategoryUpdateMutationVariables>;

/**
 * __useWebsiteCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useWebsiteCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteCategoryUpdateMutation, { data, loading, error }] = useWebsiteCategoryUpdateMutation({
 *   variables: {
 *      websiteCategoryId: // value for 'websiteCategoryId'
 *      websiteCategoryUpdateInput: // value for 'websiteCategoryUpdateInput'
 *   },
 * });
 */
export function useWebsiteCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WebsiteCategoryUpdateMutation, WebsiteCategoryUpdateMutationVariables>) {
        return Apollo.useMutation<WebsiteCategoryUpdateMutation, WebsiteCategoryUpdateMutationVariables>(WebsiteCategoryUpdateDocument, baseOptions);
      }
export type WebsiteCategoryUpdateMutationHookResult = ReturnType<typeof useWebsiteCategoryUpdateMutation>;
export type WebsiteCategoryUpdateMutationResult = Apollo.MutationResult<WebsiteCategoryUpdateMutation>;
export type WebsiteCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<WebsiteCategoryUpdateMutation, WebsiteCategoryUpdateMutationVariables>;
export const WebsiteCommonToggleDocument = gql`
    mutation WebsiteCommonToggle($websiteId: Int!) {
  toggleWebsiteCommon(websiteId: $websiteId) {
    websiteId
    isCommon
  }
}
    `;
export type WebsiteCommonToggleMutationFn = Apollo.MutationFunction<WebsiteCommonToggleMutation, WebsiteCommonToggleMutationVariables>;

/**
 * __useWebsiteCommonToggleMutation__
 *
 * To run a mutation, you first call `useWebsiteCommonToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteCommonToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteCommonToggleMutation, { data, loading, error }] = useWebsiteCommonToggleMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteCommonToggleMutation(baseOptions?: Apollo.MutationHookOptions<WebsiteCommonToggleMutation, WebsiteCommonToggleMutationVariables>) {
        return Apollo.useMutation<WebsiteCommonToggleMutation, WebsiteCommonToggleMutationVariables>(WebsiteCommonToggleDocument, baseOptions);
      }
export type WebsiteCommonToggleMutationHookResult = ReturnType<typeof useWebsiteCommonToggleMutation>;
export type WebsiteCommonToggleMutationResult = Apollo.MutationResult<WebsiteCommonToggleMutation>;
export type WebsiteCommonToggleMutationOptions = Apollo.BaseMutationOptions<WebsiteCommonToggleMutation, WebsiteCommonToggleMutationVariables>;